exports.ids = [3,10];
exports.modules = [
/* 0 */,
/* 1 */
/* no static exports found */
/* all exports used */
/*!******************************************!*\
  !*** ./scripts/player/v2/shared/l10n.js ***!
  \******************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setLocales = setLocales;
exports.l10n = l10n;
var localiztions = void 0;

function setLocales(_localizations) {
  localiztions = _localizations;
}

function l10n(key, args) {
  var text = localiztions[key];
  if (!args) {
    return text;
  }
  if (Array.isArray && !Array.isArray(args)) {
    throw new Error('l10n must receive array of args');
  }
  return args.reduce(function (acc, arg) {
    return acc.replace('%s', arg);
  }, text);
}

/***/ }),
/* 2 */,
/* 3 */,
/* 4 */
/* no static exports found */
/* all exports used */
/*!****************************************************************!*\
  !*** ./scripts/common/parse-settings/v2-settings-constants.js ***!
  \****************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MIN_WIDTH_BY_LAYOUT, _BUTTON_STYLE_CLASSES;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var LAYOUT_TYPES = exports.LAYOUT_TYPES = {
  MOBILE: -1,
  VERTICAL: 0,
  HORIZONTAL: 1,
  LIST: 2
};

var ALBUM_COVER_SCALING = exports.ALBUM_COVER_SCALING = {
  FIT: 0,
  AUTO_CROP: 1,
  HIDE: 2
};

var HORIZONTAL_ALBUM_COVER_SCALING = exports.HORIZONTAL_ALBUM_COVER_SCALING = {
  SHOW: 0,
  HIDE: 2
};

var BUTTON_STYLES = exports.BUTTON_STYLES = {
  RECT_FILL: 0,
  ROUND_FILL: 1,
  RECT_TRANSPARENT: 2,
  ROUND_TRANSPARENT: 3
};

var TRACK_ACTIONS_SHOW = exports.TRACK_ACTIONS_SHOW = {
  ON_ACTIVE: 0,
  ON_ALL: 1
};

var TRACK_INFO_SHOW_ARTIST_NAME = exports.TRACK_INFO_SHOW_ARTIST_NAME = {
  NAME_ONLY: 0,
  NAME_AND_ARTIST: 1
};

var INFO_PLACEMENT = exports.INFO_PLACEMENT = {
  BELOW: 0,
  ABOVE: 1
};

var CONTROL_BAR_TYPE = exports.CONTROL_BAR_TYPE = {
  CENTER: 0,
  LEFT: 1
};

var HORIZONTAL_CONTROL_BAR_TYPE = exports.HORIZONTAL_CONTROL_BAR_TYPE = {
  MAXI: 0,
  MINI: 1
};

var MIN_WIDTH_BY_LAYOUT = exports.MIN_WIDTH_BY_LAYOUT = (_MIN_WIDTH_BY_LAYOUT = {}, _defineProperty(_MIN_WIDTH_BY_LAYOUT, LAYOUT_TYPES.MOBILE, 280), _defineProperty(_MIN_WIDTH_BY_LAYOUT, LAYOUT_TYPES.VERTICAL, 280), _defineProperty(_MIN_WIDTH_BY_LAYOUT, LAYOUT_TYPES.HORIZONTAL, 680), _defineProperty(_MIN_WIDTH_BY_LAYOUT, LAYOUT_TYPES.LIST, 430), _MIN_WIDTH_BY_LAYOUT);

var BUTTON_STYLE_CLASSES = exports.BUTTON_STYLE_CLASSES = (_BUTTON_STYLE_CLASSES = {}, _defineProperty(_BUTTON_STYLE_CLASSES, BUTTON_STYLES.RECT_FILL, 'rect-fill'), _defineProperty(_BUTTON_STYLE_CLASSES, BUTTON_STYLES.ROUND_FILL, 'round-fill'), _defineProperty(_BUTTON_STYLE_CLASSES, BUTTON_STYLES.RECT_TRANSPARENT, 'rect-transparent'), _defineProperty(_BUTTON_STYLE_CLASSES, BUTTON_STYLES.ROUND_TRANSPARENT, 'round-transparent'), _BUTTON_STYLE_CLASSES);

var LIST_LAYOUT_TRACK_STYLE = exports.LIST_LAYOUT_TRACK_STYLE = {
  BASIC: 0,
  COVER: 1,
  MINIMAL: 2
};

var LIST_COVER_SIZE = exports.LIST_COVER_SIZE = 78;

/***/ }),
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */
/* no static exports found */
/* all exports used */
/*!******************************************************!*\
  !*** ./scripts/player/v2/shared/translation-keys.js ***!
  \******************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.translationKeys = undefined;

var _translationKeys;

exports.registerTranslationKeys = registerTranslationKeys;

var _constants = __webpack_require__(/*! ../../../common/constants */ 5);

var constants = _interopRequireDefault(_constants).default;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var translationKeys = exports.translationKeys = (_translationKeys = {}, _defineProperty(_translationKeys, constants.ALBUM_TYPES.ALBUM, {}), _defineProperty(_translationKeys, constants.ALBUM_TYPES.SINGLE, {}), _defineProperty(_translationKeys, constants.ALBUM_TYPES.PLAYLIST, {}), _translationKeys);

function registerTranslationKeys(newTranslationKeys) {
  var keyTypes = Object.keys(newTranslationKeys);
  keyTypes.forEach(function (type) {
    Object.assign(translationKeys[type], newTranslationKeys[type]);
  });
}

/***/ }),
/* 11 */
/* no static exports found */
/* all exports used */
/*!*************************************!*\
  !*** ./scripts/utils/perfomance.js ***!
  \*************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.now = now;
exports.pageLoadingTime = pageLoadingTime;
exports.timeStart = timeStart;
exports.timeLap = timeLap;
exports.timeStop = timeStop;
/* global performance */
function now() {
  if (typeof performance !== 'undefined' && performance.now) {
    return performance.now();
  }
  return Date.now();
}

function pageLoadingTime() {
  return typeof performance !== 'undefined' && performance.now ? Math.round(performance.now()) : null;
}

var timeTracking = new Map();

function timeStart(key) {
  var from = now();
  timeTracking.set(key, from);
}

function timeLap(key) {
  var to = now();
  if (!timeTracking.has(key)) {
    return undefined;
  }
  return to - timeTracking.get(key);
}

function timeStop(key) {
  var elapsedTime = timeLap(key);
  timeTracking.delete(key);
  return elapsedTime;
}

/***/ }),
/* 12 */,
/* 13 */
/* no static exports found */
/* all exports used */
/*!**************************************************!*\
  !*** ./scripts/player/v2/shared/icons/share.svg ***!
  \**************************************************/
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"11\" height=\"12\" viewBox=\"0 0 11 12\"><defs><style> .cls-1 { fill-rule: evenodd; } </style></defs><path class=\"cls-1\" d=\"M9,8a1.991,1.991,0,0,0-1.431.606L3.922,6.522a1.8,1.8,0,0,0,0-1.044L7.569,3.394A2,2,0,1,0,7,2a1.983,1.983,0,0,0,.078.523L3.431,4.606a2,2,0,1,0,0,2.788L7.078,9.478A1.979,1.979,0,0,0,7,10,2,2,0,1,0,9,8Z\"></path></svg>"

/***/ }),
/* 14 */,
/* 15 */
/* no static exports found */
/* all exports used */
/*!***********************************************!*\
  !*** ./scripts/player/v2/shared/view-mode.js ***!
  \***********************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSdkViewMode = exports.ViewMode = undefined;

var _constants = __webpack_require__(/*! ../../../common/constants */ 5);

var constants = _interopRequireDefault(_constants).default;

var _wixSdk = __webpack_require__(/*! ../../../common/wix-sdk */ 14);

var WixSdk = _interopRequireDefault(_wixSdk).default;

var _deprecated = __webpack_require__(/*! ../../../utils/deprecated */ 7);

var deprecated = _deprecated.deprecated;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getSdkViewMode = deprecated(function getSdkViewMode() {
  return WixSdk && WixSdk.Utils && WixSdk.Utils.getViewMode() || constants.VIEW_MODES.STANDALONE;
});

function isMode(desiredMode) {
  return function () {
    var testMode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getSdkViewMode();
    return testMode === desiredMode;
  };
}

var ViewMode = {
  isEditor: isMode(constants.VIEW_MODES.EDITOR),
  isPreview: isMode(constants.VIEW_MODES.PREVIEW),
  isModifying: function isModifying(testMode) {
    return this.isEditor(testMode) || this.isPreview(testMode);
  }
};

exports.ViewMode = ViewMode;
exports.getSdkViewMode = getSdkViewMode;

/***/ }),
/* 16 */
/* no static exports found */
/* all exports used */
/*!*************************************************************!*\
  !*** ./scripts/player/v2/shared/components/slider/index.js ***!
  \*************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slider = __webpack_require__(/*! ./slider.component */ 44);

Object.defineProperty(exports, 'Slider', {
  enumerable: true,
  get: function get() {
    return _slider.Slider;
  }
});

var _desktopSlider = __webpack_require__(/*! ./desktop-slider */ 65);

Object.defineProperty(exports, 'DesktopSlider', {
  enumerable: true,
  get: function get() {
    return _desktopSlider.DesktopSlider;
  }
});

/***/ }),
/* 17 */
/* no static exports found */
/* all exports used */
/*!****************************************************************!*\
  !*** ./scripts/player/v2/shared/components/buy-track/index.js ***!
  \****************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _buyTrack = __webpack_require__(/*! ./buy-track.component */ 148);

Object.defineProperty(exports, 'BuyTrack', {
  enumerable: true,
  get: function get() {
    return _buyTrack.BuyTrack;
  }
});

/***/ }),
/* 18 */,
/* 19 */,
/* 20 */
/* no static exports found */
/* all exports used */
/*!*************************************************!*\
  !*** ./scripts/player/v2/shared/artist-name.js ***!
  \*************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _TRACK_COLLABORATION_;

exports.getFullArtistName = getFullArtistName;

var _l10n = __webpack_require__(/*! ./l10n */ 1);

var l10n = _l10n.l10n;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var TRACK_COLLABORATION_TYPES = {
  FEATURING: 'FEATURING',
  WITH: 'WITH',
  REMIXED: 'REMIXED',
  PERFORMED: 'PERFORMED'
};
var TRACK_COLLABORATION_TYPES_LABELS = (_TRACK_COLLABORATION_ = {}, _defineProperty(_TRACK_COLLABORATION_, TRACK_COLLABORATION_TYPES.FEATURING, 'player_track_collaboration_featuring'), _defineProperty(_TRACK_COLLABORATION_, TRACK_COLLABORATION_TYPES.WITH, 'player_track_collaboration_with'), _defineProperty(_TRACK_COLLABORATION_, TRACK_COLLABORATION_TYPES.REMIXED, 'player_track_collaboration_remixed'), _defineProperty(_TRACK_COLLABORATION_, TRACK_COLLABORATION_TYPES.PERFORMED, 'player_track_collaboration_performed'), _TRACK_COLLABORATION_);

function getFullArtistName(track) {
  var artistName = track.artistName,
      collaborationType = track.collaborationType,
      collaborators = track.collaborators;

  if (!collaborators) {
    return artistName;
  }
  var collaborationTypeLabel = l10n(TRACK_COLLABORATION_TYPES_LABELS[collaborationType]);
  return artistName + ' (' + collaborationTypeLabel + ' ' + collaborators + ')';
}

/***/ }),
/* 21 */,
/* 22 */
/* no static exports found */
/* all exports used */
/*!********************************************************!*\
  !*** ./scripts/player/v2/shared/app/app.controller.js ***!
  \********************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AppController = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _buyItem = __webpack_require__(/*! ../buy-item */ 42);

var buyAlbumGet = _buyItem.buyAlbumGet;
var buyTrackGet = _buyItem.buyTrackGet;
var openTrackInfoPage = _buyItem.openTrackInfoPage;

var _l10n = __webpack_require__(/*! ../l10n */ 1);

var l10n = _l10n.l10n;

var _shareItem = __webpack_require__(/*! ../share-item */ 74);

var shareAlbumFn = _shareItem.shareAlbum;
var shareTrackFn = _shareItem.shareTrack;

var _translationKeys = __webpack_require__(/*! ../translation-keys */ 10);

var translationKeys = _translationKeys.translationKeys;

var _viewMode = __webpack_require__(/*! ../view-mode */ 15);

var ViewMode = _viewMode.ViewMode;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AppController = function () {
  function AppController(attrs) {
    _classCallCheck(this, AppController);

    var album = attrs.album,
        settings = attrs.settings,
        playback = attrs.playback,
        playerApi = attrs.playerApi;

    this.statisticEvents = playerApi.statisticEvents;
    this.settings = settings;
    this.album = album;
    this.playback = playback;
    this.playerApi = playerApi;
    this.playerApiEmit = function (eventName) {
      return function () {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return playerApi.emit.apply(playerApi, [eventName].concat(args));
      };
    };
    this.pixelRatio = attrs.pixelRatio || window.devicePixelRatio;
  }

  _createClass(AppController, [{
    key: 'shouldDisableShareBuy',
    value: function shouldDisableShareBuy() {
      return !this.isEditor() && (!this.hasTracks() || this.album.isDemo);
    }
  }, {
    key: 'isEditor',
    value: function isEditor() {
      return ViewMode.isEditor(this.settings.viewMode);
    }
  }, {
    key: 'hasTracks',
    value: function hasTracks() {
      var tracks = this.album.tracks;
      return Boolean(tracks && tracks.length);
    }
  }, {
    key: 'hasCurrentLyrics',
    value: function hasCurrentLyrics() {
      var album = this.album;

      if (album.description) {
        return true;
      }
      var track = this.getVisibleTrack();
      return track ? Boolean(track.lyrics) : false;
    }
  }, {
    key: 'getVisibleTrack',
    value: function getVisibleTrack() {
      var playback = this.playback;

      return playback.currentTrack || playback.getFirstTrack();
    }
  }, {
    key: 'isVisibleTrackPurchasable',
    value: function isVisibleTrackPurchasable() {
      var track = this.getVisibleTrack();
      return track ? track.purchaseAvail : false;
    }
  }, {
    key: 'isAnyTrackPurchasable',
    value: function isAnyTrackPurchasable() {
      var album = this.album;

      return album.tracks.some(function (track) {
        return track.purchaseAvail;
      });
    }
  }, {
    key: 'shareAlbum',
    value: function shareAlbum(network) {
      var album = this.album,
          settings = this.settings,
          playerApi = this.playerApi,
          statisticEvents = this.statisticEvents;

      if (this._isEditingMode) {
        playerApi.emitFeatureDisabled();
        return;
      }
      shareAlbumFn(network, album, settings);
      statisticEvents.emit('albumShareClicked', {
        album: album,
        network: network
      });
    }
  }, {
    key: 'shareCurrentTrack',
    value: function shareCurrentTrack(network) {
      var track = this.getVisibleTrack();
      this.shareTrack(network, track);
    }
  }, {
    key: 'shareTrack',
    value: function shareTrack(network, track) {
      var album = this.album,
          settings = this.settings,
          playerApi = this.playerApi,
          statisticEvents = this.statisticEvents;

      if (this._isEditingMode) {
        playerApi.emitFeatureDisabled();
        return;
      }

      shareTrackFn(network, album, settings, track);
      statisticEvents.emit('trackShareClicked', {
        network: network,
        track: track,
        album: album
      });
    }
  }, {
    key: 'openShareAlbumModal',
    value: function openShareAlbumModal() {
      this.playerApi.emit('widget:share');
    }
  }, {
    key: 'openShareTrackModal',
    value: function openShareTrackModal() {
      var track = this.getVisibleTrack();
      this.playerApi.emit('widget:share', { track: track ? track.id : null });
    }
  }, {
    key: 'openTrackInfoModal',
    value: function openTrackInfoModal() {
      var track = this.getVisibleTrack();
      this.playerApi.emit('widget:track-info', { track: track ? track.id : null });
    }
  }, {
    key: 'buyAlbum',
    value: function buyAlbum() {
      var album = this.album,
          settings = this.settings,
          playerApi = this.playerApi,
          statisticEvents = this.statisticEvents;


      if (this._isEditingMode) {
        playerApi.emitFeatureDisabled();
        return;
      }

      buyAlbumGet(playerApi, settings, album);

      statisticEvents.emit('albumPurchaseClicked', {
        album: album,
        sendToDownloadPage: true,
        origin: 'player'
      });
    }
  }, {
    key: 'buyTrack',
    value: function buyTrack(trackId) {
      var album = this.album,
          settings = this.settings,
          playerApi = this.playerApi,
          statisticEvents = this.statisticEvents;


      if (this._isEditingMode) {
        playerApi.emitFeatureDisabled();
        return;
      }
      if (playerApi.currentTrack !== trackId) {
        playerApi.pause();

        setTimeout(function () {
          playerApi.setCurrentTrack(trackId);
        }, 0);
      }

      buyTrackGet(playerApi, settings, album, trackId);

      statisticEvents.emit('trackPurchaseClicked', {
        album: album,
        track: album.tracks.find(function (track) {
          return track.id === trackId;
        }),
        sendToDownloadPage: true,
        origin: 'player'
      });
    }
  }, {
    key: 'openTrackPage',
    value: function openTrackPage(trackId) {
      var album = this.album,
          settings = this.settings,
          playerApi = this.playerApi,
          statisticEvents = this.statisticEvents;

      openTrackInfoPage(playerApi, settings, album, trackId);

      statisticEvents.emit('viewTrackPage', { album: album, track: album.tracks.find(function (track) {
          return track.id === trackId;
        }) });
    }
  }, {
    key: 'getCurrentCoverInfo',
    value: function getCurrentCoverInfo() {
      var playback = this.playback;

      var _playback$getCoverDet = playback.getCoverDetails(),
          coverUrl = _playback$getCoverDet.coverUrl,
          imageWidth = _playback$getCoverDet.imageWidth,
          imageHeight = _playback$getCoverDet.imageHeight;

      var accName = l10n(playback.currentTrack ? 'player_acc_track_cover' : 'player_acc_album_cover');
      return {
        coverUrl: coverUrl,
        imageWidth: imageWidth,
        imageHeight: imageHeight,
        pixelRatio: this.pixelRatio,
        accName: accName
      };
    }
  }, {
    key: '_isEditingMode',
    get: function get() {
      return ViewMode.isModifying(this.settings.viewMode);
    }
  }, {
    key: 'albumTranslationKeys',
    get: function get() {
      return translationKeys[this.album.albumType];
    }
  }]);

  return AppController;
}();

exports.AppController = AppController;

/***/ }),
/* 23 */
/* no static exports found */
/* all exports used */
/*!*************************************************************************************!*\
  !*** ./scripts/player/v2/shared/components/album-titles/album-titles.controller.js ***!
  \*************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AlbumTitlesController = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _artistName = __webpack_require__(/*! ../../artist-name */ 20);

var getFullArtistName = _artistName.getFullArtistName;

var _viewMode = __webpack_require__(/*! ../../view-mode */ 15);

var ViewMode = _viewMode.ViewMode;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function lengthComparator(a, b) {
  if (a.length === b.length) {
    return 0;
  }
  return a.length < b.length ? 1 : -1;
}

var AlbumTitlesController = exports.AlbumTitlesController = function () {
  function AlbumTitlesController(_ref) {
    var playback = _ref.playback,
        album = _ref.album,
        settings = _ref.settings,
        albumTranslationKeys = _ref.albumTranslationKeys;

    _classCallCheck(this, AlbumTitlesController);

    this.album = album;
    this.playback = playback;
    this.settings = settings;
    this.albumTranslationKeys = albumTranslationKeys;
  }

  _createClass(AlbumTitlesController, [{
    key: 'getTrack',
    value: function getTrack() {
      var playback = this.playback;

      return playback.currentTrack || playback.getFirstTrack();
    }
  }, {
    key: 'getTrackName',
    value: function getTrackName() {
      var track = this.getTrack();
      return track ? track.name : null;
    }
  }, {
    key: 'getLongestTrackName',
    value: function getLongestTrackName() {
      var tracks = this.album.tracks;

      if (!tracks || !tracks.length) {
        return null;
      }
      return tracks.map(function (track) {
        return track.name;
      }).sort(lengthComparator)[0];
    }
  }, {
    key: 'getLongestArtistName',
    value: function getLongestArtistName() {
      var album = this.album;
      var tracks = album.tracks,
          artistName = album.artistName;

      if (!tracks || !tracks.length) {
        return artistName;
      }
      var longestTrackArtist = tracks.map(getFullArtistName).filter(Boolean).sort(lengthComparator)[0];
      return artistName.length > longestTrackArtist.length ? artistName : longestTrackArtist;
    }
  }, {
    key: 'getArtistName',
    value: function getArtistName() {
      var track = this.getTrack();
      var albumArtistName = this.album.artistName;

      return track ? getFullArtistName(track) : albumArtistName;
    }
  }, {
    key: 'shouldShowAddFirst',
    get: function get() {
      return ViewMode.isEditor(this.settings.viewMode);
    }
  }]);

  return AlbumTitlesController;
}();

/***/ }),
/* 24 */
/* no static exports found */
/* all exports used */
/*!*******************************************************************!*\
  !*** ./scripts/player/v2/shared/components/audio-player/index.js ***!
  \*******************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AudioPlayer = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _mithril = __webpack_require__(/*! mithril */ 0);

var m = _interopRequireDefault(_mithril).default;

var _appStatus = __webpack_require__(/*! ../../../../../app-status/app-status */ 6);

var appStatus = _appStatus.appStatus;

var _perfomance = __webpack_require__(/*! ../../../../../utils/perfomance */ 11);

var timeStart = _perfomance.timeStart;
var timeStop = _perfomance.timeStop;

var _audioComponent = __webpack_require__(/*! ./_audio-component */ 143);

var Audio = _audioComponent.Audio;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var playElement = function playElement(element) {
  var fallbackPromise = function fallbackPromise() {
    return new Promise(function (resolve, reject) {
      function playHandler() {
        resolve();
        element.removeEventListener('play', playHandler);
      }

      element.addEventListener('play', playHandler);
      setTimeout(function () {
        reject(new Error({ name: 'NotAllowedError', message: 'Play action did not raise "play" event' }));
        element.removeEventListener('play', playHandler);
      }, 100);
    });
  };
  var playPromise = element.play();
  if (playPromise && playPromise.then) {
    return playPromise;
  }
  return fallbackPromise();
};

var PreviousTrackInfo = function () {
  function PreviousTrackInfo() {
    _classCallCheck(this, PreviousTrackInfo);

    this.track = null;
    this.duration = 0;
    this.playTime = 0;
    this.stopPlayTime = 0;
  }

  _createClass(PreviousTrackInfo, [{
    key: 'getPlayingProgress',
    value: function getPlayingProgress() {
      return this.stopPlayTime / this.duration;
    }
  }, {
    key: 'isNotFullyPlayed',
    value: function isNotFullyPlayed() {
      return this.getPlayingProgress() < 0.9;
    }
  }]);

  return PreviousTrackInfo;
}();

var AudioPlayerController = function () {
  function AudioPlayerController(attrs) {
    _classCallCheck(this, AudioPlayerController);

    this.playback = attrs.playback;
    this.statisticEvents = attrs.statisticEvents;
    this.timeUpdateCallback = attrs.onTimeUpdate;
    this.loadedProgressCallback = attrs.onLoadedProgress;
    this.endedCallback = attrs.onEnded;
    this.previousTrackInfo = new PreviousTrackInfo();
    this.__tracksPlayed = new Set();
    this.__playCount = 0;
  }

  _createClass(AudioPlayerController, [{
    key: 'init',
    value: function init() {
      this.addHealthLogging();
      this.addTrackPlayLogging();
    }
  }, {
    key: 'addTrackPlayLogging',
    value: function addTrackPlayLogging() {
      var _this = this;

      var playback = this.playback,
          statisticEvents = this.statisticEvents,
          previousTrackInfo = this.previousTrackInfo;
      var origin = playback.currentOrigin;

      var listener = function listener(_ref) {
        var track = _ref.track;

        if (track === previousTrackInfo.track) {
          return;
        }
        statisticEvents.emit('trackPlayAttempt', {
          track: track,
          isAutoplay: playback.hasAutoplay && _this.__playCount === 0,
          origin: origin
        });
        _this.__playCount++;
      };
      playback.on('trackChange', listener);
    }
  }, {
    key: 'addHealthLogging',
    value: function addHealthLogging() {
      var playback = this.playback;

      var listener = function listener() {
        if (playback.isPlaying && playback.currentTrack) {
          timeStart('play-requested');
        }
      };
      playback.on('trackChange', listener);
    }
  }, {
    key: 'updateLoaded',
    value: function updateLoaded(_ref2) {
      var buffered = _ref2.buffered,
          duration = _ref2.duration,
          currentTime = _ref2.currentTime;
      var playback = this.playback;

      var progress = 0;
      for (var i = 0, l = buffered.length; i < l; i += 1) {
        if (currentTime >= buffered.start(i) && currentTime <= buffered.end(i)) {
          progress = buffered.end(i) / duration;
          break;
        }
      }

      playback.loadedProgress(progress);
      this.loadedProgressCallback(progress, playback.currentTrack.id);
    }
  }, {
    key: 'onEnded',
    value: function onEnded() {
      var playback = this.playback,
          previousTrackInfo = this.previousTrackInfo,
          statisticEvents = this.statisticEvents;
      var currentTrack = playback.currentTrack,
          origin = playback.currentOrigin;

      if (!currentTrack) {
        return;
      }

      statisticEvents.emit('trackPlayCompleted', { track: currentTrack, tracks: this.playback.tracks, origin: origin });
      previousTrackInfo.track = null;
      this.endedCallback(currentTrack.id);
      var isLast = playback.tracks.indexOf(currentTrack) === playback.tracks.length - 1;
      if (isLast) {
        playback.pause();
        return;
      }
      playback.isPlaying = true;
      playback.playNext();
    }
  }, {
    key: 'onTimeUpdate',
    value: function onTimeUpdate(_ref3) {
      var buffered = _ref3.buffered,
          currentTime = _ref3.currentTime,
          played = _ref3.played,
          duration = _ref3.duration;
      var previousTrackInfo = this.previousTrackInfo,
          playback = this.playback;

      if (!playback.isPlaying) {
        return;
      }
      playback.currentProgress(currentTime);
      this.updateLoaded({
        buffered: buffered,
        duration: playback.currentDuration(),
        currentTime: currentTime
      });
      previousTrackInfo.stopPlayTime = previousTrackInfo.playTime;
      previousTrackInfo.playTime = currentTime;
      this.timeUpdateCallback(currentTime, previousTrackInfo.getPlayingProgress(), playback.currentTrack.id, this.__getPlayedTime(played), duration);
    }
  }, {
    key: 'onPlaying',
    value: function onPlaying(_ref4) {
      var duration = _ref4.duration;
      var previousTrackInfo = this.previousTrackInfo,
          playback = this.playback;
      var currentTrack = playback.currentTrack;

      playback.isPlaying = true;
      if (previousTrackInfo.track === currentTrack) {
        return;
      }
      this.__logTrackPlay();

      previousTrackInfo.track = currentTrack;
      previousTrackInfo.duration = duration;
    }
  }, {
    key: 'onPause',
    value: function onPause() {
      var playback = this.playback;

      playback.isPlaying = false;
    }
  }, {
    key: 'onNetworkError',
    value: function onNetworkError() {
      var statisticEvents = this.statisticEvents,
          playback = this.playback;
      var origin = playback.currentOrigin;

      statisticEvents.emitOnce('playerAudioFailed', { track: playback.currentTrack, origin: origin });
    }
  }, {
    key: '__logTrackPlay',
    value: function __logTrackPlay() {
      var previousTrackInfo = this.previousTrackInfo,
          statisticEvents = this.statisticEvents,
          tracksPlayed = this.__tracksPlayed;
      var _playback = this.playback,
          currentTrack = _playback.currentTrack,
          origin = _playback.currentOrigin;

      appStatus.report('track-play', {
        latency: timeStop('play-requested'),
        isFirst: !tracksPlayed.has(currentTrack)
      });
      tracksPlayed.add(currentTrack);
      if (previousTrackInfo.track) {
        if (previousTrackInfo.isNotFullyPlayed()) {
          statisticEvents.emit('trackSkipped', { track: currentTrack, tracks: this.playback.tracks });
        } else {
          statisticEvents.emit('trackPlayCompleted', { track: currentTrack, tracks: this.playback.tracks });
        }
      }
      statisticEvents.emit('trackPlayStart', {
        track: currentTrack,
        tracks: this.playback.tracks,
        isAutoplay: this.playback.hasAutoplay && this.__playCount === 1,
        origin: origin
      });
    }
  }, {
    key: '__getPlayedTime',
    value: function __getPlayedTime(played) {
      var playedTime = 0;

      for (var i = 0; i < played.length; i += 1) {
        playedTime += played.end(i) - played.start(i);
      }

      return Math.floor(playedTime * 1000);
    }
  }]);

  return AudioPlayerController;
}();

var AudioPlayer = {
  controller: AudioPlayerController,

  view: function view(ctrl) {
    var playback = ctrl.playback;

    var audioUrl = playback.getCurrentAudioUrl() || '';
    var config = function config(element, isInitialized) {
      if (isInitialized) {
        return;
      }
      var setSrc = function setSrc(src) {
        if (element.src.indexOf(src) === -1) {
          // do not replace src if it is already set to prevent track rewind
          element.src = src;
        }
      };

      ctrl.init();
      playback.on('play', function (_ref5) {
        var track = _ref5.track;

        setSrc(track.url);
        playElement(element).catch(function () {
          return playback.emitPlayError();
        });
      });
      playback.on('pause', function () {
        element.pause();
      });

      playback.on('setUrl', function (_ref6) {
        var src = _ref6.src;

        setSrc(src);
      });
    };

    return m.component(Audio, {
      config: config,
      audioUrl: audioUrl,
      volume: playback.volume(),
      isPlaying: playback.isPlaying,
      currentProgress: playback.currentProgress(),
      onTimeUpdate: function onTimeUpdate(event) {
        return ctrl.onTimeUpdate(event.target);
      },
      onProgress: function onProgress(event) {
        return ctrl.updateLoaded(event.target);
      },
      onNetworkError: function onNetworkError() {
        return ctrl.onNetworkError();
      },
      title: playback.getCurrentTitle(),
      onEnded: function onEnded() {
        return ctrl.onEnded();
      },
      onPause: function onPause() {
        return ctrl.onPause();
      },
      onPlaying: function onPlaying(event) {
        return ctrl.onPlaying(event.target);
      }
    }, []);
  }
};

exports.AudioPlayer = AudioPlayer;

/***/ }),
/* 25 */
/* no static exports found */
/* all exports used */
/*!*******************************************************************!*\
  !*** ./scripts/player/v2/shared/components/progress-bar/index.js ***!
  \*******************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _progressBar = __webpack_require__(/*! ./progress-bar.component */ 149);

Object.defineProperty(exports, 'ProgressBar', {
  enumerable: true,
  get: function get() {
    return _progressBar.ProgressBar;
  }
});

/***/ }),
/* 26 */
/* no static exports found */
/* all exports used */
/*!**********************************************************************************************!*\
  !*** ./scripts/player/v2/shared/components/play-pause-button/play-pause-button.component.js ***!
  \**********************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PlayPauseButton = undefined;

var _classnames = __webpack_require__(/*! classnames */ 3);

var classNames = _interopRequireDefault(_classnames).default;

var _mithril = __webpack_require__(/*! mithril */ 0);

var m = _interopRequireDefault(_mithril).default;

var _utils = __webpack_require__(/*! ../../../../../utils/utils */ 2);

var utils = _utils.utils;

var _l10n = __webpack_require__(/*! ../../l10n */ 1);

var l10n = _l10n.l10n;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PlayPauseButton = exports.PlayPauseButton = {
  view: function view(ctrl, attrs) {
    var isPlaying = attrs.isPlaying,
        _attrs$isDisabled = attrs.isDisabled,
        isDisabled = _attrs$isDisabled === undefined ? false : _attrs$isDisabled,
        onAction = attrs.onAction,
        className = attrs.className,
        pauseIcon = attrs.pauseIcon,
        playIcon = attrs.playIcon;


    return {
      tag: 'button',
      children: [{
        tag: 'span',
        children: [l10n(isPlaying ? 'player_acc_play_live' : 'player_acc_pause_live')],
        attrs: { className: 'sr-only', 'aria-live': 'polite' }
      }, {
        tag: 'span',
        children: [isPlaying ? pauseIcon : playIcon],
        attrs: { 'aria-hidden': 'true' }
      }],
      attrs: {
        className: classNames({ play: !isPlaying, pause: isPlaying }, className),
        'aria-label': l10n(isPlaying ? 'player_acc_pause' : 'player_acc_play'),
        disabled: isDisabled,
        onclick: isDisabled ? utils.noop : onAction
      }
    };
  }
};

/***/ }),
/* 27 */
/* no static exports found */
/* all exports used */
/*!*************************************************************!*\
  !*** ./scripts/player/v2/shared/components/volume/index.js ***!
  \*************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _volume = __webpack_require__(/*! ./volume */ 245);

Object.defineProperty(exports, 'Volume', {
  enumerable: true,
  get: function get() {
    return _volume.Volume;
  }
});

var _volumeSlider = __webpack_require__(/*! ./volume-slider */ 93);

Object.defineProperty(exports, 'VolumeSlider', {
  enumerable: true,
  get: function get() {
    return _volumeSlider.VolumeSlider;
  }
});

/***/ }),
/* 28 */
/* no static exports found */
/* all exports used */
/*!*******************************************************!*\
  !*** ./scripts/player/v2/shared/icons/track-info.svg ***!
  \*******************************************************/
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"14\" viewBox=\"0 0 16 14\"><defs><style> .cls-1 { fill-rule: evenodd; } </style></defs><path class=\"cls-1\" d=\"M5.992,0.5a0.5,0.5,0,1,0-1,0V9.2a3.541,3.541,0,0,0-3.1.41c-1.558.912-2.3,2.46-1.677,3.517S2.545,14.3,4.1,13.384a3.413,3.413,0,0,0,1.889-2.7V0.5ZM8.5,2h7a0.5,0.5,0,0,0,0-1h-7A0.5,0.5,0,0,0,8.5,2Zm7,2h-7a0.5,0.5,0,0,0,0,1h7A0.5,0.5,0,0,0,15.493,4Zm0,3h-7a0.5,0.5,0,0,0,0,1h7A0.5,0.5,0,0,0,15.493,7Z\"></path></svg>"

/***/ }),
/* 29 */
/* no static exports found */
/* all exports used */
/*!****************************************************************!*\
  !*** ./scripts/player/v2/shared/components/buy-album/index.js ***!
  \****************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _buyAlbum = __webpack_require__(/*! ./buy-album.component */ 144);

Object.defineProperty(exports, 'BuyAlbum', {
  enumerable: true,
  get: function get() {
    return _buyAlbum.BuyAlbum;
  }
});

/***/ }),
/* 30 */
/* no static exports found */
/* all exports used */
/*!************************************************************************!*\
  !*** ./scripts/utils/handle-keyboard-slider/handle-keyboard-slider.js ***!
  \************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleHorizontalKeyboardSlider = exports.handleVerticalKeyboardSlider = exports.handleKeyboardSlider = undefined;

var _keyCodes = __webpack_require__(/*! ../../common/key-codes */ 39);

var ARROW_DOWN_KEY = _keyCodes.ARROW_DOWN_KEY;
var ARROW_LEFT_KEY = _keyCodes.ARROW_LEFT_KEY;
var ARROW_RIGHT_KEY = _keyCodes.ARROW_RIGHT_KEY;
var ARROW_UP_KEY = _keyCodes.ARROW_UP_KEY;
var handleKeyboardSlider = exports.handleKeyboardSlider = function handleKeyboardSlider(_ref) {
  var decrease = _ref.decrease,
      increase = _ref.increase;
  return function (event) {
    var keyCode = event.keyCode;

    if ([ARROW_DOWN_KEY, ARROW_UP_KEY, ARROW_LEFT_KEY, ARROW_RIGHT_KEY].indexOf(keyCode) === -1) {
      return;
    }
    event.preventDefault();
    event.stopPropagation();
    switch (keyCode) {
      case ARROW_DOWN_KEY:
      case ARROW_LEFT_KEY:
        decrease();
        break;
      case ARROW_RIGHT_KEY:
      case ARROW_UP_KEY:
        increase();
        break;
      default:
        break;
    }
  };
};

var handleVerticalKeyboardSlider = exports.handleVerticalKeyboardSlider = function handleVerticalKeyboardSlider(_ref2) {
  var decrease = _ref2.decrease,
      increase = _ref2.increase;
  return function (event) {
    var keyCode = event.keyCode;

    if ([ARROW_UP_KEY, ARROW_DOWN_KEY].indexOf(keyCode) === -1) {
      return;
    }
    event.preventDefault();
    event.stopPropagation();
    switch (keyCode) {
      case ARROW_DOWN_KEY:
        decrease();
        break;
      case ARROW_UP_KEY:
        increase();
        break;
      default:
        break;
    }
  };
};

var handleHorizontalKeyboardSlider = exports.handleHorizontalKeyboardSlider = function handleHorizontalKeyboardSlider(_ref3) {
  var decrease = _ref3.decrease,
      increase = _ref3.increase;
  return function (event) {
    var keyCode = event.keyCode;

    if ([ARROW_RIGHT_KEY, ARROW_LEFT_KEY].indexOf(keyCode) === -1) {
      return;
    }
    event.preventDefault();
    event.stopPropagation();
    switch (keyCode) {
      case ARROW_LEFT_KEY:
        decrease();
        break;
      case ARROW_RIGHT_KEY:
        increase();
        break;
      default:
        break;
    }
  };
};

/***/ }),
/* 31 */
/* no static exports found */
/* all exports used */
/*!************************************************!*\
  !*** ./scripts/common/transform-collection.js ***!
  \************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (collection, widgetSettings) {
  widgetSettings = widgetSettings || {};

  var collectionPublicProperties = collection.public_properties;
  var now = Date.now();

  if (!collectionPublicProperties) {
    // collection is already transformed

    return Promise.resolve(collection);
  }

  var l10n = translations(widgetSettings.locale);

  var urlPrefixes = utils.defaults(widgetSettings.urlPrefixes, {
    audio: config.hosts.audios,
    image: config.hosts.images
  });

  function removeLeadingSlashesAndProtocol(url) {
    return url.replace(/^\/(?!\/)/, '').replace(/https?:/, '');
  }

  function fixCover(cover) {
    if (!cover) {
      return '';
    }

    cover = removeLeadingSlashesAndProtocol(cover);
    if (!utils.isAbsoluteUrl(cover)) {
      if (!/^media\//.test(cover)) {
        cover = 'media/' + cover;
      }
      cover = urlPrefixes.image + cover;
    }
    return cover;
  }

  var albumCover = fixCover(collectionPublicProperties.albumCover);

  var currency = collectionPublicProperties.albumCurrency;
  var currencySymbol = collectionPublicProperties.albumCurrencySymbol || currency || '';
  var albumPrice = Number(collectionPublicProperties.albumPrice);
  var albumType = collectionPublicProperties.albumType || constants.ALBUM_TYPES.ALBUM;

  var albumName = collectionPublicProperties.albumName;
  var albumVersion = collectionPublicProperties.albumVersion;
  if (albumVersion && albumVersion !== constants.MUSIC_VERSIONS.EMPTY) {
    albumVersion = l10n[constants.MUSIC_VERSIONS_LABELS[albumVersion]];
    albumName = albumName + ' (' + albumVersion + ')';
  }

  var description = collectionPublicProperties.albumDetails;

  var transformed = {
    tracks: [],
    album: {
      id: collection.id,
      cover: albumCover,
      url: config.hosts.collections + 'collections/' + collection.id + '.json',
      name: albumName,
      currentName: widgetSettings.playerStyle === 'detailed' || widgetSettings.playerStyle === 'sleek' ? ' / ' + albumName : '',
      artistName: collectionPublicProperties.artistName,
      purchaseAvail: collectionPublicProperties.purchaseAvail,
      currency: currency,
      currencySymbol: currencySymbol,
      description: description,
      md5: now,
      imageWidth: collectionPublicProperties.imageWidth,
      imageHeight: collectionPublicProperties.imageHeight,
      ratio: collectionPublicProperties.imageWidth / collectionPublicProperties.imageHeight,
      albumPrice: albumPrice,
      albumType: albumType,
      owner: collection.owner_id,
      externalLinks: collectionPublicProperties.isAlbumExternalLinksEnabled ? collectionPublicProperties.albumExternalLinks : null,
      demo: Boolean(collectionPublicProperties.demo)
    }
  };

  collection.items.forEach(function (item) {
    var itemPublicProperties = item.public_properties;
    if (itemPublicProperties.invalid) {
      return;
    }

    var trackCover = fixCover(itemPublicProperties.trackCover);

    var trackUrl = removeLeadingSlashesAndProtocol(itemPublicProperties.trackURL);
    var trackPrice = Number(itemPublicProperties.trackPrice);

    if (!utils.isAbsoluteUrl(trackUrl)) {
      trackUrl = urlPrefixes.audio + trackUrl;
    }

    var trackName = itemPublicProperties.trackName;
    var trackVersion = itemPublicProperties.trackVersion;
    if (trackVersion && trackVersion !== constants.TRACK_VERSIONS.EMPTY) {
      trackVersion = l10n[constants.TRACK_VERSIONS_LABELS[trackVersion]];
      trackName = trackName + ' (' + trackVersion + ')';
    }

    var isPreview = itemPublicProperties.previewType === constants.PREVIEW_TYPES.PREVIEW_30;
    var trackDuration = itemPublicProperties.trackDuration;
    var trackLength = utils.stringToDuration(trackDuration);
    var previewDuration = trackDuration;
    var previewLength = trackLength;
    if (isPreview) {
      previewLength = Math.min(previewLength, constants.PREVIEW_LENGTH.PREVIEW_30);
      previewDuration = '00:' + previewLength;
    }

    var lyrics = itemPublicProperties.trackLyrics;

    var trackExternalLinks = function trackExternalLinks() {
      if (!itemPublicProperties.isTrackExternalLinksEnabled) {
        return false;
      }
      return itemPublicProperties.trackExternalLinks.length ? itemPublicProperties.trackExternalLinks : transformed.album.externalLinks;
    };

    transformed.tracks.push({
      id: item.id,
      name: trackName,
      length: trackLength,
      duration: trackDuration,
      previewLength: previewLength,
      previewDuration: previewDuration,
      lyrics: lyrics,
      url: trackUrl,
      cover: trackCover,
      artistName: itemPublicProperties.artistName || transformed.album.artistName,
      currency: currency,
      currencySymbol: currencySymbol,
      purchaseAvail: itemPublicProperties.purchaseAvail,
      imageWidth: itemPublicProperties.imageWidth,
      imageHeight: itemPublicProperties.imageHeight,
      ratio: itemPublicProperties.imageWidth / itemPublicProperties.imageHeight,
      trackPrice: trackPrice,
      isPreview: isPreview,
      collaborationType: itemPublicProperties.collaborationType,
      collaborators: itemPublicProperties.collaborators,
      externalLinks: trackExternalLinks()
    });
  });

  return getCurrencies().then(function (currenciesData) {
    var currencyData = currenciesData[currency] || currenciesData.USD;
    var offset = currencyData.offset !== undefined ? currencyData.offset : 2;

    transformed.album.albumPriceFormatted = transformed.album.albumPrice.toFixed(offset);
    transformed.tracks.forEach(function (track) {
      track.trackPriceFormatted = track.trackPrice.toFixed(offset);
    });

    return transformed;
  });
};

var _utils = __webpack_require__(/*! ../utils/utils */ 2);

var utils = _utils.utils;

var _config = __webpack_require__(/*! ./config */ 9);

var config = _interopRequireDefault(_config).default;

var _constants = __webpack_require__(/*! ./constants */ 5);

var constants = _interopRequireDefault(_constants).default;

var _currencies = __webpack_require__(/*! ./currencies */ 135);

var getCurrencies = _currencies.getCurrencies;

var _translations = __webpack_require__(/*! ./translations */ 40);

var translations = _interopRequireDefault(_translations).default;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 32 */
/* no static exports found */
/* all exports used */
/*!*********************************!*\
  !*** ./scripts/player/cache.js ***!
  \*********************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CACHE = Symbol('cache');

var DefaultCache = exports.DefaultCache = function () {
  function DefaultCache(construct) {
    _classCallCheck(this, DefaultCache);

    this.construct = construct;
    this[CACHE] = new WeakMap();
  }

  _createClass(DefaultCache, [{
    key: 'get',
    value: function get(key) {
      if (!this[CACHE].has(key)) {
        var value = this.construct.call(null);
        this[CACHE].set(key, value);
        return value;
      }
      return this[CACHE].get(key);
    }
  }, {
    key: 'set',
    value: function set(key, value) {
      this.this[CACHE].set(key, value);
    }
  }]);

  return DefaultCache;
}();

/***/ }),
/* 33 */
/* no static exports found */
/* all exports used */
/*!*********************************************!*\
  !*** ./scripts/common/parse-settings/v2.js ***!
  \*********************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.parseSettingsV2 = parseSettingsV2;

var _deepFreeze = __webpack_require__(/*! deep-freeze */ 54);

var deepFreeze = _interopRequireDefault(_deepFreeze).default;

var _viewMode = __webpack_require__(/*! ../../player/v2/shared/view-mode */ 15);

var getSdkViewMode = _viewMode.getSdkViewMode;

var _colors = __webpack_require__(/*! ../../utils/colors */ 156);

var colorToRGBA = _colors.colorToRGBA;
var makeRGBA = _colors.makeRGBA;

var _cookie = __webpack_require__(/*! ../../utils/cookie */ 157);

var cookie = _interopRequireDefault(_cookie).default;

var _utils = __webpack_require__(/*! ../../utils/utils */ 2);

var utils = _utils.utils;

var _config = __webpack_require__(/*! ../config */ 9);

var config = _interopRequireDefault(_config).default;

var _defaultSettings = __webpack_require__(/*! ../default-settings */ 53);

var defaultSettingsV2 = _defaultSettings.defaultSettingsV2;

var _translations = __webpack_require__(/*! ../translations */ 40);

var translations = _interopRequireDefault(_translations).default;

var _v2SettingsConstants = __webpack_require__(/*! ./v2-settings-constants */ 4);

var ALBUM_COVER_SCALING = _v2SettingsConstants.ALBUM_COVER_SCALING;
var BUTTON_STYLES = _v2SettingsConstants.BUTTON_STYLES;
var HORIZONTAL_ALBUM_COVER_SCALING = _v2SettingsConstants.HORIZONTAL_ALBUM_COVER_SCALING;
var INFO_PLACEMENT = _v2SettingsConstants.INFO_PLACEMENT;
var LAYOUT_TYPES = _v2SettingsConstants.LAYOUT_TYPES;
var LIST_COVER_SIZE = _v2SettingsConstants.LIST_COVER_SIZE;
var MIN_WIDTH_BY_LAYOUT = _v2SettingsConstants.MIN_WIDTH_BY_LAYOUT;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function fixFont(value) {
  if (utils.isFunction(value)) {
    value = value();
  }
  return utils.isString(value) ? value.replace(/^font:/i, '').replace(/;$/, '') : value;
}

function getFontSize(font) {
  var element = document.createElement('div');
  element.style.font = font;
  return parseInt(element.style.fontSize, 10);
}

function getLineHeight(font) {
  var element = document.createElement('div');
  element.style.font = font;
  var _element$style = element.style,
      lineHeight = _element$style.lineHeight,
      fontSize = _element$style.fontSize;

  if (lineHeight.match(/em$/i)) {
    return Math.floor(parseInt(fontSize, 10) * parseFloat(lineHeight));
  }
  return parseInt(lineHeight, 10);
}

function getBuyShareTopMargin(buyShareLinksFont) {
  return -Math.max(0, 22 - getFontSize(buyShareLinksFont));
}

function getListTrackExtraPadding(trackInfoShowArtistName, trackFontParsed) {
  var trackMinSize = trackInfoShowArtistName ? 2 * trackFontParsed : trackFontParsed;

  return trackMinSize > LIST_COVER_SIZE ? 8 : 0;
}

function parseSettingsV2(widgetSettings) {
  var _LAYOUT_TYPES$HORIZON, _mobileBuyShareLinksV, _buttonStyles, _minWidth;

  widgetSettings = utils.defaults({}, widgetSettings, defaultSettingsV2);

  var parsedCss = {
    backgroundColor: widgetSettings.colors.backgroundColor.value,
    buyShareLinksColor: widgetSettings.colors.buyShareLinksColor.value,
    trackTitleColor: widgetSettings.colors.trackTitleColor.value,
    albumArtistColor: widgetSettings.colors.albumArtistColor.value,
    controlBarColor: widgetSettings.colors.controlBarColor.value,
    trackColor: widgetSettings.colors.trackColor.value,
    dividersColor: widgetSettings.colors.dividersColor.value,
    activeTrackColor: widgetSettings.colors.activeTrackColor.value,
    borderColor: widgetSettings.colors.borderColor.value,

    buyShareLinksFont: fixFont(widgetSettings.fonts.buyShareLinksFont.value),
    trackTitleFont: fixFont(widgetSettings.fonts.trackTitleFont.value),
    albumArtistFont: fixFont(widgetSettings.fonts.albumArtistFont.value),
    trackFont: fixFont(widgetSettings.fonts.trackFont.value),
    activeTrackButtonsFont: fixFont(widgetSettings.fonts.activeTrackButtonsFont.value),

    trackListMargins: Math.round(widgetSettings.numbers.trackListMargins),
    borderWidth: Math.round(widgetSettings.numbers.borderWidth),
    width: widgetSettings.width,
    horizontalMinWidth: widgetSettings.horizontalMinWidth || MIN_WIDTH_BY_LAYOUT[LAYOUT_TYPES.HORIZONTAL],
    mobileMinWidth: widgetSettings.mobileMinWidth || MIN_WIDTH_BY_LAYOUT[LAYOUT_TYPES.MOBILE]
  };

  var multiply = function multiply(multiplier) {
    return function (value) {
      return multiplier * value;
    };
  };

  var _colorToRGBA = colorToRGBA(parsedCss.backgroundColor),
      _colorToRGBA2 = _slicedToArray(_colorToRGBA, 4),
      backgroundOpacity = _colorToRGBA2[3];

  var locale = widgetSettings.locale || cookie.get('wixLanguage');
  var albumCoverShow = widgetSettings.numbers.albumCoverScaling !== ALBUM_COVER_SCALING.HIDE;
  var horizontalAlbumCoverShow = widgetSettings.numbers.horizontalAlbumCoverScaling !== HORIZONTAL_ALBUM_COVER_SCALING.HIDE;
  var layout = widgetSettings.numbers.layout;
  var mobileAlbumCoverShow = (_LAYOUT_TYPES$HORIZON = {}, _defineProperty(_LAYOUT_TYPES$HORIZON, LAYOUT_TYPES.HORIZONTAL, horizontalAlbumCoverShow), _defineProperty(_LAYOUT_TYPES$HORIZON, LAYOUT_TYPES.VERTICAL, albumCoverShow), _LAYOUT_TYPES$HORIZON)[layout];
  var mobileBuyShareLinksValues = (_mobileBuyShareLinksV = {}, _defineProperty(_mobileBuyShareLinksV, LAYOUT_TYPES.HORIZONTAL, {
    mobileBuyShareLinksColor: parsedCss.activeTrackColor,
    mobileBuyShareLinksColorDisabled: makeRGBA(parsedCss.activeTrackColor, multiply(0.4)),
    mobileBuyShareLinksFont: parsedCss.albumArtistFont
  }), _defineProperty(_mobileBuyShareLinksV, LAYOUT_TYPES.VERTICAL, {
    mobileBuyShareLinksColor: parsedCss.buyShareLinksColor,
    mobileBuyShareLinksColorDisabled: parsedCss.buyShareLinksColorDisabled,
    mobileBuyShareLinksFont: parsedCss.buyShareLinksFont
  }), _defineProperty(_mobileBuyShareLinksV, LAYOUT_TYPES.LIST, {
    mobileBuyShareLinksColor: parsedCss.buyShareLinksColor,
    mobileBuyShareLinksColorDisabled: parsedCss.buyShareLinksColorDisabled,
    mobileBuyShareLinksFont: parsedCss.buyShareLinksFont
  }), _mobileBuyShareLinksV);
  var buttonStyles = (_buttonStyles = {}, _defineProperty(_buttonStyles, LAYOUT_TYPES.HORIZONTAL, widgetSettings.numbers.buttonStyle), _defineProperty(_buttonStyles, LAYOUT_TYPES.VERTICAL, BUTTON_STYLES.RECT_FILL), _defineProperty(_buttonStyles, LAYOUT_TYPES.LIST, widgetSettings.numbers.buttonStyle), _buttonStyles);
  var mobileBuyShareLinks = mobileBuyShareLinksValues[layout];

  var trackInfoShowArtistName = Boolean(widgetSettings.numbers.trackInfoShowArtistName);
  var trackFontParsed = getFontSize(parsedCss.trackFont);

  var isFullWidth = widgetSettings.booleans.isFullWidth;
  var listSpacing = isFullWidth ? widgetSettings.numbers.listSpacing : 0;
  var listTrackExtraPadding = getListTrackExtraPadding(trackInfoShowArtistName, trackFontParsed);

  parsedCss = _extends({}, parsedCss, {
    trackRowHeight: trackFontParsed + 2 * (parsedCss.trackListMargins + 15),
    buyShareTopMargin: getBuyShareTopMargin(parsedCss.buyShareLinksFont) / 2,
    buyShareBottomMargin: getBuyShareTopMargin(parsedCss.buyShareLinksFont) / 2,
    backgroundColor04: makeRGBA(parsedCss.backgroundColor, 0.4),
    backgroundColor08: makeRGBA(parsedCss.backgroundColor, 0.8),
    backgroundColor088: makeRGBA(parsedCss.backgroundColor, 0.88),
    backgroundColor09: makeRGBA(parsedCss.backgroundColor, 0.9),
    backgroundColor10: makeRGBA(parsedCss.backgroundColor, 1),
    trackTitleColor092: makeRGBA(parsedCss.trackTitleColor, 0.92),
    volumeBarBorderColor: makeRGBA(parsedCss.controlBarColor, 0.1),
    volumeBarNotActiveColor: makeRGBA(parsedCss.controlBarColor, 0.3),
    controlBarColor02: makeRGBA(parsedCss.controlBarColor, 0.2),
    trackColor02: makeRGBA(parsedCss.trackColor, 0.2),
    trackColor03: makeRGBA(parsedCss.trackColor, 0.3),
    trackColor06: makeRGBA(parsedCss.trackColor, 0.8),
    activeTrackColor03: makeRGBA(parsedCss.activeTrackColor, 0.3),
    activeTrackColor04: makeRGBA(parsedCss.activeTrackColor, 0.4),
    activeTrackColor05: makeRGBA(parsedCss.activeTrackColor, 0.5),
    activeTrackColor06: makeRGBA(parsedCss.activeTrackColor, 0.8),
    activeTrackColor10: makeRGBA(parsedCss.activeTrackColor, 1),
    dividersColor10: makeRGBA(parsedCss.dividersColor, 1),
    controlBarColorDisabled: makeRGBA(parsedCss.controlBarColor, multiply(0.4)),
    buyShareLinksColorDisabled: makeRGBA(parsedCss.buyShareLinksColor, multiply(0.4)),
    buyShareLinksLineHeight: getLineHeight(parsedCss.buyShareLinksFont),
    activeTrackColorHover: makeRGBA(parsedCss.activeTrackColor, 0.7),
    transparentWhite: makeRGBA('#ffffff', backgroundOpacity),
    listTrackExtraPadding: listTrackExtraPadding,
    listCoverSize: LIST_COVER_SIZE
  }, mobileBuyShareLinks, {
    listSpacing: listSpacing
  });

  return deepFreeze({
    locale: locale,
    isMobileView: widgetSettings.isMobileView !== undefined ? widgetSettings.isMobileView : utils.isMobileView(),
    l10n: translations(locale),
    urlPrefixes: widgetSettings.urlPrefixes,
    width: widgetSettings.width,
    siteUrl: widgetSettings.siteUrl || location.href,
    baseUrl: widgetSettings.baseUrl,
    pageId: widgetSettings.pageId,
    tpaApplicationId: widgetSettings.tpaApplicationId,
    rect: widgetSettings.rect,
    scale: widgetSettings.scale || 1,
    viewMode: widgetSettings.viewMode || getSdkViewMode(),
    paymentsId: widgetSettings.paymentsId,
    instanceId: widgetSettings.instanceId,
    metasiteId: widgetSettings.metasiteId,
    sessionToken: widgetSettings.sessionToken,
    biToken: widgetSettings.biToken,
    sToken: widgetSettings.sToken,
    compId: widgetSettings.compId,
    userId: widgetSettings.userId,
    getWindowUrl: widgetSettings.getWindowUrl || config.hosts.getWindowUrl.replace('${getWindowVersion}', widgetSettings.getWindowVersion),
    artifactVersion: widgetSettings.artifactVersion,
    sharedTrackId: Number(widgetSettings.sharedTrackId),
    showDetailedTrackInfo: !widgetSettings.hideDetailedTrackInfo,

    albumCoverShow: albumCoverShow,
    horizontalAlbumCoverShow: horizontalAlbumCoverShow,
    mobileAlbumCoverShow: mobileAlbumCoverShow,
    layout: layout,
    trackListShow: widgetSettings.booleans.trackListShow,
    trackInfoShowArtistName: trackInfoShowArtistName,
    buttonStyle: buttonStyles[layout],
    albumCoverScaling: widgetSettings.numbers.albumCoverScaling,
    horizontalAlbumCoverScaling: widgetSettings.numbers.horizontalAlbumCoverScaling,
    infoPlacement: albumCoverShow ? widgetSettings.numbers.infoPlacement : INFO_PLACEMENT.BELOW,
    controlBarType: widgetSettings.numbers.controlBarType,
    horizontalControlBarType: widgetSettings.numbers.horizontalControlBarType,
    trackActionsShow: widgetSettings.numbers.trackActionsShow,
    showTrackDuration: widgetSettings.booleans.showTrackDuration,
    canShareAlbum: widgetSettings.booleans.albumShare,
    canShareTrack: widgetSettings.booleans.trackShare,
    showAlbumInfo: widgetSettings.booleans.showAlbumInfo,
    listLayoutTrackStyle: widgetSettings.numbers.listLayoutTrackStyle,
    isFullWidth: isFullWidth,
    autoplay: widgetSettings.autoplay !== undefined ? widgetSettings.autoplay : widgetSettings.booleans.autoplay,
    parsedCss: parsedCss,
    minWidth: (_minWidth = {}, _defineProperty(_minWidth, LAYOUT_TYPES.HORIZONTAL, widgetSettings.horizontalMinWidth), _defineProperty(_minWidth, LAYOUT_TYPES.MOBILE, widgetSettings.mobileMinWidth), _minWidth),
    experiments: widgetSettings.experiments || {}
  });
}

/***/ }),
/* 34 */
/* no static exports found */
/* all exports used */
/*!**************************************************!*\
  !*** ./scripts/player/build-cover-dimensions.js ***!
  \**************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RESIZE_MODE = undefined;
exports.getScaledImageSize = getScaledImageSize;
exports.getFitDimensions = getFitDimensions;
exports.getCropDimensions = getCropDimensions;
exports.getFixedDimensions = getFixedDimensions;
exports.getCoverDimensions = getCoverDimensions;
exports.getContainerDimensions = getContainerDimensions;

var _deprecated = __webpack_require__(/*! ../utils/deprecated.js */ 7);

var deprecated = _deprecated.deprecated;

var _utils = __webpack_require__(/*! ../utils/utils */ 2);

var utils = _utils.utils;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var RESIZE_MODE = exports.RESIZE_MODE = {
  MOBILE: 'MOBILE',
  FIT: 'FIT',
  CROP: 'CROP',
  FIXED: 'FIXED'
};

function getScaledImageSize(_ref) {
  var imageWidth = _ref.imageWidth,
      imageHeight = _ref.imageHeight,
      coverWidth = _ref.coverWidth,
      coverHeight = _ref.coverHeight,
      pixelRatio = _ref.pixelRatio;

  var maximumHorizontalScalingFactor = imageWidth / coverWidth;
  var maximumVerticalScalingFactor = imageHeight / coverHeight;
  var maximumScalingFactor = Math.min(maximumHorizontalScalingFactor, maximumVerticalScalingFactor);
  var scalingFactor = Math.min(maximumScalingFactor, pixelRatio);
  var coverWidthScaled = coverWidth * scalingFactor;
  var coverHeightScaled = coverHeight * scalingFactor;

  return { coverWidthScaled: coverWidthScaled, coverHeightScaled: coverHeightScaled };
}

function getFitDimensions(_ref2) {
  var containerWidth = _ref2.containerWidth,
      imageWidth = _ref2.imageWidth,
      imageHeight = _ref2.imageHeight;

  var ratio = imageWidth / imageHeight;
  var containerHeight = Math.min(containerWidth / ratio, imageHeight);

  return {
    containerWidth: containerWidth,
    containerHeight: containerHeight
  };
}

function getCropDimensions(_ref3) {
  var containerWidth = _ref3.containerWidth,
      imageHeight = _ref3.imageHeight;

  var containerHeight = Math.min(330, imageHeight);

  return {
    containerWidth: containerWidth,
    containerHeight: containerHeight
  };
}

function getFixedDimensions(_ref4) {
  var containerWidth = _ref4.containerWidth;

  //noinspection JSSuspiciousNameCombination
  var containerHeight = containerWidth;

  return {
    containerWidth: containerWidth,
    containerHeight: containerHeight
  };
}

function getCoverDimensions(_ref5) {
  var containerWidth = _ref5.containerWidth,
      containerHeight = _ref5.containerHeight,
      imageWidth = _ref5.imageWidth,
      imageHeight = _ref5.imageHeight;

  var coverWidth = Math.min(containerWidth, imageWidth);
  var coverHeight = Math.min(containerHeight, imageHeight);

  return {
    coverWidth: Math.floor(coverWidth),
    coverHeight: Math.floor(coverHeight)
  };
}

function getContainerDimensions(_ref6) {
  var _resizeFn;

  var mode = _ref6.mode,
      containerWidth = _ref6.containerWidth,
      imageWidth = _ref6.imageWidth,
      imageHeight = _ref6.imageHeight;

  var resizeFn = (_resizeFn = {}, _defineProperty(_resizeFn, RESIZE_MODE.FIT, getFitDimensions), _defineProperty(_resizeFn, RESIZE_MODE.CROP, getCropDimensions), _defineProperty(_resizeFn, RESIZE_MODE.FIXED, getFixedDimensions), _resizeFn);

  var _resizeFn$mode = resizeFn[mode]({ containerWidth: containerWidth, imageWidth: imageWidth, imageHeight: imageHeight }),
      containerHeight = _resizeFn$mode.containerHeight;

  return {
    containerWidth: Math.floor(containerWidth),
    containerHeight: Math.floor(containerHeight)
  };
}

exports.default = deprecated(function buildCoverDimensionsLegacy(settings, coverSource) {
  var cover = coverSource.cover;
  var imageWidth = coverSource.imageWidth,
      imageHeight = coverSource.imageHeight,
      ratio = coverSource.ratio;

  var pixelRatio = Math.max(window.devicePixelRatio || 1, 1);

  var coverWidth = void 0,
      coverHeight = void 0;
  var coverParentWidth = void 0,
      coverParentHeight = 200;
  var coverWidthScaled = void 0,
      coverHeightScaled = void 0;

  var _settings$parsedCss = settings.parsedCss,
      paddings = _settings$parsedCss.paddings,
      borderWidth = _settings$parsedCss.borderWidth;

  // coverParent - px, for parent element
  // cover - px, background-size
  // coveScaled - px * pixelRatio, for image scaling

  coverParentWidth = settings.width;
  coverParentWidth -= (paddings + borderWidth) * 2;

  imageWidth = imageWidth || coverParentWidth;

  if (utils.isMobileView()) {
    coverParentHeight = coverParentWidth;

    imageHeight = imageHeight || coverParentHeight;
    coverWidthScaled = Math.min(coverParentWidth * pixelRatio, imageWidth);
    coverHeightScaled = Math.min(coverParentHeight * pixelRatio, imageHeight);
    coverParentHeight = Math.max(coverParentHeight, coverHeightScaled);

    coverWidth = coverWidthScaled / pixelRatio;
    coverHeight = coverHeightScaled / pixelRatio;

    coverParentHeight = Math.min(coverParentHeight, coverHeight);
  } else if (settings.coverSize === 'small') {
    imageHeight = imageHeight || coverParentHeight;
    coverHeightScaled = Math.min(coverParentHeight * pixelRatio, imageHeight);
    coverWidthScaled = coverHeightScaled;

    coverHeight = coverHeightScaled / pixelRatio;
    coverWidth = coverWidthScaled / pixelRatio;
  } else {
    coverWidthScaled = Math.min(coverParentWidth * pixelRatio, imageWidth);

    imageHeight = imageHeight || coverParentHeight;
    ratio = ratio || imageWidth / imageHeight;
    if (settings.coverStyle === 'crop') {
      coverHeightScaled = Math.min(330 * pixelRatio, imageHeight);
    } else {
      coverHeightScaled = coverWidthScaled / ratio;
    }
    coverParentHeight = Math.max(coverParentHeight, coverHeightScaled);

    coverHeight = coverHeightScaled / pixelRatio;
    coverWidth = coverWidthScaled / pixelRatio;

    coverParentHeight = Math.min(coverParentHeight, coverHeight);
  }

  coverWidthScaled = Math.floor(coverWidthScaled);
  coverHeightScaled = Math.floor(coverHeightScaled);

  coverParentWidth = Math.floor(coverParentWidth);
  coverParentHeight = Math.floor(coverParentHeight);

  coverWidth = Math.floor(coverWidth);
  coverHeight = Math.floor(coverHeight);

  return {
    coverParentWidth: coverParentWidth,
    coverParentHeight: coverParentHeight,
    coverWidth: coverWidth,
    coverHeight: coverHeight,
    coverUrl: cover,
    coverUrlScaled: utils.buildScaledImageUrl(cover, 'fill', coverWidthScaled, coverHeightScaled)
  };
});

/***/ }),
/* 35 */
/* no static exports found */
/* all exports used */
/*!*********************************!*\
  !*** ./scripts/utils/assert.js ***!
  \*********************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.assert = assert;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AssertionError = exports.AssertionError = function (_Error) {
  _inherits(AssertionError, _Error);

  function AssertionError(message, details) {
    _classCallCheck(this, AssertionError);

    var _this = _possibleConstructorReturn(this, (AssertionError.__proto__ || Object.getPrototypeOf(AssertionError)).call(this, message));

    _this.name = 'AssertionError';
    _this.message = message;
    Error.captureStackTrace(_this, _this.constructor.name);
    _this.details = details;
    return _this;
  }

  return AssertionError;
}(Error);

function assert(condition, message) {
  var details = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  if (!condition) {
    throw new AssertionError(message, details);
  }
}

/***/ }),
/* 36 */
/* no static exports found */
/* all exports used */
/*!******************************************************************!*\
  !*** ./scripts/player/v2/shared/components/share-icons/index.js ***!
  \******************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _shareIcons = __webpack_require__(/*! ./share-icons.component */ 180);

Object.defineProperty(exports, 'ShareIcons', {
  enumerable: true,
  get: function get() {
    return _shareIcons.ShareIcons;
  }
});

/***/ }),
/* 37 */
/* no static exports found */
/* all exports used */
/*!***********************************************!*\
  !*** ./scripts/player/v2/shared/app/index.js ***!
  \***********************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _app = __webpack_require__(/*! ./app */ 140);

Object.defineProperty(exports, 'App', {
  enumerable: true,
  get: function get() {
    return _app.App;
  }
});

/***/ }),
/* 38 */
/* no static exports found */
/* all exports used */
/*!****************************!*\
  !*** ./l10n/texts_en.json ***!
  \****************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = { "app_title": "Wix Player", "app_description": "Make it easy for fans to listen, download and purchase your work and check your music's play and download stats.", "player_album": "Album", "player_acc_track_cover": "Track Cover", "player_acc_album_cover": "Album Cover", "player_acc_mute": "Mute", "player_acc_unmute": "Unmute", "player_acc_volume_value": "%s volume", "player_acc_track_played": "Track played: %s", "player_acc_track_duration": "Track duration: %s", "player_acc_progressbar": "Progress Bar", "player_acc_play": "Play", "player_acc_play_live": "Track is playing", "player_acc_pause": "Pause", "player_acc_pause_live": "Track paused", "player_acc_prev": "Previous track", "player_acc_next": "Next track", "player_acc_close": "Close", "player_acc_share": "Share", "player_acc_tracklist_play_track": "Play track number %s: %s", "player_acc_tracklist_pause_track": "Pause selected track number %s: %s", "player_acc_share_dialog": "Share", "player_acc_share_album_dialog": "Share Album", "player_acc_share_single_dialog": "Share Single", "player_acc_track_info_dialog": "Track info", "player_acc_share_playlist_dialog": "Share Playlist", "player_acc_buy_track": "Buy track for %s", "player_acc_buy_album": "Buy album for %s", "player_acc_progress_value": "%s of %s", "player_acc_tracklist": "%s track list", "player_acc_track_info": "Track info", "player_acc_share_on_facebook": "Share on Facebook", "player_acc_share_on_twitter": "Share on Twitter", "player_acc_share_on_tumblr": "Share on Tumblr", "player_acc_share_on_blogger": "Share on Blogger", "player_acc_album_description": "Album description", "player_buy_album": "Buy Album", "player_download_album": "Download Album", "player_get_album": "Get Album", "player_get_single": "Get Single", "player_get_track": "Get Track", "player_single": "Single", "player_buy_single": "Buy Single", "player_download_single": "Download Single", "player_download": "Download", "player_download_track": "Download Track", "player_share": "Share", "player_share_album": "Share Album", "player_share_single": "Share Single", "player_share_playlist": "Share Playlist", "player_buy_song": "Buy Track", "player_track": "Track", "player_free_song": "Free Download", "player_free": "Free", "player_share_song": "Share Track", "player_show_all_tracks": "Show all tracks", "player_tracks_total": "%s Total", "player_track_out_of": "Track %s (Out of %s)", "player_lyrics": "Track Info", "player_shuffle": "Shuffle", "player_previous": "Previous", "player_play": "Play", "player_pause": "Pause", "player_next": "Next", "player_repeat": "Repeat", "player_no_tracks": "Add your first track!", "player_no_tracks_publish": "This album's coming soon!", "player_no_tracks_publish_single": "This single's coming soon!", "player_no_tracks_publish_playlist": "This playlist's coming soon!", "player_no_tracks_track_name": "Track Name", "player_no_tracks_artist_name": "Artist Name", "track_page_lyrics": "Lyrics", "player_mobile_share": "Share", "player_mobile_share_this_album": "Share this Album:", "player_mobile_share_this_song": "Share this Track:", "player_mobile_view_more": "View More", "player_mobile_view_less": "View Less", "player_sharing_text": "checkout this cool music", "player_payment_got_it": "Got it", "player_payment_preview_mode": "Preview Mode", "player_payment_preview_error": "Hey, you’re in Preview Mode.\nThis feature works on your live site once it’s published.", "player_music_album_versions_empty": "—", "player_music_album_versions_remixes": "Remixes", "player_music_album_versions_remastered": "Remastered", "player_music_album_versions_clean": "Clean Version", "player_music_album_versions_live": "Live", "player_music_album_versions_bonus": "Bonus Track", "player_music_album_versions_deluxe": "Deluxe Edition", "player_music_album_versions_special": "Special Edition", "player_music_album_versions_acoustic": "Acoustic", "player_music_album_versions_demo": "Demo", "player_track_versions_empty": "—", "player_track_versions_clean": "Clean Version", "player_track_versions_edited": "Edited Version", "player_track_versions_bonus": "Bonus Track", "player_track_versions_explicit": "Explicit Version", "player_track_versions_dirty": "Dirty Version", "player_track_versions_acoustic": "Acoustic", "player_track_versions_demo": "Demo", "player_track_versions_live": "Live", "player_track_versions_radio": "Radio Edit", "player_track_collaboration_featuring": "Featuring", "player_track_collaboration_with": "With", "player_track_collaboration_remixed": "Remixed By", "player_track_collaboration_performed": "Performed By" };

/***/ }),
/* 39 */
/* no static exports found */
/* all exports used */
/*!*************************************!*\
  !*** ./scripts/common/key-codes.js ***!
  \*************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var ESC_KEY = exports.ESC_KEY = 27;
var ENTER_KEY = exports.ENTER_KEY = 13;
var SPACE_KEY = exports.SPACE_KEY = 32;
var ARROW_UP_KEY = exports.ARROW_UP_KEY = 38;
var ARROW_DOWN_KEY = exports.ARROW_DOWN_KEY = 40;
var ARROW_LEFT_KEY = exports.ARROW_LEFT_KEY = 37;
var ARROW_RIGHT_KEY = exports.ARROW_RIGHT_KEY = 39;

/***/ }),
/* 40 */
/* no static exports found */
/* all exports used */
/*!****************************************!*\
  !*** ./scripts/common/translations.js ***!
  \****************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (locale) {
  var enJson = __webpack_require__(/*! ../../l10n/texts_en.json */ 38);
  try {
    var localeJson = __webpack_require__(/*! ../../l10n */ 168)("./texts_" + locale + '.json');
    return utils.defaults(localeJson, enJson);
  } catch (ex) {
    console.error('Requested not supported locale ' + locale, ex);
    return enJson;
  }
};

var _utils = __webpack_require__(/*! ../utils/utils */ 2);

var utils = _utils.utils;

/***/ }),
/* 41 */
/* no static exports found */
/* all exports used */
/*!************************************************************************************************!*\
  !*** ./scripts/player/v2/desktop/components/track-list/track/track-name/track-name.service.js ***!
  \************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTrackName = undefined;

var _artistName = __webpack_require__(/*! ../../../../../shared/artist-name */ 20);

var getFullArtistName = _artistName.getFullArtistName;
var getTrackName = exports.getTrackName = function getTrackName(track) {
  var showArtist = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return showArtist ? track.name + ' / ' + getFullArtistName(track) : track.name;
};

/***/ }),
/* 42 */
/* no static exports found */
/* all exports used */
/*!**********************************************!*\
  !*** ./scripts/player/v2/shared/buy-item.js ***!
  \**********************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buyAlbumGet = buyAlbumGet;
exports.buyTrackGet = buyTrackGet;
exports.openTrackInfoPage = openTrackInfoPage;

var _buy = __webpack_require__(/*! ../../../common/buy */ 134);

var openGetWindow = _buy.openGetWindow;
var ROUTES = _buy.ROUTES;
function buyAlbumGet(playerApi, settings, album) {
  return openGetWindow(playerApi, settings, { albumId: album.id });
}

function buyTrackGet(playerApi, settings, album, trackId) {
  return openGetWindow(playerApi, settings, { albumId: album.id, trackId: trackId });
}

function openTrackInfoPage(playerApi, settings, album, trackId) {
  openGetWindow(playerApi, settings, { albumId: album.id, trackId: trackId, route: ROUTES.TRACK_INFO });
}

/***/ }),
/* 43 */
/* no static exports found */
/* all exports used */
/*!************************************************************!*\
  !*** ./scripts/player/v2/shared/components/price/index.js ***!
  \************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatPrice = formatPrice;

var _mithril = __webpack_require__(/*! mithril */ 0);

var m = _interopRequireDefault(_mithril).default;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function formatPrice(price, currency, currencySymbol) {
  return currencySymbol + price;
}

/***/ }),
/* 44 */
/* no static exports found */
/* all exports used */
/*!************************************************************************!*\
  !*** ./scripts/player/v2/shared/components/slider/slider.component.js ***!
  \************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Slider = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _classnames = __webpack_require__(/*! classnames */ 3);

var classNames = _interopRequireDefault(_classnames).default;

var _mithril = __webpack_require__(/*! mithril */ 0);

var m = _interopRequireDefault(_mithril).default;

var _handleKeyboardSlider = __webpack_require__(/*! ../../../../../utils/handle-keyboard-slider/handle-keyboard-slider */ 30);

var handleKeyboardSlider = _handleKeyboardSlider.handleKeyboardSlider;

var _l10n = __webpack_require__(/*! ../../l10n */ 1);

var l10n = _l10n.l10n;

var _slider = __webpack_require__(/*! ./slider.controller */ 58);

var SliderController = _slider.SliderController;

__webpack_require__(/*! ./slider.less */ 164);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Slider = {
  controller: SliderController,

  view: function view(ctrl, attrs) {
    var loaded = attrs.loaded,
        _attrs$isActive = attrs.isActive,
        isActive = _attrs$isActive === undefined ? true : _attrs$isActive,
        progress = attrs.progress,
        isDisabled = attrs.isDisabled,
        _attrs$step = attrs.step,
        step = _attrs$step === undefined ? 5 : _attrs$step,
        _attrs$minValue = attrs.minValue,
        minValue = _attrs$minValue === undefined ? 0 : _attrs$minValue,
        _attrs$maxValue = attrs.maxValue,
        maxValue = _attrs$maxValue === undefined ? 1 : _attrs$maxValue,
        valueText = attrs.valueText;

    ctrl.progress = progress;
    ctrl.minValue = minValue;
    ctrl.maxValue = maxValue;
    if (!valueText) {
      // eslint-disable-next-line no-console
      console.warn('We should pass valueText to slider for accessibility!');
    }
    var progressStyle = {
      width: ctrl.visibleProgress * 100 + '%'
    };
    var loadedStyle = {
      width: loaded * 100 + '%'
    };
    var config = function config(el, isInitialized, context) {
      ctrl.config(el, isInitialized, context);
    };
    var startDragAttr = ctrl.startDragAttr;
    var className = classNames('slider', { 'slider_is-active': isActive });

    var handleKeydown = handleKeyboardSlider({
      decrease: function decrease() {
        ctrl.onUpdate(progress - step);
      },
      increase: function increase() {
        ctrl.onUpdate(progress + step);
      }
    });

    return {
      tag: 'div',
      children: [{
        tag: 'div',
        children: [{
          tag: 'div',
          attrs: { className: 'slider-loaded', style: loadedStyle }
        }, {
          tag: 'div',
          attrs: { className: 'slider-progress', style: progressStyle }
        }],
        attrs: { className: 'slider-bar' }
      }],
      attrs: _extends({
        className: className,
        role: 'slider',
        disabled: isDisabled,
        'aria-label': l10n('player_acc_progressbar'),
        'aria-valuemin': minValue,
        'aria-valuemax': maxValue,
        'aria-valuenow': progress.toFixed(1),
        'aria-valuetext': valueText,
        tabindex: isDisabled ? -1 : 0,
        onkeydown: handleKeydown
      }, startDragAttr, {
        config: config
      })
    };
  }
};

exports.Slider = Slider;

/***/ }),
/* 45 */
/* no static exports found */
/* all exports used */
/*!*******************************************************!*\
  !*** ./scripts/player/v2/shared/models/player-api.js ***!
  \*******************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PlayerApi = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _desc, _value, _class;

var _mithril = __webpack_require__(/*! mithril */ 0);

var m = _interopRequireDefault(_mithril).default;

var _v2SettingsConstants = __webpack_require__(/*! ../../../../common/parse-settings/v2-settings-constants */ 4);

var LAYOUT_TYPES = _v2SettingsConstants.LAYOUT_TYPES;
var MIN_WIDTH_BY_LAYOUT = _v2SettingsConstants.MIN_WIDTH_BY_LAYOUT;

var _deprecated = __webpack_require__(/*! ../../../../utils/deprecated */ 7);

var deprecated = _deprecated.deprecated;

var _events = __webpack_require__(/*! ../../../../utils/events */ 158);

var Events = _events.Events;

var _statisticEvents = __webpack_require__(/*! ./statistic-events */ 72);

var StatisticEvents = _statisticEvents.StatisticEvents;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function elementRequired(target, property, descriptor) {
  var descriptorMethod = descriptor.get ? 'get' : 'value';
  var originalMethod = descriptor[descriptorMethod];
  descriptor[descriptorMethod] = function () {
    if (!this.element) {
      throw Error('call init with the element first');
    }
    return originalMethod.apply(this, arguments);
  };
  return descriptor;
}

var PlayerApi = (_class = function (_Events) {
  _inherits(PlayerApi, _Events);

  function PlayerApi() {
    var _ref;

    _classCallCheck(this, PlayerApi);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = _possibleConstructorReturn(this, (_ref = PlayerApi.__proto__ || Object.getPrototypeOf(PlayerApi)).call.apply(_ref, [this].concat(args)));

    _this.__onNextFrameCallbacks = [];
    return _this;
  }

  _createClass(PlayerApi, [{
    key: 'init',
    value: function init(_ref2) {
      var element = _ref2.element,
          playback = _ref2.playback,
          settings = _ref2.settings,
          album = _ref2.album,
          playerVersion = _ref2.playerVersion;

      this.removeAllListeners();
      this.element = element;
      this.playback = playback;
      this.settings = settings;
      this.album = album;
      this.playerVersion = playerVersion;
      this.statisticEvents = new StatisticEvents({ album: album, artifactVersion: settings.artifactVersion, playerVersion: playerVersion });
    }
  }, {
    key: 'querySelector',
    value: function querySelector() {
      var _element;

      return (_element = this.element).querySelector.apply(_element, arguments);
    }
  }, {
    key: 'querySelectorAll',
    value: function querySelectorAll() {
      var _element2;

      return (_element2 = this.element).querySelectorAll.apply(_element2, arguments);
    }
  }, {
    key: 'getBottomPadding',
    value: function getBottomPadding() {
      return parseInt(window.getComputedStyle(this.element).paddingBottom, 10) || 0;
    }
  }, {
    key: 'getNewTracklistHeight',
    value: function getNewTracklistHeight(tracksNumber) {
      var element = this.element,
          album = this.album;

      if (!tracksNumber) {
        return 0;
      }

      var trackSelector = '.track-wrapper';
      var firstTrack = element.querySelector(trackSelector);
      if (!firstTrack) {
        trackSelector = '.track';
        firstTrack = element.querySelector(trackSelector);
      }
      if (!firstTrack) {
        return 0;
      }

      var firstTrackRectangle = firstTrack.getBoundingClientRect();
      if (tracksNumber === 1) {
        return firstTrackRectangle.height;
      }

      var secondTrack = album.tracks.length > 1 ? element.querySelectorAll(trackSelector)[1] : null;
      var averageTrackRectangle = secondTrack.getBoundingClientRect();

      return firstTrackRectangle.height + (tracksNumber - 1) * averageTrackRectangle.height;
    }
  }, {
    key: '_getFixedPartHeight',
    value: function _getFixedPartHeight() {
      var element = this.element;

      var appElement = element.querySelector('.app');
      var firstTrack = element.querySelector('.track-wrapper') || element.querySelector('.track');
      var appPaddingBottom = parseInt(window.getComputedStyle(appElement).paddingBottom, 10);
      var appBorderWidth = parseInt(window.getComputedStyle(appElement).borderBottomWidth, 10);
      var elementPaddingBottom = parseInt(window.getComputedStyle(element).paddingBottom, 10);
      var elementBorderWidth = parseInt(window.getComputedStyle(element).borderBottomWidth, 10);

      return firstTrack ? firstTrack.getBoundingClientRect().top + elementPaddingBottom + appPaddingBottom + appBorderWidth + elementBorderWidth : element.offsetHeight;
    }
  }, {
    key: 'getDimensionsForFullTracks',
    value: function getDimensionsForFullTracks() {
      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref3$minimalTrackCou = _ref3.minimalTrackCount,
          minimalTrackCount = _ref3$minimalTrackCou === undefined ? 3 : _ref3$minimalTrackCou;

      var element = this.element,
          settings = this.settings,
          album = this.album;

      var firstTrack = element.querySelector('.track-wrapper') || element.querySelector('.track');
      var minMaxDimension = this.getDimensions();
      var width = Math.min(Math.max(element.offsetWidth, minMaxDimension.minWidth), minMaxDimension.maxWidth);
      var isListLayout = settings.layout === LAYOUT_TYPES.LIST;

      if (settings.isMobileView) {
        return {
          height: minMaxDimension.maxHeight,
          width: width
        };
      }

      if (!firstTrack) {
        return {
          height: Math.max(element.offsetHeight, minMaxDimension.minHeight),
          width: width
        };
      }

      var appElement = element.querySelector('.app');
      var appPaddingBottom = parseInt(window.getComputedStyle(appElement).paddingBottom, 10);
      var firstTrackRectangle = firstTrack.getBoundingClientRect();
      var tracklistVisibleHeight = element.offsetHeight - firstTrackRectangle.top - appPaddingBottom;
      var getVisibleTracksForList = function getVisibleTracksForList() {
        if (album.tracks.length < 2) {
          return album.tracks.length;
        }
        var secondTrack = firstTrack.nextSibling;
        var averageTrackRectangle = secondTrack.getBoundingClientRect();
        return 1 + Math.round((tracklistVisibleHeight - firstTrackRectangle.height) / averageTrackRectangle.height);
      };
      var getVisibleTracks = function getVisibleTracks() {
        return Math.round(tracklistVisibleHeight / firstTrackRectangle.height);
      };
      var visibleTracksNumber = isListLayout ? getVisibleTracksForList() : getVisibleTracks();

      visibleTracksNumber = Math.min(album.tracks.length, Math.max(minimalTrackCount, visibleTracksNumber));
      var newHeight = this._getFixedPartHeight() + this.getNewTracklistHeight(visibleTracksNumber);

      return {
        height: Math.max(newHeight, minMaxDimension.minHeight),
        width: width
      };
    }
  }, {
    key: 'getDimensions',
    value: function getDimensions() {
      var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref4$minimalTrackCou = _ref4.minimalTrackCount,
          minimalTrackCount = _ref4$minimalTrackCou === undefined ? 3 : _ref4$minimalTrackCou;

      var element = this.element,
          settings = this.settings,
          album = this.album;

      var fixedPartHeight = this._getFixedPartHeight();

      var allTracksNumber = album.tracks.length;
      var minimalTracksCount = Math.min(allTracksNumber, minimalTrackCount);
      var offsetHeight = element.offsetHeight;
      var minHeight = fixedPartHeight + this.getNewTracklistHeight(minimalTracksCount);
      var maxHeight = Math.min(fixedPartHeight + this.getNewTracklistHeight(allTracksNumber), offsetHeight);

      if (settings.isMobileView) {
        return {
          minWidth: settings.minWidth[LAYOUT_TYPES.MOBILE] || MIN_WIDTH_BY_LAYOUT[LAYOUT_TYPES.MOBILE],
          maxWidth: 320,
          minHeight: minHeight,
          maxHeight: maxHeight
        };
      }

      return {
        minWidth: settings.minWidth[settings.layout] || MIN_WIDTH_BY_LAYOUT[settings.layout],
        maxWidth: Number.MAX_VALUE,
        minHeight: minHeight,
        maxHeight: maxHeight
      };
    }
  }, {
    key: 'getModelData',
    value: function getModelData() {
      var settings = this.settings,
          album = this.album;

      return {
        settings: settings.serialize(),
        album: album.serialize()
      };
    }
  }, {
    key: 'on',
    value: function on(eventName, handler) {
      if (eventName === 'ready' && this.__eventsToBeReady.length === 0) {
        handler();
      }
      return _get(PlayerApi.prototype.__proto__ || Object.getPrototypeOf(PlayerApi.prototype), 'on', this).call(this, eventName, function () {
        handler.apply(this, arguments);
        m.redraw();
      });
    }
  }, {
    key: 'emitFeatureDisabled',
    value: function emitFeatureDisabled() {
      this.emit('feature-disabled');
    }
  }, {
    key: 'pause',
    value: function pause() {
      this.playback.pause();
      m.redraw(true);
    }
  }, {
    key: 'play',
    value: function play() {
      this.playback.play();
    }
  }, {
    key: 'next',
    value: function next() {
      this.playback.playNext();
      m.redraw(true);
    }
  }, {
    key: 'previous',
    value: function previous() {
      this.playback.playPrev();
      m.redraw(true);
    }
  }, {
    key: 'setCurrentTrack',
    value: function setCurrentTrack(trackId) {
      var track = this.album.tracks.find(function (track) {
        return track.id === trackId;
      });
      if (!track) {
        throw new Error('Track \'' + trackId + '\' not found');
      }
      this.playback.setCurrent(track);
      m.redraw();
    }
  }, {
    key: 'setCurrentOrigin',
    value: function setCurrentOrigin(value) {
      this.playback.currentOrigin = value;
    }
  }, {
    key: 'updateCurrentTime',
    value: function updateCurrentTime(value) {
      this.playback.updateProgress(value);
      m.redraw(true); // Force redraw is required in order to make it work in mobile browsers (can be reproduced in dev tools mobile phone emulation mode)
    }
  }, {
    key: 'onNextFrame',
    value: function onNextFrame(callback) {
      this.__onNextFrameCallbacks.push(callback);
    }
  }, {
    key: '_triggerNextFrame',
    value: function _triggerNextFrame() {
      if (this.__onNextFrameCallbacks.length) {
        this.__onNextFrameCallbacks.forEach(function (callback) {
          return callback();
        });
        this.__onNextFrameCallbacks = [];
      }
    }
  }, {
    key: 'offsetHeight',
    get: function get() {
      return this.element.offsetHeight;
    }
  }, {
    key: 'isPlaying',
    get: function get() {
      return this.playback.isPlaying;
    }
  }, {
    key: 'currentTrack',
    get: function get() {
      return this.playback.currentTrack && this.playback.currentTrack.id;
    }
  }, {
    key: 'currentOrigin',
    get: function get() {
      return this.playback.currentOrigin;
    }
  }, {
    key: 'currentTime',
    get: function get() {
      return this.playback.currentProgress();
    }
  }]);

  return PlayerApi;
}(Events), (_applyDecoratedDescriptor(_class.prototype, 'offsetHeight', [elementRequired], Object.getOwnPropertyDescriptor(_class.prototype, 'offsetHeight'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'querySelector', [elementRequired], Object.getOwnPropertyDescriptor(_class.prototype, 'querySelector'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'querySelectorAll', [elementRequired], Object.getOwnPropertyDescriptor(_class.prototype, 'querySelectorAll'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'getBottomPadding', [deprecated, elementRequired], Object.getOwnPropertyDescriptor(_class.prototype, 'getBottomPadding'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'getNewTracklistHeight', [elementRequired], Object.getOwnPropertyDescriptor(_class.prototype, 'getNewTracklistHeight'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, '_getFixedPartHeight', [elementRequired], Object.getOwnPropertyDescriptor(_class.prototype, '_getFixedPartHeight'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'getDimensionsForFullTracks', [elementRequired], Object.getOwnPropertyDescriptor(_class.prototype, 'getDimensionsForFullTracks'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'getDimensions', [elementRequired], Object.getOwnPropertyDescriptor(_class.prototype, 'getDimensions'), _class.prototype)), _class);
exports.PlayerApi = PlayerApi;

/***/ }),
/* 46 */
/* no static exports found */
/* all exports used */
/*!***********************************************************************************!*\
  !*** ./scripts/player/v2/desktop/components/track-list/track/track.controller.js ***!
  \***********************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TrackController = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _l10n = __webpack_require__(/*! ../../../../shared/l10n */ 1);

var l10n = _l10n.l10n;

var _trackName = __webpack_require__(/*! ./track-name */ 56);

var getTrackName = _trackName.getTrackName;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TrackController = exports.TrackController = function () {
  function TrackController(attrs) {
    _classCallCheck(this, TrackController);

    this.updateAttrs(attrs);
  }

  _createClass(TrackController, [{
    key: 'updateAttrs',
    value: function updateAttrs(_ref) {
      var track = _ref.track,
          isPlaying = _ref.isPlaying,
          onPause = _ref.onPause,
          onPlay = _ref.onPlay,
          canShare = _ref.canShare,
          isShareDisabled = _ref.isShareDisabled,
          onShare = _ref.onShare,
          ShareIcons = _ref.ShareIcons,
          showArtist = _ref.showArtist,
          number = _ref.number,
          isCurrent = _ref.isCurrent;

      this.track = track;
      this.isPlaying = isPlaying;
      this.onPause = onPause;
      this.onPlay = onPlay;
      this.canShare = canShare;
      this.isShareDisabled = isShareDisabled;
      this.onShare = onShare;
      this.ShareIcons = ShareIcons;
      this.showArtist = showArtist;
      this.number = number;
      this.isCurrent = isCurrent;
    }
  }, {
    key: 'isFree',
    value: function isFree() {
      var track = this.track;

      return track && track.purchaseAvail && !track.trackPrice;
    }
  }, {
    key: 'isPurchaseAvailable',
    value: function isPurchaseAvailable() {
      var track = this.track;

      return track && track.purchaseAvail;
    }
  }, {
    key: 'togglePlaying',
    value: function togglePlaying() {
      if (this.isPlaying) {
        this.onPause();
      } else {
        this.onPlay();
      }
    }
  }, {
    key: 'getShareData',
    value: function getShareData() {
      return {
        canShare: this.canShare,
        isShareDisabled: this.isShareDisabled,
        onShare: this.onShare,
        ShareIcons: this.ShareIcons
      };
    }
  }, {
    key: 'getAriaLabel',
    value: function getAriaLabel() {
      var controlButtonTranslationKey = this.isPlaying && this.isCurrent ? 'player_acc_tracklist_pause_track' : 'player_acc_tracklist_play_track';
      return l10n(controlButtonTranslationKey, [this.number, getTrackName(this.track, this.showArtist)]);
    }
  }]);

  return TrackController;
}();

/***/ }),
/* 47 */
/* no static exports found */
/* all exports used */
/*!****************************************************************!*\
  !*** ./scripts/player/v2/shared/app-keyboard-handler/index.js ***!
  \****************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleAppKeydown = undefined;

var _volumeUtils = __webpack_require__(/*! ../volume-utils/volume-utils */ 59);

var limitVolume = _volumeUtils.limitVolume;
var VOLUME_SLIDER_STEP = _volumeUtils.VOLUME_SLIDER_STEP;
var handleAppKeydown = exports.handleAppKeydown = function handleAppKeydown(_ref) {
  var playback = _ref.playback;
  return function ( /** KeyboardEvent */event) {
    var updateVolume = function updateVolume(step) {
      return playback.volume(limitVolume(playback.volume() + step));
    };
    var seek = function seek(duration) {
      return playback.updateProgress(playback.currentProgress() + duration);
    };

    var handled = function handled() {
      event.preventDefault();
      event.stopPropagation();
    };

    var ctrlKey = event.ctrlKey,
        shiftKey = event.shiftKey,
        code = event.code,
        keyCode = event.keyCode;

    var seekDuration = shiftKey ? 20 : 5;

    switch (code || keyCode) {
      case 80:
      case 'KeyP':
        playback.togglePlay();
        handled();
        break;
      case 77:
      case 'KeyM':
        playback.toggleMute();
        handled();
        break;
      case 40:
      case 'ArrowDown':
        if (ctrlKey) {
          updateVolume(-VOLUME_SLIDER_STEP);
          handled();
        }
        break;
      case 38:
      case 'ArrowUp':
        if (ctrlKey) {
          updateVolume(VOLUME_SLIDER_STEP);
          handled();
        }
        break;
      case 39:
      case 'ArrowRight':
        if (ctrlKey) {
          playback.playNext();
          handled();
        }
        break;
      case 37:
      case 'ArrowLeft':
        if (ctrlKey) {
          playback.playPrev();
          handled();
        }
        break;
      case 219:
      case 'BracketLeft':
        seek(-seekDuration);
        handled();
        break;
      case 221:
      case 'BracketRight':
        seek(seekDuration);
        handled();
        break;
      default:
        break;
    }
  };
};

/***/ }),
/* 48 */
/* no static exports found */
/* all exports used */
/*!******************************************************************!*\
  !*** ./scripts/player/v2/shared/components/album-cover/index.js ***!
  \******************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _albumCover = __webpack_require__(/*! ./album-cover.component */ 141);

Object.defineProperty(exports, 'AlbumCover', {
  enumerable: true,
  get: function get() {
    return _albumCover.AlbumCover;
  }
});

/***/ }),
/* 49 */
/* no static exports found */
/* all exports used */
/*!************************************************************************!*\
  !*** ./scripts/player/v2/shared/components/track-button-like/index.js ***!
  \************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _trackButtonLike = __webpack_require__(/*! ./track-button-like */ 153);

Object.defineProperty(exports, 'TrackButtonLike', {
  enumerable: true,
  get: function get() {
    return _trackButtonLike.TrackButtonLike;
  }
});

/***/ }),
/* 50 */
/* no static exports found */
/* all exports used */
/*!***************************************************************************!*\
  !*** ./scripts/player/v2/shared/components/track-list/scroll-to-track.js ***!
  \***************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.scrollToTrack = scrollToTrack;
function scrollToTrack(el) {
  var currentTrackEl = el.querySelector('.track_is-current');
  if (!currentTrackEl) {
    return;
  }
  el.scrollTop = currentTrackEl.getBoundingClientRect().top - el.getBoundingClientRect().top;
}

/***/ }),
/* 51 */
/* no static exports found */
/* all exports used */
/*!********************************************************************************!*\
  !*** ./scripts/player/v2/shared/components/track-list/track-list.component.js ***!
  \********************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TrackList = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _mithril = __webpack_require__(/*! mithril */ 0);

var m = _interopRequireDefault(_mithril).default;

var _keyCodes = __webpack_require__(/*! ../../../../../common/key-codes */ 39);

var ARROW_DOWN_KEY = _keyCodes.ARROW_DOWN_KEY;
var ARROW_UP_KEY = _keyCodes.ARROW_UP_KEY;

var _v2SettingsConstants = __webpack_require__(/*! ../../../../../common/parse-settings/v2-settings-constants */ 4);

var TRACK_ACTIONS_SHOW = _v2SettingsConstants.TRACK_ACTIONS_SHOW;

var _utils = __webpack_require__(/*! ../../../../../utils/utils */ 2);

var utils = _utils.utils;

var _scrollArea = __webpack_require__(/*! ../scroll-area */ 150);

var ScrollArea = _scrollArea.ScrollArea;

__webpack_require__(/*! ./track-list.less */ 166);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function findAppElement(element) {
  var parentNode = element.parentNode;
  if (element.classList.contains('app')) {
    return parentNode;
  }
  if (!parentNode) {
    return null;
  }
  return findAppElement(parentNode);
}

var TrackListController = function () {
  function TrackListController(_ref) {
    var playback = _ref.playback,
        settings = _ref.settings;

    _classCallCheck(this, TrackListController);

    this.playback = playback;
    this.settings = settings;
  }

  _createClass(TrackListController, [{
    key: 'shouldShowArtist',
    value: function shouldShowArtist() {
      return this.settings.trackInfoShowArtistName;
    }
  }]);

  return TrackListController;
}();

var TrackList = {
  controller: TrackListController,
  view: function view(ctrl, attrs, children) {
    var Track = attrs.Track,
        tracks = attrs.tracks,
        isBuyDisabled = attrs.isBuyDisabled,
        isShareDisabled = attrs.isShareDisabled,
        buy = attrs.buy,
        onShare = attrs.onShare,
        noScrollArea = attrs.noScrollArea,
        scrollToTrack = attrs.scrollToTrack,
        ShareIcons = attrs.ShareIcons,
        _attrs$buyClassName = attrs.buyClassName,
        buyClassName = _attrs$buyClassName === undefined ? '' : _attrs$buyClassName,
        openTrackPage = attrs.openTrackPage,
        trackCoverDefault = attrs.trackCoverDefault,
        showTrackCover = attrs.showTrackCover,
        showTrackDuration = attrs.showTrackDuration,
        trackStyle = attrs.trackStyle,
        albumName = attrs.albumName;
    var playback = ctrl.playback,
        settings = ctrl.settings;

    var isCurrentTrack = function isCurrentTrack(track) {
      return playback.currentTrack === track;
    };
    var isPlayingTrack = function isPlayingTrack(track) {
      return isCurrentTrack(track) && playback.isPlaying;
    };
    var handlePlay = function handlePlay(track) {
      return function () {
        return playback.playTrack(track);
      };
    };
    var handlePause = function handlePause() {
      return playback.pause();
    };
    var handleSeek = function handleSeek(track) {
      return function (value) {
        playback.currentTrack = track;
        playback.updateProgress(value);
      };
    };
    var hasTracksForPurchase = tracks.some(function (track) {
      return track.purchaseAvail;
    });
    var showTrackActions = settings.trackActionsShow === TRACK_ACTIONS_SHOW.ON_ACTIVE ? 'active' : 'all';

    var className = ['tracklist', 'tracklist_actions_' + showTrackActions].join(' ');
    // TODO: rid off ids at all

    var trackListHeight = function trackListHeight(el) {
      var rectHeight = settings.rect && settings.rect.height;
      if (!rectHeight) {
        return el.offsetHeight;
      }
      var height = Math.round(rectHeight / settings.scale);
      var appElement = findAppElement(el);
      if (!appElement) {
        return el.offsetHeight;
      }
      return Math.min(el.offsetHeight, el.offsetHeight - (appElement.offsetHeight - height));
    };
    var hasCurrentTrack = tracks.some(isCurrentTrack);

    var handleKeyDown = function handleKeyDown(event) {
      if (![ARROW_DOWN_KEY, ARROW_UP_KEY].includes(event.keyCode)) {
        return;
      }
      var direction = event.keyCode === ARROW_DOWN_KEY ? 1 : -1;
      var buttons = Array.from(event.currentTarget.querySelectorAll('.track-button'));
      var button = event.target.closest('.track-button');
      var index = buttons.indexOf(button);
      var newIndex = index + direction;
      if (newIndex < 0 || newIndex >= buttons.length) {
        return;
      }
      event.preventDefault();
      var newButton = buttons[newIndex];
      newButton.scrollIntoView(false);
      newButton.focus();
    };

    var trackList = {
      tag: 'ol',
      children: [tracks.length ? tracks.map(function (track, i) {
        return m.component(Track, {
          buyClassName: buyClassName,
          ShareIcons: ShareIcons,
          number: i + 1,
          track: track,
          buy: buy,
          onShare: onShare,
          canShare: settings.canShareTrack,
          isBuyDisabled: isBuyDisabled,
          isShareDisabled: isShareDisabled,
          hasTracksForPurchase: hasTracksForPurchase,
          isCurrent: isCurrentTrack(track),
          isPlaying: isPlayingTrack(track),
          played: isCurrentTrack(track) ? playback.currentProgress() : 0,
          loaded: isCurrentTrack(track) ? playback.loadedProgress() : 0,
          duration: utils.stringToDuration(track.duration) || 0,
          showArtist: ctrl.shouldShowArtist(),
          onPlay: handlePlay(track),
          onPause: handlePause,
          onSeek: handleSeek(track),
          openTrackPage: openTrackPage,
          trackCoverDefault: trackCoverDefault,
          showTrackCover: showTrackCover,
          showTrackDuration: showTrackDuration,
          trackStyle: trackStyle,
          isPreview: playback.preview.isPreview
        }, []);
      }) : null, children],
      attrs: { id: 'tracklist', className: className, onkeydown: handleKeyDown }
    };
    // tabindex -1, because firefox leads to it with the tab for some reason
    if (noScrollArea) {
      return {
        tag: 'div',
        children: [trackList],
        attrs: { id: 'tracklist-wrapper', className: 'track-list-wrapper', tabindex: '-1' }
      };
    }

    return m.component(ScrollArea, {
      id: 'tracklist-wrapper',
      className: 'track-list-wrapper',
      tabindex: '-1',
      maxHeight: settings.rect && settings.rect.height,
      height: trackListHeight,
      initialScrollTo: hasCurrentTrack ? scrollToTrack : null
    }, [trackList]);
  }
};

exports.TrackList = TrackList;

/***/ }),
/* 52 */
/* no static exports found */
/* all exports used */
/*!********************************************************************!*\
  !*** ./scripts/player/v2/desktop/components/share-button/index.js ***!
  \********************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _shareButton = __webpack_require__(/*! ./share-button.component */ 194);

Object.defineProperty(exports, 'ShareButton', {
  enumerable: true,
  get: function get() {
    return _shareButton.ShareButton;
  }
});

/***/ }),
/* 53 */
/* no static exports found */
/* all exports used */
/*!**************************************************!*\
  !*** ./scripts/common/default-settings/index.js ***!
  \**************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _v = __webpack_require__(/*! ./v2 */ 137);

Object.defineProperty(exports, 'defaultSettingsV2', {
  enumerable: true,
  get: function get() {
    return _v.defaultSettingsV2;
  }
});

var _v2 = __webpack_require__(/*! ./v3 */ 138);

Object.defineProperty(exports, 'defaultSettingsV3', {
  enumerable: true,
  get: function get() {
    return _v2.defaultSettingsV3;
  }
});

/***/ }),
/* 54 */,
/* 55 */,
/* 56 */
/* no static exports found */
/* all exports used */
/*!***********************************************************************************!*\
  !*** ./scripts/player/v2/desktop/components/track-list/track/track-name/index.js ***!
  \***********************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _trackName = __webpack_require__(/*! ./track-name.component */ 139);

Object.defineProperty(exports, 'TrackName', {
  enumerable: true,
  get: function get() {
    return _trackName.TrackName;
  }
});

var _trackName2 = __webpack_require__(/*! ./track-name.service */ 41);

Object.defineProperty(exports, 'getTrackName', {
  enumerable: true,
  get: function get() {
    return _trackName2.getTrackName;
  }
});

/***/ }),
/* 57 */
/* no static exports found */
/* all exports used */
/*!***************************************************************************************!*\
  !*** ./scripts/player/v2/shared/components/buy-share-actions/buy-share.controller.js ***!
  \***************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BuyShareController = exports.BuyShareController = function () {
  function BuyShareController(_ref) {
    var album = _ref.album;

    _classCallCheck(this, BuyShareController);

    this.album = album;
  }

  _createClass(BuyShareController, [{
    key: "canBuy",
    value: function canBuy() {
      return this.album.purchaseAvail;
    }
  }, {
    key: "isFree",
    value: function isFree() {
      return this.canBuy() && this.album.albumPrice === 0;
    }
  }, {
    key: "getFirstFreeTrack",
    value: function getFirstFreeTrack() {
      return this.album.tracks.find(function (track) {
        return track.purchaseAvail && track.trackPrice === 0;
      });
    }
  }, {
    key: "getTheMostExpensiveTrack",
    value: function getTheMostExpensiveTrack() {
      var purchasable = this.album.tracks.filter(function (track) {
        return track.purchaseAvail && track.trackPrice > 0;
      });
      if (!purchasable.length) {
        return;
      }
      return purchasable.sort(function (trackA, trackB) {
        return trackB.trackPrice - trackA.trackPrice;
      })[0];
    }
  }]);

  return BuyShareController;
}();

/***/ }),
/* 58 */
/* no static exports found */
/* all exports used */
/*!*************************************************************************!*\
  !*** ./scripts/player/v2/shared/components/slider/slider.controller.js ***!
  \*************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SliderController = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _throttle = __webpack_require__(/*! lodash/throttle */ 60);

var throttle = _interopRequireDefault(_throttle).default;

var _mithril = __webpack_require__(/*! mithril */ 0);

var m = _interopRequireDefault(_mithril).default;

var _slider = __webpack_require__(/*! ./slider.model */ 152);

var SliderModel = _slider.SliderModel;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SliderController = exports.SliderController = function () {
  function SliderController(_ref) {
    var _this = this;

    var onUpdate = _ref.onUpdate,
        startDragEvent = _ref.startDragEvent,
        addDragHandlers = _ref.addDragHandlers,
        removeDragHandlers = _ref.removeDragHandlers;

    _classCallCheck(this, SliderController);

    this.model = new SliderModel();
    this.progress = null;
    this.onUpdate = function (value) {
      var minValue = _this.minValue,
          maxValue = _this.maxValue;

      onUpdate(Math.max(minValue, Math.min(value, maxValue)));
    };
    this.startDragEvent = startDragEvent;
    this.addDragHandlers = addDragHandlers;
    this.removeDragHandlers = removeDragHandlers;
  }

  _createClass(SliderController, [{
    key: 'getProgressValue',
    value: function getProgressValue(sliderEl, event) {
      var minValue = this.minValue,
          maxValue = this.maxValue;

      var sliderClientRect = sliderEl.getBoundingClientRect();
      if (event.touches && !event.touches[0]) {
        return null;
      }
      var clientX = event.touches ? event.touches[0].clientX : event.clientX;
      var rawValue = (clientX - sliderClientRect.left) / sliderClientRect.width;
      return minValue + Math.max(0, Math.min(rawValue, 1)) * maxValue;
    }
  }, {
    key: 'drag',
    value: function drag(sliderEl, event) {
      var model = this.model;


      model.drag(this.getProgressValue(sliderEl, event));
    }
  }, {
    key: 'stopDragging',
    value: function stopDragging(sliderEl, event) {
      var model = this.model,
          onUpdate = this.onUpdate;


      if (!model.isDragging()) {
        return;
      }
      var sliderValue = this.getProgressValue(sliderEl, event) || model.draggingProgress();
      model.stopDragging();
      if (sliderValue !== null) {
        onUpdate(sliderValue);
      }
    }
  }, {
    key: 'startDragging',
    value: function startDragging(event) {
      var progress = this.progress,
          model = this.model;


      model.startDragging(progress);
      this.drag(event.currentTarget, event);
      event.preventDefault();
    }
  }, {
    key: 'config',
    value: function config(el, isInitialized, context) {
      var _this2 = this;

      var model = this.model,
          addDragHandlers = this.addDragHandlers,
          removeDragHandlers = this.removeDragHandlers;

      var startDragging = this.startDragging.bind(this);

      if (isInitialized) {
        return;
      }

      var dragHandler = throttle(function (event) {
        if (!model.isDragging()) {
          return;
        }
        m.startComputation();
        _this2.drag(el, event);
        m.endComputation();
      }, 100);

      var dragEndHandler = function dragEndHandler(event) {
        m.startComputation();
        _this2.stopDragging(el, event);
        m.endComputation();
      };

      if (addDragHandlers) {
        addDragHandlers({
          el: el,
          dragStartHandler: startDragging,
          dragHandler: dragHandler,
          dragEndHandler: dragEndHandler
        });
      }

      context.onunload = function () {
        if (removeDragHandlers) {
          removeDragHandlers({
            el: el,
            dragStartHandler: startDragging,
            dragHandler: dragHandler,
            dragEndHandler: dragEndHandler
          });
        }
      };
    }
  }, {
    key: 'visibleProgress',
    get: function get() {
      var model = this.model,
          progress = this.progress,
          maxValue = this.maxValue;


      return (model.draggingProgress() !== null ? model.draggingProgress() : progress) / maxValue;
    }
  }, {
    key: 'startDragAttr',
    get: function get() {
      var startDragEvent = this.startDragEvent;

      var startDragging = this.startDragging.bind(this);

      return startDragEvent ? _defineProperty({}, 'on' + startDragEvent, startDragging) : {};
    }
  }]);

  return SliderController;
}();

/***/ }),
/* 59 */
/* no static exports found */
/* all exports used */
/*!***************************************************************!*\
  !*** ./scripts/player/v2/shared/volume-utils/volume-utils.js ***!
  \***************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var VOLUME_SLIDER_STEP = exports.VOLUME_SLIDER_STEP = 0.1;

var limitVolume = exports.limitVolume = function limitVolume(volume) {
  return Math.max(0, Math.min(volume, 1));
};

/***/ }),
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */
/* no static exports found */
/* all exports used */
/*!**********************************************************************!*\
  !*** ./scripts/player/v2/shared/components/slider/desktop-slider.js ***!
  \**********************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DesktopSlider = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _mithril = __webpack_require__(/*! mithril */ 0);

var m = _interopRequireDefault(_mithril).default;

var _slider = __webpack_require__(/*! ./slider.component */ 44);

var Slider = _slider.Slider;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DesktopSlider = {
  view: function view(ctrl, attrs) {
    var addDragHandlers = function addDragHandlers(_ref) {
      var dragHandler = _ref.dragHandler,
          dragEndHandler = _ref.dragEndHandler;

      document.addEventListener('mousemove', dragHandler);
      document.addEventListener('mouseup', dragEndHandler);
      document.addEventListener('mouseleave', dragEndHandler);
    };

    var removeDragHandlers = function removeDragHandlers(_ref2) {
      var dragHandler = _ref2.dragHandler,
          dragEndHandler = _ref2.dragEndHandler;

      document.removeEventListener('mousemove', dragHandler);
      document.removeEventListener('mouseup', dragEndHandler);
      document.removeEventListener('mouseleave', dragEndHandler);
    };
    return m.component(Slider, _extends({}, attrs, {
      startDragEvent: 'mousedown',
      addDragHandlers: addDragHandlers,
      removeDragHandler: removeDragHandlers
    }), []);
  }
};

exports.DesktopSlider = DesktopSlider;

/***/ }),
/* 66 */
/* no static exports found */
/* all exports used */
/*!***************************************************!*\
  !*** ./styles/v2/desktop-wiring-v2.settings.less ***!
  \***************************************************/
/***/ (function(module, exports) {

module.exports =  function buildCss(settings) {
  var css = ".--appName--.desktop.v2 .app {\n  border: --borderWidth--px solid --borderColor--;\n  background-color: --backgroundColor--;\n}\n.--appName--.desktop.v2 .app.app_no-tracks .buy-share {\n  color: --buyShareLinksColorDisabled--;\n}\n.--appName--.desktop.v2 .app.app_no-tracks .control-bar svg path,\n.--appName--.desktop.v2 .app.app_no-tracks .play-pause-maxi svg path {\n  fill: --controlBarColorDisabled-- !important;\n}\n.--appName--.desktop.v2 .app.app_no-tracks .progress-bar,\n.--appName--.desktop.v2 .app.app_no-tracks .progress-bar__duration,\n.--appName--.desktop.v2 .app.app_no-tracks .progress-bar__duration-slash,\n.--appName--.desktop.v2 .app.app_no-tracks .progress-bar__played {\n  color: --controlBarColorDisabled--;\n}\n.--appName--.desktop.v2 .app.app_layout_vertical .track .buy-item {\n  font: --trackFont--;\n}\n.--appName--.desktop.v2 .app.app_layout_vertical .buy-share {\n  margin-top: --buyShareTopMargin--px;\n  padding-bottom: calc(13px + --buyShareBottomMargin--px);\n}\n.--appName--.desktop.v2 .app.app_layout_vertical .buy-share.buy-share_disabled button {\n  color: --buyShareLinksColorDisabled--;\n}\n.--appName--.desktop.v2 .app.app_layout_vertical.app_hide-cover .buy-share {\n  border-bottom: 1px solid --dividersColor10--;\n}\n.--appName--.desktop.v2 .app .wiring-button {\n  border-color: --activeTrackColor03--;\n}\n.--appName--.desktop.v2 .app.app_button-style_rect-fill .wiring-button,\n.--appName--.desktop.v2 .app.app_button-style_round-fill .wiring-button {\n  background-color: --activeTrackColor--;\n  color: --backgroundColor10--;\n}\n.--appName--.desktop.v2 .app.app_button-style_rect-fill .wiring-button:hover:enabled,\n.--appName--.desktop.v2 .app.app_button-style_round-fill .wiring-button:hover:enabled {\n  background-color: --activeTrackColorHover--;\n  color: --backgroundColor10--;\n}\n.--appName--.desktop.v2 .app.app_button-style_rect-fill .wiring-button[disabled],\n.--appName--.desktop.v2 .app.app_button-style_round-fill .wiring-button[disabled] {\n  border-color: transparent;\n  background-color: --activeTrackColor04--;\n}\n.--appName--.desktop.v2 .app.app_button-style_rect-transparent .wiring-button,\n.--appName--.desktop.v2 .app.app_button-style_round-transparent .wiring-button {\n  color: --activeTrackColor--;\n}\n.--appName--.desktop.v2 .app.app_button-style_rect-transparent .wiring-button:hover:enabled,\n.--appName--.desktop.v2 .app.app_button-style_round-transparent .wiring-button:hover:enabled {\n  background-color: --activeTrackColor--;\n  color: --backgroundColor10--;\n}\n.--appName--.desktop.v2 .app.app_button-style_rect-transparent .wiring-button[disabled],\n.--appName--.desktop.v2 .app.app_button-style_round-transparent .wiring-button[disabled] {\n  color: --activeTrackColor04--;\n}\n.--appName--.desktop.v2 .app.app_layout_horizontal {\n  min-width: --horizontalMinWidth--px;\n}\n.--appName--.desktop.v2 .app.app_layout_horizontal .track .buy-item {\n  font: --activeTrackButtonsFont--;\n}\n.--appName--.desktop.v2 .app.app_layout_horizontal .share-container__handler {\n  color: --activeTrackColor--;\n}\n.--appName--.desktop.v2 .app.app_layout_horizontal .share-container__handler svg path {\n  fill: --activeTrackColor--;\n}\n.--appName--.desktop.v2 .app.app_layout_horizontal.app_overlay-opened {\n  background-color: --transparentWhite--;\n}\n.--appName--.desktop.v2 .app.app_layout_list {\n  margin-right: --listSpacing--px;\n  margin-left: --listSpacing--px;\n}\n.--appName--.desktop.v2 .app.app_layout_list.app_basic .track_is-current .track-index-control {\n  border-color: --activeTrackColor03--;\n}\n.--appName--.desktop.v2 .app.app_layout_list.app_basic .track-index-control {\n  border-color: --trackColor03--;\n}\n.--appName--.desktop.v2 .app.app_layout_list.app_basic .track-index-control:hover {\n  border-color: --activeTrackColor03--;\n}\n.--appName--.desktop.v2 .app.app_layout_list.app_cover .track {\n  padding-top: calc(14px + --trackListMargins--px/2);\n  padding-bottom: --listTrackExtraPadding--px;\n}\n.--appName--.desktop.v2 .app.app_layout_list.app_cover .progress-bar {\n  padding-bottom: calc(--trackListMargins--px/2);\n}\n.--appName--.desktop.v2 .app.app_layout_list.app_minimal .track {\n  padding-bottom: calc(14px - 3px + --trackListMargins--px/2);\n}\n.--appName--.desktop.v2 .app.app_layout_list .track-slider-info {\n  color: --activeTrackColor--;\n}\n.--appName--.desktop.v2 .app.app_layout_list .album-info-separator {\n  border-top: 1px solid --dividersColor--;\n}\n.--appName--.desktop.v2 .app.app_layout_list .no-tracks {\n  padding-top: 30px;\n  border-top: 1px solid --dividersColor--;\n}\n.--appName--.desktop.v2 .app.app_layout_list .track-info svg {\n  fill: --activeTrackColor--;\n}\n.--appName--.desktop.v2 .app.app_layout_list .track-artist-name {\n  color: --trackColor06--;\n}\n.--appName--.desktop.v2 .app.app_layout_list .track {\n  padding-top: calc(14px + --trackListMargins--px/2);\n  padding-bottom: calc(14px + --trackListMargins--px/2);\n}\n.--appName--.desktop.v2 .app.app_layout_list .track .buy-item {\n  font: --activeTrackButtonsFont--;\n}\n.--appName--.desktop.v2 .app.app_layout_list .track.app_overlay-opened {\n  background-color: --transparentWhite--;\n}\n.--appName--.desktop.v2 .app.app_layout_list .track.track_is-current .track-artist-name,\n.--appName--.desktop.v2 .app.app_layout_list .track:hover .track-artist-name {\n  color: --activeTrackColor06--;\n}\n.--appName--.desktop.v2 .app.app_layout_list.app_hide_album_info .track-wrapper:first-child .track {\n  padding-top: 0;\n}\n.--appName--.desktop.v2 .app.app_layout_list .share-container__handler {\n  color: --activeTrackColor--;\n}\n.--appName--.desktop.v2 .app.app_layout_list .share-container__handler svg path {\n  fill: --activeTrackColor--;\n}\n.--appName--.desktop.v2 .app.app_layout_list .track-slider-progress {\n  background-color: --activeTrackColor--;\n}\n.--appName--.desktop.v2 .app.app_layout_list .track-slider-loaded {\n  background-color: --activeTrackColor03--;\n}\n.--appName--.desktop.v2 .app.app_layout_list .track-slider-as-divider {\n  background-color: --dividersColor--;\n}\n.--appName--.desktop.v2 .app.app_layout_list .album-titles .album-name {\n  font: --trackTitleFont--;\n}\n.--appName--.desktop.v2 .app .share-container.share-container_disabled svg path {\n  fill: --activeTrackColor04-- !important;\n}\n.--appName--.desktop.v2 .app .album-titles .track-name-wrapper,\n.--appName--.desktop.v2 .app .album-titles .track-name,\n.--appName--.desktop.v2 .app .album-titles .no-tracks {\n  color: --trackTitleColor--;\n  font: --trackTitleFont--;\n}\n.--appName--.desktop.v2 .app .album-titles .album-name,\n.--appName--.desktop.v2 .app .album-titles .artist-name {\n  color: --albumArtistColor--;\n  font: --albumArtistFont--;\n}\n.--appName--.desktop.v2 .app .album-titles .buy-item:not(.wiring-button) {\n  color: --activeTrackColor--;\n  font: --trackFont--;\n}\n.--appName--.desktop.v2 .app .album-titles .buy-item:not(.wiring-button) svg path {\n  fill: --activeTrackColor--;\n}\n.--appName--.desktop.v2 .app .album-cover .album-titles-center,\n.--appName--.desktop.v2 .app .album-cover .album-titles-left {\n  background: --backgroundColor08--;\n}\n.--appName--.desktop.v2 .app .progress-bar,\n.--appName--.desktop.v2 .app .progress-bar__duration,\n.--appName--.desktop.v2 .app .progress-bar__played {\n  color: --controlBarColor--;\n  font: --trackFont--;\n  font-size: 12px;\n}\n.--appName--.desktop.v2 .app .slider-bar {\n  background-color: --controlBarColor02--;\n}\n.--appName--.desktop.v2 .app .slider-loaded {\n  background-color: --activeTrackColor05--;\n}\n.--appName--.desktop.v2 .app .slider-progress {\n  background-color: --activeTrackColor10--;\n}\n.--appName--.desktop.v2 .app .buy-share {\n  color: --buyShareLinksColor--;\n}\n.--appName--.desktop.v2 .app .buy-share button {\n  color: --buyShareLinksColor--;\n  font: --buyShareLinksFont--;\n}\n.--appName--.desktop.v2 .app .buy-share button:hover:enabled {\n  color: --activeTrackColor--;\n}\n.--appName--.desktop.v2 .app .buy-share .action-icon {\n  font: --buyShareLinksFont--;\n}\n.--appName--.desktop.v2 .app .buy-share .wiring-button {\n  font: --activeTrackButtonsFont--;\n}\n.--appName--.desktop.v2 .app .volume-slider {\n  border-color: --volumeBarBorderColor--;\n  background-color: --backgroundColor10--;\n}\n.--appName--.desktop.v2 .app .volume-slider .volume-slider__total {\n  background-color: --volumeBarNotActiveColor--;\n}\n.--appName--.desktop.v2 .app .volume-slider .volume-slider__level {\n  background-color: --controlBarColor--;\n}\n.--appName--.desktop.v2 .app .volume-slider .volume-slider__handle {\n  background-color: --controlBarColor--;\n}\n.--appName--.desktop.v2 .app .track,\n.--appName--.desktop.v2 .app .no-tracks,\n.--appName--.desktop.v2 .app .track .buy-item:not(.wiring-button) {\n  color: --trackColor--;\n  font: --trackFont--;\n}\n.--appName--.desktop.v2 .app .track {\n  height: --trackRowHeight--px;\n  border-color: --dividersColor--;\n  line-height: 1.2em;\n}\n.--appName--.desktop.v2 .app .track .play svg path,\n.--appName--.desktop.v2 .app .track .pause svg path {\n  fill: --trackColor--;\n}\n.--appName--.desktop.v2 .app .track__list-item:focus .track,\n.--appName--.desktop.v2 .app .track__list-item.focus-within .track,\n.--appName--.desktop.v2 .app .track__list-item:hover .track,\n.--appName--.desktop.v2 .app .track_is-current,\n.--appName--.desktop.v2 .app .track_is-playing {\n  color: --activeTrackColor--;\n}\n.--appName--.desktop.v2 .app .track__list-item:focus .track .play svg path,\n.--appName--.desktop.v2 .app .track__list-item.focus-within .track .play svg path,\n.--appName--.desktop.v2 .app .track__list-item:hover .track .play svg path,\n.--appName--.desktop.v2 .app .track_is-current .play svg path,\n.--appName--.desktop.v2 .app .track_is-playing .play svg path,\n.--appName--.desktop.v2 .app .track__list-item:focus .track .pause svg path,\n.--appName--.desktop.v2 .app .track__list-item.focus-within .track .pause svg path,\n.--appName--.desktop.v2 .app .track__list-item:hover .track .pause svg path,\n.--appName--.desktop.v2 .app .track_is-current .pause svg path,\n.--appName--.desktop.v2 .app .track_is-playing .pause svg path {\n  fill: --activeTrackColor--;\n}\n.--appName--.desktop.v2 .app .track .track-share .share-container__handler svg path {\n  fill: --activeTrackColor--;\n}\n.--appName--.desktop.v2 .app .track .buy-item:not(.wiring-button) {\n  background-color: --activeTrackColor--;\n  color: --backgroundColor10--;\n}\n.--appName--.desktop.v2 .app .share-icons svg path {\n  fill: --trackTitleColor--;\n}\n.--appName--.desktop.v2 .app .share-icons > .share-container::before {\n  background: --backgroundColor10--;\n}\n.--appName--.desktop.v2 .app .track .share-icons .share-button svg path {\n  fill: --trackTitleColor--;\n}\n.--appName--.desktop.v2 .app .control-bar:not(.control-bar_is-disabled) {\n  color: --controlBarColor--;\n}\n.--appName--.desktop.v2 .app .control-bar:not(.control-bar_is-disabled) .prev,\n.--appName--.desktop.v2 .app .control-bar:not(.control-bar_is-disabled) .play,\n.--appName--.desktop.v2 .app .control-bar:not(.control-bar_is-disabled) .pause,\n.--appName--.desktop.v2 .app .control-bar:not(.control-bar_is-disabled) .next,\n.--appName--.desktop.v2 .app .control-bar:not(.control-bar_is-disabled) .volume,\n.--appName--.desktop.v2 .app .control-bar:not(.control-bar_is-disabled) .track-info,\n.--appName--.desktop.v2 .app .control-bar:not(.control-bar_is-disabled) .share {\n  border-color: --controlBarColor--;\n}\n.--appName--.desktop.v2 .app .control-bar:not(.control-bar_is-disabled) .prev svg path,\n.--appName--.desktop.v2 .app .control-bar:not(.control-bar_is-disabled) .play svg path,\n.--appName--.desktop.v2 .app .control-bar:not(.control-bar_is-disabled) .pause svg path,\n.--appName--.desktop.v2 .app .control-bar:not(.control-bar_is-disabled) .next svg path,\n.--appName--.desktop.v2 .app .control-bar:not(.control-bar_is-disabled) .volume svg path,\n.--appName--.desktop.v2 .app .control-bar:not(.control-bar_is-disabled) .track-info svg path,\n.--appName--.desktop.v2 .app .control-bar:not(.control-bar_is-disabled) .share svg path {\n  fill: --controlBarColor--;\n}\n.--appName--.desktop.v2 .app .control-bar:not(.control-bar_is-disabled) .prev:hover,\n.--appName--.desktop.v2 .app .control-bar:not(.control-bar_is-disabled) .play:hover,\n.--appName--.desktop.v2 .app .control-bar:not(.control-bar_is-disabled) .pause:hover,\n.--appName--.desktop.v2 .app .control-bar:not(.control-bar_is-disabled) .next:hover,\n.--appName--.desktop.v2 .app .control-bar:not(.control-bar_is-disabled) .volume:hover,\n.--appName--.desktop.v2 .app .control-bar:not(.control-bar_is-disabled) .track-info:hover,\n.--appName--.desktop.v2 .app .control-bar:not(.control-bar_is-disabled) .share:hover {\n  border-color: --activeTrackColor--;\n}\n.--appName--.desktop.v2 .app .control-bar:not(.control-bar_is-disabled) .prev:hover svg path,\n.--appName--.desktop.v2 .app .control-bar:not(.control-bar_is-disabled) .play:hover svg path,\n.--appName--.desktop.v2 .app .control-bar:not(.control-bar_is-disabled) .pause:hover svg path,\n.--appName--.desktop.v2 .app .control-bar:not(.control-bar_is-disabled) .next:hover svg path,\n.--appName--.desktop.v2 .app .control-bar:not(.control-bar_is-disabled) .volume:hover svg path,\n.--appName--.desktop.v2 .app .control-bar:not(.control-bar_is-disabled) .track-info:hover svg path,\n.--appName--.desktop.v2 .app .control-bar:not(.control-bar_is-disabled) .share:hover svg path {\n  fill: --activeTrackColor--;\n}\n.--appName--.desktop.v2 .app .control-bar:not(.control-bar_is-disabled) .volume:hover .volume-button {\n  border-color: --activeTrackColor--;\n}\n.--appName--.desktop.v2 .app .control-bar:not(.control-bar_is-disabled) .volume:hover .volume-button svg path {\n  fill: --activeTrackColor--;\n}\n.--appName--.desktop.v2 .app .control-bar:not(.control-bar_is-disabled) .volume-slider:hover .volume-slider__level,\n.--appName--.desktop.v2 .app .control-bar:not(.control-bar_is-disabled) .volume-slider:hover .volume-slider__handle {\n  background-color: --activeTrackColor--;\n}\n.--appName--.desktop.v2 .app .current-album {\n  color: --albumArtistColor--;\n  font: --albumArtistFont--;\n}\n.--appName--.desktop.v2 .app .play-pause-maxi {\n  border-color: --controlBarColor--;\n}\n.--appName--.desktop.v2 .app .play-pause-maxi svg path {\n  fill: --controlBarColor--;\n}\n.--appName--.desktop.v2 .app .play-pause-maxi:not(.play-pause-maxi_is-disabled):hover {\n  border-color: --activeTrackColor--;\n}\n.--appName--.desktop.v2 .app .play-pause-maxi:not(.play-pause-maxi_is-disabled):hover svg path {\n  fill: --activeTrackColor--;\n}\n.--appName--.desktop.v2 .app .share-overlay {\n  background-color: --backgroundColor088--;\n}\n.--appName--.desktop.v2 .app .share-overlay__close svg path {\n  fill: --albumArtistColor--;\n}\n.--appName--.desktop.v2 .app .share-overlay-header {\n  color: --albumArtistColor--;\n  font: --albumArtistFont--;\n}\n.--appName--.desktop.v2 .app .share-overlay-header:active .share-overlay-header__slider {\n  background-color: --activeTrackColor--;\n}\n.--appName--.desktop.v2 .app .share-overlay-header__share-title {\n  color: --albumArtistColor--;\n  font: --albumArtistFont--;\n}\n.--appName--.desktop.v2 .app .share-overlay-header__slider {\n  background-color: --albumArtistColor--;\n}\n.--appName--.desktop.v2 .app .share-overlay .share-button path {\n  fill: --albumArtistColor--;\n}\n.--appName--.desktop.v2 .app .share-overlay .share-button:hover path {\n  fill: --activeTrackColor--;\n}\n.--appName--.desktop.v2 .app .circular-progress__background {\n  fill: transparent;\n  stroke: --activeTrackColor05--;\n}\n.--appName--.desktop.v2 .app .circular-progress__foreground {\n  fill: transparent;\n  stroke: --activeTrackColor10--;\n}\n";
  return css.replace(/--(\w[\w\d]*)--/g, function (match, group) {
    return settings.hasOwnProperty(group) ? settings[group] : match;
  });
};

/***/ }),
/* 67 */
/* no static exports found */
/* all exports used */
/*!*********************************************!*\
  !*** ./scripts/common/persistent-events.js ***!
  \*********************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PersistentEventEmitter = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _events = __webpack_require__(/*! events */ 8);

var EventEmitter = _interopRequireDefault(_events).default;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PersistentEventEmitter = exports.PersistentEventEmitter = function (_EventEmitter) {
  _inherits(PersistentEventEmitter, _EventEmitter);

  function PersistentEventEmitter() {
    var allowedEventsNumber = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

    _classCallCheck(this, PersistentEventEmitter);

    var _this = _possibleConstructorReturn(this, (PersistentEventEmitter.__proto__ || Object.getPrototypeOf(PersistentEventEmitter)).call(this));

    _this.__allowedEventsNumber = allowedEventsNumber;
    _this.__persistentEvents = {};
    return _this;
  }

  _createClass(PersistentEventEmitter, [{
    key: 'emit',
    value: function emit(eventName) {
      var _get2;

      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      this.__persistentEvents[eventName] = [].concat(_toConsumableArray(this.__persistentEvents[eventName] || []), [args]).slice(-this.__allowedEventsNumber);
      (_get2 = _get(PersistentEventEmitter.prototype.__proto__ || Object.getPrototypeOf(PersistentEventEmitter.prototype), 'emit', this)).call.apply(_get2, [this, eventName].concat(args));
    }
  }, {
    key: 'addListener',
    value: function addListener(eventName, listener) {
      var _this2 = this;

      _get(PersistentEventEmitter.prototype.__proto__ || Object.getPrototypeOf(PersistentEventEmitter.prototype), 'addListener', this).call(this, eventName, listener);
      var eventsHistory = this.__persistentEvents[eventName];

      if (eventsHistory) {
        setTimeout(function () {
          eventsHistory.forEach(function (args) {
            listener.apply(_this2, args);
          });
        }, 0);
      }
    }
  }, {
    key: 'on',
    value: function on() {
      this.addListener.apply(this, arguments);
    }
  }]);

  return PersistentEventEmitter;
}(EventEmitter);

/***/ }),
/* 68 */
/* no static exports found */
/* all exports used */
/*!*******************************************************!*\
  !*** ./scripts/common/social-urls-builder-creator.js ***!
  \*******************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.urlsBuilderCreator = undefined;

var _utils = __webpack_require__(/*! ../utils/utils */ 2);

var utils = _utils.utils;
var urlsBuilderCreator = exports.urlsBuilderCreator = function urlsBuilderCreator(albumData, siteUrl) {
  return {
    facebook: function facebook(data) {
      var scaledImageCoverUrl = utils.buildScaledImageUrl(data.cover || albumData.album.cover, 'fill', 158, 158);

      // Album description for album share, album name for track share
      var description = data.id === albumData.id ? data.description : albumData.name;

      var params = utils.params({
        ref: 'site',
        display: 'popup',
        picture: 'https:' + scaledImageCoverUrl,
        title: data.name + ' | ' + data.artistName,
        description: description || '&nbsp;', // prevent facebook from parsing page tags if description is empty
        u: siteUrl,
        source: data.url,
        redirect_uri: 'http://musicwizard.wix.com/backend/assets/notify_parent.html'
      });

      return 'https://www.facebook.com/sharer/sharer.php?' + params;
    },
    twitter: function twitter(data) {
      var params = utils.params({
        original_referer: siteUrl,
        text: siteUrl + ' ' + data.name
      });

      return 'https://twitter.com/intent/tweet?' + params;
    },
    blogger: function blogger(data) {
      var params = utils.params({
        u: siteUrl,
        n: data.name
      });

      return 'https://www.blogger.com/blog-this.g?' + params;
    },
    tumblr: function tumblr() {
      var params = utils.params({
        url: siteUrl
      });

      return 'https://www.tumblr.com/share/link?' + params;
    }
  };
};

/***/ }),
/* 69 */
/* no static exports found */
/* all exports used */
/*!****************************************************!*\
  !*** ./scripts/player/v2/desktop/app.component.js ***!
  \****************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DesktopAppComponent = undefined;

var _focusSource = __webpack_require__(/*! @wix/music-shared/dist/src/accessibility/focus-source */ 96);

var focusSource = _focusSource.focusSource;

var _mithril = __webpack_require__(/*! mithril */ 0);

var m = _interopRequireDefault(_mithril).default;

var _focusWithin = __webpack_require__(/*! ../../../common/focus-within/focus-within */ 80);

var focusWithin = _focusWithin.focusWithin;

var _v2SettingsConstants = __webpack_require__(/*! ../../../common/parse-settings/v2-settings-constants */ 4);

var LAYOUT_TYPES = _v2SettingsConstants.LAYOUT_TYPES;

var _appKeyboardHandler = __webpack_require__(/*! ../shared/app-keyboard-handler */ 47);

var handleAppKeydown = _appKeyboardHandler.handleAppKeydown;

var _l10n = __webpack_require__(/*! ../shared/l10n */ 1);

var l10n = _l10n.l10n;

var _app = __webpack_require__(/*! ./horizontal/app.component */ 198);

var HorizontalAppComponent = _app.HorizontalAppComponent;

var _app2 = __webpack_require__(/*! ./list/app.component */ 211);

var ListAppComponent = _app2.ListAppComponent;

var _app3 = __webpack_require__(/*! ./vertical/app.component */ 233);

var VerticalAppComponent = _app3.VerticalAppComponent;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var DesktopAppComponent = exports.DesktopAppComponent = {
  view: function view(ctrl, attrs) {
    var _layouts;

    var playback = attrs.playback,
        settings = attrs.settings;

    var layouts = (_layouts = {}, _defineProperty(_layouts, LAYOUT_TYPES.VERTICAL, VerticalAppComponent), _defineProperty(_layouts, LAYOUT_TYPES.HORIZONTAL, HorizontalAppComponent), _defineProperty(_layouts, LAYOUT_TYPES.LIST, ListAppComponent), _layouts);
    var LayoutAppComponent = layouts[settings.layout];
    var config = function config(element, isInitialized, context) {
      if (isInitialized) {
        return;
      }
      var disengageFocusWithin = focusWithin();
      var handleFocusSource = focusSource();
      context.onunload = function () {
        disengageFocusWithin();
        handleFocusSource.disengage();
      };
    };
    return {
      tag: 'section',
      children: [m.component(LayoutAppComponent, attrs, [])],
      attrs: { config: config, 'aria-label': l10n('app_title'), onkeyup: handleAppKeydown({ playback: playback }) }
    };
  }
};

/***/ }),
/* 70 */
/* no static exports found */
/* all exports used */
/*!********************************************************!*\
  !*** ./scripts/player/v2/shared/models/album-model.js ***!
  \********************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Album = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _desc, _value, _class;

var _deprecated = __webpack_require__(/*! ../../../../utils/deprecated */ 7);

var deprecated = _deprecated.deprecated;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var Album = exports.Album = (_class = function () {
  function Album(albumData) {
    _classCallCheck(this, Album);

    if (albumData) {
      Object.assign(this, albumData.album);
      this.tracks = albumData.tracks;
    }
  }

  _createClass(Album, [{
    key: 'serialize',
    value: function serialize() {
      return JSON.stringify(this);
    }
  }, {
    key: 'isDemo',
    get: function get() {
      return this.demo;
    }
  }, {
    key: 'album',
    get: function get() {
      return this;
    }
  }], [{
    key: 'unserialize',
    value: function unserialize(serialized) {
      var data = JSON.parse(serialized);
      var album = new Album();
      Object.assign(album, data);
      return album;
    }
  }]);

  return Album;
}(), (_applyDecoratedDescriptor(_class.prototype, 'album', [deprecated], Object.getOwnPropertyDescriptor(_class.prototype, 'album'), _class.prototype)), _class);

/***/ }),
/* 71 */
/* no static exports found */
/* all exports used */
/*!***********************************************************!*\
  !*** ./scripts/player/v2/shared/models/settings-model.js ***!
  \***********************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Settings = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _desc, _value, _class;

var _v2SettingsConstants = __webpack_require__(/*! ../../../../common/parse-settings/v2-settings-constants */ 4);

var ALBUM_COVER_SCALING = _v2SettingsConstants.ALBUM_COVER_SCALING;
var LAYOUT_TYPES = _v2SettingsConstants.LAYOUT_TYPES;

var _deprecated = __webpack_require__(/*! ../../../../utils/deprecated */ 7);

var deprecated = _deprecated.deprecated;

var _buildCoverDimensions = __webpack_require__(/*! ../../../build-cover-dimensions */ 34);

var RESIZE_MODE = _buildCoverDimensions.RESIZE_MODE;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var Settings = exports.Settings = (_class = function () {
  function Settings(settings) {
    _classCallCheck(this, Settings);

    Object.assign(this, settings);
    this.imageResizeMode = this._getResizeMode();
  }

  _createClass(Settings, [{
    key: 'serialize',
    value: function serialize() {
      return JSON.stringify(this);
    }
  }, {
    key: '_getResizeMode',
    value: function _getResizeMode() {
      var _LAYOUT_TYPES$VERTICA;

      if (this.isMobileView) {
        return RESIZE_MODE.FIT;
      }
      return (_LAYOUT_TYPES$VERTICA = {}, _defineProperty(_LAYOUT_TYPES$VERTICA, LAYOUT_TYPES.VERTICAL, this.albumCoverScaling === ALBUM_COVER_SCALING.AUTO_CROP ? RESIZE_MODE.CROP : RESIZE_MODE.FIT), _defineProperty(_LAYOUT_TYPES$VERTICA, LAYOUT_TYPES.HORIZONTAL, RESIZE_MODE.FIXED), _LAYOUT_TYPES$VERTICA)[this.layout];
    }
  }, {
    key: 'coverStyle',
    get: function get() {
      return this.albumCoverScaling === ALBUM_COVER_SCALING.FIT ? 'fit' : 'crop';
    }
  }], [{
    key: 'unserialize',
    value: function unserialize(serialized) {
      return new Settings(JSON.parse(serialized));
    }
  }]);

  return Settings;
}(), (_applyDecoratedDescriptor(_class.prototype, 'coverStyle', [deprecated], Object.getOwnPropertyDescriptor(_class.prototype, 'coverStyle'), _class.prototype)), _class);

/***/ }),
/* 72 */
/* no static exports found */
/* all exports used */
/*!*************************************************************!*\
  !*** ./scripts/player/v2/shared/models/statistic-events.js ***!
  \*************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StatisticEvents = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _persistentEvents = __webpack_require__(/*! ../../../../common/persistent-events */ 67);

var PersistentEventEmitter = _persistentEvents.PersistentEventEmitter;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var StatisticEvents = function (_PersistentEventEmitt) {
  _inherits(StatisticEvents, _PersistentEventEmitt);

  function StatisticEvents(args) {
    _classCallCheck(this, StatisticEvents);

    var _this = _possibleConstructorReturn(this, (StatisticEvents.__proto__ || Object.getPrototypeOf(StatisticEvents)).call(this, 20));

    _this.__args = args;
    _this.__completedTracks = [];
    _this.__oneTimeEvents = new Set();
    return _this;
  }

  _createClass(StatisticEvents, [{
    key: 'emit',
    value: function emit(eventName, args) {
      _get(StatisticEvents.prototype.__proto__ || Object.getPrototypeOf(StatisticEvents.prototype), 'emit', this).call(this, eventName, _extends({}, this.__args, args));
      if (eventName === 'trackPlayCompleted') {
        // this cannot be added by addEventListener, cause listener can be deleted
        this.__onTrackPlayCompleted(args);
      }
    }
  }, {
    key: 'emitOnce',
    value: function emitOnce(eventName, args) {
      if (this.__oneTimeEvents.has(eventName)) {
        return;
      }
      this.__oneTimeEvents.add(eventName);
      this.emit(eventName, args);
    }
  }, {
    key: '__onTrackPlayCompleted',
    value: function __onTrackPlayCompleted(_ref) {
      var track = _ref.track,
          tracks = _ref.tracks;

      var completedTracks = this.__completedTracks;

      if (completedTracks.indexOf(track) === -1) {
        completedTracks.push(track);
      }
      if (completedTracks.length === tracks.length) {
        this.emit('albumPlayCompleted');
        completedTracks = [];
      }
      this.__completedTracks = completedTracks;
    }
  }]);

  return StatisticEvents;
}(PersistentEventEmitter);

exports.StatisticEvents = StatisticEvents;

/***/ }),
/* 73 */
/* no static exports found */
/* all exports used */
/*!****************************************************!*\
  !*** ./scripts/player/v2/shared/new-share-item.js ***!
  \****************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getNewFacebookShareUrl = getNewFacebookShareUrl;

var _index = __webpack_require__(/*! @wix/music-shared/dist/src/utils/url/index */ 76);

var createParam = _index.createParam;
var joinUrl = _index.joinUrl;

var _assert = __webpack_require__(/*! ../../../utils/assert */ 35);

var assert = _assert.assert;


function getOrigin(url) {
  var a = document.createElement('a');
  a.setAttribute('href', url);
  var port = a.port,
      protocol = a.protocol,
      hostname = a.hostname;

  var urlPort = port === '80' && protocol === 'http:' || port === '443' && protocol === 'https:' || !port ? '' : ':' + port;
  return protocol + '//' + hostname + urlPort;
}

function getRedirectUrl() {
  var settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var albumId = arguments[1];
  var trackId = arguments[2];
  var baseUrl = settings.baseUrl,
      pageId = settings.pageId,
      instanceId = settings.instanceId,
      compId = settings.compId,
      tpaApplicationId = settings.tpaApplicationId;

  assert(baseUrl, 'baseUrl is missing');
  assert(pageId, 'pageId is missing');
  assert(instanceId, 'instanceId is missing');
  assert(compId, 'compId is missing');
  assert(albumId, 'albumId is missing');

  var path = joinUrl(getOrigin(baseUrl), 'music-share', pageId);
  var params = {
    'instance-id': instanceId,
    'component-id': compId,
    'album-id': albumId,
    'tpa-id': tpaApplicationId,
    'track-id': trackId
  };
  return path + '?' + createParam(params);
}

function getNewFacebookShareUrl(settings, album, track) {
  var baseUrl = 'https://www.facebook.com/sharer/sharer.php';
  var params = {
    ref: 'site',
    display: 'popup',
    title: 'share it now!',
    u: getRedirectUrl(settings, album.id, track && track.id)
  };
  return baseUrl + '?' + createParam(params);
}

/***/ }),
/* 74 */
/* no static exports found */
/* all exports used */
/*!************************************************!*\
  !*** ./scripts/player/v2/shared/share-item.js ***!
  \************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.shareAlbum = shareAlbum;
exports.shareTrack = shareTrack;

var _socialUrlsBuilderCreator = __webpack_require__(/*! ../../../common/social-urls-builder-creator */ 68);

var urlsBuilderCreator = _socialUrlsBuilderCreator.urlsBuilderCreator;

var _queryString = __webpack_require__(/*! ../../../utils/query-string */ 75);

var queryString = _queryString.queryString;

var _utils = __webpack_require__(/*! ../../../utils/utils */ 2);

var utils = _utils.utils;

var _newShareItem = __webpack_require__(/*! ./new-share-item */ 73);

var getNewFacebookShareUrl = _newShareItem.getNewFacebookShareUrl;


function getShareUrl(social, album, siteUrl, shareItem) {
  var urlsBuilder = urlsBuilderCreator(album, siteUrl);

  return urlsBuilder[social](shareItem);
}

function tryGetFacebookShareUrl(settings, social, album, track) {
  if (social === 'facebook') {
    return getNewFacebookShareUrl(settings, album, track);
  }
}

function shareAlbum(social, album, settings) {
  var shareUrl = tryGetFacebookShareUrl(settings, social, album) || getShareUrl(social, album, settings.siteUrl, album);
  openSocialPopup(shareUrl);
}

function shareTrack(social, album, settings, track) {
  var siteUrl = settings.siteUrl;

  var _siteUrl$split = siteUrl.split('?'),
      _siteUrl$split2 = _slicedToArray(_siteUrl$split, 2),
      host = _siteUrl$split2[0],
      queryParamsStr = _siteUrl$split2[1];

  var queryParams = queryString.parse(queryParamsStr);
  var trackArgs = _extends({}, queryParams, {
    'wix-music-track-id': track.id
  });
  if (settings.compId) {
    trackArgs['wix-music-comp-id'] = settings.compId;
  }
  var trackQueryString = queryString.stringify(trackArgs);
  var trackSiteUrl = host + '?' + trackQueryString;

  var shareUrl = tryGetFacebookShareUrl(settings, social, album, track) || getShareUrl(social, album, trackSiteUrl, track);
  openSocialPopup(shareUrl);
}

function openSocialPopup(shareUrl) {
  utils.openPopup(shareUrl, 626, 436);
}

/***/ }),
/* 75 */
/* no static exports found */
/* all exports used */
/*!***************************************!*\
  !*** ./scripts/utils/query-string.js ***!
  \***************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var queryString = exports.queryString = {
  parse: function parse(str) {
    return str ? str.split('&').reduce(function (acc, param) {
      var _param$split = param.split('='),
          _param$split2 = _slicedToArray(_param$split, 2),
          key = _param$split2[0],
          value = _param$split2[1];

      acc[key] = value;
      return acc;
    }, {}) : {};
  },
  stringify: function stringify(obj) {
    return Object.keys(obj).map(function (arg) {
      return arg + '=' + obj[arg];
    }).join('&');
  }
};

exports.default = queryString;

/***/ }),
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */
/* no static exports found */
/* all exports used */
/*!*****************************************************!*\
  !*** ./scripts/common/focus-within/focus-within.js ***!
  \*****************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _focusWithin = __webpack_require__(/*! @wix/music-shared/dist/src/accessibility/focus-within */ 169);

Object.defineProperty(exports, 'focusWithin', {
  enumerable: true,
  get: function get() {
    return _focusWithin.focusWithin;
  }
});

/***/ }),
/* 81 */
/* no static exports found */
/* all exports used */
/*!************************************************************************!*\
  !*** ./scripts/player/v2/shared/components/buy-share-actions/index.js ***!
  \************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _buyShare = __webpack_require__(/*! ./buy-share.component */ 147);

Object.defineProperty(exports, 'BuyShareActions', {
  enumerable: true,
  get: function get() {
    return _buyShare.BuyShareActions;
  }
});

/***/ }),
/* 82 */
/* no static exports found */
/* all exports used */
/*!*******************************************************************!*\
  !*** ./scripts/player/v2/desktop/components/moving-text/index.js ***!
  \*******************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _movingText = __webpack_require__(/*! ./moving-text */ 192);

Object.defineProperty(exports, 'MovingText', {
  enumerable: true,
  get: function get() {
    return _movingText.MovingText;
  }
});

/***/ }),
/* 83 */
/* no static exports found */
/* all exports used */
/*!*******************************************************************!*\
  !*** ./scripts/player/v2/desktop/components/share-album/index.js ***!
  \*******************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _shareAlbumComponent = __webpack_require__(/*! ./share-album.component.js */ 193);

Object.defineProperty(exports, 'ShareAlbum', {
  enumerable: true,
  get: function get() {
    return _shareAlbumComponent.ShareAlbum;
  }
});

/***/ }),
/* 84 */
/* no static exports found */
/* all exports used */
/*!******************************************************************!*\
  !*** ./scripts/player/v2/desktop/components/track-list/index.js ***!
  \******************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TrackListDesktop = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _mithril = __webpack_require__(/*! mithril */ 0);

var m = _interopRequireDefault(_mithril).default;

var _trackList = __webpack_require__(/*! ../../../shared/components/track-list/track-list.component */ 51);

var TrackList = _trackList.TrackList;

var _scrollToTrack = __webpack_require__(/*! ../../../shared/components/track-list/scroll-to-track */ 50);

var scrollToTrack = _scrollToTrack.scrollToTrack;

var _track = __webpack_require__(/*! ./track */ 195);

var Track = _track.Track;

__webpack_require__(/*! ./track-list.less */ 94);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TrackListDesktop = {
  view: function view(ctrl, attrs) {
    return m.component(TrackList, _extends({}, attrs, { Track: Track, scrollToTrack: scrollToTrack }), []);
  }
};

exports.TrackListDesktop = TrackListDesktop;

/***/ }),
/* 85 */
/* no static exports found */
/* all exports used */
/*!******************************************************************************!*\
  !*** ./scripts/player/v2/desktop/components/track-list/track/share-track.js ***!
  \******************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ShareTrack = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _mithril = __webpack_require__(/*! mithril */ 0);

var m = _interopRequireDefault(_mithril).default;

var _share = __webpack_require__(/*! ../../../../shared/icons/share.svg */ 13);

var shareTrackIcon = _interopRequireDefault(_share).default;

var _l10n = __webpack_require__(/*! ../../../../shared/l10n */ 1);

var l10n = _l10n.l10n;

var _shareButton = __webpack_require__(/*! ../../share-button */ 52);

var ShareButton = _shareButton.ShareButton;

__webpack_require__(/*! ./share-track.less */ 249);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ShareTrack = {
  view: function view(ctrl, attrs) {
    var _onShare = attrs.onShare,
        track = attrs.shareItem;


    return {
      tag: 'div',
      children: [m.component(ShareButton, _extends({}, attrs, { onShare: function onShare(network) {
          return _onShare(network, track);
        } }), [{
        tag: 'span',
        children: [m.trust(shareTrackIcon)],
        attrs: { 'aria-hidden': 'true' }
      }])],
      attrs: { className: 'track-share', 'aria-label': l10n('player_share_song') }
    };
  }
};

exports.ShareTrack = ShareTrack;

/***/ }),
/* 86 */
/* no static exports found */
/* all exports used */
/*!**********************************************************************************!*\
  !*** ./scripts/player/v2/desktop/components/track-list/track/track-buy/index.js ***!
  \**********************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _trackBuyWrapper = __webpack_require__(/*! ./track-buy-wrapper */ 196);

Object.defineProperty(exports, 'TrackBuyWrapper', {
  enumerable: true,
  get: function get() {
    return _trackBuyWrapper.TrackBuyWrapper;
  }
});

/***/ }),
/* 87 */
/* no static exports found */
/* all exports used */
/*!*****************************************************************************************!*\
  !*** ./scripts/player/v2/desktop/horizontal/components/control-bar/control-bar-maxi.js ***!
  \*****************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ControlBarMaxi = exports.PlayPauseMaxi = undefined;

var _classnames = __webpack_require__(/*! classnames */ 3);

var classNames = _interopRequireDefault(_classnames).default;

var _mithril = __webpack_require__(/*! mithril */ 0);

var m = _interopRequireDefault(_mithril).default;

var _utils = __webpack_require__(/*! ../../../../../../utils/utils */ 2);

var utils = _utils.utils;

var _playPauseButton = __webpack_require__(/*! ../../../../shared/components/play-pause-button/play-pause-button.component */ 26);

var PlayPauseButton = _playPauseButton.PlayPauseButton;

var _progressBar = __webpack_require__(/*! ../../../../shared/components/progress-bar */ 25);

var ProgressBar = _progressBar.ProgressBar;

var _slider = __webpack_require__(/*! ../../../../shared/components/slider */ 16);

var Slider = _slider.DesktopSlider;

var _volume = __webpack_require__(/*! ../../../../shared/components/volume */ 27);

var Volume = _volume.Volume;

var _share = __webpack_require__(/*! ../../../../shared/icons/share.svg */ 13);

var shareIcon = _interopRequireDefault(_share).default;

var _trackInfo = __webpack_require__(/*! ../../../../shared/icons/track-info.svg */ 28);

var trackInfoIcon = _interopRequireDefault(_trackInfo).default;

var _l10n = __webpack_require__(/*! ../../../../shared/l10n */ 1);

var l10n = _l10n.l10n;

var _next = __webpack_require__(/*! ./icons/maxi/next.svg */ 280);

var nextIcon = _interopRequireDefault(_next).default;

var _pause = __webpack_require__(/*! ./icons/maxi/pause.svg */ 281);

var pauseIcon = _interopRequireDefault(_pause).default;

var _play = __webpack_require__(/*! ./icons/maxi/play.svg */ 282);

var playIcon = _interopRequireDefault(_play).default;

var _prev = __webpack_require__(/*! ./icons/maxi/prev.svg */ 283);

var prevIcon = _interopRequireDefault(_prev).default;

__webpack_require__(/*! ./styles/control-bar-maxi.less */ 252);

__webpack_require__(/*! ./styles/play-pause-maxi.less */ 255);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PlayPauseMaxi = exports.PlayPauseMaxi = {
  view: function view(ctrl, attrs) {
    var onPlay = attrs.onPlay,
        onPause = attrs.onPause,
        isPlaying = attrs.isPlaying,
        isDisabled = attrs.isDisabled;

    var togglePlay = function togglePlay() {
      if (isPlaying) {
        onPause();
      } else {
        onPlay();
      }
    };

    return m.component(PlayPauseButton, {
      className: 'play-pause-maxi',
      isDisabled: isDisabled,
      isPlaying: isPlaying,
      onAction: togglePlay,
      playIcon: m.trust(playIcon),
      pauseIcon: m.trust(pauseIcon)
    }, []);
  }
};

var ControlBarMaxi = exports.ControlBarMaxi = {
  view: function view(ctrl, attrs) {
    var playback = attrs.playback,
        isDisabled = attrs.isDisabled,
        duration = attrs.duration,
        played = attrs.played,
        loaded = attrs.loaded,
        onUpdateProgress = attrs.onUpdateProgress,
        openTrackPage = attrs.openTrackPage,
        onShare = attrs.onShare,
        onPrev = attrs.onPrev,
        onNext = attrs.onNext,
        showShareButton = attrs.showShareButton,
        showDetailedTrackInfo = attrs.showDetailedTrackInfo;

    var className = classNames('control-bar', 'control-bar_type_maxi', { 'control-bar_is-disabled': isDisabled });
    var playedText = utils.durationToAccString(played);
    var durationText = utils.durationToAccString(duration);

    return {
      tag: 'div',
      children: [{
        tag: 'div',
        children: [{
          tag: 'button',
          children: [{
            tag: 'span',
            children: [m.trust(prevIcon)],
            attrs: { 'aria-hidden': 'true' }
          }],
          attrs: {
            className: 'prev',
            type: 'button',
            'aria-label': l10n('player_acc_prev'),
            onclick: onPrev,
            disabled: isDisabled
          }
        }, {
          tag: 'button',
          children: [{
            tag: 'span',
            children: [m.trust(nextIcon)],
            attrs: { 'aria-hidden': 'true' }
          }],
          attrs: {
            className: 'next',
            type: 'button',
            'aria-label': l10n('player_acc_next'),
            onclick: onNext,
            disabled: isDisabled
          }
        }],
        attrs: { className: 'control-bar__controls control-bar__controls_navigation' }
      }, m.component(ProgressBar, { duration: duration, played: played, loaded: loaded, shouldAriaHide: !playback.hasPlayed }, [m.component(Slider, {
        progress: played || 0,
        maxValue: duration,
        valueText: l10n('player_acc_progress_value', [playedText, durationText]),
        loaded: loaded,
        isDisabled: isDisabled,
        onUpdate: onUpdateProgress
      }, [])]), {
        tag: 'div',
        children: [m.component(Volume, { playback: playback, isDisabled: isDisabled }, []), showDetailedTrackInfo ? {
          tag: 'button',
          children: [{
            tag: 'span',
            children: [m.trust(trackInfoIcon)],
            attrs: { 'aria-hidden': 'true' }
          }],
          attrs: {
            className: 'track-info',
            'aria-label': l10n('player_acc_track_info'),
            type: 'button',
            onclick: openTrackPage,
            disabled: isDisabled
          }
        } : null, showShareButton ? {
          tag: 'button',
          children: [{
            tag: 'span',
            children: [m.trust(shareIcon)],
            attrs: { 'aria-hidden': 'true' }
          }],
          attrs: {
            className: 'share',
            type: 'button',
            'aria-label': l10n('player_acc_share'),
            'aria-haspopup': 'true',
            disabled: isDisabled,
            onclick: onShare
          }
        } : null],
        attrs: { className: 'control-bar__controls' }
      }],
      attrs: { className: className }
    };
  }
};

/***/ }),
/* 88 */
/* no static exports found */
/* all exports used */
/*!***************************************************************************************************!*\
  !*** ./scripts/player/v2/desktop/vertical/components/album-titles/album-titles-view.component.js ***!
  \***************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AlbumTitlesView = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _mithril = __webpack_require__(/*! mithril */ 0);

var m = _interopRequireDefault(_mithril).default;

var _utils = __webpack_require__(/*! ../../../../../../utils/utils */ 2);

var utils = _utils.utils;

var _buyTrack = __webpack_require__(/*! ../../../../shared/components/buy-track */ 17);

var BuyTrack = _buyTrack.BuyTrack;

var _trackName = __webpack_require__(/*! ../../../../shared/components/track-name/track-name */ 92);

var TrackName = _trackName.TrackName;

var _l10n = __webpack_require__(/*! ../../../../shared/l10n */ 1);

var l10n = _l10n.l10n;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FakeBuyTrack = {
  view: function view(ctrl, attrs) {
    var track = attrs.track,
        _attrs$shouldShowBuyC = attrs.shouldShowBuyCurrentTrack,
        shouldShowBuyCurrentTrack = _attrs$shouldShowBuyC === undefined ? true : _attrs$shouldShowBuyC,
        _attrs$shouldShowFake = attrs.shouldShowFakeBuyTrack,
        shouldShowFakeBuyTrack = _attrs$shouldShowFake === undefined ? false : _attrs$shouldShowFake;

    var shouldShowFakeBuyTrackButton = !shouldShowBuyCurrentTrack && shouldShowFakeBuyTrack;
    return shouldShowFakeBuyTrackButton ? m.component(BuyTrack, { className: 'fake-buy-track', buy: utils.noop, track: track }, []) : {
      tag: 'div'
    };
  }
};

var AlbumTitlesView = {
  view: function view(ctrl, attrs) {
    var track = attrs.track,
        albumName = attrs.albumName,
        artistName = attrs.artistName,
        trackName = attrs.trackName,
        theme = attrs.theme,
        isBuyDisabled = attrs.isBuyDisabled,
        albumTranslationKeys = attrs.albumTranslationKeys,
        shouldShowAddFirst = attrs.shouldShowAddFirst,
        _attrs$shouldShowBuyC2 = attrs.shouldShowBuyCurrentTrack,
        shouldShowBuyCurrentTrack = _attrs$shouldShowBuyC2 === undefined ? true : _attrs$shouldShowBuyC2;

    var albumArtistName = artistName + ' / ' + albumName;
    var className = ['album-titles', 'album-titles_theme_' + theme].join(' ');
    var buyTrackAttrs = {
      isDisabled: isBuyDisabled,
      track: track
    };

    return {
      tag: 'div',
      children: [{
        tag: 'div',
        children: [{
          tag: 'p',
          children: [m.component(TrackName, {
            trackName: trackName,
            shouldShowAddFirst: shouldShowAddFirst,
            albumTranslationKeys: albumTranslationKeys
          }, [])],
          attrs: { className: 'track-name', title: trackName, 'aria-label': trackName }
        }, shouldShowBuyCurrentTrack ? m.component(BuyTrack, _extends({
          buy: attrs.buy
        }, buyTrackAttrs, {
          freeText: l10n('player_download_track'),
          freeAccText: l10n('player_download_track')
        }), []) : null, m.component(FakeBuyTrack, attrs, [])],
        attrs: { className: 'track-name-wrapper' }
      }, {
        tag: 'p',
        children: [albumArtistName],
        attrs: { className: 'album-name', title: albumArtistName }
      }, shouldShowBuyCurrentTrack ? m.component(BuyTrack, _extends({
        buy: attrs.buy
      }, buyTrackAttrs, {
        buyText: function buyText(price) {
          return l10n('player_track') + ' ' + price;
        },
        buyAccText: function buyAccText(price) {
          return l10n('player_acc_buy_track', [price]);
        },
        freeText: l10n('player_download_track'),
        freeAccText: l10n('player_download_track')
      }), []) : null, m.component(FakeBuyTrack, attrs, [])],
      attrs: { className: className }
    };
  }
};

exports.AlbumTitlesView = AlbumTitlesView;

/***/ }),
/* 89 */
/* no static exports found */
/* all exports used */
/*!*********************************************************************************************!*\
  !*** ./scripts/player/v2/desktop/vertical/components/control-bar/control-bar-controller.js ***!
  \*********************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ControlBarController = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = __webpack_require__(/*! ../../../../../../utils/utils */ 2);

var utils = _utils.utils;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ControlBarController = function () {
  function ControlBarController(_ref) {
    var playback = _ref.playback;

    _classCallCheck(this, ControlBarController);

    this.playback = playback;
  }

  _createClass(ControlBarController, [{
    key: 'play',
    value: function play() {
      this.playback.play();
    }
  }, {
    key: 'pause',
    value: function pause() {
      this.playback.pause(false);
    }
  }, {
    key: 'playNext',
    value: function playNext() {
      this.playback.playNext(true);
    }
  }, {
    key: 'playPrev',
    value: function playPrev() {
      this.playback.playPrev(true);
    }
  }, {
    key: 'getDuration',
    value: function getDuration() {
      var playback = this.playback;

      var track = playback.currentTrack || playback.getFirstTrack();
      if (!track) {
        return 0;
      }
      return utils.stringToDuration(track.isPreview ? track.previewDuration : track.duration);
    }
  }, {
    key: 'getProgress',
    value: function getProgress() {
      return this.playback.currentProgress();
    }
  }, {
    key: 'getLoaded',
    value: function getLoaded() {
      return this.playback.loadedProgress();
    }
  }, {
    key: 'updateProgress',
    value: function updateProgress(value) {
      return this.playback.updateProgress(value);
    }
  }]);

  return ControlBarController;
}();

exports.ControlBarController = ControlBarController;

/***/ }),
/* 90 */
/* no static exports found */
/* all exports used */
/*!**************************************************************************************************!*\
  !*** ./scripts/player/v2/desktop/vertical/components/control-bar/track-info-button.component.js ***!
  \**************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TrackInfoButton = undefined;

var _mithril = __webpack_require__(/*! mithril */ 0);

var m = _interopRequireDefault(_mithril).default;

var _trackInfo = __webpack_require__(/*! ../../../../shared/icons/track-info.svg */ 28);

var trackInfoIcon = _interopRequireDefault(_trackInfo).default;

var _l10n = __webpack_require__(/*! ../../../../shared/l10n */ 1);

var l10n = _l10n.l10n;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TrackInfoButton = {
  view: function view(ctrl, attrs) {
    var isDisabled = attrs.isDisabled,
        onClick = attrs.onclick;


    return {
      tag: 'button',
      children: [{
        tag: 'span',
        children: [m.trust(trackInfoIcon)],
        attrs: { 'aria-hidden': 'true' }
      }],
      attrs: {
        className: 'track-info',
        type: 'button',
        'aria-label': l10n('player_acc_track_info'),
        disabled: isDisabled,
        onclick: onClick
      }
    };
  }
};

exports.TrackInfoButton = TrackInfoButton;

/***/ }),
/* 91 */
/* no static exports found */
/* all exports used */
/*!****************************************************************!*\
  !*** ./scripts/player/v2/shared/components/no-tracks/index.js ***!
  \****************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _noTracks = __webpack_require__(/*! ./no-tracks */ 243);

Object.defineProperty(exports, 'NoTracks', {
  enumerable: true,
  get: function get() {
    return _noTracks.NoTracks;
  }
});

/***/ }),
/* 92 */
/* no static exports found */
/* all exports used */
/*!**********************************************************************!*\
  !*** ./scripts/player/v2/shared/components/track-name/track-name.js ***!
  \**********************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TrackName = undefined;

var _mithril = __webpack_require__(/*! mithril */ 0);

var m = _interopRequireDefault(_mithril).default;

var _noTracks = __webpack_require__(/*! ../no-tracks */ 91);

var NoTracks = _noTracks.NoTracks;

__webpack_require__(/*! ./track-name.less */ 277);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TrackName = {
  view: function view(ctrl, attrs) {
    var trackName = attrs.trackName,
        albumTranslationKeys = attrs.albumTranslationKeys,
        shouldShowAddFirst = attrs.shouldShowAddFirst;


    return {
      tag: 'div',
      children: [trackName ? trackName : m.component(NoTracks, { albumTranslationKeys: albumTranslationKeys, shouldShowAddFirst: shouldShowAddFirst }, [])],
      attrs: { className: 'track-name-component' }
    };
  }
};

exports.TrackName = TrackName;

/***/ }),
/* 93 */
/* no static exports found */
/* all exports used */
/*!*********************************************************************!*\
  !*** ./scripts/player/v2/shared/components/volume/volume-slider.js ***!
  \*********************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VolumeSlider = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _throttle = __webpack_require__(/*! lodash/throttle */ 60);

var throttle = _interopRequireDefault(_throttle).default;

var _mithril = __webpack_require__(/*! mithril */ 0);

var m = _interopRequireDefault(_mithril).default;

var _handleKeyboardSlider = __webpack_require__(/*! ../../../../../utils/handle-keyboard-slider/handle-keyboard-slider */ 30);

var handleKeyboardSlider = _handleKeyboardSlider.handleKeyboardSlider;

var _l10n = __webpack_require__(/*! ../../l10n */ 1);

var l10n = _l10n.l10n;

var _volumeUtils = __webpack_require__(/*! ../../volume-utils/volume-utils */ 59);

var limitVolume = _volumeUtils.limitVolume;
var VOLUME_SLIDER_STEP = _volumeUtils.VOLUME_SLIDER_STEP;

__webpack_require__(/*! ./volume-slider.less */ 278);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var VolumeSliderModel = function VolumeSliderModel() {
  _classCallCheck(this, VolumeSliderModel);

  this.isDragging = m.prop(false);
};

var VolumeSliderController = function () {
  function VolumeSliderController(attrs) {
    _classCallCheck(this, VolumeSliderController);

    this.model = new VolumeSliderModel();
    this.onDragStart = attrs.ondragstart;
    this.onDragEnd = attrs.ondragend;
    this.previousVolume = null;
  }

  _createClass(VolumeSliderController, [{
    key: 'startDragging',
    value: function startDragging() {
      this.model.isDragging(true);
      this.onDragStart();
    }
  }, {
    key: 'stopDragging',
    value: function stopDragging() {
      this.model.isDragging(false);
      this.onDragEnd();
    }
  }]);

  return VolumeSliderController;
}();

var VolumeSlider = {
  controller: VolumeSliderController,

  view: function view(ctrl, attrs) {
    var volume = attrs.volume,
        onUpdateVolume = attrs.onUpdateVolume;

    var levelStyle = {
      height: Math.round(volume * 100) + '%'
    };
    var handleStyle = {
      bottom: Math.round(volume * 100) + '%'
    };

    var updateVolume = function updateVolume(newVolume) {
      onUpdateVolume(limitVolume(newVolume));
      m.redraw();
    };

    var config = function config(element, isInitialized, context) {
      // because mithril reassigns attribute no matter if it equals to the current if it's in focus
      if (ctrl.previousVolume !== volume) {
        element.setAttribute('aria-valuenow', Math.round(volume * 100));
        element.setAttribute('aria-valuetext', l10n('player_acc_volume_value', [Math.round(volume * 100) + '%']));
      }

      ctrl.previousVolume = volume;

      if (isInitialized) {
        return;
      }

      var updateDragVolume = function updateDragVolume(event) {
        var sliderEl = element.querySelector('.volume-slider__total');
        var sliderClientRect = sliderEl.getBoundingClientRect();
        var rawVolume = (sliderClientRect.bottom - event.clientY) / sliderClientRect.height;
        updateVolume(rawVolume);
      };

      var drag = throttle(function (event) {
        event.preventDefault();
        if (ctrl.model.isDragging()) {
          updateDragVolume(event);
        }
      }, 100);

      var stopDragging = function stopDragging(event) {
        if (!ctrl.model.isDragging()) {
          return;
        }
        updateDragVolume(event);
        ctrl.stopDragging();
      };

      var startDragging = function startDragging(event) {
        event.preventDefault();
        ctrl.startDragging();
        updateDragVolume(event);
      };

      element.addEventListener('mousedown', startDragging);
      document.addEventListener('mousemove', drag);
      document.addEventListener('mouseup', stopDragging);
      document.addEventListener('mouseleave', stopDragging);
      window.addEventListener('blur', stopDragging);

      context.onunload = function () {
        element.removeEventListener('mousedown', startDragging);
        document.removeEventListener('mousemove', drag);
        document.removeEventListener('mouseup', stopDragging);
        document.removeEventListener('mouseleave', stopDragging);
        window.removeEventListener('blur', stopDragging);
      };
    };

    var handleKeyDown = handleKeyboardSlider({
      decrease: function decrease() {
        updateVolume(volume - VOLUME_SLIDER_STEP);
      },
      increase: function increase() {
        updateVolume(volume + VOLUME_SLIDER_STEP);
      }
    });

    return {
      tag: 'div',
      children: [{
        tag: 'div',
        children: [{
          tag: 'div',
          attrs: { className: 'volume-slider__level', style: levelStyle }
        }, {
          tag: 'div',
          children: [{
            tag: 'div',
            attrs: { className: 'volume-slider__handle', style: handleStyle }
          }],
          attrs: { className: 'volume-slider__handle-container' }
        }],
        attrs: { className: 'volume-slider__total' }
      }],
      attrs: {
        className: 'volume-slider',
        role: 'slider',
        'aria-valuemin': '0',
        'aria-valuemax': '100',
        onkeydown: handleKeyDown,
        tabindex: '0',
        config: config
      }
    };
  }
};

exports.VolumeSlider = VolumeSlider;

/***/ }),
/* 94 */
/* no static exports found */
/* all exports used */
/*!*************************************************************************!*\
  !*** ./scripts/player/v2/desktop/components/track-list/track-list.less ***!
  \*************************************************************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 95 */
/* no static exports found */
/* all exports used */
/*!**************************************************************************!*\
  !*** ./scripts/player/v2/desktop/components/track-list/track/track.less ***!
  \**************************************************************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */
/* no static exports found */
/* all exports used */
/*!*******************************************!*\
  !*** ./scripts/player/init-desktop-v3.js ***!
  \*******************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initV3 = initV3;

var _appStatus = __webpack_require__(/*! ../app-status/app-status */ 6);

var appStatus = _appStatus.appStatus;

var _v = __webpack_require__(/*! ../common/parse-settings/v3 */ 174);

var parseSettingsV3 = _v.parseSettingsV3;

var _transformCollection = __webpack_require__(/*! ../common/transform-collection */ 31);

var transformCollection = _interopRequireDefault(_transformCollection).default;

var _perfomance = __webpack_require__(/*! ../utils/perfomance */ 11);

var timeStart = _perfomance.timeStart;
var timeStop = _perfomance.timeStop;

var _utils = __webpack_require__(/*! ../utils/utils */ 2);

var utils = _utils.utils;

var _cache = __webpack_require__(/*! ./cache */ 32);

var DefaultCache = _cache.DefaultCache;

var _desktop = __webpack_require__(/*! ./v3/desktop */ 312);

var DesktopAppV3 = _desktop.DesktopApp;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var desktopApps = new DefaultCache(function () {
  return new DesktopAppV3();
});

var isFirst = true;

function initV3(domElement, widgetSettings, albumData) {
  var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : utils.noop;

  appStatus.report('init-called', { version: '3', isMobile: false });
  appStatus.step('init-called');
  timeStart(initV3);
  var settings = parseSettingsV3(widgetSettings);
  transformCollection(albumData, settings).then(function (albumData) {
    appStatus.step('transform-finished');
    appStatus.report('init-finished', { version: '3', time: timeStop(initV3), isFirst: isFirst, isMobile: false });
    isFirst = false;
    desktopApps.get(domElement).init({ domElement: domElement, settings: settings, albumData: albumData, callback: callback });
  });
}

exports.default = initV3;

/***/ }),
/* 100 */
/* no static exports found */
/* all exports used */
/*!****************************!*\
  !*** ./l10n/texts_ar.json ***!
  \****************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = { "player_acc_track_played": "المقطوعة قيد التشغيل: %s", "player_acc_tracklist_pause_track": "Pause selected track number %s: %s", "player_acc_album_description": "Album description", "player_play": "تشغيل", "player_acc_share_on_facebook": "مشاركة عبر Facebook", "player_acc_tracklist": "قائمة المقطوعات %s", "player_track_collaboration_with": "With", "player_music_album_versions_bonus": "مقطوعة إضافية", "player_show_all_tracks": "اعرض جميع المقطوعات", "player_download_single": "قم بتنزيل أغنية منفردة", "player_get_album": "احصل على الألبوم", "player_previous": "السابق", "player_track_collaboration_featuring": "Featuring", "app_description": "Make it easy for fans to listen, download and purchase your work and check your music's play and download stats.", "player_acc_progress_value": "%s من %s", "player_payment_preview_error": "Hey, you’re in Preview Mode.\nThis feature works on your live site once it’s published.", "player_track_collaboration_performed": "Performed By", "player_acc_track_duration": "المدة الزمنية للمقطوعة: %s", "player_acc_pause": "توقف", "player_share_playlist": "شارك قائمة التشغيل", "player_acc_track_info": "معلومات المقطوعة", "player_acc_prev": "المقطوعة السابقة", "player_acc_next": "المقطوعة التالية", "player_track_versions_dirty": "إصدار غير نظيف", "player_music_album_versions_empty": "—", "player_acc_buy_album": "اشترِ الألبوم مقابل %s", "player_track_versions_acoustic": "صوتي", "player_pause": "توقف", "player_acc_volume_value": "الصوت %s", "player_buy_single": "اشترِ أغنية منفردة", "player_acc_close": "إغلاق", "player_no_tracks_artist_name": "اسم الفنان", "player_acc_share_single_dialog": "شارك الأغنية المنفردة", "track_page_lyrics": "Lyrics", "player_mobile_share_this_song": "شارِك هذه المقطوعة:", "player_acc_unmute": "Unmute", "player_acc_share_on_twitter": "مشاركة عبر Twitter", "player_track_versions_bonus": "مقطوعة إضافية", "player_track_versions_empty": "—", "player_acc_play_live": "Track is playing", "player_acc_play": "تشغيل", "player_free": "مجانًا", "player_track_collaboration_remixed": "Remixed By", "player_acc_share_album_dialog": "شارِك الألبوم", "player_single": "أغنية منفردة", "player_acc_pause_live": "Track paused", "player_acc_share_on_tumblr": "شارِك عبر Tumblr", "player_tracks_total": "%s من الإجمالي", "player_no_tracks": "أضِف مقطوعتك الأولى!", "player_music_album_versions_deluxe": "Deluxe Edition", "player_no_tracks_track_name": "اسم المقطوعة", "player_shuffle": "أعِد ترتيب", "player_music_album_versions_remastered": "Remastered", "player_download_album": "Download Album", "player_music_album_versions_remixes": "Remixes", "player_track": "Track", "player_track_out_of": "مقطوعة %s (من %s)", "player_track_versions_demo": "عرض", "player_next": "التالي", "player_acc_buy_track": "اشترِ المقطوعة مقابل %s", "app_title": "Wix Player", "player_acc_share_on_blogger": "شارِك عبر Blogger", "player_music_album_versions_acoustic": "Acoustic", "player_no_tracks_publish_playlist": "قائمة التشغيل هذه تأتيكم قريبًا!", "player_repeat": "تكرار", "player_mobile_view_less": "إظهار أقل", "player_acc_tracklist_play_track": "Play track number %s: %s", "player_acc_share": "مشاركة", "player_track_versions_clean": "إصدار نظيف", "player_no_tracks_publish": "هذا الألبوم يأتيكم قريبًا!", "player_share": "Share", "player_share_song": "Share Track", "player_track_versions_radio": "تعديل إذاعي", "player_download_track": "Download Track", "player_mobile_view_more": "عرض المزيد", "player_lyrics": "Track Info", "player_track_versions_edited": "إصدار منقَّح", "player_mobile_share": "Share", "player_acc_share_dialog": "مشاركة", "player_music_album_versions_live": "بث مباشر", "player_acc_track_cover": "غلاف المقطوعة", "player_buy_album": "Buy Album", "player_music_album_versions_clean": "Clean Version", "player_album": "Album", "player_payment_preview_mode": "Preview Mode", "player_acc_share_playlist_dialog": "شارك قائمة التشغيل", "player_track_versions_explicit": "إصدار صريح", "player_free_song": "Free Download", "player_acc_track_info_dialog": "معلومات المقطوعة", "player_music_album_versions_special": "Special Edition", "player_track_versions_live": "Live", "player_no_tracks_publish_single": "هذه الأغنية المنفردة تأتيكم قريبًا!", "player_share_album": "شارِك الألبوم", "player_payment_got_it": "وصلتك المعلومة؟", "player_buy_song": "Buy Track", "player_download": "Download", "player_get_single": "احصل على الأغنية المنفردة", "player_acc_mute": "كتم الصوت", "player_acc_album_cover": "غلاف الألبوم", "player_get_track": "احصل على المقطوعة", "player_music_album_versions_demo": "Demo", "player_mobile_share_this_album": "شارِك هذا الألبوم:", "player_sharing_text": "تحقق من هذه الموسيقى الرائعة", "player_share_single": "شارك الأغنية المنفردة", "player_acc_progressbar": "شريط التقدم" };

/***/ }),
/* 101 */
/* no static exports found */
/* all exports used */
/*!****************************!*\
  !*** ./l10n/texts_bg.json ***!
  \****************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = { "player_acc_track_played": "Възпроизвеждана песен: %s", "player_acc_tracklist_pause_track": "Pause selected track number %s: %s", "player_acc_album_description": "Album description", "player_play": "Възпроизвеждане", "player_acc_share_on_facebook": "Споделете във Facebook", "player_acc_tracklist": "%s списък с песни", "player_track_collaboration_with": "With", "player_music_album_versions_bonus": "Бонус песен", "player_show_all_tracks": "Покажи всички песни", "player_download_single": "Изтегляне на сингъл", "player_get_album": "Вземете албума", "player_previous": "Предишна", "player_track_collaboration_featuring": "Featuring", "app_description": "Make it easy for fans to listen, download and purchase your work and check your music's play and download stats.", "player_acc_progress_value": "%s от %s", "player_payment_preview_error": "Hey, you’re in Preview Mode.\nThis feature works on your live site once it’s published.", "player_track_collaboration_performed": "Performed By", "player_acc_track_duration": "Продължителност на песента: %s", "player_acc_pause": "Пауза", "player_share_playlist": "Споделяне на плейлистата", "player_acc_track_info": "Информация за песента", "player_acc_prev": "Предишна песен", "player_acc_next": "Следваща песен", "player_track_versions_dirty": "Мръсна версия", "player_music_album_versions_empty": "—", "player_acc_buy_album": "Купете албум за %s", "player_track_versions_acoustic": "Акустична", "player_pause": "Пауза", "player_acc_volume_value": "%s сила на звука", "player_buy_single": "Купи сингъл", "player_acc_close": "Затвори", "player_no_tracks_artist_name": "Име на изпълнителя", "player_acc_share_single_dialog": "Споделете сингъла", "track_page_lyrics": "Lyrics", "player_mobile_share_this_song": "Споделете тази песен:", "player_acc_unmute": "Unmute", "player_acc_share_on_twitter": "Споделете в Twitter", "player_track_versions_bonus": "Бонус песен", "player_track_versions_empty": "—", "player_acc_play_live": "Track is playing", "player_acc_play": "Възпроизвеждане", "player_free": "Безплатна", "player_track_collaboration_remixed": "Remixed By", "player_acc_share_album_dialog": "Споделете албума", "player_single": "Сингъл", "player_acc_pause_live": "Track paused", "player_acc_share_on_tumblr": "Споделете в Tumblr", "player_tracks_total": "%s общо", "player_no_tracks": "Добави първата си песен!", "player_music_album_versions_deluxe": "Deluxe Edition", "player_no_tracks_track_name": "Име на песента", "player_shuffle": "Миксиране", "player_music_album_versions_remastered": "Remastered", "player_download_album": "Download Album", "player_music_album_versions_remixes": "Remixes", "player_track": "Track", "player_track_out_of": "Песен %s (от %s)", "player_track_versions_demo": "Демо", "player_next": "Напред", "player_acc_buy_track": "Купете песен за %s", "app_title": "Wix Player", "player_acc_share_on_blogger": "Споделете в Blogger", "player_music_album_versions_acoustic": "Acoustic", "player_no_tracks_publish_playlist": "Очаквайте скоро този плейлист!", "player_repeat": "Повтаряне", "player_mobile_view_less": "Вижте по-малко", "player_acc_tracklist_play_track": "Play track number %s: %s", "player_acc_share": "Споделяне", "player_track_versions_clean": "Чиста версия", "player_no_tracks_publish": "Очаквайте скоро този албум!", "player_share": "Share", "player_share_song": "Share Track", "player_track_versions_radio": "Радио редактиране", "player_download_track": "Download Track", "player_mobile_view_more": "Вижте повече", "player_lyrics": "Track Info", "player_track_versions_edited": "Редактирана версия", "player_mobile_share": "Share", "player_acc_share_dialog": "Споделяне", "player_music_album_versions_live": "На живо", "player_acc_track_cover": "Корица на песен", "player_buy_album": "Buy Album", "player_music_album_versions_clean": "Clean Version", "player_album": "Album", "player_payment_preview_mode": "Preview Mode", "player_acc_share_playlist_dialog": "Споделяне на плейлистата", "player_track_versions_explicit": "Пълна версия", "player_free_song": "Free Download", "player_acc_track_info_dialog": "Информация за песента", "player_music_album_versions_special": "Special Edition", "player_track_versions_live": "Live", "player_no_tracks_publish_single": "Очаквайте скоро този сингъл!", "player_share_album": "Споделете албума", "player_payment_got_it": "Разбрах", "player_buy_song": "Buy Track", "player_download": "Download", "player_get_single": "Вземете сингъла", "player_acc_mute": "Без звук", "player_acc_album_cover": "Корица на албума", "player_get_track": "Вземете песента", "player_music_album_versions_demo": "Demo", "player_mobile_share_this_album": "Споделете този албум", "player_sharing_text": "чуйте тази готина музика", "player_share_single": "Споделяне на сингъла", "player_acc_progressbar": "Лента за напредъка" };

/***/ }),
/* 102 */
/* no static exports found */
/* all exports used */
/*!****************************!*\
  !*** ./l10n/texts_ca.json ***!
  \****************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = { "player_acc_track_played": "Track played: %s", "player_acc_tracklist_pause_track": "Pause selected track number %s: %s", "player_acc_album_description": "Album description", "player_play": "Play", "player_acc_share_on_facebook": "Share on Facebook", "player_acc_tracklist": "%s track list", "player_track_collaboration_with": "With", "player_music_album_versions_bonus": "Bonus Track", "player_show_all_tracks": "Show all tracks", "player_download_single": "Download Single", "player_get_album": "Get Album", "player_previous": "Previous", "player_track_collaboration_featuring": "Featuring", "app_description": "Make it easy for fans to listen, download and purchase your work and check your music's play and download stats.", "player_acc_progress_value": "%s of %s", "player_payment_preview_error": "Hey, you’re in Preview Mode.\nThis feature works on your live site once it’s published.", "player_track_collaboration_performed": "Performed By", "player_acc_track_duration": "Track duration: %s", "player_acc_pause": "Pause", "player_share_playlist": "Share Playlist", "player_acc_track_info": "Track info", "player_acc_prev": "Previous track", "player_acc_next": "Next track", "player_track_versions_dirty": "Dirty Version", "player_music_album_versions_empty": "—", "player_acc_buy_album": "Buy album for %s", "player_track_versions_acoustic": "Acoustic", "player_pause": "Pause", "player_acc_volume_value": "%s volume", "player_buy_single": "Buy Single", "player_acc_close": "Close", "player_no_tracks_artist_name": "Artist Name", "player_acc_share_single_dialog": "Share Single", "track_page_lyrics": "Lyrics", "player_mobile_share_this_song": "Share this Track:", "player_acc_unmute": "Unmute", "player_acc_share_on_twitter": "Share on Twitter", "player_track_versions_bonus": "Bonus Track", "player_track_versions_empty": "—", "player_acc_play_live": "Track is playing", "player_acc_play": "Play", "player_free": "Free", "player_track_collaboration_remixed": "Remixed By", "player_acc_share_album_dialog": "Share Album", "player_single": "Single", "player_acc_pause_live": "Track paused", "player_acc_share_on_tumblr": "Share on Tumblr", "player_tracks_total": "%s Total", "player_no_tracks": "Add your first track!", "player_music_album_versions_deluxe": "Deluxe Edition", "player_no_tracks_track_name": "Track Name", "player_shuffle": "Shuffle", "player_music_album_versions_remastered": "Remastered", "player_download_album": "Download Album", "player_music_album_versions_remixes": "Remixes", "player_track": "Track", "player_track_out_of": "Track %s (Out of %s)", "player_track_versions_demo": "Demo", "player_next": "Next", "player_acc_buy_track": "Buy track for %s", "app_title": "Wix Player", "player_acc_share_on_blogger": "Share on Blogger", "player_music_album_versions_acoustic": "Acoustic", "player_no_tracks_publish_playlist": "This playlist's coming soon!", "player_repeat": "Repeat", "player_mobile_view_less": "View Less", "player_acc_tracklist_play_track": "Play track number %s: %s", "player_acc_share": "Share", "player_track_versions_clean": "Clean Version", "player_no_tracks_publish": "This album's coming soon!", "player_share": "Share", "player_share_song": "Share Track", "player_track_versions_radio": "Radio Edit", "player_download_track": "Download Track", "player_mobile_view_more": "View More", "player_lyrics": "Track Info", "player_track_versions_edited": "Edited Version", "player_mobile_share": "Share", "player_acc_share_dialog": "Share", "player_music_album_versions_live": "Live", "player_acc_track_cover": "Track Cover", "player_buy_album": "Buy Album", "player_music_album_versions_clean": "Clean Version", "player_album": "Album", "player_payment_preview_mode": "Preview Mode", "player_acc_share_playlist_dialog": "Share Playlist", "player_track_versions_explicit": "Explicit Version", "player_free_song": "Free Download", "player_acc_track_info_dialog": "Track info", "player_music_album_versions_special": "Special Edition", "player_track_versions_live": "Live", "player_no_tracks_publish_single": "This single's coming soon!", "player_share_album": "Share Album", "player_payment_got_it": "Got it", "player_buy_song": "Buy Track", "player_download": "Download", "player_get_single": "Get Single", "player_acc_mute": "Mute", "player_acc_album_cover": "Album Cover", "player_get_track": "Get Track", "player_music_album_versions_demo": "Demo", "player_mobile_share_this_album": "Share this Album:", "player_sharing_text": "checkout this cool music", "player_share_single": "Share Single", "player_acc_progressbar": "Progress Bar" };

/***/ }),
/* 103 */
/* no static exports found */
/* all exports used */
/*!****************************!*\
  !*** ./l10n/texts_cs.json ***!
  \****************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = { "player_acc_track_played": "Přehrávaná skladba: %s", "player_acc_tracklist_pause_track": "Pause selected track number %s: %s", "player_acc_album_description": "Popis Singlu", "player_play": "Přehrát", "player_acc_share_on_facebook": "Sdílet na Facebooku", "player_acc_tracklist": "Seznam skladeb %s", "player_track_collaboration_with": "S", "player_music_album_versions_bonus": "Bonusová skladba", "player_show_all_tracks": "Ukázat všechny skladby", "player_download_single": "Stáhnout singl", "player_get_album": "Získat album", "player_previous": "Předchozí", "player_track_collaboration_featuring": "Představuje", "app_description": "Usnadněte fanouškům poslech, stahování a nákup vašich děl, kontrolu přehrávání hudby a stahování statistik.", "player_acc_progress_value": "%s z %s", "player_payment_preview_error": "Jste v režimu náhledu.\nTato funkce je aktivní na zveřejněném webu.", "player_track_collaboration_performed": "Složil", "player_acc_track_duration": "Doba trvání skladby: %s", "player_acc_pause": "Pauza", "player_share_playlist": "Sdílet playlist", "player_acc_track_info": "Informace o skladbě", "player_acc_prev": "Předchozí skladba", "player_acc_next": "Další skladba", "player_track_versions_dirty": "Verze jen pro dospělé", "player_music_album_versions_empty": "—", "player_acc_buy_album": "Koupit album za %s", "player_track_versions_acoustic": "Akustistická", "player_pause": "Pauza", "player_acc_volume_value": "Hlasitost %s", "player_buy_single": "Koupit singl", "player_acc_close": "Zavřít", "player_no_tracks_artist_name": "Jméno umělce", "player_acc_share_single_dialog": "Sdílet singl", "track_page_lyrics": "Text", "player_mobile_share_this_song": "Sdílet tuto skladbu:", "player_acc_unmute": "Unmute", "player_acc_share_on_twitter": "Sdílet na Twitteru", "player_track_versions_bonus": "Bonusový track", "player_track_versions_empty": "—", "player_acc_play_live": "Track is playing", "player_acc_play": "Přehrát", "player_free": "Zdarma", "player_track_collaboration_remixed": "Remixováno", "player_acc_share_album_dialog": "Sdílet album", "player_single": "Singl", "player_acc_pause_live": "Track paused", "player_acc_share_on_tumblr": "Sdílet na Tumblru", "player_tracks_total": "%s celkem", "player_no_tracks": "Přidejte svoji první skladbu!", "player_music_album_versions_deluxe": "Deluxe edice", "player_no_tracks_track_name": "Název skladby", "player_shuffle": "Přeházet", "player_music_album_versions_remastered": "Upravená verze", "player_download_album": "Stáhnout album", "player_music_album_versions_remixes": "Remixy", "player_track": "Skladba", "player_track_out_of": "Skladba %s (z %s)", "player_track_versions_demo": "Demo", "player_next": "Další", "player_acc_buy_track": "Koupit skladbu za %s", "app_title": "Přehrávač Wix", "player_acc_share_on_blogger": "Sdílet na Bloggeru", "player_music_album_versions_acoustic": "Akustická verze", "player_no_tracks_publish_playlist": "Tento playlist již brzy k dispozici!", "player_repeat": "Opakovat", "player_mobile_view_less": "Zobrazit méně", "player_acc_tracklist_play_track": "Play track number %s: %s", "player_acc_share": "Sdílet", "player_track_versions_clean": "Čistá verze", "player_no_tracks_publish": "Tohle album vyjde brzy!", "player_share": "Sdílet", "player_share_song": "Sdílet skladbu", "player_track_versions_radio": "Upravit radio", "player_download_track": "Stáhnout album", "player_mobile_view_more": "Zobrazit více", "player_lyrics": "Informace o skladbě", "player_track_versions_edited": "Upravená verze", "player_mobile_share": "Sdílet", "player_acc_share_dialog": "Sdílet", "player_music_album_versions_live": "Živě", "player_acc_track_cover": "Přebal skladby", "player_buy_album": "Koupit album", "player_music_album_versions_clean": "Čistá verze", "player_album": "Album", "player_payment_preview_mode": "Režim náhledu", "player_acc_share_playlist_dialog": "Sdílet playlist", "player_track_versions_explicit": "Verze nevhodná pro děti", "player_free_song": "Stažení zdarma", "player_acc_track_info_dialog": "Informace o skladbě", "player_music_album_versions_special": "Speciální edice", "player_track_versions_live": "Živě", "player_no_tracks_publish_single": "Tento singl již brzy k dispozici!", "player_share_album": "Sdílet album", "player_payment_got_it": "Získejte to!", "player_buy_song": "Koupit skladbu", "player_download": "Stáhnout", "player_get_single": "Získat singl", "player_acc_mute": "Ztlumit", "player_acc_album_cover": "Přebal alba", "player_get_track": "Získat skladbu", "player_music_album_versions_demo": "Demo", "player_mobile_share_this_album": "Sdílet toto album:", "player_sharing_text": "podívejte se na tuto skvělou muziku", "player_share_single": "Sdílet singl", "player_acc_progressbar": "Ukazatel postupu" };

/***/ }),
/* 104 */
/* no static exports found */
/* all exports used */
/*!****************************!*\
  !*** ./l10n/texts_da.json ***!
  \****************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = { "player_acc_track_played": "Afspillet single: %s", "player_acc_tracklist_pause_track": "Pause selected track number %s: %s", "player_acc_album_description": "Albumbeskrivelse", "player_play": "Afspil", "player_acc_share_on_facebook": "Del på Facebook", "player_acc_tracklist": "%s singleliste", "player_track_collaboration_with": "med", "player_music_album_versions_bonus": "Bonus musiknummer", "player_show_all_tracks": "Vis alle singler", "player_download_single": "Download singleudgivelse", "player_get_album": "Hent album", "player_previous": "Forrige", "player_track_collaboration_featuring": "og", "app_description": "Gør det nemt for dine fans at lytte, downloade og købe og se dine musik afspilninger og downloade statistikker.", "player_acc_progress_value": "%s af %s", "player_payment_preview_error": "Hey, du er i forhåndsvisning.\nDenne funktion\nvirker på din hjemmeside online, når den er publiceret.", "player_track_collaboration_performed": "Sunget af", "player_acc_track_duration": "Singlelængde: %s", "player_acc_pause": "Pause", "player_share_playlist": "Del afspilningsliste", "player_acc_track_info": "Singleinfo", "player_acc_prev": "Forrige single", "player_acc_next": "Næste single", "player_track_versions_dirty": "Dirty version", "player_music_album_versions_empty": "—", "player_acc_buy_album": "Køb album for %s", "player_track_versions_acoustic": "Akustisk", "player_pause": "Pause", "player_acc_volume_value": "%s lydstyrke", "player_buy_single": "Køb singleudgivelse", "player_acc_close": "Luk", "player_no_tracks_artist_name": "Kunstnerens navn", "player_acc_share_single_dialog": "Del singleudgivelse", "track_page_lyrics": "Lyrics", "player_mobile_share_this_song": "Del denne single:", "player_acc_unmute": "Unmute", "player_acc_share_on_twitter": "Del på Twitter", "player_track_versions_bonus": "Bonus musiknummer", "player_track_versions_empty": "—", "player_acc_play_live": "Track is playing", "player_acc_play": "Afspil", "player_free": "Gratis", "player_track_collaboration_remixed": "Remix af", "player_acc_share_album_dialog": "Del album", "player_single": "Singleudgivelse", "player_acc_pause_live": "Track paused", "player_acc_share_on_tumblr": "Del på Tumblr", "player_tracks_total": "%s total", "player_no_tracks": "Tilføj din første single!", "player_music_album_versions_deluxe": "Deluxe udgave", "player_no_tracks_track_name": "Singlenavn", "player_shuffle": "Bland", "player_music_album_versions_remastered": "Remastered", "player_download_album": "Download album", "player_music_album_versions_remixes": "Remixes", "player_track": "Single", "player_track_out_of": "Single %s (fra %s)", "player_track_versions_demo": "Demo", "player_next": "Næste", "player_acc_buy_track": "Køb single for %s", "app_title": "Wix Player", "player_acc_share_on_blogger": "Del på Blogger", "player_music_album_versions_acoustic": "Akustisk", "player_no_tracks_publish_playlist": "Denne afspilningsliste kommer snart!", "player_repeat": "Gentag", "player_mobile_view_less": "Vis mindre", "player_acc_tracklist_play_track": "Play track number %s: %s", "player_acc_share": "Del", "player_track_versions_clean": "Ren version", "player_no_tracks_publish": "Dette album kommer snart!", "player_share": "Del", "player_share_song": "Del single", "player_track_versions_radio": "Radio edit", "player_download_track": "Download single", "player_mobile_view_more": "Se mere", "player_lyrics": "Singleinfo", "player_track_versions_edited": "Redigeret version", "player_mobile_share": "Del", "player_acc_share_dialog": "Del", "player_music_album_versions_live": "Live", "player_acc_track_cover": "Singlecover", "player_buy_album": "Køb Album", "player_music_album_versions_clean": "Ren version", "player_album": "Album", "player_payment_preview_mode": "Forhåndsvisningstilstand", "player_acc_share_playlist_dialog": "Del afspilningsliste", "player_track_versions_explicit": "Eksplicit version", "player_free_song": "Gratis Download", "player_acc_track_info_dialog": "Singleinfo", "player_music_album_versions_special": "Special udgave", "player_track_versions_live": "Live", "player_no_tracks_publish_single": "Denne singleudgivelse kommer snart!", "player_share_album": "Del album", "player_payment_got_it": "OK", "player_buy_song": "Køb single", "player_download": "Download", "player_get_single": "Hent singleudgivelse", "player_acc_mute": "Slå lyd fra", "player_acc_album_cover": "Albumcover", "player_get_track": "Hent single", "player_music_album_versions_demo": "Demo", "player_mobile_share_this_album": "Del dette album:", "player_sharing_text": "hør denne cool musik", "player_share_single": "Del singleudgivelse", "player_acc_progressbar": "Statuslinje" };

/***/ }),
/* 105 */
/* no static exports found */
/* all exports used */
/*!****************************!*\
  !*** ./l10n/texts_de.json ***!
  \****************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = { "player_acc_track_played": "Wiedergabe: %s", "player_acc_tracklist_pause_track": "Pause selected track number %s: %s", "player_acc_album_description": "Albumbeschreibung", "player_play": "Wiedergabe", "player_acc_share_on_facebook": "Auf Facebook teilen", "player_acc_tracklist": "%s Titelliste", "player_track_collaboration_with": "Mit", "player_music_album_versions_bonus": "Bonustrack", "player_show_all_tracks": "Alle Titel anzeigen", "player_download_single": "Single runterladen", "player_get_album": "Album holen", "player_previous": "Zurück", "player_track_collaboration_featuring": "Featuring", "app_description": "Mach es leichter für deine Fans, deine Musik zu hören, herunterzuladen und zu kaufen. Analysiere Statistiken zu Wiedergabe und Downloads deiner Musik.", "player_acc_progress_value": "%s von %s", "player_payment_preview_error": "Hey, du bist im Vorschaumodus!\nDiese Funktion\nist nur auf der veröffentlichten Website verfügbar.", "player_track_collaboration_performed": "Gesungen von", "player_acc_track_duration": "Titeldauer: %s", "player_acc_pause": "Pause", "player_share_playlist": "Playlist teilen", "player_acc_track_info": "Titel-Info", "player_acc_prev": "Vorheriger Titel", "player_acc_next": "Nächster Titel", "player_track_versions_dirty": "Dirty Version", "player_music_album_versions_empty": "—", "player_acc_buy_album": "Album für %s kaufen", "player_track_versions_acoustic": "Acoustic", "player_pause": "Pause", "player_acc_volume_value": "%s Lautstärke", "player_buy_single": "Single kaufen", "player_acc_close": "Schließen", "player_no_tracks_artist_name": "Künstlername", "player_acc_share_single_dialog": "Single teilen", "track_page_lyrics": "Lyrics", "player_mobile_share_this_song": "Diesen Titel teilen:", "player_acc_unmute": "Unmute", "player_acc_share_on_twitter": "Auf Twitter teilen", "player_track_versions_bonus": "Bonustrack", "player_track_versions_empty": "—", "player_acc_play_live": "Track is playing", "player_acc_play": "Wiedergabe", "player_free": "Kostenlos", "player_track_collaboration_remixed": "Remix von", "player_acc_share_album_dialog": "Album teilen", "player_single": "Single", "player_acc_pause_live": "Track paused", "player_acc_share_on_tumblr": "Auf Tumblr teilen", "player_tracks_total": "%s insgesamt", "player_no_tracks": "Ersten Titel hinzufügen!", "player_music_album_versions_deluxe": "Deluxe Edition", "player_no_tracks_track_name": "Titelname", "player_shuffle": "Zufallswiedergabe", "player_music_album_versions_remastered": "Remastered", "player_download_album": "Album herunterladen", "player_music_album_versions_remixes": "Remix", "player_track": "Titel", "player_track_out_of": "Titel %s (von %s)", "player_track_versions_demo": "Demo", "player_next": "Weiter", "player_acc_buy_track": "Titel für %s kaufen", "app_title": "Wix Player", "player_acc_share_on_blogger": "Auf Blogger teilen", "player_music_album_versions_acoustic": "Acoustic", "player_no_tracks_publish_playlist": "Diese Playlist kommt bald!", "player_repeat": "Wiederholen", "player_mobile_view_less": "Weniger", "player_acc_tracklist_play_track": "Play track number %s: %s", "player_acc_share": "Teilen", "player_track_versions_clean": "Clean Version", "player_no_tracks_publish": "Dieses Album wird in Kürze herausgebracht!", "player_share": "Teilen", "player_share_song": "Titel teilen", "player_track_versions_radio": "Radio Edit", "player_download_track": "Titel herunterladen", "player_mobile_view_more": "Mehr", "player_lyrics": "Titel-Info", "player_track_versions_edited": "Edited Version", "player_mobile_share": "Teilen", "player_acc_share_dialog": "Teilen", "player_music_album_versions_live": "Live", "player_acc_track_cover": "Titelbild", "player_buy_album": "Album kaufen", "player_music_album_versions_clean": "Clean Version", "player_album": "Album", "player_payment_preview_mode": "Vorschaumodus", "player_acc_share_playlist_dialog": "Playlist teilen", "player_track_versions_explicit": "Explicit Version", "player_free_song": "Kostenloser Download", "player_acc_track_info_dialog": "Titel-Info", "player_music_album_versions_special": "Special Edition", "player_track_versions_live": "Live", "player_no_tracks_publish_single": "Diese Single kommt bald!", "player_share_album": "Album teilen", "player_payment_got_it": "OK", "player_buy_song": "Titel kaufen", "player_download": "Download", "player_get_single": "Single holen", "player_acc_mute": "Stummschaltung", "player_acc_album_cover": "Albumcover", "player_get_track": "Titel holen", "player_music_album_versions_demo": "Demo", "player_mobile_share_this_album": "Dieses Album teilen:", "player_sharing_text": "Meine neue Musik", "player_share_single": "Single teilen", "player_acc_progressbar": "Fortschrittsbalken" };

/***/ }),
/* 106 */
/* no static exports found */
/* all exports used */
/*!****************************!*\
  !*** ./l10n/texts_el.json ***!
  \****************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = { "player_acc_track_played": "Κομμάτι που αναπαράγεται: %s", "player_acc_tracklist_pause_track": "Pause selected track number %s: %s", "player_acc_album_description": "Album description", "player_play": "Αναπαραγωγή", "player_acc_share_on_facebook": "Μοιραστείτε στο Facebook", "player_acc_tracklist": "%s της λίστας κομματιών", "player_track_collaboration_with": "With", "player_music_album_versions_bonus": "Κομμάτι δώρο", "player_show_all_tracks": "Εμφάνιση όλων των κομματιών", "player_download_single": "Λήψη σινγκλ", "player_get_album": "Αποκτήστε άλμπουμ", "player_previous": "Προηγούμενο", "player_track_collaboration_featuring": "Featuring", "app_description": "Make it easy for fans to listen, download and purchase your work and check your music's play and download stats.", "player_acc_progress_value": "%s από %s", "player_payment_preview_error": "Hey, you’re in Preview Mode.\nThis feature works on your live site once it’s published.", "player_track_collaboration_performed": "Performed By", "player_acc_track_duration": "Διάρκεια κομματιού: %s", "player_acc_pause": "Παύση", "player_share_playlist": "Κοινοποίηση λίστας αναπαραγωγής", "player_acc_track_info": "Πληροφορίες κομματιού", "player_acc_prev": "Προηγούμενο κομμάτι", "player_acc_next": "Επόμενο κομμάτι", "player_track_versions_dirty": "Εκδοχή με βρισιές", "player_music_album_versions_empty": "—", "player_acc_buy_album": "Αγορά άλμπουμ για %s", "player_track_versions_acoustic": "Ακουστικό κομμάτι", "player_pause": "Παύση", "player_acc_volume_value": "%s Ήχου", "player_buy_single": "Αγορά σινγκλ", "player_acc_close": "Κλείσιμο", "player_no_tracks_artist_name": "Όνομα καλλιτέχνη", "player_acc_share_single_dialog": "Κοινοποίηση σινγκλ", "track_page_lyrics": "Lyrics", "player_mobile_share_this_song": "Κοινή χρήση αυτού του κομματιού", "player_acc_unmute": "Unmute", "player_acc_share_on_twitter": "Κοινοποίηση στο Twitter", "player_track_versions_bonus": "Κομμάτι δώρο", "player_track_versions_empty": "—", "player_acc_play_live": "Track is playing", "player_acc_play": "Αναπαραγωγή", "player_free": "Δωρεάν", "player_track_collaboration_remixed": "Remixed By", "player_acc_share_album_dialog": "Κοινή χρήση άλμπουμ", "player_single": "Σινγκλ", "player_acc_pause_live": "Track paused", "player_acc_share_on_tumblr": "Κοινή χρήση στο Tumblr", "player_tracks_total": "Σύνολο %s", "player_no_tracks": "Προσθέστε το πρώτο σας κομμάτι!", "player_music_album_versions_deluxe": "Deluxe Edition", "player_no_tracks_track_name": "Παρακολούθηση ονόματος", "player_shuffle": "Τυχαία σειρά", "player_music_album_versions_remastered": "Remastered", "player_download_album": "Download Album", "player_music_album_versions_remixes": "Remixes", "player_track": "Track", "player_track_out_of": "%s (από %s)", "player_track_versions_demo": "Δείγμα", "player_next": "Επόμενο", "player_acc_buy_track": "Αγορά κομματιού για %s", "app_title": "Wix Player", "player_acc_share_on_blogger": "Κοινή χρήση στο Blogger", "player_music_album_versions_acoustic": "Acoustic", "player_no_tracks_publish_playlist": "Η λίστα αναπαραγωγής θα κυκλοφορήσει σύντομα!", "player_repeat": "Επανάληψη", "player_mobile_view_less": "Δείτε λιγότερα", "player_acc_tracklist_play_track": "Play track number %s: %s", "player_acc_share": "Κοινοποίηση", "player_track_versions_clean": "Σεμνή εκδοχή", "player_no_tracks_publish": "Αυτό το άλμπουμ θα κυκλοφορήσει σύντομα!", "player_share": "Share", "player_share_song": "Share Track", "player_track_versions_radio": "Επεξεργασία για το ραδιόφωνο", "player_download_track": "Download Track", "player_mobile_view_more": "Δείτε περισσότερα", "player_lyrics": "Track Info", "player_track_versions_edited": "Έκδοση με διορθώσεις", "player_mobile_share": "Share", "player_acc_share_dialog": "Κοινοποίηση", "player_music_album_versions_live": "Ζωντανά", "player_acc_track_cover": "Εξώφυλλο Κομματιού", "player_buy_album": "Buy Album", "player_music_album_versions_clean": "Clean Version", "player_album": "Album", "player_payment_preview_mode": "Preview Mode", "player_acc_share_playlist_dialog": "Κοινοποίηση λίστας αναπαραγωγής", "player_track_versions_explicit": "Άσεμνη εκδοχή", "player_free_song": "Free Download", "player_acc_track_info_dialog": "Πληροφορίες κομματιού", "player_music_album_versions_special": "Special Edition", "player_track_versions_live": "Live", "player_no_tracks_publish_single": "Αυτό το σινγκλ θα κυκλοφορήσει σύντομα!", "player_share_album": "Κοινοποίηση άλμπουμ", "player_payment_got_it": "Κατάλαβα", "player_buy_song": "Buy Track", "player_download": "Download", "player_get_single": "Αποκτήστε σίνγκλ", "player_acc_mute": "Σίγαση", "player_acc_album_cover": "Εξώφυλλο Άλμπουμ", "player_get_track": "Αποκτήστε το κομμάτι", "player_music_album_versions_demo": "Demo", "player_mobile_share_this_album": "Κοινή χρήση αυτού του άλμπουμ", "player_sharing_text": "Ολοκληρώστε την παραγγελία αυτής της υπέροχης μουσικής", "player_share_single": "Κοινοποίηση σινγκλ", "player_acc_progressbar": "Γραμμή προόδου" };

/***/ }),
/* 107 */
/* no static exports found */
/* all exports used */
/*!****************************!*\
  !*** ./l10n/texts_es.json ***!
  \****************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = { "player_acc_track_played": "audios reproducidos: %s", "player_acc_tracklist_pause_track": "Pause selected track number %s: %s", "player_acc_album_description": "Descripción del álbum", "player_play": "Reproducir", "player_acc_share_on_facebook": "Compartir en Facebook", "player_acc_tracklist": "%s lista de audios", "player_track_collaboration_with": "Con", "player_music_album_versions_bonus": "Audio extra", "player_show_all_tracks": "Mostrar todos los audios", "player_download_single": "Descargar single", "player_get_album": "Obtener álbum", "player_previous": "Previo", "player_track_collaboration_featuring": "Presentando", "app_description": "Facilita a los fans el poder escuchar, descargar y comprar tu música y verifica las estadísticas de descargas y reproducciones de tu música.", "player_acc_progress_value": "%s de %s", "player_payment_preview_error": "Ten en cuenta que estás en el modo Vista Previa.\nEsta función se activa después de que tu página web haya sido publicada.", "player_track_collaboration_performed": "Interpretado por", "player_acc_track_duration": "Duración del audio: %s", "player_acc_pause": "Pausa", "player_share_playlist": "Compartir lista", "player_acc_track_info": "Información del audio", "player_acc_prev": "Audio anterior", "player_acc_next": "Próximo audio", "player_track_versions_dirty": "Versión no censurada", "player_music_album_versions_empty": "—", "player_acc_buy_album": "Comprar álbum por %s", "player_track_versions_acoustic": "Acústico", "player_pause": "Pausa", "player_acc_volume_value": "%s volumen", "player_buy_single": "Comprar single", "player_acc_close": "Cerrar", "player_no_tracks_artist_name": "Nombre del artista", "player_acc_share_single_dialog": "Compartir single", "track_page_lyrics": "Letras", "player_mobile_share_this_song": "Compartir audio", "player_acc_unmute": "Unmute", "player_acc_share_on_twitter": "Compartir en Twitter", "player_track_versions_bonus": "Audio extra", "player_track_versions_empty": "—", "player_acc_play_live": "Track is playing", "player_acc_play": "Reproducir", "player_free": "Gratis", "player_track_collaboration_remixed": "Remezclado por", "player_acc_share_album_dialog": "Compartir el álbum", "player_single": "Single", "player_acc_pause_live": "Track paused", "player_acc_share_on_tumblr": "Compartir en Tumblr", "player_tracks_total": "%s Total", "player_no_tracks": "¡Agrega tu primera pista!", "player_music_album_versions_deluxe": "Edición de lujo", "player_no_tracks_track_name": "Nombre del audio", "player_shuffle": "Reproducción aleatoria", "player_music_album_versions_remastered": "Remasterizado", "player_download_album": "Descargar álbum", "player_music_album_versions_remixes": "Remixes", "player_track": "Audio", "player_track_out_of": "Audio %s (fuera de %s)", "player_track_versions_demo": "Demostración", "player_next": "Siguiente", "player_acc_buy_track": "Comprar audio por %s", "app_title": "Wix Music", "player_acc_share_on_blogger": "Compartir en Blogger", "player_music_album_versions_acoustic": "Acústico", "player_no_tracks_publish_playlist": "¡Esta lista pronto estará disponible!", "player_repeat": "Repetir", "player_mobile_view_less": "Ver menos", "player_acc_tracklist_play_track": "Play track number %s: %s", "player_acc_share": "Compartir", "player_track_versions_clean": "Versión censurada", "player_no_tracks_publish": "¡Este álbum estará disponible próximamente!", "player_share": "Compartir", "player_share_song": "Compartir audio", "player_track_versions_radio": "Versión editada para radio", "player_download_track": "Descargar audio", "player_mobile_view_more": "Ver más", "player_lyrics": "Info del audio", "player_track_versions_edited": "Versión editada", "player_mobile_share": "Compartir", "player_acc_share_dialog": "Compartir", "player_music_album_versions_live": "En vivo", "player_acc_track_cover": "Portada del audio", "player_buy_album": "Comprar el álbum", "player_music_album_versions_clean": "Versión depurada", "player_album": "álbum", "player_payment_preview_mode": "Modo de Vista Previa", "player_acc_share_playlist_dialog": "Compartir lista", "player_track_versions_explicit": "Versión explícita", "player_free_song": "Descarga gratuita", "player_acc_track_info_dialog": "Información del audio", "player_music_album_versions_special": "Edición especial", "player_track_versions_live": "En vivo", "player_no_tracks_publish_single": "¡Este single pronto estará disponible!", "player_share_album": "Compartir el álbum", "player_payment_got_it": "OK", "player_buy_song": "Comprar audio", "player_download": "Descargar", "player_get_single": "Obtener single", "player_acc_mute": "Mudo", "player_acc_album_cover": "Portada del álbum", "player_get_track": "Obtener audio", "player_music_album_versions_demo": "Demostración", "player_mobile_share_this_album": "Comparte este álbum:", "player_sharing_text": "conoce esta genial música", "player_share_single": "Compartir single", "player_acc_progressbar": "Barra de progreso" };

/***/ }),
/* 108 */
/* no static exports found */
/* all exports used */
/*!****************************!*\
  !*** ./l10n/texts_fi.json ***!
  \****************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = { "player_acc_track_played": "Raidasta soitettu: %s", "player_acc_tracklist_pause_track": "Pause selected track number %s: %s", "player_acc_album_description": "Album description", "player_play": "Toista", "player_acc_share_on_facebook": "Jaa Facebookissa", "player_acc_tracklist": "%s raitaluettelo", "player_track_collaboration_with": "With", "player_music_album_versions_bonus": "Bonusraita", "player_show_all_tracks": "Näytä kaikki kappaleet", "player_download_single": "Lataa single", "player_get_album": "Hanki albumi", "player_previous": "Edellinen", "player_track_collaboration_featuring": "Featuring", "app_description": "Make it easy for fans to listen, download and purchase your work and check your music's play and download stats.", "player_acc_progress_value": "%s sta %s", "player_payment_preview_error": "Hey, you’re in Preview Mode.\nThis feature works on your live site once it’s published.", "player_track_collaboration_performed": "Performed By", "player_acc_track_duration": "Raidan kesto: %s", "player_acc_pause": "Keskeytä", "player_share_playlist": "Jaa soittolista", "player_acc_track_info": "Raidan tiedot", "player_acc_prev": "Edellinen raita", "player_acc_next": "Seuraava raita", "player_track_versions_dirty": "Likainen versio", "player_music_album_versions_empty": "—", "player_acc_buy_album": "Osta albumi hintaan %s", "player_track_versions_acoustic": "Akustinen", "player_pause": "Keskeytä", "player_acc_volume_value": "%s äänenvoimakkuus", "player_buy_single": "Osta single", "player_acc_close": "Sulje", "player_no_tracks_artist_name": "Artistin nimi", "player_acc_share_single_dialog": "Jaa single", "track_page_lyrics": "Lyrics", "player_mobile_share_this_song": "Jaa tämä raita:", "player_acc_unmute": "Unmute", "player_acc_share_on_twitter": "Jaa Twitterissä", "player_track_versions_bonus": "Bonusraita", "player_track_versions_empty": "—", "player_acc_play_live": "Track is playing", "player_acc_play": "Toista", "player_free": "Ilmainen", "player_track_collaboration_remixed": "Remixed By", "player_acc_share_album_dialog": "Jaa albumi", "player_single": "Single", "player_acc_pause_live": "Track paused", "player_acc_share_on_tumblr": "Jaa Tumblr-sovelluksessa", "player_tracks_total": "%s yhteensä", "player_no_tracks": "Lisää ensimmäinen raitasi!", "player_music_album_versions_deluxe": "Deluxe Edition", "player_no_tracks_track_name": "Kappaleen nimi", "player_shuffle": "Sekoita", "player_music_album_versions_remastered": "Remastered", "player_download_album": "Download Album", "player_music_album_versions_remixes": "Remixes", "player_track": "Track", "player_track_out_of": "Raita %s (%s sta)", "player_track_versions_demo": "Demo", "player_next": "Seuraava", "player_acc_buy_track": "Osta raita hintaan %s", "app_title": "Wix Player", "player_acc_share_on_blogger": "Jaa Blogger-sovelluksessa", "player_music_album_versions_acoustic": "Acoustic", "player_no_tracks_publish_playlist": "Tämä soittolista on saatavilla pian!", "player_repeat": "Toista", "player_mobile_view_less": "Näytä vähemmän", "player_acc_tracklist_play_track": "Play track number %s: %s", "player_acc_share": "Jaa", "player_track_versions_clean": "Puhdas versio", "player_no_tracks_publish": "Tämä albumi tulossa pian!", "player_share": "Share", "player_share_song": "Share Track", "player_track_versions_radio": "Radioversio", "player_download_track": "Download Track", "player_mobile_view_more": "Näytä lisää", "player_lyrics": "Track Info", "player_track_versions_edited": "Editoitu versio", "player_mobile_share": "Share", "player_acc_share_dialog": "Jaa", "player_music_album_versions_live": "Live", "player_acc_track_cover": "Raidan kansi", "player_buy_album": "Buy Album", "player_music_album_versions_clean": "Clean Version", "player_album": "Album", "player_payment_preview_mode": "Preview Mode", "player_acc_share_playlist_dialog": "Jaa soittolista", "player_track_versions_explicit": "Eksplisiittinen versio", "player_free_song": "Free Download", "player_acc_track_info_dialog": "Raidan tiedot", "player_music_album_versions_special": "Special Edition", "player_track_versions_live": "Live", "player_no_tracks_publish_single": "Tämä single on saatavilla pian!", "player_share_album": "Jaa albumi", "player_payment_got_it": "Ok", "player_buy_song": "Buy Track", "player_download": "Download", "player_get_single": "Hanki single", "player_acc_mute": "Vaimenna", "player_acc_album_cover": "Albumin kansi", "player_get_track": "Hanki kappale", "player_music_album_versions_demo": "Demo", "player_mobile_share_this_album": "Jaa tämä albumi:", "player_sharing_text": "Tsekkaa tätä siistiä musiikkia", "player_share_single": "Jaa single", "player_acc_progressbar": "Edistymispalkki" };

/***/ }),
/* 109 */
/* no static exports found */
/* all exports used */
/*!****************************!*\
  !*** ./l10n/texts_fr.json ***!
  \****************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = { "player_acc_track_played": "Morceau lu : %s", "player_acc_tracklist_pause_track": "Pause selected track number %s: %s", "player_acc_album_description": "Description de l'album", "player_play": "Lecture", "player_acc_share_on_facebook": "Partager sur Facebook", "player_acc_tracklist": "%s Liste morceaux ", "player_track_collaboration_with": "avec", "player_music_album_versions_bonus": "Morceau bonus", "player_show_all_tracks": "Afficher tous les morceaux", "player_download_single": "Télécharger single", "player_get_album": "Recevez l'album", "player_previous": "Précédent", "player_track_collaboration_featuring": "Featuring", "app_description": "Permettez à vos fans d'écouter, de télécharger et d'acheter votre musique. Consultez les statistiques de lecture et de téléchargement.", "player_acc_progress_value": "%s de %s", "player_payment_preview_error": "Vous êtes en mode \"Aperçu\".\nCette fonctionnalité ne sera disponible qu'une fois votre site publié.", "player_track_collaboration_performed": "Par", "player_acc_track_duration": "Durée morceau : %s", "player_acc_pause": "Pause", "player_share_playlist": "Partager liste de lecture", "player_acc_track_info": "Infos morceau", "player_acc_prev": "Morceau précédent", "player_acc_next": "Morceau suivant", "player_track_versions_dirty": "Version longue", "player_music_album_versions_empty": "—", "player_acc_buy_album": "Acheter album pour %s", "player_track_versions_acoustic": "Acoustique", "player_pause": "Pause", "player_acc_volume_value": "%s volume", "player_buy_single": "Acheter single", "player_acc_close": "Fermer", "player_no_tracks_artist_name": "Nom de l'artiste", "player_acc_share_single_dialog": "Partager single", "track_page_lyrics": "Paroles", "player_mobile_share_this_song": "Partager", "player_acc_unmute": "Unmute", "player_acc_share_on_twitter": "Partager sur Twitter", "player_track_versions_bonus": "Morceau bonus", "player_track_versions_empty": "—", "player_acc_play_live": "Track is playing", "player_acc_play": "Lecture", "player_free": "Gratuit", "player_track_collaboration_remixed": "Remixé par", "player_acc_share_album_dialog": "Partager album", "player_single": "Single", "player_acc_pause_live": "Track paused", "player_acc_share_on_tumblr": "Partager sur Tumblr", "player_tracks_total": "%s total", "player_no_tracks": "Ajoutez votre premier morceau  !", "player_music_album_versions_deluxe": "Édition Deluxe", "player_no_tracks_track_name": "Nom du morceau", "player_shuffle": "Aléatoire", "player_music_album_versions_remastered": "Remastérisé ", "player_download_album": "Télécharger album", "player_music_album_versions_remixes": "Remix", "player_track": "Morceau", "player_track_out_of": "%s morceau (sur %s)", "player_track_versions_demo": "Démo", "player_next": "Suivant", "player_acc_buy_track": "Acheter morceau pour %s", "app_title": "Lecteur Wix", "player_acc_share_on_blogger": "Partager sur Blogger", "player_music_album_versions_acoustic": "Acoustique", "player_no_tracks_publish_playlist": "Cette liste de lecture sera disponible bientôt !", "player_repeat": "Répétition", "player_mobile_view_less": "Voir moins", "player_acc_tracklist_play_track": "Play track number %s: %s", "player_acc_share": "Partager", "player_track_versions_clean": "Version originale", "player_no_tracks_publish": "Cet album sort bientôt !", "player_share": "Partager", "player_share_song": "Partager", "player_track_versions_radio": "Radio Edit", "player_download_track": "Télécharger morceau", "player_mobile_view_more": "En voir plus", "player_lyrics": "Info", "player_track_versions_edited": "Version modifiée", "player_mobile_share": "Partager", "player_acc_share_dialog": "Partager", "player_music_album_versions_live": "Live", "player_acc_track_cover": "Couverture du morceau", "player_buy_album": "Acheter album", "player_music_album_versions_clean": "Version originale", "player_album": "Album", "player_payment_preview_mode": "Mode Aperçu", "player_acc_share_playlist_dialog": "Partager liste de lecture", "player_track_versions_explicit": "Version explicite", "player_free_song": "Téléchargement gratuit", "player_acc_track_info_dialog": "Infos morceau", "player_music_album_versions_special": "Édition Spéciale", "player_track_versions_live": "Live", "player_no_tracks_publish_single": "Ce single sera disponible bientôt !", "player_share_album": "Partager album", "player_payment_got_it": "OK, j'ai compris", "player_buy_song": "Acheter", "player_download": "Télécharger", "player_get_single": "Recevez le single", "player_acc_mute": "Silencieux", "player_acc_album_cover": "Couverture d'album", "player_get_track": "Recevez le titre", "player_music_album_versions_demo": "Démo", "player_mobile_share_this_album": "Partager cet album :", "player_sharing_text": "Découvrez cette musique", "player_share_single": "Partager single", "player_acc_progressbar": "Barre de progression" };

/***/ }),
/* 110 */
/* no static exports found */
/* all exports used */
/*!****************************!*\
  !*** ./l10n/texts_he.json ***!
  \****************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = { "player_acc_track_played": "הקטע שמושמע: %s", "player_acc_tracklist_pause_track": "Pause selected track number %s: %s", "player_acc_album_description": "Album description", "player_play": "ניגון", "player_acc_share_on_facebook": "שיתוף בפייסבוק", "player_acc_tracklist": "רשימת השירים ב%s", "player_track_collaboration_with": "With", "player_music_album_versions_bonus": "שיר בונוס", "player_show_all_tracks": "הצג את כל השירים", "player_download_single": "להורדת הסינגל", "player_get_album": "להורדת האלבום", "player_previous": "קודם", "player_track_collaboration_featuring": "Featuring", "app_description": "Make it easy for fans to listen, download and purchase your work and check your music's play and download stats.", "player_acc_progress_value": "%s מתוך %s", "player_payment_preview_error": "Hey, you’re in Preview Mode.\nThis feature works on your live site once it’s published.", "player_track_collaboration_performed": "Performed By", "player_acc_track_duration": "אורך השיר: %s", "player_acc_pause": "השהייה", "player_share_playlist": "שיתוף הפלייליסט", "player_acc_track_info": "פרטי השיר", "player_acc_prev": "השיר הקודם", "player_acc_next": "השיר הבא", "player_track_versions_dirty": "גרסה \"מלוכלכת\"", "player_music_album_versions_empty": "—", "player_acc_buy_album": "קניית האלבום במחיר %s", "player_track_versions_acoustic": "אקוסטי", "player_pause": "השהייה", "player_acc_volume_value": "%s עוצמה", "player_buy_single": "לקניית הסינגל", "player_acc_close": "סגירה", "player_no_tracks_artist_name": "שם המבצע/ת", "player_acc_share_single_dialog": "שיתוף סינגל", "track_page_lyrics": "Lyrics", "player_mobile_share_this_song": "שיתוף הקטע:", "player_acc_unmute": "Unmute", "player_acc_share_on_twitter": "שיתוף בטוויטר", "player_track_versions_bonus": "שיר בונוס", "player_track_versions_empty": "—", "player_acc_play_live": "Track is playing", "player_acc_play": "ניגון", "player_free": "חינם", "player_track_collaboration_remixed": "Remixed By", "player_acc_share_album_dialog": "שיתוף האלבום", "player_single": "סינגל", "player_acc_pause_live": "Track paused", "player_acc_share_on_tumblr": "שיתוף ב-Tumblr", "player_tracks_total": "סך הכל %s", "player_no_tracks": "הוספת השיר הראשון שלך", "player_music_album_versions_deluxe": "Deluxe Edition", "player_no_tracks_track_name": "שם הקטע", "player_shuffle": "ערבוב", "player_music_album_versions_remastered": "Remastered", "player_download_album": "Download Album", "player_music_album_versions_remixes": "Remixes", "player_track": "Track", "player_track_out_of": "שיר %s (מתוך %s)", "player_track_versions_demo": "דמו", "player_next": "הבא", "player_acc_buy_track": "לקנייה במחיר %s", "app_title": "Wix Player", "player_acc_share_on_blogger": "שיתוף ב-Blogger", "player_music_album_versions_acoustic": "Acoustic", "player_no_tracks_publish_playlist": "הפלייליסט הזה יוצא בקרוב!", "player_repeat": "נגן שוב", "player_mobile_view_less": "הצג פחות", "player_acc_tracklist_play_track": "Play track number %s: %s", "player_acc_share": "שיתוף", "player_track_versions_clean": "גרסה \"נקייה\"", "player_no_tracks_publish": "האלבום הזה יוצא בקרוב!", "player_share": "Share", "player_share_song": "Share Track", "player_track_versions_radio": "גרסת רדיו", "player_download_track": "Download Track", "player_mobile_view_more": "הצג עוד", "player_lyrics": "Track Info", "player_track_versions_edited": "גרסה ערוכה", "player_mobile_share": "Share", "player_acc_share_dialog": "שיתוף", "player_music_album_versions_live": "שידור חי", "player_acc_track_cover": "עטיפת השיר", "player_buy_album": "Buy Album", "player_music_album_versions_clean": "Clean Version", "player_album": "Album", "player_payment_preview_mode": "Preview Mode", "player_acc_share_playlist_dialog": "שיתוף פלייליסט", "player_track_versions_explicit": "גרסה לא ערוכה", "player_free_song": "Free Download", "player_acc_track_info_dialog": "פרטי השיר", "player_music_album_versions_special": "Special Edition", "player_track_versions_live": "Live", "player_no_tracks_publish_single": "הסינגל הזה יוצא בקרוב!", "player_share_album": "שיתוף האלבום", "player_payment_got_it": "הבנתי", "player_buy_song": "Buy Track", "player_download": "Download", "player_get_single": "להורדת הסינגל", "player_acc_mute": "השתקה", "player_acc_album_cover": "עטיפת האלבום", "player_get_track": "להורדת השיר", "player_music_album_versions_demo": "Demo", "player_mobile_share_this_album": "שיתוף האלבום:", "player_sharing_text": "קבלו את המוזיקה המעולה הזאת", "player_share_single": "שיתוף סינגל", "player_acc_progressbar": "סרגל התקדמות" };

/***/ }),
/* 111 */
/* no static exports found */
/* all exports used */
/*!****************************!*\
  !*** ./l10n/texts_hi.json ***!
  \****************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = { "player_acc_track_played": "ट्रैक इतनी बार चला: %s", "player_acc_tracklist_pause_track": "Pause selected track number %s: %s", "player_acc_album_description": "एल्बम का विवरण", "player_play": "चलाएँ", "player_acc_share_on_facebook": "Facebook पर शेयर करें", "player_acc_tracklist": "%s ट्रैक सूची", "player_track_collaboration_with": "के साथ", "player_music_album_versions_bonus": "बोनस ट्रैक", "player_show_all_tracks": "सभी ट्रैक्स दिखाएँ", "player_download_single": "सिंगल डाउनलोड करें", "player_get_album": "एल्बम प्राप्त करें", "player_previous": "पिछला", "player_track_collaboration_featuring": "चल रहा है", "app_description": "प्रशंसकों के लिए आपका काम सुनना, डाउनलोड करना और खरीदना आसान बनाएं और अपने म्यूजिक को प्ले करने एवं डाउनलोड करने के आंकड़े देखें।", "player_acc_progress_value": "%s का %s", "player_payment_preview_error": "सुनिए, आप पूर्वावलोकन मोड में हैं।\nप्रकाशित होने के बाद यह सुविधा आपकी लाइव साइट पर काम करती है।", "player_track_collaboration_performed": "द्वारा प्रदर्शित", "player_acc_track_duration": "ट्रैक की अवधि: %s", "player_acc_pause": "रोकें", "player_share_playlist": "प्लेलिस्ट साझा करें", "player_acc_track_info": "ट्रैक की जानकारी", "player_acc_prev": "पिछला ट्रैक", "player_acc_next": "अगला ट्रैक", "player_track_versions_dirty": "गंदा संस्करण", "player_music_album_versions_empty": "—", "player_acc_buy_album": "%s में एल्बम खरीदें", "player_track_versions_acoustic": "अकूस्टिक", "player_pause": "रोकें", "player_acc_volume_value": "%s वॉल्यूम", "player_buy_single": "सिंगल खरीदें", "player_acc_close": "बंद करें", "player_no_tracks_artist_name": "कलाकार का नाम", "player_acc_share_single_dialog": "सिंगल साझा करें", "track_page_lyrics": "लिरिक्स", "player_mobile_share_this_song": "यह ट्रैक शेयर करें:", "player_acc_unmute": "Unmute", "player_acc_share_on_twitter": "Twitter पर शेयर करें", "player_track_versions_bonus": "बोनस ट्रैक", "player_track_versions_empty": "—", "player_acc_play_live": "Track is playing", "player_acc_play": "चलाएँ", "player_free": "निःशुल्क", "player_track_collaboration_remixed": "रीमीक्ष बनाया गया", "player_acc_share_album_dialog": "एलबम शेयर करें", "player_single": "सिंगल", "player_acc_pause_live": "Track paused", "player_acc_share_on_tumblr": "Tumblr पर साझा करें", "player_tracks_total": "%s कुल", "player_no_tracks": "अपना पहला ट्रैक जोड़ें!", "player_music_album_versions_deluxe": "डीलक्स संस्करण", "player_no_tracks_track_name": "ट्रैक का नाम", "player_shuffle": "शफ़ल करें", "player_music_album_versions_remastered": "परिष्कृत किया गया", "player_download_album": "एल्बम डाउनलोड करें", "player_music_album_versions_remixes": "रीमिक्स", "player_track": "ट्रैक", "player_track_out_of": "ट्रैक्स %s (%s में से)", "player_track_versions_demo": "डेमो", "player_next": "अगला", "player_acc_buy_track": "%s में ट्रैक खरीदें", "app_title": "Wix प्लेयर", "player_acc_share_on_blogger": "Blogger पर साझा करें", "player_music_album_versions_acoustic": "अकूस्टिक", "player_no_tracks_publish_playlist": "यह प्लेलिस्ट शीघ्र ही आ रही है!", "player_repeat": "दोहराएँ", "player_mobile_view_less": "कम दिखाएं", "player_acc_tracklist_play_track": "Play track number %s: %s", "player_acc_share": "शेयर करें", "player_track_versions_clean": "क्लीन संस्करण", "player_no_tracks_publish": "यह एल्बम जल्द ही आ रहा है!", "player_share": "साझा करें", "player_share_song": "ट्रैक शेयर करें", "player_track_versions_radio": "रेडियो संपादन", "player_download_track": "ट्रैक डाउनलोड करें", "player_mobile_view_more": "अधिक देखें", "player_lyrics": "ट्रैक जानकारी", "player_track_versions_edited": "संपादित संस्करण", "player_mobile_share": "शेयर करें", "player_acc_share_dialog": "शेयर करें", "player_music_album_versions_live": "लाइव", "player_acc_track_cover": "ट्रैक कवर", "player_buy_album": "एल्बम खरीदें", "player_music_album_versions_clean": "क्लीन संस्करण", "player_album": "एल्बम", "player_payment_preview_mode": "पूर्वावलोकन मोड", "player_acc_share_playlist_dialog": "प्लेलिस्ट साझा करें", "player_track_versions_explicit": "बेबाक संस्करण", "player_free_song": "निःशुल्क डाउनलोड", "player_acc_track_info_dialog": "ट्रैक की जानकारी", "player_music_album_versions_special": "विशेष संस्करण", "player_track_versions_live": "लाइव", "player_no_tracks_publish_single": "यह सिंगल शीघ्र ही आ रहा है!", "player_share_album": "एलबम शेयर करें", "player_payment_got_it": "समझ लिया", "player_buy_song": "ट्रैक खरीदें", "player_download": "डाउनलोड करें", "player_get_single": "सिंगल प्राप्त करें", "player_acc_mute": "आवाज बंद करें", "player_acc_album_cover": "एल्बम कवर", "player_get_track": "ट्रैक प्राप्त करें", "player_music_album_versions_demo": "डेमो", "player_mobile_share_this_album": "इस एल्बम को साझा करें:", "player_sharing_text": "इस सुंदर म्यूजिक को जांचें", "player_share_single": "सिंगल साझा करें", "player_acc_progressbar": "प्रगति पट्टी" };

/***/ }),
/* 112 */
/* no static exports found */
/* all exports used */
/*!****************************!*\
  !*** ./l10n/texts_hu.json ***!
  \****************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = { "player_acc_track_played": "Játszott szám (dal): %s", "player_acc_tracklist_pause_track": "Pause selected track number %s: %s", "player_acc_album_description": "Album description", "player_play": "Lejátszás", "player_acc_share_on_facebook": "Megosztás a Facebookon", "player_acc_tracklist": "%s számok listája", "player_track_collaboration_with": "With", "player_music_album_versions_bonus": "Bónusz szám", "player_show_all_tracks": "Összes szám mutatása", "player_download_single": "Kislemez letöltése", "player_get_album": "Album megvásárlása", "player_previous": "Előző", "player_track_collaboration_featuring": "Featuring", "app_description": "Make it easy for fans to listen, download and purchase your work and check your music's play and download stats.", "player_acc_progress_value": "%s / %s", "player_payment_preview_error": "Hey, you’re in Preview Mode.\nThis feature works on your live site once it’s published.", "player_track_collaboration_performed": "Performed By", "player_acc_track_duration": "Szám hossza: %s", "player_acc_pause": "Szünet", "player_share_playlist": "Lejátszási lista megosztása", "player_acc_track_info": "Infók a számról", "player_acc_prev": "Előző szám", "player_acc_next": "Következő szám", "player_track_versions_dirty": "Vulgáris (nyers) változat", "player_music_album_versions_empty": "—", "player_acc_buy_album": "Album megvásárlása %s részére", "player_track_versions_acoustic": "Akusztikus", "player_pause": "Szünet", "player_acc_volume_value": "%s hangerő", "player_buy_single": "Kislemez vásárlása", "player_acc_close": "Bezár", "player_no_tracks_artist_name": "Művész neve", "player_acc_share_single_dialog": "Kislemez megosztása", "track_page_lyrics": "Lyrics", "player_mobile_share_this_song": "Megosztom ezt a számot:", "player_acc_unmute": "Unmute", "player_acc_share_on_twitter": "Megosztás a Twitteren", "player_track_versions_bonus": "Bónusz szám", "player_track_versions_empty": "—", "player_acc_play_live": "Track is playing", "player_acc_play": "Lejátszás", "player_free": "Ingyenes", "player_track_collaboration_remixed": "Remixed By", "player_acc_share_album_dialog": "Album megosztása", "player_single": "Kislemez", "player_acc_pause_live": "Track paused", "player_acc_share_on_tumblr": "Megosztás a Tumblr-en", "player_tracks_total": "összesen %s", "player_no_tracks": "Add hozzá az első számot!", "player_music_album_versions_deluxe": "Deluxe Edition", "player_no_tracks_track_name": "Szám címe", "player_shuffle": "Keverés", "player_music_album_versions_remastered": "Remastered", "player_download_album": "Download Album", "player_music_album_versions_remixes": "Remixes", "player_track": "Track", "player_track_out_of": "%s. szám (összesen: %s)", "player_track_versions_demo": "Demó", "player_next": "Következő", "player_acc_buy_track": "Szám megvásárlása %s részére", "app_title": "Wix Player", "player_acc_share_on_blogger": "Megosztás a Bloggeren", "player_music_album_versions_acoustic": "Acoustic", "player_no_tracks_publish_playlist": "Ez a lejátszási lista hamarosan megjelenik!", "player_repeat": "Ismétlés", "player_mobile_view_less": "Kevesebb mutatása", "player_acc_tracklist_play_track": "Play track number %s: %s", "player_acc_share": "Megosztás", "player_track_versions_clean": "Szalonképes változat", "player_no_tracks_publish": "Ez az album hamarosan megjelenik!", "player_share": "Share", "player_share_song": "Share Track", "player_track_versions_radio": "Rádiós változat", "player_download_track": "Download Track", "player_mobile_view_more": "Több mutatása", "player_lyrics": "Track Info", "player_track_versions_edited": "Szerkesztett változat", "player_mobile_share": "Share", "player_acc_share_dialog": "Megosztás", "player_music_album_versions_live": "Élő", "player_acc_track_cover": "Szám (dal) borítója", "player_buy_album": "Buy Album", "player_music_album_versions_clean": "Clean Version", "player_album": "Album", "player_payment_preview_mode": "Preview Mode", "player_acc_share_playlist_dialog": "Lejátszási lista megosztása", "player_track_versions_explicit": "Nyers (vulgáris) változat", "player_free_song": "Free Download", "player_acc_track_info_dialog": "Infók a számról", "player_music_album_versions_special": "Special Edition", "player_track_versions_live": "Live", "player_no_tracks_publish_single": "Ez a kislemez hamarosan megjelenik!", "player_share_album": "Album megosztása", "player_payment_got_it": "Megvan!", "player_buy_song": "Buy Track", "player_download": "Download", "player_get_single": "Kislemez megvásárlása", "player_acc_mute": "Némítás", "player_acc_album_cover": "Albumborító", "player_get_track": "Szám megvásárlása", "player_music_album_versions_demo": "Demo", "player_mobile_share_this_album": "Megosztom ezt az albumot:", "player_sharing_text": "hallgasd meg ezt a remek zenét", "player_share_single": "Kislemez megosztása", "player_acc_progressbar": "Folyamatjelző sáv" };

/***/ }),
/* 113 */
/* no static exports found */
/* all exports used */
/*!****************************!*\
  !*** ./l10n/texts_id.json ***!
  \****************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = { "player_acc_track_played": "Lagu diputar: %s", "player_acc_tracklist_pause_track": "Pause selected track number %s: %s", "player_acc_album_description": "Deskripsi album", "player_play": "Putar", "player_acc_share_on_facebook": "Bagikan di Facebook", "player_acc_tracklist": "Daftar lagu %s", "player_track_collaboration_with": "Dengan", "player_music_album_versions_bonus": "Lagu Bonus", "player_show_all_tracks": "Tampilkan semua lagu", "player_download_single": "Unduh Single", "player_get_album": "Dapatkan Album", "player_previous": "Sebelumnya", "player_track_collaboration_featuring": "Bersama", "app_description": "Permudah penggemar mendengar, mengunduh, dan membeli karya, serta memeriksa statistik pemutaran dan unduhan musik.", "player_acc_progress_value": "%s dari %s", "player_payment_preview_error": "Halo, Anda berada di mode Pratinjau.\nFitur ini berfungsi di situs aktif setelah dipublikasikan.", "player_track_collaboration_performed": "Dibawakan Oleh", "player_acc_track_duration": "Durasi lagu: %s", "player_acc_pause": "Jeda", "player_share_playlist": "Bagikan Daftar Putar", "player_acc_track_info": "Info lagu", "player_acc_prev": "Lagu sebelumnya", "player_acc_next": "Lagu berikutnya", "player_track_versions_dirty": "Versi Jorok", "player_music_album_versions_empty": "—", "player_acc_buy_album": "Beli album seharga %s", "player_track_versions_acoustic": "Akustik", "player_pause": "Jeda", "player_acc_volume_value": "Volume %s", "player_buy_single": "Beli Single", "player_acc_close": "Tutup", "player_no_tracks_artist_name": "Nama Artis", "player_acc_share_single_dialog": "Bagikan Single", "track_page_lyrics": "Lirik", "player_mobile_share_this_song": "Bagikan Lagu Ini:", "player_acc_unmute": "Unmute", "player_acc_share_on_twitter": "Bagikan di Twitter", "player_track_versions_bonus": "Lagu Bonus", "player_track_versions_empty": "—", "player_acc_play_live": "Track is playing", "player_acc_play": "Putar", "player_free": "Gratis", "player_track_collaboration_remixed": "Diremix Oleh", "player_acc_share_album_dialog": "Bagikan Album", "player_single": "Single", "player_acc_pause_live": "Track paused", "player_acc_share_on_tumblr": "Bagikan di Tumblr", "player_tracks_total": "%s Total", "player_no_tracks": "Tambahkan lagu pertamamu!", "player_music_album_versions_deluxe": "Edisi Deluxe", "player_no_tracks_track_name": "Nama Trek", "player_shuffle": "Acak", "player_music_album_versions_remastered": "Remaster", "player_download_album": "Unduh Album", "player_music_album_versions_remixes": "Remix", "player_track": "Lagu", "player_track_out_of": "Lagu %s (Dari %s)", "player_track_versions_demo": "Demo", "player_next": "Berikutnya", "player_acc_buy_track": "Beli lagu untuk %s", "app_title": "Wix Player", "player_acc_share_on_blogger": "Bagikan di Blogger", "player_music_album_versions_acoustic": "Akustik", "player_no_tracks_publish_playlist": "Daftar putar ini segera hadir!", "player_repeat": "Ulangi", "player_mobile_view_less": "Lihat Sedikit", "player_acc_tracklist_play_track": "Play track number %s: %s", "player_acc_share": "Bagikan", "player_track_versions_clean": "Versi Bersih", "player_no_tracks_publish": "Album ini segera hadir!", "player_share": "Bagikan", "player_share_song": "Bagikan Lagu", "player_track_versions_radio": "Diedit Radio", "player_download_track": "Unduh Lagu", "player_mobile_view_more": "Lihat Lainnya", "player_lyrics": "Info Lagu", "player_track_versions_edited": "Bersi Diedit", "player_mobile_share": "Bagikan", "player_acc_share_dialog": "Bagikan", "player_music_album_versions_live": "Langsung", "player_acc_track_cover": "Sampul Lagu", "player_buy_album": "Beli Album", "player_music_album_versions_clean": "Versi Jernih", "player_album": "Album", "player_payment_preview_mode": "Mode Pratinjau", "player_acc_share_playlist_dialog": "Bagikan Daftar Lagu", "player_track_versions_explicit": "Versi Eksplisit", "player_free_song": "Unduh Gratis", "player_acc_track_info_dialog": "Info Lagu", "player_music_album_versions_special": "Edisi Spesial", "player_track_versions_live": "Langsung", "player_no_tracks_publish_single": "Single ini segera hadir!", "player_share_album": "Bagikan Album", "player_payment_got_it": "Sip!", "player_buy_song": "Beli Lagu", "player_download": "Unduh", "player_get_single": "Dapatkan Singel", "player_acc_mute": "Bisukan", "player_acc_album_cover": "Sampul Album", "player_get_track": "Dapatkan Trek", "player_music_album_versions_demo": "Demo", "player_mobile_share_this_album": "Bagikan Album ini:", "player_sharing_text": "cek lagu keren ini", "player_share_single": "Bagikan Single", "player_acc_progressbar": "Garis Kemajuan" };

/***/ }),
/* 114 */
/* no static exports found */
/* all exports used */
/*!****************************!*\
  !*** ./l10n/texts_it.json ***!
  \****************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = { "player_acc_track_played": "Traccia riprodotte: %s", "player_acc_tracklist_pause_track": "Pause selected track number %s: %s", "player_acc_album_description": "Descrizione dell'album", "player_play": "Play", "player_acc_share_on_facebook": "Condividi su Facebook", "player_acc_tracklist": "%s lista tracce", "player_track_collaboration_with": "Con", "player_music_album_versions_bonus": "Traccia bonus", "player_show_all_tracks": "Mostra tutte le tracce", "player_download_single": "Scarica il singolo", "player_get_album": "Ottieni album", "player_previous": "Precedente", "player_track_collaboration_featuring": "Featuring", "app_description": "Rendi semplice ai tuoi fan ascoltare, scaricare e acquistare i tuoi lavori e verifica le statistiche dei download e degli ascolti.", "player_acc_progress_value": "%s di %s", "player_payment_preview_error": "Ciao, sei in modalità anteprima.\nQuesta funzione\n si attiva sul tuo sito live una volta pubblicato.", "player_track_collaboration_performed": "Eseguita da", "player_acc_track_duration": "Durata della traccia: %s", "player_acc_pause": "Pausa", "player_share_playlist": "Condividi playlist", "player_acc_track_info": "Info traccia", "player_acc_prev": "Traccia precedente", "player_acc_next": "Prossima traccia", "player_track_versions_dirty": "Versione grezza", "player_music_album_versions_empty": "—", "player_acc_buy_album": "Acquista album a %s", "player_track_versions_acoustic": "Acustico", "player_pause": "Pausa", "player_acc_volume_value": "%s volume", "player_buy_single": "Acquista singolo", "player_acc_close": "Chiudi", "player_no_tracks_artist_name": "Nome dell'artista", "player_acc_share_single_dialog": "Condividi singolo", "track_page_lyrics": "Testi", "player_mobile_share_this_song": "Condividi questa traccia:", "player_acc_unmute": "Unmute", "player_acc_share_on_twitter": "Condividi su Twitter", "player_track_versions_bonus": "Traccia bonus", "player_track_versions_empty": "—", "player_acc_play_live": "Track is playing", "player_acc_play": "Riproduci", "player_free": "Gratuito", "player_track_collaboration_remixed": "Remixato da", "player_acc_share_album_dialog": "Condividi l'album", "player_single": "Singolo", "player_acc_pause_live": "Track paused", "player_acc_share_on_tumblr": "Condividi su Tumblr", "player_tracks_total": "Totale %s", "player_no_tracks": "Aggiungi il tuo primo brano!", "player_music_album_versions_deluxe": "Edizione deluxe", "player_no_tracks_track_name": "Nome della traccia", "player_shuffle": "Riproduzione Casuale", "player_music_album_versions_remastered": "Remaster", "player_download_album": "Scarica Album", "player_music_album_versions_remixes": "Remix", "player_track": "Traccia", "player_track_out_of": "Traccia %s (Su %s)", "player_track_versions_demo": "Demo", "player_next": "Avanti", "player_acc_buy_track": "Acquista traccia a %s", "app_title": "Wix Player", "player_acc_share_on_blogger": "Condividi su Blogger", "player_music_album_versions_acoustic": "Acustico", "player_no_tracks_publish_playlist": "La playlist sta per uscire!", "player_repeat": "Ripeti", "player_mobile_view_less": "Vedi meno", "player_acc_tracklist_play_track": "Play track number %s: %s", "player_acc_share": "Condividi", "player_track_versions_clean": "Versione pulita", "player_no_tracks_publish": "Quest'album è in arrivo!", "player_share": "Condividi", "player_share_song": "Condividi traccia", "player_track_versions_radio": "Radio Edit", "player_download_track": "Scarica traccia", "player_mobile_view_more": "Mostra di più", "player_lyrics": "Informazioni sulla traccia", "player_track_versions_edited": "Versione con editing", "player_mobile_share": "Condividi", "player_acc_share_dialog": "Condividi", "player_music_album_versions_live": "Live", "player_acc_track_cover": "Copertina della traccia", "player_buy_album": "Acquista l'Album", "player_music_album_versions_clean": "Versione pulita", "player_album": "Album", "player_payment_preview_mode": "Modalità anteprima", "player_acc_share_playlist_dialog": "Condividi playlist", "player_track_versions_explicit": "Versione esplicita", "player_free_song": "Download gratuito", "player_acc_track_info_dialog": "Info traccia", "player_music_album_versions_special": "Edizione speciale", "player_track_versions_live": "Live", "player_no_tracks_publish_single": "Questo singolo sta per uscire!", "player_share_album": "Condividi l'album", "player_payment_got_it": "OK", "player_buy_song": "Acquista traccia", "player_download": "Scarica", "player_get_single": "Ottieni singolo", "player_acc_mute": "Silenzioso", "player_acc_album_cover": "Copertina dell'album", "player_get_track": "Ottieni traccia", "player_music_album_versions_demo": "Demo", "player_mobile_share_this_album": "Condividi questo album:", "player_sharing_text": "ascolta questa musica fantastica", "player_share_single": "Condividi singolo", "player_acc_progressbar": "Barra di avanzamento" };

/***/ }),
/* 115 */
/* no static exports found */
/* all exports used */
/*!****************************!*\
  !*** ./l10n/texts_ja.json ***!
  \****************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = { "player_acc_track_played": "再生済み: %s", "player_acc_tracklist_pause_track": "Pause selected track number %s: %s", "player_acc_album_description": "アルバム詳細", "player_play": "再生", "player_acc_share_on_facebook": "Facebook でシェア", "player_acc_tracklist": "%s 曲リスト", "player_track_collaboration_with": "With", "player_music_album_versions_bonus": "Bonus Track", "player_show_all_tracks": "すべて表示", "player_download_single": "シングルをダウンロード", "player_get_album": "アルバムを取得", "player_previous": "前へ", "player_track_collaboration_featuring": "Featuring", "app_description": "Wix サイトで音楽配信を始めましょう。ストリーム再生、無料ダウンロード、ダウンロード販売に対応し、再生回数やダウンロード数などのデータを解析できます。", "player_acc_progress_value": "%s / %s", "player_payment_preview_error": "プレビューでは使用できません。\n公開後のサイトでお試しください。", "player_track_collaboration_performed": "Performed By", "player_acc_track_duration": "曲の長さ: %s", "player_acc_pause": "一時停止", "player_share_playlist": "プレイリストをシェア", "player_acc_track_info": "トラック情報", "player_acc_prev": "前の曲", "player_acc_next": "次の曲", "player_track_versions_dirty": "Dirty Version", "player_music_album_versions_empty": "—", "player_acc_buy_album": "%s でアルバムを購入", "player_track_versions_acoustic": "Acoustic", "player_pause": "一時停止", "player_acc_volume_value": "音量%s", "player_buy_single": "シングルを購入", "player_acc_close": "閉じる", "player_no_tracks_artist_name": "アーティスト名", "player_acc_share_single_dialog": "シングルをシェア", "track_page_lyrics": "歌詞（オプション）", "player_mobile_share_this_song": "トラックをシェア：", "player_acc_unmute": "Unmute", "player_acc_share_on_twitter": "Twitter でツイート", "player_track_versions_bonus": "Bonus Track", "player_track_versions_empty": "—", "player_acc_play_live": "Track is playing", "player_acc_play": "再生", "player_free": "無料", "player_track_collaboration_remixed": "Remixed By", "player_acc_share_album_dialog": "アルバムをシェア", "player_single": "シングル", "player_acc_pause_live": "Track paused", "player_acc_share_on_tumblr": "Tumblr でシェア", "player_tracks_total": "合計%s曲", "player_no_tracks": "最初のトラックを追加しましょう！", "player_music_album_versions_deluxe": "Limited Edition", "player_no_tracks_track_name": "トラック名", "player_shuffle": "シャッフル", "player_music_album_versions_remastered": "Remastered", "player_download_album": "アルバムをダウンロード", "player_music_album_versions_remixes": "Remix", "player_track": "楽曲", "player_track_out_of": "トラック%s / %s", "player_track_versions_demo": "Demo", "player_next": "次へ", "player_acc_buy_track": "%s で曲を購入", "app_title": "Wix ミュージック", "player_acc_share_on_blogger": "Blogger でシェア", "player_music_album_versions_acoustic": "Acoustic", "player_no_tracks_publish_playlist": "近日公開予定", "player_repeat": "リピート", "player_mobile_view_less": "折りたたむ", "player_acc_tracklist_play_track": "Play track number %s: %s", "player_acc_share": "シェア", "player_track_versions_clean": "Clean Version", "player_no_tracks_publish": "近日公開予定", "player_share": "シェア", "player_share_song": "シェア", "player_track_versions_radio": "Radio Edit", "player_download_track": "楽曲をダウンロード", "player_mobile_view_more": "もっと見る", "player_lyrics": "トラック情報", "player_track_versions_edited": "Edited Version", "player_mobile_share": "シェア", "player_acc_share_dialog": "シェア", "player_music_album_versions_live": "Live", "player_acc_track_cover": "カバーアート", "player_buy_album": "アルバムを購入", "player_music_album_versions_clean": "Clean Version", "player_album": "アルバム", "player_payment_preview_mode": "プレビューでは使用できません", "player_acc_share_playlist_dialog": "プレイリストをシェア", "player_track_versions_explicit": "Explicit Version", "player_free_song": "無料ダウンロード", "player_acc_track_info_dialog": "トラック情報", "player_music_album_versions_special": "Special Edition", "player_track_versions_live": "Live", "player_no_tracks_publish_single": "近日公開予定", "player_share_album": "アルバムをシェア", "player_payment_got_it": "閉じる", "player_buy_song": "購入する", "player_download": "ダウンロード", "player_get_single": "シングルを取得", "player_acc_mute": "ミュート", "player_acc_album_cover": "カバーアート", "player_get_track": "トラックを取得", "player_music_album_versions_demo": "Demo", "player_mobile_share_this_album": "アルバムをシェア：", "player_sharing_text": "この音楽がオススメ！", "player_share_single": "シングルをシェア", "player_acc_progressbar": "再生バー" };

/***/ }),
/* 116 */
/* no static exports found */
/* all exports used */
/*!****************************!*\
  !*** ./l10n/texts_ko.json ***!
  \****************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = { "player_acc_track_played": "트랙 재생: %s회", "player_acc_tracklist_pause_track": "Pause selected track number %s: %s", "player_acc_album_description": "앨범 소개", "player_play": "재생", "player_acc_share_on_facebook": "Facebook 공유", "player_acc_tracklist": "%s개 트랙 목록", "player_track_collaboration_with": "Feat.", "player_music_album_versions_bonus": "보너스 트랙", "player_show_all_tracks": "전체 트랙 표시", "player_download_single": "싱글 다운로드", "player_get_album": "앨범 받기", "player_previous": "이전", "player_track_collaboration_featuring": "Feat.", "app_description": "팬들이 내 음악을 감상, 다운로드, 구매할 수 있도록 하고, 내 음악의 재생 횟수 및 다운로드 수 또한 확인하세요.", "player_acc_progress_value": "%s/%s", "player_payment_preview_error": "해당 기능을 확인하려면 사이트를 게시하세요.  \n", "player_track_collaboration_performed": "연주:", "player_acc_track_duration": "길이: %s", "player_acc_pause": "정지", "player_share_playlist": "재생목록 공유", "player_acc_track_info": "트랙 정보", "player_acc_prev": "이전 트랙", "player_acc_next": "다음 트랙", "player_track_versions_dirty": "더티 버전", "player_music_album_versions_empty": " ", "player_acc_buy_album": "앨범 구매 %s", "player_track_versions_acoustic": "어쿠스틱", "player_pause": "정지", "player_acc_volume_value": "볼륨 %s ", "player_buy_single": "싱글 구매", "player_acc_close": "닫기", "player_no_tracks_artist_name": "아티스트명", "player_acc_share_single_dialog": "싱글 공유", "track_page_lyrics": "가사", "player_mobile_share_this_song": "공유:", "player_acc_unmute": "Unmute", "player_acc_share_on_twitter": "Twitter 공유", "player_track_versions_bonus": "보너스 트랙", "player_track_versions_empty": " ", "player_acc_play_live": "Track is playing", "player_acc_play": "재생", "player_free": "무료", "player_track_collaboration_remixed": "리믹스", "player_acc_share_album_dialog": "앨범 공유", "player_single": "싱글", "player_acc_pause_live": "Track paused", "player_acc_share_on_tumblr": "Tumblr 공유", "player_tracks_total": "전체 %s개", "player_no_tracks": "첫 음원을 추가하세요!", "player_music_album_versions_deluxe": "딜럭스 에디션", "player_no_tracks_track_name": "트랙명", "player_shuffle": "셔플", "player_music_album_versions_remastered": "리마스터링", "player_download_album": "앨범 다운로드", "player_music_album_versions_remixes": "재발매 버전", "player_track": "트랙구매", "player_track_out_of": "트랙 %s (전체 %s)", "player_track_versions_demo": "데모", "player_next": "다음", "player_acc_buy_track": "트랙 구매 %s", "app_title": "Wix 뮤직", "player_acc_share_on_blogger": "Blogger 공유", "player_music_album_versions_acoustic": "어쿠스틱", "player_no_tracks_publish_playlist": "공개 예정 재생목록입니다!", "player_repeat": "반복", "player_mobile_view_less": "접기", "player_acc_tracklist_play_track": "Play track number %s: %s", "player_acc_share": "공유", "player_track_versions_clean": "클린 버전", "player_no_tracks_publish": "앨범이 곧 발매됩니다!", "player_share": "공유", "player_share_song": "공유", "player_track_versions_radio": "라디오 버전", "player_download_track": "트랙 다운로드", "player_mobile_view_more": "더 보기", "player_lyrics": "트랙 정보", "player_track_versions_edited": "에디트 버전", "player_mobile_share": "공유", "player_acc_share_dialog": "공유", "player_music_album_versions_live": "라이브", "player_acc_track_cover": "트랙 커버", "player_buy_album": "앨범 구매", "player_music_album_versions_clean": "클린 버전", "player_album": "앨범구매", "player_payment_preview_mode": "미리보기 모드", "player_acc_share_playlist_dialog": "재생목록 공유", "player_track_versions_explicit": "청소년 불가", "player_free_song": "무료 다운로드", "player_acc_track_info_dialog": "트랙 정보", "player_music_album_versions_special": "스페셜 에디션", "player_track_versions_live": "라이브", "player_no_tracks_publish_single": "공개 예정 싱글입니다!", "player_share_album": "앨범 공유", "player_payment_got_it": "확인", "player_buy_song": "구매", "player_download": "다운로드", "player_get_single": "싱글 받기", "player_acc_mute": "음소거", "player_acc_album_cover": "앨범 커버", "player_get_track": "음원 받기", "player_music_album_versions_demo": "데모", "player_mobile_share_this_album": "앨범을 SNS로 공유하세요!", "player_sharing_text": "공유하고 싶은 멋진 음악!", "player_share_single": "싱글 공유", "player_acc_progressbar": "재생바" };

/***/ }),
/* 117 */
/* no static exports found */
/* all exports used */
/*!****************************!*\
  !*** ./l10n/texts_lt.json ***!
  \****************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = { "player_acc_track_played": "Track played: %s", "player_acc_tracklist_pause_track": "Pause selected track number %s: %s", "player_acc_album_description": "Album description", "player_play": "Play", "player_acc_share_on_facebook": "Share on Facebook", "player_acc_tracklist": "%s track list", "player_track_collaboration_with": "With", "player_music_album_versions_bonus": "Bonus Track", "player_show_all_tracks": "Show all tracks", "player_download_single": "Download Single", "player_get_album": "Get Album", "player_previous": "Previous", "player_track_collaboration_featuring": "Featuring", "app_description": "Make it easy for fans to listen, download and purchase your work and check your music's play and download stats.", "player_acc_progress_value": "%s of %s", "player_payment_preview_error": "Hey, you’re in Preview Mode.\nThis feature works on your live site once it’s published.", "player_track_collaboration_performed": "Performed By", "player_acc_track_duration": "Track duration: %s", "player_acc_pause": "Pause", "player_share_playlist": "Share Playlist", "player_acc_track_info": "Track info", "player_acc_prev": "Previous track", "player_acc_next": "Next track", "player_track_versions_dirty": "Dirty Version", "player_music_album_versions_empty": "—", "player_acc_buy_album": "Buy album for %s", "player_track_versions_acoustic": "Acoustic", "player_pause": "Pause", "player_acc_volume_value": "%s volume", "player_buy_single": "Buy Single", "player_acc_close": "Close", "player_no_tracks_artist_name": "Artist Name", "player_acc_share_single_dialog": "Share Single", "track_page_lyrics": "Lyrics", "player_mobile_share_this_song": "Share this Track:", "player_acc_unmute": "Unmute", "player_acc_share_on_twitter": "Share on Twitter", "player_track_versions_bonus": "Bonus Track", "player_track_versions_empty": "—", "player_acc_play_live": "Track is playing", "player_acc_play": "Play", "player_free": "Free", "player_track_collaboration_remixed": "Remixed By", "player_acc_share_album_dialog": "Share Album", "player_single": "Single", "player_acc_pause_live": "Track paused", "player_acc_share_on_tumblr": "Share on Tumblr", "player_tracks_total": "%s Total", "player_no_tracks": "Add your first track!", "player_music_album_versions_deluxe": "Deluxe Edition", "player_no_tracks_track_name": "Track Name", "player_shuffle": "Shuffle", "player_music_album_versions_remastered": "Remastered", "player_download_album": "Download Album", "player_music_album_versions_remixes": "Remixes", "player_track": "Track", "player_track_out_of": "Track %s (Out of %s)", "player_track_versions_demo": "Demo", "player_next": "Next", "player_acc_buy_track": "Buy track for %s", "app_title": "Wix Player", "player_acc_share_on_blogger": "Share on Blogger", "player_music_album_versions_acoustic": "Acoustic", "player_no_tracks_publish_playlist": "This playlist's coming soon!", "player_repeat": "Repeat", "player_mobile_view_less": "View Less", "player_acc_tracklist_play_track": "Play track number %s: %s", "player_acc_share": "Share", "player_track_versions_clean": "Clean Version", "player_no_tracks_publish": "This album's coming soon!", "player_share": "Share", "player_share_song": "Share Track", "player_track_versions_radio": "Radio Edit", "player_download_track": "Download Track", "player_mobile_view_more": "View More", "player_lyrics": "Track Info", "player_track_versions_edited": "Edited Version", "player_mobile_share": "Share", "player_acc_share_dialog": "Share", "player_music_album_versions_live": "Live", "player_acc_track_cover": "Track Cover", "player_buy_album": "Buy Album", "player_music_album_versions_clean": "Clean Version", "player_album": "Album", "player_payment_preview_mode": "Preview Mode", "player_acc_share_playlist_dialog": "Share Playlist", "player_track_versions_explicit": "Explicit Version", "player_free_song": "Free Download", "player_acc_track_info_dialog": "Track info", "player_music_album_versions_special": "Special Edition", "player_track_versions_live": "Live", "player_no_tracks_publish_single": "This single's coming soon!", "player_share_album": "Share Album", "player_payment_got_it": "Got it", "player_buy_song": "Buy Track", "player_download": "Download", "player_get_single": "Get Single", "player_acc_mute": "Mute", "player_acc_album_cover": "Album Cover", "player_get_track": "Get Track", "player_music_album_versions_demo": "Demo", "player_mobile_share_this_album": "Share this Album:", "player_sharing_text": "checkout this cool music", "player_share_single": "Share Single", "player_acc_progressbar": "Progress Bar" };

/***/ }),
/* 118 */
/* no static exports found */
/* all exports used */
/*!****************************!*\
  !*** ./l10n/texts_ms.json ***!
  \****************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = { "player_acc_track_played": "Runut yang dimainkan: %s", "player_acc_tracklist_pause_track": "Pause selected track number %s: %s", "player_acc_album_description": "Album description", "player_play": "Mainkan", "player_acc_share_on_facebook": "Kongsi di Facebook", "player_acc_tracklist": "senarai lagu %s", "player_track_collaboration_with": "With", "player_music_album_versions_bonus": "Lagu Bonus", "player_show_all_tracks": "Paparkan semua lagu", "player_download_single": "Muat turun Single", "player_get_album": "Dapatkan Album", "player_previous": "Sebelum", "player_track_collaboration_featuring": "Featuring", "app_description": "Make it easy for fans to listen, download and purchase your work and check your music's play and download stats.", "player_acc_progress_value": "%s daripada %s", "player_payment_preview_error": "Hey, you’re in Preview Mode.\nThis feature works on your live site once it’s published.", "player_track_collaboration_performed": "Performed By", "player_acc_track_duration": "Tempoh masa lagu: %s", "player_acc_pause": "Jedakan", "player_share_playlist": "Kongsikan Senarai main", "player_acc_track_info": "Maklumat Lagu", "player_acc_prev": "Lagu sebelumnya", "player_acc_next": "Lagu seterusnya", "player_track_versions_dirty": "Versi Kotor", "player_music_album_versions_empty": "—", "player_acc_buy_album": "Beli album untuk %s", "player_track_versions_acoustic": "Akustik", "player_pause": "Jedakan", "player_acc_volume_value": "Jilid %s", "player_buy_single": "Beli Single", "player_acc_close": "Tutup", "player_no_tracks_artist_name": "Nama Artis", "player_acc_share_single_dialog": "Kongsikan Single", "track_page_lyrics": "Lyrics", "player_mobile_share_this_song": "Kongsikan Lagu ini:", "player_acc_unmute": "Unmute", "player_acc_share_on_twitter": "Kongsi di Twitter", "player_track_versions_bonus": "Lagu Bonus", "player_track_versions_empty": "—", "player_acc_play_live": "Track is playing", "player_acc_play": "Mainkan", "player_free": "Percuma", "player_track_collaboration_remixed": "Remixed By", "player_acc_share_album_dialog": "Kongsikan Album", "player_single": "Single", "player_acc_pause_live": "Track paused", "player_acc_share_on_tumblr": "Kongsikan di Tumblr", "player_tracks_total": "Jumlah %s", "player_no_tracks": "Masukkan lagu pertama anda!", "player_music_album_versions_deluxe": "Deluxe Edition", "player_no_tracks_track_name": "Nama Trek", "player_shuffle": "Rombakan", "player_music_album_versions_remastered": "Remastered", "player_download_album": "Download Album", "player_music_album_versions_remixes": "Remixes", "player_track": "Track", "player_track_out_of": "Lagu %s (Daripada %s)", "player_track_versions_demo": "Demo", "player_next": "Seterusnya", "player_acc_buy_track": "Beli lagu untuk %s", "app_title": "Wix Player", "player_acc_share_on_blogger": "Berkongsi di Blogger", "player_music_album_versions_acoustic": "Acoustic", "player_no_tracks_publish_playlist": "Senarai main ini akan datang tidak lama lagi!", "player_repeat": "Ulangkan", "player_mobile_view_less": "Kurangkan Maklumat", "player_acc_tracklist_play_track": "Play track number %s: %s", "player_acc_share": "Kongsikan", "player_track_versions_clean": "Versi Bersih", "player_no_tracks_publish": "Album ini akan datang tidak lama lagi!", "player_share": "Share", "player_share_song": "Share Track", "player_track_versions_radio": "Pengubahsuaian untuk Radio", "player_download_track": "Download Track", "player_mobile_view_more": "Maklumat Lanjut", "player_lyrics": "Track Info", "player_track_versions_edited": "Versi Diubahsuai", "player_mobile_share": "Share", "player_acc_share_dialog": "Kongsikan", "player_music_album_versions_live": "Siaran Langsung", "player_acc_track_cover": "Cover Lagu", "player_buy_album": "Buy Album", "player_music_album_versions_clean": "Clean Version", "player_album": "Album", "player_payment_preview_mode": "Preview Mode", "player_acc_share_playlist_dialog": "Kongsikan Senarai main", "player_track_versions_explicit": "Versi Jelas", "player_free_song": "Free Download", "player_acc_track_info_dialog": "Maklumat Lagu", "player_music_album_versions_special": "Special Edition", "player_track_versions_live": "Live", "player_no_tracks_publish_single": "Single ini akan datang tidak lama lagi!", "player_share_album": "Kongsikan Album", "player_payment_got_it": "Faham", "player_buy_song": "Buy Track", "player_download": "Download", "player_get_single": "Dapatkan Single", "player_acc_mute": "Senyapkan", "player_acc_album_cover": "Kulit Album", "player_get_track": "Dapatkan Trek", "player_music_album_versions_demo": "Demo", "player_mobile_share_this_album": "Kongsikan Album ini:", "player_sharing_text": "semak lagu yang menarik ini", "player_share_single": "Kongsikan Single", "player_acc_progressbar": "Bar Kemajuan" };

/***/ }),
/* 119 */
/* no static exports found */
/* all exports used */
/*!****************************!*\
  !*** ./l10n/texts_nl.json ***!
  \****************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = { "player_acc_track_played": "Afgespeeld nummer: %s", "player_acc_tracklist_pause_track": "Pause selected track number %s: %s", "player_acc_album_description": "Beschrijving album", "player_play": "Afspelen", "player_acc_share_on_facebook": "Delen op Facebook", "player_acc_tracklist": "%s nummerlijst", "player_track_collaboration_with": "met", "player_music_album_versions_bonus": "Bonusnummer", "player_show_all_tracks": "Alle nummers weergeven", "player_download_single": "Single downloaden", "player_get_album": "Album downloaden", "player_previous": "Vorige", "player_track_collaboration_featuring": "featuring", "app_description": "Maak het makkelijk voor uw fans om uw muziek te beluisteren, te downloaden en aan te kopen, en bekijk statistieken over het afspelen en downloaden.", "player_acc_progress_value": "%s van %s", "player_payment_preview_error": "U gebruikt de voorbeeldmodus.\nDeze functie werkt pas zodra uw website is gepubliceerd.", "player_track_collaboration_performed": "uitgevoerd door", "player_acc_track_duration": "Duurtijd nummer: %s", "player_acc_pause": "Pauze", "player_share_playlist": "Afspeellijst delen", "player_acc_track_info": "Details nummer", "player_acc_prev": "Vorig nummer", "player_acc_next": "Volgend nummer", "player_track_versions_dirty": "Dirty Version", "player_music_album_versions_empty": "—", "player_acc_buy_album": "Album kopen voor %s", "player_track_versions_acoustic": "Akoestisch", "player_pause": "Pauze", "player_acc_volume_value": "%s volume", "player_buy_single": "Single kopen", "player_acc_close": "Sluiten", "player_no_tracks_artist_name": "Naam artiest", "player_acc_share_single_dialog": "Single delen", "track_page_lyrics": "Songtekst", "player_mobile_share_this_song": "Dit nummer delen:", "player_acc_unmute": "Unmute", "player_acc_share_on_twitter": "Delen op Twitter", "player_track_versions_bonus": "Bonusnummer", "player_track_versions_empty": "—", "player_acc_play_live": "Track is playing", "player_acc_play": "Afspelen", "player_free": "Gratis", "player_track_collaboration_remixed": "Remix door", "player_acc_share_album_dialog": "Album delen", "player_single": "Single", "player_acc_pause_live": "Track paused", "player_acc_share_on_tumblr": "Delen op Tumblr", "player_tracks_total": "%s totaal", "player_no_tracks": "Voeg uw eerste nummer toe!", "player_music_album_versions_deluxe": "Deluxe-editie", "player_no_tracks_track_name": "Naam nummer", "player_shuffle": "Willekeurige volgorde", "player_music_album_versions_remastered": "Remastered", "player_download_album": "Album downloaden", "player_music_album_versions_remixes": "Remixes", "player_track": "nummer", "player_track_out_of": "Nummer %s (van %s)", "player_track_versions_demo": "Demo", "player_next": "Volgende", "player_acc_buy_track": "Nummer kopen voor %s", "app_title": "Wix Music", "player_acc_share_on_blogger": "Delen op Blogger", "player_music_album_versions_acoustic": "Akoestisch", "player_no_tracks_publish_playlist": "Deze afspeellijst komt er binnenkort aan!", "player_repeat": "Herhalen", "player_mobile_view_less": "Minder bekijken", "player_acc_tracklist_play_track": "Play track number %s: %s", "player_acc_share": "Delen", "player_track_versions_clean": "Clean Version", "player_no_tracks_publish": "Dit album komt er binnenkort aan!", "player_share": "Delen", "player_share_song": "Nummer delen", "player_track_versions_radio": "Radio Edit", "player_download_track": "Nummer downloaden", "player_mobile_view_more": "Meer weergeven", "player_lyrics": "Details nummer", "player_track_versions_edited": "Edited Version", "player_mobile_share": "Delen", "player_acc_share_dialog": "Delen", "player_music_album_versions_live": "Live", "player_acc_track_cover": "Afbeelding nummer", "player_buy_album": "Album kopen", "player_music_album_versions_clean": "Clean Version", "player_album": "album", "player_payment_preview_mode": "Voorbeeldmodus", "player_acc_share_playlist_dialog": "Afspeellijst delen", "player_track_versions_explicit": "Explicit Version", "player_free_song": "Gratis download", "player_acc_track_info_dialog": "Details nummer", "player_music_album_versions_special": "Speciale editie", "player_track_versions_live": "Live", "player_no_tracks_publish_single": "Deze single komt er binnenkort aan!", "player_share_album": "Album delen", "player_payment_got_it": "Begrepen", "player_buy_song": "Nummer kopen", "player_download": "Downloaden", "player_get_single": "Single downloaden", "player_acc_mute": "Dempen", "player_acc_album_cover": "Albumomslag", "player_get_track": "Nummer downloaden", "player_music_album_versions_demo": "Demo", "player_mobile_share_this_album": "Dit album delen:", "player_sharing_text": "luister even naar deze coole muziek", "player_share_single": "Single delen", "player_acc_progressbar": "Voortgangsbalk" };

/***/ }),
/* 120 */
/* no static exports found */
/* all exports used */
/*!****************************!*\
  !*** ./l10n/texts_no.json ***!
  \****************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = { "player_acc_track_played": "Spor spilt: %s", "player_acc_tracklist_pause_track": "Pause selected track number %s: %s", "player_acc_album_description": "Albumbeskrivelse", "player_play": "Spill av", "player_acc_share_on_facebook": "Del på Facebook", "player_acc_tracklist": "%s sporliste", "player_track_collaboration_with": "Med", "player_music_album_versions_bonus": "Bonus Track", "player_show_all_tracks": "Vis alle spor", "player_download_single": "Last ned singel", "player_get_album": "Hent album", "player_previous": "Forrige", "player_track_collaboration_featuring": "med", "app_description": "Gjør det enkelt for fansen å lytte til, laste ned og kjøpe verkene dine, og sjekk avspillings- og nedlastingsstatistikk for musikken din.", "player_acc_progress_value": "%s av %s", "player_payment_preview_error": "Heisann, du er på forhåndsvisningsmodus.\nDenne funksjonen fungerer på din aktive nettside så fort den er publisert.", "player_track_collaboration_performed": "Fremført av", "player_acc_track_duration": "Sporvarighet: %s", "player_acc_pause": "Pause", "player_share_playlist": "Del spilleliste", "player_acc_track_info": "Sporinfo", "player_acc_prev": "Forrige spor", "player_acc_next": "Neste spor", "player_track_versions_dirty": "Dirty Version", "player_music_album_versions_empty": "—", "player_acc_buy_album": "Kjøp album for %s", "player_track_versions_acoustic": "Acoustic", "player_pause": "Pause", "player_acc_volume_value": "%s volum", "player_buy_single": "Kjøp singel", "player_acc_close": "Lukk", "player_no_tracks_artist_name": "Artistnavn", "player_acc_share_single_dialog": "Del singel", "track_page_lyrics": "Tekst", "player_mobile_share_this_song": "Del dette sporet:", "player_acc_unmute": "Unmute", "player_acc_share_on_twitter": "Del på Twitter", "player_track_versions_bonus": "Bonus Track", "player_track_versions_empty": "—", "player_acc_play_live": "Track is playing", "player_acc_play": "Spill av", "player_free": "Gratis", "player_track_collaboration_remixed": "remixet av", "player_acc_share_album_dialog": "Del album", "player_single": "Singel", "player_acc_pause_live": "Track paused", "player_acc_share_on_tumblr": "Del på Tumblr", "player_tracks_total": "%s total", "player_no_tracks": "Legg til det første sporet!", "player_music_album_versions_deluxe": "Deluxe Edition", "player_no_tracks_track_name": "Navn på spor", "player_shuffle": "Tilfeldig rekkefølge", "player_music_album_versions_remastered": "Remastered", "player_download_album": "Last ned album", "player_music_album_versions_remixes": "Remix", "player_track": "Spor", "player_track_out_of": "Spor %s (av %s)", "player_track_versions_demo": "Demonstrasjon", "player_next": "Neste", "player_acc_buy_track": "Kjøp spor for %s", "app_title": "Wix Player", "player_acc_share_on_blogger": "Del på Blogger", "player_music_album_versions_acoustic": "Acoustic", "player_no_tracks_publish_playlist": "Denne spillelisten kommer snart!", "player_repeat": "Gjenta", "player_mobile_view_less": "Vis mindre", "player_acc_tracklist_play_track": "Play track number %s: %s", "player_acc_share": "Del", "player_track_versions_clean": "Clean Version", "player_no_tracks_publish": "Dette albumet kommer snart!", "player_share": "Del", "player_share_song": "Del spor", "player_track_versions_radio": "Radio Edit", "player_download_track": "Last ned spor", "player_mobile_view_more": "Vis mer", "player_lyrics": "Sporinfo", "player_track_versions_edited": "Edited Version", "player_mobile_share": "Del", "player_acc_share_dialog": "Del", "player_music_album_versions_live": "Live", "player_acc_track_cover": "Sporets cover", "player_buy_album": "Kjøp album", "player_music_album_versions_clean": "Clean Version", "player_album": "Album", "player_payment_preview_mode": "Forhåndsvisningsmodus", "player_acc_share_playlist_dialog": "Del spilleliste", "player_track_versions_explicit": "Explicit Version", "player_free_song": "Gratis nedlasting", "player_acc_track_info_dialog": "Sporinfo", "player_music_album_versions_special": "Special Edition", "player_track_versions_live": "Live", "player_no_tracks_publish_single": "Denne singelen kommer snart!", "player_share_album": "Del album", "player_payment_got_it": "Ok", "player_buy_song": "Kjøp spor", "player_download": "Last ned", "player_get_single": "Hent singel", "player_acc_mute": "Mute", "player_acc_album_cover": "Albumcover", "player_get_track": "Hent spor", "player_music_album_versions_demo": "Demonstrasjon", "player_mobile_share_this_album": "Del dette albumet:", "player_sharing_text": "sjekk denne fete musikken", "player_share_single": "Del singel", "player_acc_progressbar": "Fremdriftslinje" };

/***/ }),
/* 121 */
/* no static exports found */
/* all exports used */
/*!****************************!*\
  !*** ./l10n/texts_pl.json ***!
  \****************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = { "player_acc_track_played": "Odtwarzany utwór: %s", "player_acc_tracklist_pause_track": "Pause selected track number %s: %s", "player_acc_album_description": "Opis albumu", "player_play": "Odtwarzaj", "player_acc_share_on_facebook": "Udostępnij na Facebooku", "player_acc_tracklist": "lista utworów %s", "player_track_collaboration_with": "z", "player_music_album_versions_bonus": "Bonus Track", "player_show_all_tracks": "Pokaż wszystkie utwory", "player_download_single": "Pobierz Singiel", "player_get_album": "Pobierz Album", "player_previous": "Poprzedni", "player_track_collaboration_featuring": "Z udziałem:", "app_description": "Ułatw fanom odsłuch, pobieranie i zakup swoich utworów i sprawdzaj statystyki odtworzeń i pobrań utworów.", "player_acc_progress_value": "%s z %s", "player_payment_preview_error": "Hej, to tylko podgląd.\nTa funkcja zadziała na Twojej witrynie, gdy ją opublikujesz.", "player_track_collaboration_performed": "Wykonany przez", "player_acc_track_duration": "Czas odtwarzania: %s", "player_acc_pause": "Pauza", "player_share_playlist": "Udostępnij Playlistę", "player_acc_track_info": "Informacja o utworze", "player_acc_prev": "Poprzedni utwór", "player_acc_next": "Następny utwór", "player_track_versions_dirty": "Wersja \"dirty\"", "player_music_album_versions_empty": "—", "player_acc_buy_album": "Kup album za %s", "player_track_versions_acoustic": "Akustyczne", "player_pause": "Pauza", "player_acc_volume_value": "%s głośności", "player_buy_single": "Kup Singiel", "player_acc_close": "Zamknij", "player_no_tracks_artist_name": "Wykonawca", "player_acc_share_single_dialog": "Udostępnij singiel", "track_page_lyrics": "Tekst", "player_mobile_share_this_song": "Udostępnij ten utwór:", "player_acc_unmute": "Unmute", "player_acc_share_on_twitter": "Udostępnij na Twitterze", "player_track_versions_bonus": "Bonus Track", "player_track_versions_empty": "—", "player_acc_play_live": "Track is playing", "player_acc_play": "Odtwarzaj", "player_free": "Darmowy", "player_track_collaboration_remixed": "Miksowane przez", "player_acc_share_album_dialog": "Udostępnij album", "player_single": "Singiel", "player_acc_pause_live": "Track paused", "player_acc_share_on_tumblr": "Udostępnij na Tumblr", "player_tracks_total": "Razem %s", "player_no_tracks": "Dodaj swój pierwszy utwór!", "player_music_album_versions_deluxe": "Wydanie Deluxe", "player_no_tracks_track_name": "Nazwij Utwór", "player_shuffle": "Pomieszaj", "player_music_album_versions_remastered": "Wersja po remasteringu", "player_download_album": "Pobierz album", "player_music_album_versions_remixes": "Remixy", "player_track": "Utwór", "player_track_out_of": "Utwór %s (spośród %s)", "player_track_versions_demo": "Demo", "player_next": "Dalej", "player_acc_buy_track": "Kup utwór za %s", "app_title": "Wix Music", "player_acc_share_on_blogger": "Udostępnij na Bloggerze", "player_music_album_versions_acoustic": "Akustyczne", "player_no_tracks_publish_playlist": "Ta playlista pojawi się wkrótce!", "player_repeat": "Powtórz", "player_mobile_view_less": "Zobacz mniej", "player_acc_tracklist_play_track": "Play track number %s: %s", "player_acc_share": "Udostępnij", "player_track_versions_clean": "Wersja \"clean\"", "player_no_tracks_publish": "Ten album wkrótce będzie dostępny!", "player_share": "Udostępnij", "player_share_song": "Udostępnij utwór", "player_track_versions_radio": "Radio Edit (wersja radiowa)", "player_download_track": "Pobierz utwór", "player_mobile_view_more": "Zobacz więcej", "player_lyrics": "Informacja o utworze", "player_track_versions_edited": "Wersja edytowana", "player_mobile_share": "Udostępnij", "player_acc_share_dialog": "Udostępnij", "player_music_album_versions_live": "Live", "player_acc_track_cover": "Okładka utworu", "player_buy_album": "Kup Album", "player_music_album_versions_clean": "Wersja \"clean\"", "player_album": "Album", "player_payment_preview_mode": "Tryb Podglądu", "player_acc_share_playlist_dialog": "Udostępnij playlistę", "player_track_versions_explicit": "Wersja zawierająca treści niecenzuralne", "player_free_song": "Darmowe pobieranie", "player_acc_track_info_dialog": "Informacja o utworze", "player_music_album_versions_special": "Wydanie specjalne", "player_track_versions_live": "Live", "player_no_tracks_publish_single": "Ten singiel pojawi się wkrótce!", "player_share_album": "Udostępnij Album", "player_payment_got_it": "Rozumiem", "player_buy_song": "Kup utwór", "player_download": "Pobierz", "player_get_single": "Pobierz Singiel", "player_acc_mute": "Wycisz", "player_acc_album_cover": "Okładka albumu", "player_get_track": "Pobierz Utwór", "player_music_album_versions_demo": "Demo", "player_mobile_share_this_album": "Udostępnij ten album:", "player_sharing_text": "posłuchaj tej odjazdowej muzyki", "player_share_single": "Udostępnij Singiel", "player_acc_progressbar": "Pasek postępu" };

/***/ }),
/* 122 */
/* no static exports found */
/* all exports used */
/*!****************************!*\
  !*** ./l10n/texts_pt.json ***!
  \****************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = { "player_acc_track_played": "Faixa reproduzida: %s", "player_acc_tracklist_pause_track": "Pause selected track number %s: %s", "player_acc_album_description": "Descrição do álbum", "player_play": "Reproduzir", "player_acc_share_on_facebook": "Compartilhar no Facebook", "player_acc_tracklist": "%s lista de faixas de música", "player_track_collaboration_with": "com", "player_music_album_versions_bonus": "Faixa bônus", "player_show_all_tracks": "Mostrar todas as faixas", "player_download_single": "Fazer download do single", "player_get_album": "Obtenha o álbum", "player_previous": "Anterior", "player_track_collaboration_featuring": "Participação de", "app_description": "Seus fãs podem ouvir, fazer download e comprar seu trabalho facilmente. Além de monitorar as estatísticas de reproduções e downloads.", "player_acc_progress_value": "%s de %s", "player_payment_preview_error": "Você está no modo de pré-visualização.\nEste recurso funciona no seu site online uma vez que for publicado.", "player_track_collaboration_performed": "Por", "player_acc_track_duration": "Duração da faixa: %s", "player_acc_pause": "Pausar", "player_share_playlist": "Compartilhar playlist", "player_acc_track_info": "Informações da faixa", "player_acc_prev": "Faixa anterior", "player_acc_next": "Próxima faixa", "player_track_versions_dirty": "Versão suja", "player_music_album_versions_empty": "—", "player_acc_buy_album": "Comprar álbum por %s", "player_track_versions_acoustic": "Acústico", "player_pause": "Pausar", "player_acc_volume_value": "%s volume", "player_buy_single": "Comprar single", "player_acc_close": "Fechar", "player_no_tracks_artist_name": "Nome do artista", "player_acc_share_single_dialog": "Compartilhar single", "track_page_lyrics": "Letra da Música", "player_mobile_share_this_song": "Compartilhar esta faixa:", "player_acc_unmute": "Unmute", "player_acc_share_on_twitter": "Compartilhar no Twitter", "player_track_versions_bonus": "Faixa bônus", "player_track_versions_empty": "—", "player_acc_play_live": "Track is playing", "player_acc_play": "Reproduzir", "player_free": "Grátis", "player_track_collaboration_remixed": "Remixado por", "player_acc_share_album_dialog": "Compartilhar álbum", "player_single": "Single", "player_acc_pause_live": "Track paused", "player_acc_share_on_tumblr": "Compartilhar no Tumblr", "player_tracks_total": "Total de %s", "player_no_tracks": "Adicione sua primeira faixa de música!", "player_music_album_versions_deluxe": "Edição deluxe", "player_no_tracks_track_name": "Nome da faixa", "player_shuffle": "Reprodução Aleatória", "player_music_album_versions_remastered": "Remasterizado", "player_download_album": "Fazer download do álbum", "player_music_album_versions_remixes": "Remixado", "player_track": "Faixa", "player_track_out_of": "Faixa %s (De %s)", "player_track_versions_demo": "Demo", "player_next": "Próximo", "player_acc_buy_track": "Comprar faixa por %s", "app_title": "Wix Music", "player_acc_share_on_blogger": "Compartilhar no Blogger", "player_music_album_versions_acoustic": "Acústico", "player_no_tracks_publish_playlist": "Esta playlist estará disponível em breve!", "player_repeat": "Repetir", "player_mobile_view_less": "Ver menos", "player_acc_tracklist_play_track": "Play track number %s: %s", "player_acc_share": "Compartilhar", "player_track_versions_clean": "Versão limpa", "player_no_tracks_publish": "Este álbum estará disponível em breve!", "player_share": "Compartilhar", "player_share_song": "Compartilhar faixa", "player_track_versions_radio": "Edição para rádio", "player_download_track": "Fazer download da faixa", "player_mobile_view_more": "Ver mais", "player_lyrics": "Informações da faixa", "player_track_versions_edited": "Versão editada", "player_mobile_share": "Compartilhar", "player_acc_share_dialog": "Compartilhar", "player_music_album_versions_live": "Ao vivo", "player_acc_track_cover": "Capa da faixa de música", "player_buy_album": "Comprar álbum", "player_music_album_versions_clean": "Versão limpa", "player_album": "Álbum", "player_payment_preview_mode": "Modo de pré-visualização", "player_acc_share_playlist_dialog": "Compartilhar playlist", "player_track_versions_explicit": "Versão explicita", "player_free_song": "Download gratuito", "player_acc_track_info_dialog": "Informações da faixa", "player_music_album_versions_special": "Edição especial", "player_track_versions_live": "Ao vivo", "player_no_tracks_publish_single": "Este single estará disponível em breve!", "player_share_album": "Compartilhar álbum", "player_payment_got_it": "Entendi", "player_buy_song": "Comprar faixa", "player_download": "Fazer download", "player_get_single": "Obtenha o single", "player_acc_mute": "Mudo", "player_acc_album_cover": "Capa do álbum", "player_get_track": "Obtenha a faixa", "player_music_album_versions_demo": "Demo", "player_mobile_share_this_album": "Compartilhar este álbum:", "player_sharing_text": "Confira essa música!", "player_share_single": "Compartilhar single", "player_acc_progressbar": "Barra de progresso" };

/***/ }),
/* 123 */
/* no static exports found */
/* all exports used */
/*!****************************!*\
  !*** ./l10n/texts_ro.json ***!
  \****************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = { "player_acc_track_played": "Melodia redată: %s", "player_acc_tracklist_pause_track": "Pause selected track number %s: %s", "player_acc_album_description": "Album description", "player_play": "Redă", "player_acc_share_on_facebook": "Partajează pe Facebook", "player_acc_tracklist": "Lista de melodii a lui %s", "player_track_collaboration_with": "With", "player_music_album_versions_bonus": "Melodie bonus", "player_show_all_tracks": "Afișează toate melodiile", "player_download_single": "Descarcă melodia", "player_get_album": "Descarcă albumul", "player_previous": "Înapoi", "player_track_collaboration_featuring": "Featuring", "app_description": "Make it easy for fans to listen, download and purchase your work and check your music's play and download stats.", "player_acc_progress_value": "%s din %s", "player_payment_preview_error": "Hey, you’re in Preview Mode.\nThis feature works on your live site once it’s published.", "player_track_collaboration_performed": "Performed By", "player_acc_track_duration": "Durata melodiei: %s", "player_acc_pause": "Întrerupe", "player_share_playlist": "Partajează playlistul", "player_acc_track_info": "Informații privind melodia", "player_acc_prev": "Melodia anterioară", "player_acc_next": "Melodia următoare", "player_track_versions_dirty": "Versiune cu înjurături", "player_music_album_versions_empty": "—", "player_acc_buy_album": "Cumpără albumul pentru %s", "player_track_versions_acoustic": "Acustică", "player_pause": "Întrerupe", "player_acc_volume_value": "%s volum", "player_buy_single": "Cumpără single", "player_acc_close": "Închide", "player_no_tracks_artist_name": "Numele artistului", "player_acc_share_single_dialog": "Distribuie sigle", "track_page_lyrics": "Lyrics", "player_mobile_share_this_song": "Distribuie melodia:", "player_acc_unmute": "Unmute", "player_acc_share_on_twitter": "Partajează pe Twitter", "player_track_versions_bonus": "Melodie bonus", "player_track_versions_empty": "—", "player_acc_play_live": "Track is playing", "player_acc_play": "Redă", "player_free": "Gratuit", "player_track_collaboration_remixed": "Remixed By", "player_acc_share_album_dialog": "Distribuie albumul", "player_single": "Single", "player_acc_pause_live": "Track paused", "player_acc_share_on_tumblr": "Distribuie pe Tumblr", "player_tracks_total": "%s total", "player_no_tracks": "Adaugă prima ta melodie!", "player_music_album_versions_deluxe": "Deluxe Edition", "player_no_tracks_track_name": "Numele melodiei", "player_shuffle": "Shuffle", "player_music_album_versions_remastered": "Remastered", "player_download_album": "Download Album", "player_music_album_versions_remixes": "Remixes", "player_track": "Track", "player_track_out_of": "Melodia %s (din %s)", "player_track_versions_demo": "Demo", "player_next": "Înainte", "player_acc_buy_track": "Cumpără melodia pentru %s", "app_title": "Wix Player", "player_acc_share_on_blogger": "Distribuie pe Blogger", "player_music_album_versions_acoustic": "Acoustic", "player_no_tracks_publish_playlist": "Acest playlist va fi lansat în curând!", "player_repeat": "Repetă", "player_mobile_view_less": "Afișează mai puține", "player_acc_tracklist_play_track": "Play track number %s: %s", "player_acc_share": "Partajează", "player_track_versions_clean": "Versiune curată", "player_no_tracks_publish": "Acest album va fi lansat în curând!", "player_share": "Share", "player_share_song": "Share Track", "player_track_versions_radio": "Editată pentru radio", "player_download_track": "Download Track", "player_mobile_view_more": "Afișează mai multe", "player_lyrics": "Track Info", "player_track_versions_edited": "Versiune editată", "player_mobile_share": "Share", "player_acc_share_dialog": "Partajează", "player_music_album_versions_live": "Live", "player_acc_track_cover": "Coperta melodiei", "player_buy_album": "Buy Album", "player_music_album_versions_clean": "Clean Version", "player_album": "Album", "player_payment_preview_mode": "Preview Mode", "player_acc_share_playlist_dialog": "Distribuie playlistul", "player_track_versions_explicit": "Versiune explicită", "player_free_song": "Free Download", "player_acc_track_info_dialog": "Informații privind melodia", "player_music_album_versions_special": "Special Edition", "player_track_versions_live": "Live", "player_no_tracks_publish_single": "Acest single va fi lansat în curând!", "player_share_album": "Distribuie albumul", "player_payment_got_it": "Am înțeles", "player_buy_song": "Buy Track", "player_download": "Download", "player_get_single": "Descarcă single-ul", "player_acc_mute": "Fără sunet", "player_acc_album_cover": "Coperta albumului", "player_get_track": "Descarcă melodia", "player_music_album_versions_demo": "Demo", "player_mobile_share_this_album": "Distribuie albumul:", "player_sharing_text": "Uite ce muzică bună", "player_share_single": "Distribuie sigle", "player_acc_progressbar": "Bară de progres" };

/***/ }),
/* 124 */
/* no static exports found */
/* all exports used */
/*!****************************!*\
  !*** ./l10n/texts_ru.json ***!
  \****************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = { "player_acc_track_played": "Трек играл: %s", "player_acc_tracklist_pause_track": "Pause selected track number %s: %s", "player_acc_album_description": "Описание альбома", "player_play": "Играть", "player_acc_share_on_facebook": "Поделиться в Facebook", "player_acc_tracklist": "%s трек-лист", "player_track_collaboration_with": "с", "player_music_album_versions_bonus": "Бонус-трек", "player_show_all_tracks": "Показать все треки", "player_download_single": "Скачать сингл", "player_get_album": "Получить альбом", "player_previous": "Предыдущий", "player_track_collaboration_featuring": "при участии", "app_description": "Фанаты смогут легко слушать, скачивать и покупать вашу музыку, а вы — узнавать статистику воспроизведений и скачиваний.", "player_acc_progress_value": "%s из %s", "player_payment_preview_error": "Вы в режиме предпросмотра.\nФункция заработает на живом сайте после публикации.", "player_track_collaboration_performed": "в исполнении", "player_acc_track_duration": "Длительность трека: %s", "player_acc_pause": "Пауза", "player_share_playlist": "Поделиться", "player_acc_track_info": "О треке", "player_acc_prev": "Предыдущий", "player_acc_next": "Следующий", "player_track_versions_dirty": "Грязная версия", "player_music_album_versions_empty": "—", "player_acc_buy_album": "Купить альбом за %s", "player_track_versions_acoustic": "Акустика", "player_pause": "Пауза", "player_acc_volume_value": "Громкость: %s", "player_buy_single": "Купить сингл", "player_acc_close": "Закрыть", "player_no_tracks_artist_name": "Имя артиста", "player_acc_share_single_dialog": "Поделиться", "track_page_lyrics": "Слова", "player_mobile_share_this_song": "Поделиться треком:", "player_acc_unmute": "Unmute", "player_acc_share_on_twitter": "Поделиться в Twitter", "player_track_versions_bonus": "Бонус-трек", "player_track_versions_empty": "—", "player_acc_play_live": "Track is playing", "player_acc_play": "Играть", "player_free": "Бесплатно", "player_track_collaboration_remixed": "ремикс", "player_acc_share_album_dialog": "Поделиться альбомом", "player_single": "Сингл", "player_acc_pause_live": "Track paused", "player_acc_share_on_tumblr": "Поделиться в Tumblr", "player_tracks_total": "Всего %s", "player_no_tracks": "Добавьте свой первый трек", "player_music_album_versions_deluxe": "Делюкс-версия", "player_no_tracks_track_name": "Название трека", "player_shuffle": "Перемешать", "player_music_album_versions_remastered": "Ремастеред", "player_download_album": "Скачать альбом", "player_music_album_versions_remixes": "Ремиксы", "player_track": "Трек", "player_track_out_of": "Трек %s-й (из %s)", "player_track_versions_demo": "Демо", "player_next": "Дальше", "player_acc_buy_track": "Купить трек за %s", "app_title": "Wix-плеер", "player_acc_share_on_blogger": "Поделиться в Blogger", "player_music_album_versions_acoustic": "Акустика", "player_no_tracks_publish_playlist": "Плей-лист скоро появится", "player_repeat": "Повторять", "player_mobile_view_less": "Показать меньше", "player_acc_tracklist_play_track": "Play track number %s: %s", "player_acc_share": "Поделиться", "player_track_versions_clean": "Чистая версия", "player_no_tracks_publish": "Этот альбом скоро появится", "player_share": "Поделиться", "player_share_song": "Поделиться", "player_track_versions_radio": "Радиоверсия", "player_download_track": "Скачать трек", "player_mobile_view_more": "Показать больше", "player_lyrics": "О треке", "player_track_versions_edited": "Укороченная версия", "player_mobile_share": "Поделиться", "player_acc_share_dialog": "Поделиться", "player_music_album_versions_live": "Живая версия", "player_acc_track_cover": "Обложка трека", "player_buy_album": "Купить альбом", "player_music_album_versions_clean": "Чистая версия", "player_album": "Альбом", "player_payment_preview_mode": "Предпросмотр", "player_acc_share_playlist_dialog": "Поделиться", "player_track_versions_explicit": "Без цензуры", "player_free_song": "Бесплатное скачивание", "player_acc_track_info_dialog": "О треке", "player_music_album_versions_special": "Специальное издание", "player_track_versions_live": "Живая версия", "player_no_tracks_publish_single": "Сингл скоро появится", "player_share_album": "Поделиться альбомом", "player_payment_got_it": "ОК", "player_buy_song": "Купить трек", "player_download": "Скачать", "player_get_single": "Получить сингл", "player_acc_mute": "Без звука", "player_acc_album_cover": "Обложка альбома", "player_get_track": "Получить трек", "player_music_album_versions_demo": "Демо", "player_mobile_share_this_album": "Поделитесь этим альбомом:", "player_sharing_text": "отличная музыка, послушай", "player_share_single": "Поделиться", "player_acc_progressbar": "Полоса воспроизведения" };

/***/ }),
/* 125 */
/* no static exports found */
/* all exports used */
/*!****************************!*\
  !*** ./l10n/texts_sk.json ***!
  \****************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = { "player_acc_track_played": "Track played: %s", "player_acc_tracklist_pause_track": "Pause selected track number %s: %s", "player_acc_album_description": "Album description", "player_play": "Play", "player_acc_share_on_facebook": "Share on Facebook", "player_acc_tracklist": "%s track list", "player_track_collaboration_with": "With", "player_music_album_versions_bonus": "Bonus Track", "player_show_all_tracks": "Show all tracks", "player_download_single": "Download Single", "player_get_album": "Get Album", "player_previous": "Previous", "player_track_collaboration_featuring": "Featuring", "app_description": "Make it easy for fans to listen, download and purchase your work and check your music's play and download stats.", "player_acc_progress_value": "%s of %s", "player_payment_preview_error": "Hey, you’re in Preview Mode.\nThis feature works on your live site once it’s published.", "player_track_collaboration_performed": "Performed By", "player_acc_track_duration": "Track duration: %s", "player_acc_pause": "Pause", "player_share_playlist": "Share Playlist", "player_acc_track_info": "Track info", "player_acc_prev": "Previous track", "player_acc_next": "Next track", "player_track_versions_dirty": "Dirty Version", "player_music_album_versions_empty": "—", "player_acc_buy_album": "Buy album for %s", "player_track_versions_acoustic": "Acoustic", "player_pause": "Pause", "player_acc_volume_value": "%s volume", "player_buy_single": "Buy Single", "player_acc_close": "Close", "player_no_tracks_artist_name": "Artist Name", "player_acc_share_single_dialog": "Share Single", "track_page_lyrics": "Lyrics", "player_mobile_share_this_song": "Share this Track:", "player_acc_unmute": "Unmute", "player_acc_share_on_twitter": "Share on Twitter", "player_track_versions_bonus": "Bonus Track", "player_track_versions_empty": "—", "player_acc_play_live": "Track is playing", "player_acc_play": "Play", "player_free": "Free", "player_track_collaboration_remixed": "Remixed By", "player_acc_share_album_dialog": "Share Album", "player_single": "Single", "player_acc_pause_live": "Track paused", "player_acc_share_on_tumblr": "Share on Tumblr", "player_tracks_total": "%s Total", "player_no_tracks": "Add your first track!", "player_music_album_versions_deluxe": "Deluxe Edition", "player_no_tracks_track_name": "Track Name", "player_shuffle": "Shuffle", "player_music_album_versions_remastered": "Remastered", "player_download_album": "Download Album", "player_music_album_versions_remixes": "Remixes", "player_track": "Track", "player_track_out_of": "Track %s (Out of %s)", "player_track_versions_demo": "Demo", "player_next": "Next", "player_acc_buy_track": "Buy track for %s", "app_title": "Wix Player", "player_acc_share_on_blogger": "Share on Blogger", "player_music_album_versions_acoustic": "Acoustic", "player_no_tracks_publish_playlist": "This playlist's coming soon!", "player_repeat": "Repeat", "player_mobile_view_less": "View Less", "player_acc_tracklist_play_track": "Play track number %s: %s", "player_acc_share": "Share", "player_track_versions_clean": "Clean Version", "player_no_tracks_publish": "This album's coming soon!", "player_share": "Share", "player_share_song": "Share Track", "player_track_versions_radio": "Radio Edit", "player_download_track": "Download Track", "player_mobile_view_more": "View More", "player_lyrics": "Track Info", "player_track_versions_edited": "Edited Version", "player_mobile_share": "Share", "player_acc_share_dialog": "Share", "player_music_album_versions_live": "Live", "player_acc_track_cover": "Track Cover", "player_buy_album": "Buy Album", "player_music_album_versions_clean": "Clean Version", "player_album": "Album", "player_payment_preview_mode": "Preview Mode", "player_acc_share_playlist_dialog": "Share Playlist", "player_track_versions_explicit": "Explicit Version", "player_free_song": "Free Download", "player_acc_track_info_dialog": "Track info", "player_music_album_versions_special": "Special Edition", "player_track_versions_live": "Live", "player_no_tracks_publish_single": "This single's coming soon!", "player_share_album": "Share Album", "player_payment_got_it": "Got it", "player_buy_song": "Buy Track", "player_download": "Download", "player_get_single": "Get Single", "player_acc_mute": "Mute", "player_acc_album_cover": "Album Cover", "player_get_track": "Get Track", "player_music_album_versions_demo": "Demo", "player_mobile_share_this_album": "Share this Album:", "player_sharing_text": "checkout this cool music", "player_share_single": "Share Single", "player_acc_progressbar": "Progress Bar" };

/***/ }),
/* 126 */
/* no static exports found */
/* all exports used */
/*!****************************!*\
  !*** ./l10n/texts_sl.json ***!
  \****************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = { "player_acc_track_played": "Track played: %s", "player_acc_tracklist_pause_track": "Pause selected track number %s: %s", "player_acc_album_description": "Album description", "player_play": "Play", "player_acc_share_on_facebook": "Share on Facebook", "player_acc_tracklist": "%s track list", "player_track_collaboration_with": "With", "player_music_album_versions_bonus": "Bonus Track", "player_show_all_tracks": "Show all tracks", "player_download_single": "Download Single", "player_get_album": "Get Album", "player_previous": "Previous", "player_track_collaboration_featuring": "Featuring", "app_description": "Make it easy for fans to listen, download and purchase your work and check your music's play and download stats.", "player_acc_progress_value": "%s of %s", "player_payment_preview_error": "Hey, you’re in Preview Mode.\nThis feature works on your live site once it’s published.", "player_track_collaboration_performed": "Performed By", "player_acc_track_duration": "Track duration: %s", "player_acc_pause": "Pause", "player_share_playlist": "Share Playlist", "player_acc_track_info": "Track info", "player_acc_prev": "Previous track", "player_acc_next": "Next track", "player_track_versions_dirty": "Dirty Version", "player_music_album_versions_empty": "—", "player_acc_buy_album": "Buy album for %s", "player_track_versions_acoustic": "Acoustic", "player_pause": "Pause", "player_acc_volume_value": "%s volume", "player_buy_single": "Buy Single", "player_acc_close": "Close", "player_no_tracks_artist_name": "Artist Name", "player_acc_share_single_dialog": "Share Single", "track_page_lyrics": "Lyrics", "player_mobile_share_this_song": "Share this Track:", "player_acc_unmute": "Unmute", "player_acc_share_on_twitter": "Share on Twitter", "player_track_versions_bonus": "Bonus Track", "player_track_versions_empty": "—", "player_acc_play_live": "Track is playing", "player_acc_play": "Play", "player_free": "Free", "player_track_collaboration_remixed": "Remixed By", "player_acc_share_album_dialog": "Share Album", "player_single": "Single", "player_acc_pause_live": "Track paused", "player_acc_share_on_tumblr": "Share on Tumblr", "player_tracks_total": "%s Total", "player_no_tracks": "Add your first track!", "player_music_album_versions_deluxe": "Deluxe Edition", "player_no_tracks_track_name": "Track Name", "player_shuffle": "Shuffle", "player_music_album_versions_remastered": "Remastered", "player_download_album": "Download Album", "player_music_album_versions_remixes": "Remixes", "player_track": "Track", "player_track_out_of": "Track %s (Out of %s)", "player_track_versions_demo": "Demo", "player_next": "Next", "player_acc_buy_track": "Buy track for %s", "app_title": "Wix Player", "player_acc_share_on_blogger": "Share on Blogger", "player_music_album_versions_acoustic": "Acoustic", "player_no_tracks_publish_playlist": "This playlist's coming soon!", "player_repeat": "Repeat", "player_mobile_view_less": "View Less", "player_acc_tracklist_play_track": "Play track number %s: %s", "player_acc_share": "Share", "player_track_versions_clean": "Clean Version", "player_no_tracks_publish": "This album's coming soon!", "player_share": "Share", "player_share_song": "Share Track", "player_track_versions_radio": "Radio Edit", "player_download_track": "Download Track", "player_mobile_view_more": "View More", "player_lyrics": "Track Info", "player_track_versions_edited": "Edited Version", "player_mobile_share": "Share", "player_acc_share_dialog": "Share", "player_music_album_versions_live": "Live", "player_acc_track_cover": "Track Cover", "player_buy_album": "Buy Album", "player_music_album_versions_clean": "Clean Version", "player_album": "Album", "player_payment_preview_mode": "Preview Mode", "player_acc_share_playlist_dialog": "Share Playlist", "player_track_versions_explicit": "Explicit Version", "player_free_song": "Free Download", "player_acc_track_info_dialog": "Track info", "player_music_album_versions_special": "Special Edition", "player_track_versions_live": "Live", "player_no_tracks_publish_single": "This single's coming soon!", "player_share_album": "Share Album", "player_payment_got_it": "Got it", "player_buy_song": "Buy Track", "player_download": "Download", "player_get_single": "Get Single", "player_acc_mute": "Mute", "player_acc_album_cover": "Album Cover", "player_get_track": "Get Track", "player_music_album_versions_demo": "Demo", "player_mobile_share_this_album": "Share this Album:", "player_sharing_text": "checkout this cool music", "player_share_single": "Share Single", "player_acc_progressbar": "Progress Bar" };

/***/ }),
/* 127 */
/* no static exports found */
/* all exports used */
/*!****************************!*\
  !*** ./l10n/texts_sv.json ***!
  \****************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = { "player_acc_track_played": "Spår spelade: %s", "player_acc_tracklist_pause_track": "Pause selected track number %s: %s", "player_acc_album_description": "Albumbeskrivning", "player_play": "Spela upp", "player_acc_share_on_facebook": "Dela på Facebook", "player_acc_tracklist": "%s spårlista", "player_track_collaboration_with": "med", "player_music_album_versions_bonus": "Bonusspår", "player_show_all_tracks": "Visa alla spår", "player_download_single": "Ladda ner singel", "player_get_album": "Skaffa albumet", "player_previous": "Föregående", "player_track_collaboration_featuring": "Medverkande", "app_description": "Gör det lätt för fans att lyssna på, ladda ner och köpa dina verk, samt se statistik över uppspelningar och nedladdningar av din musik.", "player_acc_progress_value": "%s av %s", "player_payment_preview_error": "Hallå där, du är i förhandsgranskningläge.\nDenna funktion fungerar på livesidan när den har publicerats.", "player_track_collaboration_performed": "Utförd av", "player_acc_track_duration": "Spår varaktighet: %s", "player_acc_pause": "Pausa", "player_share_playlist": "Dela spellista", "player_acc_track_info": "Spårinfo", "player_acc_prev": "Föregående spår", "player_acc_next": "Nästa spår", "player_track_versions_dirty": "Rå version", "player_music_album_versions_empty": "—", "player_acc_buy_album": "Köp album %s", "player_track_versions_acoustic": "Akustisk", "player_pause": "Pausa", "player_acc_volume_value": "%s volym", "player_buy_single": "Köp singel", "player_acc_close": "Stäng", "player_no_tracks_artist_name": "Artistens namn", "player_acc_share_single_dialog": "Dela singel", "track_page_lyrics": "Sångtexter", "player_mobile_share_this_song": "Dela detta spår:", "player_acc_unmute": "Unmute", "player_acc_share_on_twitter": "Dela på Twitter", "player_track_versions_bonus": "Bonusspår", "player_track_versions_empty": "—", "player_acc_play_live": "Track is playing", "player_acc_play": "Spela upp", "player_free": "Gratis", "player_track_collaboration_remixed": "Remix av", "player_acc_share_album_dialog": "Dela album", "player_single": "Singel", "player_acc_pause_live": "Track paused", "player_acc_share_on_tumblr": "Dela på Tumblr", "player_tracks_total": "%s Totalt", "player_no_tracks": "Lägg till ditt första spår!", "player_music_album_versions_deluxe": "Deluxe-utgåva", "player_no_tracks_track_name": "Spårets namn", "player_shuffle": "Blanda", "player_music_album_versions_remastered": "Remastrad", "player_download_album": "Ladda ner album", "player_music_album_versions_remixes": "Remix", "player_track": "Spår", "player_track_out_of": "Spår %s (ut av %s)", "player_track_versions_demo": "Demo", "player_next": "Nästa", "player_acc_buy_track": "Köp spår för %s", "app_title": "Wix Player", "player_acc_share_on_blogger": "Dela på Blogger", "player_music_album_versions_acoustic": "Akustisk", "player_no_tracks_publish_playlist": "Denna spellista kommer snart!", "player_repeat": "Upprepa", "player_mobile_view_less": "Visa mindre", "player_acc_tracklist_play_track": "Play track number %s: %s", "player_acc_share": "Dela", "player_track_versions_clean": "Clean version", "player_no_tracks_publish": "Detta album kommer snart!", "player_share": "Dela", "player_share_song": "Dela spår", "player_track_versions_radio": "Radioversion", "player_download_track": "Ladda ner spår", "player_mobile_view_more": "Visa mer", "player_lyrics": "Spårinfo", "player_track_versions_edited": "Redigerad version", "player_mobile_share": "Dela", "player_acc_share_dialog": "Dela", "player_music_album_versions_live": "Live", "player_acc_track_cover": "Spåromslag", "player_buy_album": "Köp album", "player_music_album_versions_clean": "Clean version", "player_album": "Album", "player_payment_preview_mode": "Förhandsgranskningsläge", "player_acc_share_playlist_dialog": "Dela spellista", "player_track_versions_explicit": "Explicit version", "player_free_song": "Gratis nedladdning", "player_acc_track_info_dialog": "Spårinfo", "player_music_album_versions_special": "Specialutgåva", "player_track_versions_live": "Live", "player_no_tracks_publish_single": "Denna singel kommer snart!", "player_share_album": "Dela album", "player_payment_got_it": "Jag förstår", "player_buy_song": "Köp spår", "player_download": "Ladda ner", "player_get_single": "Skaffa singeln", "player_acc_mute": "Stäng av ljud", "player_acc_album_cover": "Albumomslag", "player_get_track": "Skaffa spåret", "player_music_album_versions_demo": "Demo", "player_mobile_share_this_album": "Dela detta album:", "player_sharing_text": "Kolla in den här häftiga musiken", "player_share_single": "Dela singel", "player_acc_progressbar": "Framstegsfält" };

/***/ }),
/* 128 */
/* no static exports found */
/* all exports used */
/*!****************************!*\
  !*** ./l10n/texts_th.json ***!
  \****************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = { "player_acc_track_played": "แทร็คที่เล่นแล้ว: %s", "player_acc_tracklist_pause_track": "Pause selected track number %s: %s", "player_acc_album_description": "คำบรรยายอัลบั้ม", "player_play": "เล่น", "player_acc_share_on_facebook": "แชร์ลง Facebook", "player_acc_tracklist": "รายชื่อแทร็ค %s", "player_track_collaboration_with": "กับ", "player_music_album_versions_bonus": "แทร็คโบนัส", "player_show_all_tracks": "แสดงทุกแทร็ค", "player_download_single": "ดาวน์โหลดซิงเกิ้ล", "player_get_album": "ซื้ออัลบั้ม", "player_previous": "ก่อนหน้า", "player_track_collaboration_featuring": "แขกรับเชิญ", "app_description": "ให้แฟนๆ สามารถฟัง ดาวน์โหลด และซื้อผลงานของคุณ และดูสถิติจำนวนครั้งที่เล่นและดาวน์โหลดได้ง่ายๆ", "player_acc_progress_value": "%s จาก %s", "player_payment_preview_error": "คุณกำลังอยู่ในโหมดดูตัวอย่าง คุณสมบัตินี้\nใช้ได้บนหน้าเว็บไซต์ที่กำลังออนไลน์ของคุณเมื่อถูกเผยแพร่แล้ว", "player_track_collaboration_performed": "นำเสนอโดย", "player_acc_track_duration": "ความยาวของแทร็ค: %s", "player_acc_pause": "หยุด", "player_share_playlist": "แชร์เพลย์ลิสต์", "player_acc_track_info": "ข้อมูลของแทร็ค", "player_acc_prev": "แทร็คก่อนหน้า", "player_acc_next": "แทร็คถัดไป", "player_track_versions_dirty": "เวอร์ชั่นลามก", "player_music_album_versions_empty": "—", "player_acc_buy_album": "ซื้ออัลบั้มในราคา %s", "player_track_versions_acoustic": "Acoustic", "player_pause": "หยุด", "player_acc_volume_value": "ความดัง %s", "player_buy_single": "ซื้อซิงเกิ้ล", "player_acc_close": "ปิด", "player_no_tracks_artist_name": "ชื่อศิลปิน", "player_acc_share_single_dialog": "แชร์ซิงเกิ้ล", "track_page_lyrics": "เนื้อเพลง", "player_mobile_share_this_song": "แชร์แทร็คนี้:", "player_acc_unmute": "Unmute", "player_acc_share_on_twitter": "แชร์ลง Twitter", "player_track_versions_bonus": "แทร็คโบนัส", "player_track_versions_empty": "—", "player_acc_play_live": "Track is playing", "player_acc_play": "เล่น", "player_free": "ฟรี", "player_track_collaboration_remixed": "รีมิกซ์โดย", "player_acc_share_album_dialog": "แชร์อัลบั้ม", "player_single": "เดี่ยว", "player_acc_pause_live": "Track paused", "player_acc_share_on_tumblr": "แชร์ลง Tumblr", "player_tracks_total": "รวมทั้งสิ้น %s", "player_no_tracks": "เพิ่มแทร็คแรกของคุณเลย!", "player_music_album_versions_deluxe": "ฉบับดีลักซ์", "player_no_tracks_track_name": "ชื่อแทร็ค", "player_shuffle": "เล่นเพลงแบบสุ่ม", "player_music_album_versions_remastered": "รีมาสเตอร์", "player_download_album": "ดาวน์โหลดอัลบั้ม", "player_music_album_versions_remixes": "รีมิกซ์", "player_track": "แทร็ค", "player_track_out_of": "แทร็คที่ %s (จาก %s)", "player_track_versions_demo": "เดโม", "player_next": "ถัดไป", "player_acc_buy_track": "ซื้อแทร็คในราคา %s", "app_title": "Wix Player", "player_acc_share_on_blogger": "แชร์ลง Blogger", "player_music_album_versions_acoustic": "Acoustic", "player_no_tracks_publish_playlist": "เพลย์ลิสต์นี้กำลังจะมาถึง!", "player_repeat": "เล่นซ้ำ", "player_mobile_view_less": "ดูน้อยลง", "player_acc_tracklist_play_track": "Play track number %s: %s", "player_acc_share": "แชร์", "player_track_versions_clean": "เวอร์ชั่นที่พร้อมวางขาย", "player_no_tracks_publish": "อัลบั้มนี้กำลังจะมาถึง!", "player_share": "แชร์", "player_share_song": "แชร์แทร็ค", "player_track_versions_radio": "ตัดต่อสำหรับกระจายเสียง", "player_download_track": "ดาวน์โหลดแทร็ค", "player_mobile_view_more": "ดูเพิ่มเติม", "player_lyrics": "ข้อมูลของแทร็ค", "player_track_versions_edited": "เวอร์ชั่นที่ตัดต่อ", "player_mobile_share": "แชร์", "player_acc_share_dialog": "แชร์", "player_music_album_versions_live": "สด", "player_acc_track_cover": "หน้าปกแทร็ค", "player_buy_album": "ซื้ออัลบั้ม", "player_music_album_versions_clean": "เวอร์ชันที่พร้อมวางขาย", "player_album": "อัลบั้ม", "player_payment_preview_mode": "โหมดดูตัวอย่าง", "player_acc_share_playlist_dialog": "แชร์เพลย์ลิสต์", "player_track_versions_explicit": "เวอร์ชั่นรุนแรง", "player_free_song": "ดาวน์โหลดฟรี", "player_acc_track_info_dialog": "ข้อมูลของแทร็ค", "player_music_album_versions_special": "ฉบับพิเศษ", "player_track_versions_live": "สด", "player_no_tracks_publish_single": "ซิงเกิ้ลนี้กำลังจะมาถึง!", "player_share_album": "แชร์อัลบั้ม", "player_payment_got_it": "รับทราบ", "player_buy_song": "ซื้อแทร็ค", "player_download": "ดาวน์โหลด", "player_get_single": "ซื้อซิงเกิ้ล", "player_acc_mute": "ปิดเสียง", "player_acc_album_cover": "หน้าปกอัลบั้ม", "player_get_track": "ซื้อแทร็ค", "player_music_album_versions_demo": "เดโม", "player_mobile_share_this_album": "แชร์อัลบั้มนี้:", "player_sharing_text": "ดูรายละเอียดเพลงสุดเจ๋งนี้", "player_share_single": "แชร์ซิงเกิ้ล", "player_acc_progressbar": "แถบแสดงความคืบหน้า" };

/***/ }),
/* 129 */
/* no static exports found */
/* all exports used */
/*!****************************!*\
  !*** ./l10n/texts_tl.json ***!
  \****************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = { "player_acc_track_played": "Track na na-play: %s", "player_acc_tracklist_pause_track": "Pause selected track number %s: %s", "player_acc_album_description": "Album description", "player_play": "I-play", "player_acc_share_on_facebook": "I-share sa Facebook", "player_acc_tracklist": "%s listahan ng track", "player_track_collaboration_with": "With", "player_music_album_versions_bonus": "Bonus na Track", "player_show_all_tracks": "Ipakita ang lahat ng track", "player_download_single": "I-download ang Single", "player_get_album": "Makuha ang Album", "player_previous": "Nakaraan", "player_track_collaboration_featuring": "Featuring", "app_description": "Make it easy for fans to listen, download and purchase your work and check your music's play and download stats.", "player_acc_progress_value": "%s ng %s", "player_payment_preview_error": "Hey, you’re in Preview Mode.\nThis feature works on your live site once it’s published.", "player_track_collaboration_performed": "Performed By", "player_acc_track_duration": "Haba ng track: %s", "player_acc_pause": "I-pause", "player_share_playlist": "Ibahagi ang Playlist", "player_acc_track_info": "Impormasyon sa Track", "player_acc_prev": "Nakaraang track", "player_acc_next": "Susunod na track", "player_track_versions_dirty": "Dirty na Bersyon", "player_music_album_versions_empty": "—", "player_acc_buy_album": "Bilhin ang album sa halagang %s", "player_track_versions_acoustic": "Acoustic", "player_pause": "I-pause", "player_acc_volume_value": "%s volume", "player_buy_single": "Bilhin ang Sngle", "player_acc_close": "Isara", "player_no_tracks_artist_name": "Pangalan ng Artis", "player_acc_share_single_dialog": "Ibahagi ang Single", "track_page_lyrics": "Lyrics", "player_mobile_share_this_song": "Ibahagi ang Track na ito:", "player_acc_unmute": "Unmute", "player_acc_share_on_twitter": "I-share sa Twitter", "player_track_versions_bonus": "Bonus na Track", "player_track_versions_empty": "—", "player_acc_play_live": "Track is playing", "player_acc_play": "I-play", "player_free": "Libre", "player_track_collaboration_remixed": "Remixed By", "player_acc_share_album_dialog": "Ibahagi ang Album", "player_single": "Single", "player_acc_pause_live": "Track paused", "player_acc_share_on_tumblr": "Ibahagi sa Tumblr", "player_tracks_total": "%s Kabuuan", "player_no_tracks": "Idagdag ang una mong track!", "player_music_album_versions_deluxe": "Deluxe Edition", "player_no_tracks_track_name": "Pangalan ng Track", "player_shuffle": "I-shuffle", "player_music_album_versions_remastered": "Remastered", "player_download_album": "Download Album", "player_music_album_versions_remixes": "Remixes", "player_track": "Track", "player_track_out_of": "Track %s (Ng %s track)", "player_track_versions_demo": "Demo", "player_next": "Susunod", "player_acc_buy_track": "Bilhin ang track sa halagang %s", "app_title": "Wix Player", "player_acc_share_on_blogger": "Ibahagi sa Blogger", "player_music_album_versions_acoustic": "Acoustic", "player_no_tracks_publish_playlist": "Paparating na ang playlist na ito!", "player_repeat": "Ulitin", "player_mobile_view_less": "Tingnan ang mas kaunti", "player_acc_tracklist_play_track": "Play track number %s: %s", "player_acc_share": "Ibahagi", "player_track_versions_clean": "Malinis na Bersyon", "player_no_tracks_publish": "Paparating na ang album na ito!", "player_share": "Share", "player_share_song": "Share Track", "player_track_versions_radio": "Radio Edit", "player_download_track": "Download Track", "player_mobile_view_more": "Tingnan ang Higit pa", "player_lyrics": "Track Info", "player_track_versions_edited": "Edited na Bersyon", "player_mobile_share": "Share", "player_acc_share_dialog": "Ibahagi", "player_music_album_versions_live": "Live", "player_acc_track_cover": "Cover ng Track", "player_buy_album": "Buy Album", "player_music_album_versions_clean": "Clean Version", "player_album": "Album", "player_payment_preview_mode": "Preview Mode", "player_acc_share_playlist_dialog": "Ibahagi ang Playlist", "player_track_versions_explicit": "Explicit na Bersyon", "player_free_song": "Free Download", "player_acc_track_info_dialog": "Impormasyon sa track", "player_music_album_versions_special": "Special Edition", "player_track_versions_live": "Live", "player_no_tracks_publish_single": "Paparating na ang single na ito!", "player_share_album": "Ibahagi ang Album", "player_payment_got_it": "Ok", "player_buy_song": "Buy Track", "player_download": "Download", "player_get_single": "Makuha ang Single", "player_acc_mute": "I-mute", "player_acc_album_cover": "Cover ng Album", "player_get_track": "Makuha ang Track", "player_music_album_versions_demo": "Demo", "player_mobile_share_this_album": "Ibahagi ang Album na ito:", "player_sharing_text": "tingnan ang astig na music na ito", "player_share_single": "Ibahagi ang Single", "player_acc_progressbar": "Progress Bar" };

/***/ }),
/* 130 */
/* no static exports found */
/* all exports used */
/*!****************************!*\
  !*** ./l10n/texts_tr.json ***!
  \****************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = { "player_acc_track_played": "Çalınan parça: %s", "player_acc_tracklist_pause_track": "Pause selected track number %s: %s", "player_acc_album_description": "Albüm açıklaması", "player_play": "Oynat", "player_acc_share_on_facebook": "Facebook'ta Paylaş", "player_acc_tracklist": "%s parça listesi", "player_track_collaboration_with": "*", "player_music_album_versions_bonus": "Bonus Parça", "player_show_all_tracks": "Tüm Parçaları Göster", "player_download_single": "Single'ı İndir", "player_get_album": "Albüm Al", "player_previous": "Önceki", "player_track_collaboration_featuring": "Ft.", "app_description": "Hayranlarınızın şarkılarınızı kolayca indirmelerini sağlayın. Şarkınızın oynatılma ve indirilme istatistiklerini edinin.", "player_acc_progress_value": "%s / %s", "player_payment_preview_error": "Şu an önizleme modundasınız.\nBu öğe siteniz yayınlandıktan sonra çalışmaya başlar.", "player_track_collaboration_performed": "Sanatçı", "player_acc_track_duration": "Parça süresi: %s", "player_acc_pause": "Durdur", "player_share_playlist": "Müzik Listesini Paylaş", "player_acc_track_info": "Parça Bilgileri", "player_acc_prev": "Önceki parça", "player_acc_next": "Sıradaki parça", "player_track_versions_dirty": "Kirli Sürüm", "player_music_album_versions_empty": "—", "player_acc_buy_album": "Albümü satın al - %s", "player_track_versions_acoustic": "Akustik", "player_pause": "Durdur", "player_acc_volume_value": "%s ses", "player_buy_single": "Single'ı Satın Al", "player_acc_close": "Kapat", "player_no_tracks_artist_name": "Sanatçı Adı", "player_acc_share_single_dialog": "Single'ı", "track_page_lyrics": "Şarkı Sözleri", "player_mobile_share_this_song": "Bu Parçayı Paylaş:", "player_acc_unmute": "Unmute", "player_acc_share_on_twitter": "Twitter'da Paylaş", "player_track_versions_bonus": "Bonus Parça", "player_track_versions_empty": "—", "player_acc_play_live": "Track is playing", "player_acc_play": "Oynat", "player_free": "Bedava", "player_track_collaboration_remixed": "Remix", "player_acc_share_album_dialog": "Albümü Paylaş", "player_single": "Single", "player_acc_pause_live": "Track paused", "player_acc_share_on_tumblr": "Tumblr'da Paylaş", "player_tracks_total": "Toplam %s ", "player_no_tracks": "İlk parçanızı ekleyin!", "player_music_album_versions_deluxe": "Delüks Versiyon", "player_no_tracks_track_name": "Parça Adı", "player_shuffle": "Karıştır", "player_music_album_versions_remastered": "Yeni Düzenleme", "player_download_album": "Albümü İndir", "player_music_album_versions_remixes": "Remixler", "player_track": "Parça", "player_track_out_of": "Parça %s (%s taneden)", "player_track_versions_demo": "Demo", "player_next": "Sonraki", "player_acc_buy_track": "Parçayı satın al - %s", "app_title": "Wix Player", "player_acc_share_on_blogger": "Blogger'da Paylaş", "player_music_album_versions_acoustic": "Akustik", "player_no_tracks_publish_playlist": "Bu müzik listesi yakında geliyor!", "player_repeat": "Tekrarla", "player_mobile_view_less": "Daha Az Görüntüle", "player_acc_tracklist_play_track": "Play track number %s: %s", "player_acc_share": "Paylaş", "player_track_versions_clean": "Temiz Sürüm", "player_no_tracks_publish": "Bu albüm çok yakında geliyor!", "player_share": "Paylaş", "player_share_song": "Parçayı Paylaş", "player_track_versions_radio": "Radyo Düzenlemesi", "player_download_track": "Parçayı İndir", "player_mobile_view_more": "Daha Fazla", "player_lyrics": "Parça Bilgileri", "player_track_versions_edited": "Düzenlenen Sürüm", "player_mobile_share": "Paylaş", "player_acc_share_dialog": "Paylaş", "player_music_album_versions_live": "Canlı", "player_acc_track_cover": "Parça Kapağı", "player_buy_album": "Albümü Satın Al", "player_music_album_versions_clean": "Temiz Sürüm", "player_album": "Albüm", "player_payment_preview_mode": "Önizleme Modu", "player_acc_share_playlist_dialog": "Müzik Listesini Paylaş", "player_track_versions_explicit": "Explicit Versiyon", "player_free_song": "Bedava İndir", "player_acc_track_info_dialog": "Parça Bilgileri", "player_music_album_versions_special": "Özel Parça", "player_track_versions_live": "Canlı", "player_no_tracks_publish_single": "Bu single yakında geliyor!", "player_share_album": "Albümü Paylaş", "player_payment_got_it": "Tamam", "player_buy_song": "Parçayı Satın Al", "player_download": "Yükle", "player_get_single": "Single Al", "player_acc_mute": "Sessiz", "player_acc_album_cover": "Albüm Kapağı", "player_get_track": "Parça Al", "player_music_album_versions_demo": "Demo", "player_mobile_share_this_album": "Bu Albümü Paylaşın:", "player_sharing_text": "bu harika müziği dinleyin", "player_share_single": "Single'ı", "player_acc_progressbar": "İlerleme Çubuğu" };

/***/ }),
/* 131 */
/* no static exports found */
/* all exports used */
/*!****************************!*\
  !*** ./l10n/texts_uk.json ***!
  \****************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = { "player_acc_track_played": "Відтворено композицій: %s", "player_acc_tracklist_pause_track": "Pause selected track number %s: %s", "player_acc_album_description": "Опис альбому", "player_play": "Відтворити", "player_acc_share_on_facebook": "Поділитися у Facebook", "player_acc_tracklist": "Список композицій %s", "player_track_collaboration_with": "З", "player_music_album_versions_bonus": "Bonus Track", "player_show_all_tracks": "Показати всі композиції", "player_download_single": "Завантажити сингл", "player_get_album": "Отримати альбом", "player_previous": "Попередній", "player_track_collaboration_featuring": "За участі", "app_description": "Запропонуйте шанувальникам зручний формат прослуховування, завантаження та придбання музики, отримайте доступ до статистики відтворення та завантаження композицій.", "player_acc_progress_value": "%s із %s", "player_payment_preview_error": "Ви перейшли до режиму попереднього перегляду.\nЦя функція працюватиме на вашому сайті після його публікації.", "player_track_collaboration_performed": "Виконавець", "player_acc_track_duration": "Тривалість композиції: %s", "player_acc_pause": "Пауза", "player_share_playlist": "Поділитися плейлистом", "player_acc_track_info": "Інформація композиції", "player_acc_prev": "Попередній композиція", "player_acc_next": "Наступний композиція", "player_track_versions_dirty": "Dirty Version", "player_music_album_versions_empty": "–", "player_acc_buy_album": "Купити альбом за %s", "player_track_versions_acoustic": "Acoustic", "player_pause": "Пауза", "player_acc_volume_value": "%s гучності", "player_buy_single": "Купити сингл", "player_acc_close": "Закрити", "player_no_tracks_artist_name": "Ім'я виконавця", "player_acc_share_single_dialog": "Поділитися синглом", "track_page_lyrics": "Текст", "player_mobile_share_this_song": "Поділитися цією композицією:", "player_acc_unmute": "Unmute", "player_acc_share_on_twitter": "Поділитися у Twitter", "player_track_versions_bonus": "Bonus Track", "player_track_versions_empty": "–", "player_acc_play_live": "Track is playing", "player_acc_play": "Відтворити", "player_free": "Безкоштовно", "player_track_collaboration_remixed": "Автор реміксу", "player_acc_share_album_dialog": "Поділитися альбомом", "player_single": "Сингл", "player_acc_pause_live": "Track paused", "player_acc_share_on_tumblr": "Поділитись у Tumblr", "player_tracks_total": "Усього %s", "player_no_tracks": "Додайте свою першу композицію!", "player_music_album_versions_deluxe": "Deluxe Edition", "player_no_tracks_track_name": "Назва композиції", "player_shuffle": "Перемішати", "player_music_album_versions_remastered": "Remastered", "player_download_album": "Завантажити альбом", "player_music_album_versions_remixes": "Ремікси", "player_track": "Композиція", "player_track_out_of": "Композиція %s (із %s)", "player_track_versions_demo": "Demo", "player_next": "Далі", "player_acc_buy_track": "Купити композицію за %s", "app_title": "Плеєр Wix", "player_acc_share_on_blogger": "Поділитись у Blogger", "player_music_album_versions_acoustic": "Acoustic", "player_no_tracks_publish_playlist": "Цей плейлист уже скоро у продажу!", "player_repeat": "Повторити", "player_mobile_view_less": "Приховати", "player_acc_tracklist_play_track": "Play track number %s: %s", "player_acc_share": "Поділитися", "player_track_versions_clean": "Clean Version", "player_no_tracks_publish": "Альбом уже скоро у продажу!", "player_share": "Поділитися", "player_share_song": "Поділитися композицією", "player_track_versions_radio": "Radio Edit", "player_download_track": "Завантажити композицію", "player_mobile_view_more": "Детальніше", "player_lyrics": "Інформація", "player_track_versions_edited": "Edited Version", "player_mobile_share": "Поділитися", "player_acc_share_dialog": "Поділитися", "player_music_album_versions_live": "Наживо", "player_acc_track_cover": "Обкладинка композиції", "player_buy_album": "Придбати альбом", "player_music_album_versions_clean": "Clean Version", "player_album": "Альбом", "player_payment_preview_mode": "Режим попереднього перегляду", "player_acc_share_playlist_dialog": "Поділитися плейлистом", "player_track_versions_explicit": "Explicit Version", "player_free_song": "Безкоштовне завантаження", "player_acc_track_info_dialog": "Інформація композиції", "player_music_album_versions_special": "Special Edition", "player_track_versions_live": "Наживо", "player_no_tracks_publish_single": "Цей сингл уже скоро у продажу!", "player_share_album": "Поділитися альбомом", "player_payment_got_it": "Готово", "player_buy_song": "Придбати композицію", "player_download": "Завантажити", "player_get_single": "Отримати сингл", "player_acc_mute": "Без звуку", "player_acc_album_cover": "Обкладинка альбому", "player_get_track": "Отримати композицію", "player_music_album_versions_demo": "Demo", "player_mobile_share_this_album": "Поділитися цим альбомом:", "player_sharing_text": "послухайте цю кльову музику", "player_share_single": "Поділитися синглом", "player_acc_progressbar": "Індикатор прогресу" };

/***/ }),
/* 132 */
/* no static exports found */
/* all exports used */
/*!****************************!*\
  !*** ./l10n/texts_vi.json ***!
  \****************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = { "player_acc_track_played": "Bản nhạc đã phát: %s", "player_acc_tracklist_pause_track": "Tạm dừng bản nhạc đã chọn số %s: %s", "player_acc_album_description": "Mô tả album", "player_play": "Phát", "player_acc_share_on_facebook": "Chia sẻ trên Facebook", "player_acc_tracklist": "Danh sách bản nhạc %s", "player_track_collaboration_with": "Với", "player_music_album_versions_bonus": "Bài tặng thêm", "player_show_all_tracks": "Hiển thị tất cả bản nhạc", "player_download_single": "Tải về đĩa đơn", "player_get_album": "Tải album", "player_previous": "Trước", "player_track_collaboration_featuring": "Kết hợp cùng", "app_description": "Giúp người hâm mộ có thể dễ dàng nghe, tải về và mua tác phẩm của bạn cũng như kiểm tra số liệu thống kê về lượt phát và tải về.", "player_acc_progress_value": "%s trong số %s", "player_payment_preview_error": "Bạn đang ở chế độ Xem trước.\nTính năng này hoạt động trên trang web đang hoạt động của bạn sau xuất bản trang web.", "player_track_collaboration_performed": "Thể hiện bởi", "player_acc_track_duration": "Thời lượng bản nhạc: %s", "player_acc_pause": "Tạm dừng", "player_share_playlist": "Chia sẻ danh sách phát", "player_acc_track_info": "Thông tin bản nhạc", "player_acc_prev": "Bản nhạc trước", "player_acc_next": "Bản nhạc tiếp theo", "player_track_versions_dirty": "Bản có yếu tố dung tục", "player_music_album_versions_empty": "–", "player_acc_buy_album": "Mua album với %s", "player_track_versions_acoustic": "Bản hát mộc", "player_pause": "Tạm dừng", "player_acc_volume_value": "%s âm lượng", "player_buy_single": "Mua đĩa đơn", "player_acc_close": "Đóng", "player_no_tracks_artist_name": "Tên nghệ sĩ", "player_acc_share_single_dialog": "Chia sẻ đĩa đơn", "track_page_lyrics": "Lời bài hát", "player_mobile_share_this_song": "Chia sẻ bản nhạc này:", "player_acc_unmute": "Bật tiếng", "player_acc_share_on_twitter": "Chia sẻ trên Twitter", "player_track_versions_bonus": "Bài tặng thêm", "player_track_versions_empty": "–", "player_acc_play_live": "Bản nhạc đang phát", "player_acc_play": "Phát", "player_free": "Miễn phí", "player_track_collaboration_remixed": "Bản phối lại của", "player_acc_share_album_dialog": "Chia sẻ album", "player_single": "Đĩa đơn", "player_acc_pause_live": "Bản nhạc đã tạm dừng", "player_acc_share_on_tumblr": "Chia sẻ trên Tumblr", "player_tracks_total": "Tổng cộng %s", "player_no_tracks": "Hãy thêm bản nhạc đầu tiên!", "player_music_album_versions_deluxe": "Bản cao cấp", "player_no_tracks_track_name": "Tên bài hát", "player_shuffle": "Phát ngẫu nhiên", "player_music_album_versions_remastered": "Bản cải tiến", "player_download_album": "Tải album xuống", "player_music_album_versions_remixes": "Bản phối lại", "player_track": "Theo dõi", "player_track_out_of": "Bản nhạc %s (trong tổng số %s bài)", "player_track_versions_demo": "Bản demo", "player_next": "Tiếp", "player_acc_buy_track": "Mua bản nhạc với %s", "app_title": "Trình phát nhạc Wix", "player_acc_share_on_blogger": "Chia sẻ trên Blogger", "player_music_album_versions_acoustic": "Bản hát mộc", "player_no_tracks_publish_playlist": "Danh sách phát này sắp ra mắt!", "player_repeat": "Lặp lại", "player_mobile_view_less": "Thu gọn", "player_acc_tracklist_play_track": "Phát bản nhạc số %s: %s", "player_acc_share": "Chia sẻ", "player_track_versions_clean": "Bản sạch", "player_no_tracks_publish": "Album này sẽ sớm được ra mắt!", "player_share": "Chia sẻ", "player_share_song": "Chia sẻ bản nhạc", "player_track_versions_radio": "Bản phát thanh", "player_download_track": "Tải bản nhạc về", "player_mobile_view_more": "Xem thêm", "player_lyrics": "Thông tin bản nhạc", "player_track_versions_edited": "Bản đã chỉnh sửa", "player_mobile_share": "Chia sẻ", "player_acc_share_dialog": "Chia sẻ", "player_music_album_versions_live": "Trực tiếp", "player_acc_track_cover": "Bìa bản nhạc", "player_buy_album": "Mua album", "player_music_album_versions_clean": "Bản sạch", "player_album": "Album", "player_payment_preview_mode": "Chế độ xem trước", "player_acc_share_playlist_dialog": "Chia sẻ danh sách phát", "player_track_versions_explicit": "Bản có yếu tố nhạy cảm", "player_free_song": "Tải về miễn phí", "player_acc_track_info_dialog": "Thông tin bản nhạc", "player_music_album_versions_special": "Bản đặc biệt", "player_track_versions_live": "Trực tiếp", "player_no_tracks_publish_single": "Đĩa đơn này sắp ra mắt!", "player_share_album": "Chia sẻ album", "player_payment_got_it": "Đã hiểu", "player_buy_song": "Mua bản nhạc", "player_download": "Tải về", "player_get_single": "Tải đĩa đơn", "player_acc_mute": "Tắt tiếng", "player_acc_album_cover": "Bìa album", "player_get_track": "Tải bản nhạc", "player_music_album_versions_demo": "Bản demo", "player_mobile_share_this_album": "Chia sẻ album này:", "player_sharing_text": "khám phá bản nhạc thú vị này", "player_share_single": "Chia sẻ đĩa đơn", "player_acc_progressbar": "Thanh tiến độ" };

/***/ }),
/* 133 */
/* no static exports found */
/* all exports used */
/*!****************************!*\
  !*** ./l10n/texts_zh.json ***!
  \****************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = { "player_acc_track_played": "已播放曲目：%s", "player_acc_tracklist_pause_track": "Pause selected track number %s: %s", "player_acc_album_description": "專輯說明", "player_play": "播放", "player_acc_share_on_facebook": "在Facebook上分享", "player_acc_tracklist": "%s曲目清單", "player_track_collaboration_with": "同台演出", "player_music_album_versions_bonus": "特別收錄曲目", "player_show_all_tracks": "顯示全部曲目", "player_download_single": "下載單曲", "player_get_album": "取得專輯", "player_previous": "前一個", "player_track_collaboration_featuring": "客串演出", "app_description": "讓粉絲輕鬆聆聽、下載並購買您的作品，查看您的音樂播放與下載統計資料。", "player_acc_progress_value": "%s / %s", "player_payment_preview_error": "嗨，您正在預覽模式。該功能\n在發佈後將顯示於您的即時網站上。", "player_track_collaboration_performed": "演唱", "player_acc_track_duration": "曲目持續期間：%s", "player_acc_pause": "暫停", "player_share_playlist": "分享播放清單", "player_acc_track_info": "曲目資訊", "player_acc_prev": "前一曲目", "player_acc_next": "下一曲目", "player_track_versions_dirty": "髒版", "player_music_album_versions_empty": "—", "player_acc_buy_album": "購買%s的專輯", "player_track_versions_acoustic": "原音", "player_pause": "暫停", "player_acc_volume_value": "%s音量", "player_buy_single": "購買單曲", "player_acc_close": "關閉", "player_no_tracks_artist_name": "演出者名稱", "player_acc_share_single_dialog": "分享單曲", "track_page_lyrics": "歌詞", "player_mobile_share_this_song": "分享此曲目：", "player_acc_unmute": "Unmute", "player_acc_share_on_twitter": "在Twitter上分享", "player_track_versions_bonus": "特別收錄曲目", "player_track_versions_empty": "—", "player_acc_play_live": "Track is playing", "player_acc_play": "播放", "player_free": "免費", "player_track_collaboration_remixed": "混音", "player_acc_share_album_dialog": "分享專輯", "player_single": "單曲", "player_acc_pause_live": "Track paused", "player_acc_share_on_tumblr": "在Tumblr上分享", "player_tracks_total": "共%s曲目", "player_no_tracks": "新增您的第一首曲目！", "player_music_album_versions_deluxe": "豪華版", "player_no_tracks_track_name": "曲目名稱", "player_shuffle": "隨機播放", "player_music_album_versions_remastered": "重新混音版", "player_download_album": "下載專輯", "player_music_album_versions_remixes": "混音特辑", "player_track": "曲目", "player_track_out_of": "第%s首曲目，共%s首曲目", "player_track_versions_demo": "示範版", "player_next": "下一步", "player_acc_buy_track": "購買%s的曲目", "app_title": "Wix播放器", "player_acc_share_on_blogger": "在Blogger上分享", "player_music_album_versions_acoustic": "原聲版", "player_no_tracks_publish_playlist": "此播放清單即將推出！", "player_repeat": "重複播放", "player_mobile_view_less": "查看更少", "player_acc_tracklist_play_track": "Play track number %s: %s", "player_acc_share": "分享", "player_track_versions_clean": "普級版", "player_no_tracks_publish": "此專輯即將推出！", "player_share": "分享", "player_share_song": "分享曲目", "player_track_versions_radio": "電音版", "player_download_track": "下載曲目", "player_mobile_view_more": "查看更多", "player_lyrics": "曲目資訊", "player_track_versions_edited": "修剪版", "player_mobile_share": "分享", "player_acc_share_dialog": "分享", "player_music_album_versions_live": "現場版", "player_acc_track_cover": "曲目封面", "player_buy_album": "購買專輯", "player_music_album_versions_clean": "普級版", "player_album": "專輯", "player_payment_preview_mode": "預覽模式", "player_acc_share_playlist_dialog": "分享播放清單", "player_track_versions_explicit": "完整版", "player_free_song": "免費下載", "player_acc_track_info_dialog": "曲目資訊", "player_music_album_versions_special": "特別版", "player_track_versions_live": "現場版", "player_no_tracks_publish_single": "此單曲即將推出！", "player_share_album": "分享專輯", "player_payment_got_it": "知道了", "player_buy_song": "購買曲目", "player_download": "下載", "player_get_single": "取得單曲", "player_acc_mute": "靜音", "player_acc_album_cover": "專輯封面", "player_get_track": "取得曲目", "player_music_album_versions_demo": "示範版", "player_mobile_share_this_album": "分享此專輯：", "player_sharing_text": "查看此酷炫的音樂", "player_share_single": "分享單曲", "player_acc_progressbar": "進度條" };

/***/ }),
/* 134 */
/* no static exports found */
/* all exports used */
/*!*******************************!*\
  !*** ./scripts/common/buy.js ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ROUTES = undefined;
exports.openGetWindow = openGetWindow;

var _url = __webpack_require__(/*! @wix/music-shared/dist/src/utils/url */ 171);

var createParam = _url.createParam;
var ROUTES = exports.ROUTES = {
  GET: '/get',
  TRACK_INFO: '/track-info'
};

function openGetWindow(player, settings, _ref) {
  var albumId = _ref.albumId,
      trackId = _ref.trackId,
      _ref$route = _ref.route,
      route = _ref$route === undefined ? ROUTES.GET : _ref$route;

  var baseUrl = settings.getWindowUrl;
  var params = createParam({
    paymentsId: settings.paymentsId,
    tpaApplicationId: settings.tpaApplicationId,
    pageId: settings.pageId
  });
  var hashParams = createParam({ albumId: albumId, trackId: trackId });
  var getWindowUrl = baseUrl + '?' + params + '#' + route + '?' + hashParams;
  player.emit('widget:get-window', {
    url: getWindowUrl,
    onClose: function onClose() {
      player.setCurrentOrigin('widget');
      player.emit('ended.track');
    }
  });
}

/***/ }),
/* 135 */
/* no static exports found */
/* all exports used */
/*!**************************************!*\
  !*** ./scripts/common/currencies.js ***!
  \**************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCurrencies = getCurrencies;
/* global CURRENCIES */

function getCurrencies() {
  return Promise.resolve({"USD":{"offset":2,"symbol":"$","sl":"2000","al":"2000","sd":"1.00","ad":"9.99","single":"3.99","rate":"1.00"},"EUR":{"offset":2,"symbol":"€","sl":"2000","al":"2000","sd":"1.00","ad":"9.99","single":"3.99","rate":"1.11"},"AUD":{"offset":2,"symbol":"$","sl":"2500","al":"2500","sd":"1.00","ad":"9.90","single":"3.90","rate":"0.77"},"BRL":{"offset":2,"symbol":"R$","sl":"6500","al":"6500","sd":"2.90","ad":"29.90","single":"14.90","rate":"0.31"},"CAD":{"offset":2,"symbol":"$","sl":"2500","al":"2500","sd":"1.00","ad":"9.90","single":"3.90","rate":"0.75"},"CHF":{"offset":2,"symbol":"CHF","sl":"2000","al":"2000","sd":"1.00","ad":"9.90","single":"4.90","rate":"1.03"},"CZK":{"offset":2,"symbol":"Kč","sl":"49000","al":"49000","sd":"25","ad":"245","single":"120","rate":"0.041"},"DKK":{"offset":2,"symbol":"kr","sl":"13500","al":"13500","sd":"6.90","ad":"69.90","single":"34.90","rate":"0.15"},"GBP":{"offset":2,"symbol":"£","sl":"2000","al":"2000","sd":"1.00","ad":"7.99","single":"3.99","rate":"1.24"},"HKD":{"offset":2,"symbol":"$","sl":"15500","al":"15500","sd":"7.90","ad":"79.90","single":"39.90","rate":"0.13"},"HUF":{"offset":0,"symbol":"Ft","sl":"570000","al":"570000","sd":"280","ad":"2800","single":"1400","rate":"0.0036"},"ILS":{"offset":2,"symbol":"₪","sl":"8000","al":"8000","sd":"3.99","ad":"39.99","single":"19.99","rate":"0.26"},"JPY":{"offset":0,"symbol":"¥","sl":"250000","al":"250000","sd":"99","ad":"999","single":"499","rate":"0.0096"},"MXN":{"offset":2,"symbol":"$","sl":"38000","al":"38000","sd":"18","ad":"185","single":"90","rate":"0.054"},"MYR":{"offset":2,"symbol":"RM","sl":"8000","al":"8000","sd":"3.90","ad":"39.90","single":"19.90","rate":"0.24"},"NOK":{"offset":2,"symbol":"kr","sl":"17000","al":"17000","sd":"8","ad":"85","single":"40","rate":"0.12"},"NZD":{"offset":2,"symbol":"$","sl":"2500","al":"2500","sd":"1.00","ad":"9.90","single":"3.90","rate":"0.73"},"PHP":{"offset":2,"symbol":"₱","sl":"94500","al":"94500","sd":"45","ad":"450","single":"220","rate":"0.020"},"PLN":{"offset":2,"symbol":"zł","sl":"8000","al":"8000","sd":"4","ad":"40","single":"20","rate":"0.24"},"RUB":{"offset":2,"symbol":"₽","sl":"150000","al":"150000","sd":"59","ad":"599","single":"299","rate":"0.016"},"SEK":{"offset":2,"symbol":"kr","sl":"17000","al":"17000","sd":"8","ad":"85","single":"40","rate":"0.11"},"SGD":{"offset":2,"symbol":"$","sl":"3000","al":"3000","sd":"1.90","ad":"13.90","single":"6.90","rate":"0.72"},"THB":{"offset":2,"symbol":"฿","sl":"70000","al":"70000","sd":"35","ad":"350","single":"170","rate":"0.029"},"TWD":{"offset":0,"symbol":"NT$","sl":"65000","al":"65000","sd":"29","ad":"299","single":"149","rate":"0.032"},"BIF":{"symbol":"FBu","rate":"1.00"},"CVE":{"symbol":"$","rate":"1.00"},"KMF":{"symbol":"CF","rate":"1.00"},"DJF":{"symbol":"Fdj","rate":"1.00"},"ERN":{"symbol":"ናቕፋ","rate":"1.00"},"GNF":{"symbol":"FG","rate":"1.00"},"LSL":{"symbol":"L","rate":"1.00"},"LYD":{"symbol":"ل.د","rate":"1.00"},"MWK":{"symbol":"MK","rate":"1.00"},"MRO":{"symbol":"UM","rate":"1.00"},"SLL":{"symbol":"LE","rate":"1.00"},"SZL":{"symbol":"L","rate":"1.00"},"TJS":{"symbol":"TJS","rate":"1.00"},"TOP":{"symbol":"T$","rate":"1.00"},"XPF":{"symbol":"F","rate":"1.00"},"XOF":{"symbol":"CFA","rate":"1.00"},"XAF":{"symbol":"FCFA","rate":"1.00"},"WST":{"symbol":"WS$","rate":"1.00"},"VUV":{"symbol":"VT","rate":"1.00"},"UGX":{"symbol":"USh","rate":"1.00"},"TZS":{"symbol":"TSh","rate":"1.00"},"STD":{"symbol":"Db","rate":"1.00"},"RWF":{"symbol":"R₣","rate":"1.00"},"PGK":{"symbol":"K","rate":"1.00"},"MVR":{"symbol":"Rf","rate":"1.00"},"MOP":{"symbol":"MOP$","rate":"1.00"},"MMK":{"symbol":"K","rate":"1.00"},"MDL":{"symbol":"L","rate":"1.00"},"HTG":{"symbol":"G","rate":"1.00"},"GMD":{"symbol":"D","rate":"1.00"},"GEL":{"symbol":"GEL","rate":"1.00"},"ETB":{"symbol":"Br","rate":"1.00"},"BTN":{"symbol":"Nu.","rate":"1.00"},"BDT":{"symbol":"৳","rate":"1.00"},"AOA":{"symbol":"Kz","rate":"1.00"},"AED":{"symbol":"AED","rate":"1.00"},"MGA":{"symbol":"Ar","rate":"1.00"},"GHS":{"symbol":"GH₵","rate":"1.00"},"TMT":{"symbol":"T","rate":"1.00"},"DZD":{"symbol":"دج","rate":"1.00"},"MAD":{"symbol":"د.م.","rate":"1.00"},"KWD":{"symbol":"د.ك","rate":"1.00"},"TND":{"symbol":"د.ت","rate":"1.00"},"AZN":{"symbol":"ман","rate":"1.00"},"BGL":{"symbol":"лв","rate":"1.00"},"UZS":{"symbol":"сум","rate":"1.00"},"KZT":{"symbol":"₸","rate":"1.00"},"KGS":{"symbol":"сом","rate":"1.00"},"RSD":{"symbol":"РСД","rate":"1.00"},"MKD":{"symbol":"ден","rate":"1.00"},"TTD":{"symbol":"TT$","rate":"1.00"},"PEN":{"symbol":"S/.","rate":"1.00"},"SOS":{"symbol":"S","rate":"1.00"},"IDR":{"symbol":"Rp","rate":"1.00"},"DOP":{"symbol":"RD$","rate":"1.00"},"ZAR":{"symbol":"R","rate":"1.00"},"GTQ":{"symbol":"Q","rate":"1.00"},"BYN":{"symbol":"BYR","rate":"1.00"},"BWP":{"symbol":"P","rate":"1.00"},"MZN":{"symbol":"MT","rate":"1.00"},"ALL":{"symbol":"Lek","rate":"1.00"},"RON":{"symbol":"lei","rate":"1.00"},"HNL":{"symbol":"L","rate":"1.00"},"KES":{"symbol":"Ksh","rate":"1.00"},"ISK":{"symbol":"kr","rate":"1.00"},"HRK":{"symbol":"kn","rate":"1.00"},"BAM":{"symbol":"KM","rate":"1.00"},"JOD":{"symbol":"JD","rate":"1.00"},"JMD":{"symbol":"J$","rate":"1.00"},"PYG":{"symbol":"Gs","rate":"1.00"},"AWG":{"symbol":"ƒ","rate":"1.00"},"ANG":{"symbol":"ƒ","rate":"1.00"},"NIO":{"symbol":"C$","rate":"1.00"},"BZD":{"symbol":"BZ$","rate":"1.00"},"VEF":{"symbol":"Bs","rate":"1.00"},"PAB":{"symbol":"B/.","rate":"1.00"},"YER":{"symbol":"﷼","rate":"1.00"},"SAR":{"symbol":"﷼","rate":"1.00"},"QAR":{"symbol":"﷼","rate":"1.00"},"OMR":{"symbol":"﷼","rate":"1.00"},"SCR":{"symbol":"₨","rate":"1.00"},"PKR":{"symbol":"₨","rate":"1.00"},"NPR":{"symbol":"₨","rate":"1.00"},"MUR":{"symbol":"₨","rate":"1.00"},"LKR":{"symbol":"₨","rate":"1.00"},"UAH":{"symbol":"₴","rate":"1.00"},"MNT":{"symbol":"₮","rate":"1.00"},"LAK":{"symbol":"₭","rate":"1.00"},"VND":{"symbol":"₫","rate":"1.00"},"KRW":{"symbol":"₩","rate":"1.00"},"NGN":{"symbol":"₦","rate":"1.00"},"CRC":{"symbol":"₡","rate":"1.00"},"KHR":{"symbol":"៛","rate":"1.00"},"AFN":{"symbol":"؋","rate":"1.00"},"CNY":{"symbol":"¥","rate":"1.00"},"FKP":{"symbol":"£","rate":"1.00"},"SHP":{"symbol":"£","rate":"1.00"},"GIP":{"symbol":"£","rate":"1.00"},"LBP":{"symbol":".ل.ل","rate":"1.00"},"EGP":{"symbol":"£","rate":"1.00"},"UYU":{"symbol":"$U","rate":"1.00"},"BOB":{"symbol":"$b","rate":"1.00"},"BMD":{"symbol":"BD$","rate":"1.00"},"SBD":{"symbol":"$","rate":"1.00"},"XCD":{"symbol":"$","rate":"1.00"},"LRD":{"symbol":"$","rate":"1.00"},"KYD":{"symbol":"$","rate":"1.00"},"GYD":{"symbol":"$","rate":"1.00"},"FJD":{"symbol":"$","rate":"1.00"},"COP":{"symbol":"$","rate":"1.00"},"CLP":{"symbol":"$","rate":"1.00"},"BSD":{"symbol":"$","rate":"1.00"},"BND":{"symbol":"$","rate":"1.00"},"BBD":{"symbol":"$","rate":"1.00"},"ARS":{"symbol":"$","rate":"1.00"},"NAD":{"symbol":"$","rate":"1.00"},"SRD":{"symbol":"$","rate":"1.00"},"BHD":{"symbol":".د.ب","rate":"1.00"},"AMD":{"symbol":"AMD","rate":"1.00"},"TRY":{"symbol":"₺","rate":"1.00"},"INR":{"symbol":"₹","rate":"1.00"},"IQD":{"symbol":"ع.د","rate":"1.00"},"ZMW":{"symbol":"ZK","rate":"1.00"},"BGN":{"symbol":"лв","rate":"1.00"}});
}

/***/ }),
/* 136 */
/* no static exports found */
/* all exports used */
/*!*************************************************************!*\
  !*** ./scripts/common/default-settings/colors-constants.js ***!
  \*************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// const WHITE_BLACK =  "#FFFFFF";
// const BLACK_WHITE =  "#000000";
// const PRIMERY_1 =  "#ED1C24";
// const PRIMERY_2 =  "#0088CB";
// const PRIMERY_3 =  "#FFCB05";
var COLOR_1 = exports.COLOR_1 = '#FFFFFF';
var COLOR_2 = exports.COLOR_2 = '#CCCCCC';
// const COLOR_3 =  "#A0A09F";
// const COLOR_4 =  "#605E5E";
var COLOR_5 = exports.COLOR_5 = '#2F2E2E';
// const COLOR_6 =  "#BAE9FF";
// const COLOR_7 =  "#97DEFF";
var COLOR_8 = exports.COLOR_8 = '#30BDFF';
// const COLOR_9 =  "#207EA9";
// const COLOR_10 =  "#103F54";
// const COLOR_11 =  "#B6E8E3";
// const COLOR_12 =  "#8DD1CA";
// const COLOR_13 =  "#41BAAE";
// const COLOR_14 =  "#2B7C74";
// const COLOR_15 =  "#163E3A";
// const COLOR_16 =  "#F4C0AF";
// const COLOR_17 =  "#E99F86";
// const COLOR_18 =  "#DE5021";
// const COLOR_19 =  "#943616";
// const COLOR_20 =  "#4A1B0B";
// const COLOR_21 =  "#F4EAB1";
// const COLOR_22 =  "#E9DB89";
// const COLOR_23 =  "#DEC328";
// const COLOR_24 =  "#94821B";
// const COLOR_25 =  "#4A410D";

/***/ }),
/* 137 */
/* no static exports found */
/* all exports used */
/*!***********************************************!*\
  !*** ./scripts/common/default-settings/v2.js ***!
  \***********************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultSettingsV2 = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _v2SettingsConstants = __webpack_require__(/*! ../parse-settings/v2-settings-constants.js */ 4);

var SETTINGS_CONSTANTS = _interopRequireWildcard(_v2SettingsConstants);

var _wixSdk = __webpack_require__(/*! ../wix-sdk */ 14);

var WixSdk = _interopRequireDefault(_wixSdk).default;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

// Default values from site created using blank template
var BODY_M_DEFAULT = 'font:normal normal normal 15px/1.4em din-next-w01-light,din-next-w02-light,din-next-w10-light,sans-serif;';
var BODY_L_DEFAULT = 'font:normal normal normal 17px/1.4em din-next-w01-light,din-next-w02-light,din-next-w10-light,sans-serif;';

var getFontValue = function getFontValue(_ref) {
  var fontFamily = _ref.fontFamily,
      lineHeight = _ref.lineHeight,
      size = _ref.size,
      weight = _ref.weight,
      style = _ref.style,
      value = _ref.value;

  var fallbackFonts = value.split(',').slice(1).join(',');
  return 'font:' + style + ' normal ' + weight + ' ' + size + '/' + lineHeight + ' ' + fontFamily + ',' + fallbackFonts;
};

var sitePresetFont = function sitePresetFont(fontName, defaultValue) {
  return function () {
    var fontDefaults = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return function () {
      var siteTextPresets = WixSdk && WixSdk.Styles ? WixSdk.Styles.getSiteTextPresets() : null;
      if (!siteTextPresets || !siteTextPresets[fontName]) {
        return defaultValue;
      }
      return getFontValue(_extends({}, siteTextPresets[fontName], fontDefaults));
    };
  };
};

var BODY_M = sitePresetFont('Body-M', BODY_M_DEFAULT);
var BODY_L = sitePresetFont('Body-L', BODY_L_DEFAULT);
// const WHITE_BLACK =  "#FFFFFF";
// const BLACK_WHITE =  "#000000";
// const PRIMERY_1 =  "#ED1C24";
// const PRIMERY_2 =  "#0088CB";
// const PRIMERY_3 =  "#FFCB05";
var COLOR_1 = '#FFFFFF';
var COLOR_2 = '#CCCCCC';
// const COLOR_3 =  "#A0A09F";
// const COLOR_4 =  "#605E5E";
var COLOR_5 = '#2F2E2E';
// const COLOR_6 =  "#BAE9FF";
// const COLOR_7 =  "#97DEFF";
var COLOR_8 = '#30BDFF';
// const COLOR_9 =  "#207EA9";
// const COLOR_10 =  "#103F54";
// const COLOR_11 =  "#B6E8E3";
// const COLOR_12 =  "#8DD1CA";
// const COLOR_13 =  "#41BAAE";
// const COLOR_14 =  "#2B7C74";
// const COLOR_15 =  "#163E3A";
// const COLOR_16 =  "#F4C0AF";
// const COLOR_17 =  "#E99F86";
// const COLOR_18 =  "#DE5021";
// const COLOR_19 =  "#943616";
// const COLOR_20 =  "#4A1B0B";
// const COLOR_21 =  "#F4EAB1";
// const COLOR_22 =  "#E9DB89";
// const COLOR_23 =  "#DEC328";
// const COLOR_24 =  "#94821B";
// const COLOR_25 =  "#4A410D";

var defaultSettingsV2 = Object.freeze({
  booleans: {
    albumCoverShow: true,
    trackListShow: true,
    albumShare: true,
    trackShare: true,
    autoplay: false
  },
  colors: {
    backgroundColor: { value: COLOR_1 },
    buyShareLinksColor: { value: COLOR_5 },
    trackTitleColor: { value: COLOR_5 },
    albumArtistColor: { value: COLOR_5 },
    controlBarColor: { value: COLOR_5 },
    trackColor: { value: COLOR_5 },
    dividersColor: { value: COLOR_2 },
    activeTrackColor: { value: COLOR_8 },
    borderColor: { value: COLOR_5 }
  },
  numbers: {
    layout: SETTINGS_CONSTANTS.LAYOUT_TYPES.VERTICAL,
    albumCoverScaling: SETTINGS_CONSTANTS.ALBUM_COVER_SCALING.FIT,
    horizontalAlbumCoverScaling: SETTINGS_CONSTANTS.HORIZONTAL_ALBUM_COVER_SCALING.SHOW,
    buttonStyle: SETTINGS_CONSTANTS.BUTTON_STYLES.RECT_TRANSPARENT,
    infoPlacement: SETTINGS_CONSTANTS.INFO_PLACEMENT.BELOW,
    controlBarType: SETTINGS_CONSTANTS.CONTROL_BAR_TYPE.CENTER,
    horizontalControlBarType: SETTINGS_CONSTANTS.HORIZONTAL_CONTROL_BAR_TYPE.MAXI,
    trackActionsShow: SETTINGS_CONSTANTS.TRACK_ACTIONS_SHOW.ON_ACTIVE,
    trackInfoShowArtistName: SETTINGS_CONSTANTS.TRACK_INFO_SHOW_ARTIST_NAME.NAME_ONLY,
    trackListMargins: 0,
    borderWidth: 0
  },
  fonts: {
    buyShareLinksFont: { value: BODY_M({ size: '16px' }) },
    activeTrackButtonsFont: { value: BODY_M({ size: '16px' }) },
    trackTitleFont: { value: BODY_L({ size: '22px' }) },
    albumArtistFont: { value: BODY_M({ size: '16px' }) },
    trackFont: { value: BODY_M({ size: '16px' }) }
  }
});

exports.defaultSettingsV2 = defaultSettingsV2;

/***/ }),
/* 138 */
/* no static exports found */
/* all exports used */
/*!***********************************************!*\
  !*** ./scripts/common/default-settings/v3.js ***!
  \***********************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultSettingsV3 = undefined;

var _v2SettingsConstants = __webpack_require__(/*! ../parse-settings/v2-settings-constants */ 4);

var BUTTON_STYLES = _v2SettingsConstants.BUTTON_STYLES;

var _colorsConstants = __webpack_require__(/*! ./colors-constants */ 136);

var COLOR_5 = _colorsConstants.COLOR_5;


var defaultSettingsV3 = Object.freeze({
  colors: { allTextColor: { value: COLOR_5 } },
  numbers: {
    buttonStyle: BUTTON_STYLES.RECT_TRANSPARENT
  }
});

exports.defaultSettingsV3 = defaultSettingsV3;

/***/ }),
/* 139 */
/* no static exports found */
/* all exports used */
/*!**************************************************************************************************!*\
  !*** ./scripts/player/v2/desktop/components/track-list/track/track-name/track-name.component.js ***!
  \**************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TrackName = undefined;

var _mithril = __webpack_require__(/*! mithril */ 0);

var m = _interopRequireDefault(_mithril).default;

var _trackName = __webpack_require__(/*! ./track-name.service */ 41);

var getTrackName = _trackName.getTrackName;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TrackName = {
  view: function view(ctrl, attrs) {
    var track = attrs.track,
        showArtist = attrs.showArtist;

    var trackName = getTrackName(track, showArtist);

    return {
      tag: 'div',
      children: [trackName],
      attrs: { className: 'track-name', title: trackName }
    };
  }
};

exports.TrackName = TrackName;

/***/ }),
/* 140 */
/* no static exports found */
/* all exports used */
/*!*********************************************!*\
  !*** ./scripts/player/v2/shared/app/app.js ***!
  \*********************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.App = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _uniqueId = __webpack_require__(/*! lodash/uniqueId */ 172);

var uniqueId = _interopRequireDefault(_uniqueId).default;

var _mithril = __webpack_require__(/*! mithril */ 0);

var m = _interopRequireDefault(_mithril).default;

var _appStatus = __webpack_require__(/*! ../../../../app-status/app-status */ 6);

var appStatus = _appStatus.appStatus;

var _v2SettingsConstants = __webpack_require__(/*! ../../../../common/parse-settings/v2-settings-constants */ 4);

var LAYOUT_TYPES = _v2SettingsConstants.LAYOUT_TYPES;

var _perfomance = __webpack_require__(/*! ../../../../utils/perfomance */ 11);

var pageLoadingTime = _perfomance.pageLoadingTime;

var _buyItem = __webpack_require__(/*! ../buy-item */ 42);

var openTrackInfoPage = _buyItem.openTrackInfoPage;

var _l10n = __webpack_require__(/*! ../l10n */ 1);

var setLocales = _l10n.setLocales;

var _albumModel = __webpack_require__(/*! ../models/album-model */ 70);

var Album = _albumModel.Album;

var _MediaSessionSupport = __webpack_require__(/*! ../models/MediaSessionSupport */ 154);

var MediaSessionSupport = _MediaSessionSupport.MediaSessionSupport;

var _playbackModel = __webpack_require__(/*! ../models/playback-model */ 155);

var Playback = _playbackModel.Playback;

var _playerApi = __webpack_require__(/*! ../models/player-api */ 45);

var PlayerApi = _playerApi.PlayerApi;

var _settingsModel = __webpack_require__(/*! ../models/settings-model */ 71);

var Settings = _settingsModel.Settings;

__webpack_require__(/*! ../styles/app.less */ 167);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function initTrackEvents(playerApi, playback, tracks) {
  playerApi.on('playbacktoggle.track', function (trackId) {
    var currentTrack = playback.currentTrack;
    if (currentTrack && currentTrack.id === trackId) {
      playback.togglePlay();
    } else {
      var track = tracks.find(function (track) {
        return track.id === trackId;
      });
      if (track) {
        playback.playTrack(track);
      }
    }
  });

  playerApi.on('playing.track', function (trackId) {
    var track = tracks.find(function (track) {
      return track.id === trackId;
    });
    if (track) {
      playback.playTrack(track);
    }
  });

  playerApi.on('timeupdate.track', function (currentTime) {
    playback.currentProgress(currentTime);
  });
}

var App = function () {
  function App(version) {
    _classCallCheck(this, App);

    this.playerApi = new PlayerApi();
    this.mediaSessionSupport = new MediaSessionSupport(this.playerApi);
    this.openSharedTrackPage = false;
    this.version = version;
  }

  _createClass(App, [{
    key: 'init',
    value: function init(options) {
      var _this = this;

      var domElement = options.domElement,
          rawSettings = options.settings,
          albumData = options.albumData,
          callback = options.callback;

      this.domElement = domElement;
      var models = this.initModels({ rawSettings: rawSettings, albumData: albumData, domElement: domElement });
      var album = models.album,
          settings = models.settings,
          playback = models.playback,
          playerApi = models.playerApi;

      setLocales(settings.l10n);

      this.addStyles(this.dynamicCss, this.className, settings);
      appStatus.step('styles-added');
      var comp = m.component(this.component, _extends({}, models, {
        config: function config() {
          requestAnimationFrame(function () {
            playerApi._triggerNextFrame();
          });
        }
      }));
      playerApi.onNextFrame(function () {
        return appStatus.step('app-rendered');
      });

      // TODO move to init. Moved cause it rendered first time without applied styles
      m.mount(domElement, comp);
      appStatus.step('app-mounted');

      // because track modal was not opening on track page modal on share track links.
      // See issue https://jira.wixpress.com/browse/MUS-345
      setTimeout(function () {
        var isCurrentTrackInited = _this.initCurrentTrack(settings, album, playback);
        if (!isCurrentTrackInited) {
          _this.initAutoPlay(settings, playback);
        }
      }, 0);
      this.initPreview(playback, playerApi);
      initTrackEvents(playerApi, playback, album.tracks);

      callback(playerApi);
      playerApi.statisticEvents.emit('playerStarted', {
        album: album,
        layout: settings.isMobileView ? LAYOUT_TYPES.MOBILE : settings.layout,
        loading_time: pageLoadingTime()
      });
      appStatus.step('internal-inited');
    }
  }, {
    key: 'initPreview',
    value: function initPreview(playback, playerApi) {
      playerApi.on('preview', function (isPreview) {
        playback.setPreview(isPreview);
        m.redraw();
      });
    }
  }, {
    key: 'initAutoPlay',
    value: function initAutoPlay(settings, playback) {
      if (settings.autoplay) {
        playback.autoplay();
      }
    }
  }, {
    key: 'initCurrentTrack',
    value: function initCurrentTrack(settings, album, playback) {
      var playerApi = this.playerApi;

      var sharedTrackId = settings.sharedTrackId;
      if (!sharedTrackId) {
        return false;
      }
      var sharedTrack = album.tracks.find(function (track) {
        return track.id === sharedTrackId;
      });
      if (!sharedTrack) {
        return false;
      }
      playback.autoplay(sharedTrack);
      if (this.openSharedTrackPage) {
        openTrackInfoPage(playerApi, settings, album, sharedTrackId);
      }
      return true;
    }
  }, {
    key: 'initModels',
    value: function initModels(_ref) {
      var rawSettings = _ref.rawSettings,
          albumData = _ref.albumData,
          domElement = _ref.domElement;
      var playerApi = this.playerApi,
          mediaSessionSupport = this.mediaSessionSupport;

      var settings = new Settings(rawSettings);
      var album = new Album(albumData, settings);
      var playback = new Playback(album, playerApi);
      playerApi.init({
        element: domElement,
        playback: playback,
        settings: settings,
        album: album,
        playerVersion: this.version
      });
      mediaSessionSupport.init({ settings: settings });

      return { album: album, settings: settings, playback: playback, playerApi: playerApi };
    }
  }, {
    key: 'addStyles',
    value: function addStyles(generators, additionalClassNames, settings) {
      var domElement = this.domElement;

      if (this.__appName) {
        domElement.classList.remove(this.__appName);
      }
      var appId = uniqueId();
      var appName = this.__appName = 'app-' + appId;

      // IE doesn't support multiple args to add
      domElement.classList.add('v2');
      domElement.classList.add('wix-pl-app');
      domElement.classList.add(additionalClassNames);
      domElement.classList.add(appName);
      var css = generators.reduce(function (result, generator) {
        return result + generator(_extends({}, settings.parsedCss, { appName: appName }));
      }, '');
      this.__setStyle(css, appId);
    }
  }, {
    key: '__setStyle',
    value: function __setStyle(cssText, appId) {
      var style = this.__styleNode;
      if (!style) {
        this.__styleNode = style = document.createElement('style');
        style.type = 'text/css';
        document.head.appendChild(style);
      }
      style.id = 'style-' + appId;
      if (style.styleSheet) {
        style.styleSheet.cssText = cssText;
      } else {
        style.innerHTML = cssText;
      }
    }
  }]);

  return App;
}();

exports.App = App;

/***/ }),
/* 141 */
/* no static exports found */
/* all exports used */
/*!**********************************************************************************!*\
  !*** ./scripts/player/v2/shared/components/album-cover/album-cover.component.js ***!
  \**********************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AlbumCover = undefined;

var _classnames = __webpack_require__(/*! classnames */ 3);

var classNames = _interopRequireDefault(_classnames).default;

var _mithril = __webpack_require__(/*! mithril */ 0);

var m = _interopRequireDefault(_mithril).default;

var _l10n = __webpack_require__(/*! ../../l10n */ 1);

var l10n = _l10n.l10n;

var _albumCover = __webpack_require__(/*! ./album-cover.controller */ 142);

var AlbumCoverController = _albumCover.AlbumCoverController;

__webpack_require__(/*! ./album-cover.less */ 159);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AlbumCover = {
  controller: AlbumCoverController,
  view: function view(ctrl, attrs, children) {
    var coverUrl = attrs.coverUrl,
        imageWidth = attrs.imageWidth,
        imageHeight = attrs.imageHeight,
        _attrs$shouldSetPropo = attrs.shouldSetProportion,
        shouldSetProportion = _attrs$shouldSetPropo === undefined ? true : _attrs$shouldSetPropo,
        _attrs$accName = attrs.accName,
        accName = _attrs$accName === undefined ? l10n('player_acc_album_cover') : _attrs$accName;

    var styles = {};

    if (coverUrl && ctrl.containerDimensions) {
      var _ctrl$getCoverInfo = ctrl.getCoverInfo({ coverUrl: coverUrl, imageWidth: imageWidth, imageHeight: imageHeight }),
          scaledImageUrl = _ctrl$getCoverInfo.scaledImageUrl;

      ctrl.checkImage(scaledImageUrl);
    }
    styles = getStyles();

    function config(element, isInitialized) {
      // when widget is not visible then element.offsetWidth is 0 and ctrl.initialize incorrectly calculates height and
      // tries to load image with zero dimensions (w_0,h_0) which fails
      if (isInitialized && !(element.offsetWidth && !ctrl.containerDimensions)) {
        return;
      }
      ctrl.initialize({ containerWidth: element.offsetWidth }).then(function () {
        Object.assign(element.style, getStyles()); // To prevent flickering
        m.redraw();
      });
    }

    function getStyles() {
      if (!coverUrl) {
        return {
          paddingTop: shouldSetProportion ? '100%' : 0
        };
      }

      var _ctrl$getCoverInfo2 = ctrl.getCoverInfo({ coverUrl: coverUrl, imageWidth: imageWidth, imageHeight: imageHeight }),
          scaledImageUrl = _ctrl$getCoverInfo2.scaledImageUrl,
          coverWidth = _ctrl$getCoverInfo2.coverWidth,
          coverHeight = _ctrl$getCoverInfo2.coverHeight;

      return {
        paddingTop: shouldSetProportion ? 100 * coverHeight / coverWidth + '%' : 0,
        // Composite properties should be set using one attribute.
        // For example: if you are setting background via expression and another prop, ie backgroundSize, on new
        // values flow will look like:
        // 1. mithril will update background property
        // 2. it will reset node's background size property to 'initial'
        // 3. cause background size is not changed it will not set previous value, and it will leave 'initial'
        background: 'url("' + scaledImageUrl + '") center center / ' + coverWidth + 'px ' + coverHeight + 'px no-repeat'
      };
    }

    var className = classNames('album-cover', {
      'album-cover_failed': ctrl.isFailed,
      'album-cover_dummy': !coverUrl
    });

    return {
      tag: 'div',
      children: [children],
      attrs: { className: className, style: styles, config: config, role: 'img', 'aria-label': accName }
    };
  }
};

exports.AlbumCover = AlbumCover;

/***/ }),
/* 142 */
/* no static exports found */
/* all exports used */
/*!***********************************************************************************!*\
  !*** ./scripts/player/v2/shared/components/album-cover/album-cover.controller.js ***!
  \***********************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AlbumCoverController = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _mithril = __webpack_require__(/*! mithril */ 0);

var m = _interopRequireDefault(_mithril).default;

var _utils = __webpack_require__(/*! ../../../../../utils/utils */ 2);

var utils = _utils.utils;

var _buildCoverDimensions = __webpack_require__(/*! ../../../../build-cover-dimensions */ 34);

var getContainerDimensions = _buildCoverDimensions.getContainerDimensions;
var getCoverDimensions = _buildCoverDimensions.getCoverDimensions;
var getScaledImageSize = _buildCoverDimensions.getScaledImageSize;

var _errors = __webpack_require__(/*! ../../errors */ 12);

var BI_ERRORS = _errors.BI_ERRORS;
var errorReporter = _errors.errorReporter;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AlbumCoverController = exports.AlbumCoverController = function () {
  function AlbumCoverController(_ref) {
    var imageResizeMode = _ref.imageResizeMode,
        coverUrl = _ref.coverUrl,
        imageWidth = _ref.imageWidth,
        imageHeight = _ref.imageHeight,
        pixelRatio = _ref.pixelRatio,
        onCoverReady = _ref.onCoverReady;

    _classCallCheck(this, AlbumCoverController);

    this.__checkedImages = new Set();
    this.imageResizeMode = imageResizeMode;
    this.firstCoverInfo = { coverUrl: coverUrl, imageWidth: imageWidth, imageHeight: imageHeight };
    this.pixelRatio = pixelRatio || 1;
    this.onCoverReady = onCoverReady;
  }

  _createClass(AlbumCoverController, [{
    key: 'checkImage',
    value: function checkImage(url) {
      var _this = this;

      if (this.__checkedImages.has(url)) {
        return;
      }
      this.isFailed = false;
      this.__checkedImages.add(url);
      utils.loadImage(url).catch(errorReporter.createPromiseErrorHandler(BI_ERRORS.widget.content.image.get)).catch(function () {
        _this.isFailed = true;
        m.redraw();
      });
    }
  }, {
    key: 'initialize',
    value: function initialize(_ref2) {
      var _this2 = this,
          _arguments = arguments;

      var containerWidth = _ref2.containerWidth;
      var imageResizeMode = this.imageResizeMode,
          firstCoverInfo = this.firstCoverInfo;
      var imageWidth = firstCoverInfo.imageWidth,
          imageHeight = firstCoverInfo.imageHeight,
          coverUrl = firstCoverInfo.coverUrl;

      if (coverUrl && !(imageHeight && imageWidth)) {
        errorReporter.report(BI_ERRORS.widget.content.image.noDimensions);
        return AlbumCoverController.__getImageDimensions(coverUrl).catch(function (reason) {
          _this2.onCoverReady(false);
          return Promise.reject(reason);
        }).then(function (dimensions) {
          Object.assign(firstCoverInfo, dimensions);
          return _this2.initialize.apply(_this2, _arguments);
        });
      }
      if (!coverUrl && !(imageHeight && imageWidth)) {
        // In ShoutOut containerWidth would be zero, so this would cause infinite recursion loop
        // And in the case when we don't have coverUrl we don't really care much about its actual size
        if (!containerWidth) {
          this.containerDimensions = {};
          requestAnimationFrame(function () {
            return _this2.onCoverReady(true);
          });
          return Promise.resolve(this.containerDimensions);
        }
        Object.assign(firstCoverInfo, {
          imageWidth: containerWidth,
          imageHeight: containerWidth
        });
        return this.initialize.apply(this, arguments);
      }
      this.containerDimensions = getContainerDimensions({ mode: imageResizeMode, containerWidth: containerWidth, imageWidth: imageWidth, imageHeight: imageHeight });
      requestAnimationFrame(function () {
        return _this2.onCoverReady(true);
      });
      return Promise.resolve(this.containerDimensions);
    }
  }, {
    key: 'getCoverInfo',
    value: function getCoverInfo(_ref3) {
      var coverUrl = _ref3.coverUrl,
          imageWidth = _ref3.imageWidth,
          imageHeight = _ref3.imageHeight;
      var pixelRatio = this.pixelRatio;

      var imageDimensions = { imageWidth: imageWidth, imageHeight: imageHeight };
      var coverDimensions = getCoverDimensions(_extends({}, this.containerDimensions, imageDimensions));
      var scaledDimensions = getScaledImageSize(_extends({}, imageDimensions, coverDimensions, { pixelRatio: pixelRatio }));
      var scaledImageUrl = utils.buildScaledImageUrl(coverUrl, 'fill', scaledDimensions.coverWidthScaled, scaledDimensions.coverHeightScaled);
      return _extends({
        scaledImageUrl: scaledImageUrl
      }, coverDimensions);
    }
  }], [{
    key: '__getImageDimensions',
    value: function __getImageDimensions(coverUrl) {
      return utils.loadImage(coverUrl).then(function (image) {
        var width = image.width,
            height = image.height;

        return {
          imageWidth: width,
          imageHeight: height
        };
      });
    }
  }]);

  return AlbumCoverController;
}();

/***/ }),
/* 143 */
/* no static exports found */
/* all exports used */
/*!******************************************************************************!*\
  !*** ./scripts/player/v2/shared/components/audio-player/_audio-component.js ***!
  \******************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Audio = undefined;

var _mithril = __webpack_require__(/*! mithril */ 0);

var m = _interopRequireDefault(_mithril).default;

var _errors = __webpack_require__(/*! ../../errors */ 12);

var BI_ERRORS = _errors.BI_ERRORS;
var errorReporter = _errors.errorReporter;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Audio = {
  view: function view(ctrl, attrs) {
    var volume = attrs.volume,
        isPlaying = attrs.isPlaying,
        currentProgress = attrs.currentProgress,
        onTimeUpdate = attrs.onTimeUpdate,
        _attrs$onProgress = attrs.onProgress,
        onProgress = _attrs$onProgress === undefined ? function () {} : _attrs$onProgress,
        onEnded = attrs.onEnded,
        onNetworkError = attrs.onNetworkError;


    var setCurrentTime = function setCurrentTime(el) {
      if (Math.abs(el.currentTime - currentProgress) < 1) {
        return;
      }
      try {
        el.currentTime = currentProgress;
      } catch (err) {
        //expected
      }
    };

    var onError = function onError(event) {
      var el = event.target;
      /* codes
       1 = MEDIA_ERR_ABORTED - fetching process aborted by user
       2 = MEDIA_ERR_NETWORK - error occurred when downloading
       3 = MEDIA_ERR_DECODE - error occurred when decoding
       4 = MEDIA_ERR_SRC_NOT_SUPPORTED - audio/video not supported
       */
      if (el.src === location.href) {
        return;
      }
      if (el.error && el.error.code > 1) {
        if (el.error.code === 2) {
          onNetworkError();
        }
        errorReporter.report(BI_ERRORS.widget.content.audio.get);
      }
    };

    var config = function config(element) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      if (attrs.config) {
        attrs.config.apply(attrs, [element].concat(args));
      }
      if (isPlaying) {
        setCurrentTime(element);
      }
    };

    return {
      tag: 'audio',
      attrs: {
        preload: 'auto',
        volume: volume,
        ontimeupdate: onTimeUpdate,
        onprogress: onProgress,
        onended: onEnded,
        onplaying: attrs.onPlaying,
        onpause: attrs.onPause,
        onerror: onError,
        title: attrs.title,
        config: config
      }
    };
  }
};

exports.Audio = Audio;

/***/ }),
/* 144 */
/* no static exports found */
/* all exports used */
/*!******************************************************************************!*\
  !*** ./scripts/player/v2/shared/components/buy-album/buy-album.component.js ***!
  \******************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BuyAlbum = undefined;

var _classnames = __webpack_require__(/*! classnames */ 3);

var classNames = _interopRequireDefault(_classnames).default;

var _mithril = __webpack_require__(/*! mithril */ 0);

var m = _interopRequireDefault(_mithril).default;

var _l10n = __webpack_require__(/*! ../../l10n */ 1);

var l10n = _l10n.l10n;

var _price = __webpack_require__(/*! ../price */ 43);

var formatPrice = _price.formatPrice;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BuyAlbum = {
  view: function view(ctrl, attrs) {
    var defaultBuyTextKey = 'player_buy_album';
    var defaultDownloadTextKey = 'player_download_album';
    var defaultGetTextKey = 'player_get_album';
    var album = attrs.album,
        isDisabled = attrs.isDisabled,
        buy = attrs.buy,
        price = attrs.price,
        currency = attrs.currency,
        currencySymbol = attrs.currencySymbol,
        isFree = attrs.isFree,
        className = attrs.className,
        _attrs$hasExternalLin = attrs.hasExternalLinks,
        hasExternalLinks = _attrs$hasExternalLin === undefined ? false : _attrs$hasExternalLin,
        _attrs$isDownloadable = attrs.isDownloadable,
        isDownloadable = _attrs$isDownloadable === undefined ? true : _attrs$isDownloadable,
        _attrs$buyTextKey = attrs.buyTextKey,
        buyTextKey = _attrs$buyTextKey === undefined ? defaultBuyTextKey : _attrs$buyTextKey,
        _attrs$downloadTextKe = attrs.downloadTextKey,
        downloadTextKey = _attrs$downloadTextKe === undefined ? defaultDownloadTextKey : _attrs$downloadTextKe,
        _attrs$getTextKey = attrs.getTextKey,
        getTextKey = _attrs$getTextKey === undefined ? defaultGetTextKey : _attrs$getTextKey;


    var buttonClassName = classNames('buy', className);

    if (hasExternalLinks) {
      return {
        tag: 'button',
        children: [l10n(getTextKey)],
        attrs: {
          className: buttonClassName,
          onclick: buy,
          disabled: isDisabled,
          'aria-label': album.name + ' ' + l10n(getTextKey)
        }
      };
    }

    if (!isDownloadable) {
      return {
        tag: 'span'
      };
    }
    if (isFree) {
      return {
        tag: 'button',
        children: [l10n(downloadTextKey)],
        attrs: {
          className: buttonClassName,
          onclick: buy,
          disabled: isDisabled,
          'aria-label': album.name + ' ' + l10n(downloadTextKey)
        }
      };
    }

    var formattedPrice = formatPrice(price, currency, currencySymbol);

    return {
      tag: 'button',
      children: [{
        tag: 'span',
        children: [l10n(buyTextKey), ' ', formattedPrice]
      }],
      attrs: {
        className: buttonClassName,
        onclick: buy,
        disabled: isDisabled,
        'aria-label': album.name + ' ' + l10n('player_acc_buy_album', [price + ' ' + currency])
      }
    };
  }
};

exports.BuyAlbum = BuyAlbum;

/***/ }),
/* 145 */
/* no static exports found */
/* all exports used */
/*!****************************************************************************!*\
  !*** ./scripts/player/v2/shared/components/buy-item/buy-item.component.js ***!
  \****************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BuyItem = undefined;

var _classnames = __webpack_require__(/*! classnames */ 3);

var classNames = _interopRequireDefault(_classnames).default;

var _mithril = __webpack_require__(/*! mithril */ 0);

var m = _interopRequireDefault(_mithril).default;

__webpack_require__(/*! ./buy-item.less */ 160);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BuyItem = {
  view: function view(ctrl, attrs, children) {
    var buy = attrs.buy,
        isDisabled = attrs.isDisabled,
        className = attrs.className,
        accName = attrs.accName;

    var handleClick = function handleClick(event) {
      event.stopPropagation();
      buy();
    };
    return {
      tag: 'button',
      children: [children],
      attrs: {
        className: classNames('buy-item', className),
        'aria-label': accName,
        onclick: handleClick,
        disabled: isDisabled
      }
    };
  }
};

exports.BuyItem = BuyItem;

/***/ }),
/* 146 */
/* no static exports found */
/* all exports used */
/*!***************************************************************!*\
  !*** ./scripts/player/v2/shared/components/buy-item/index.js ***!
  \***************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _buyItem = __webpack_require__(/*! ./buy-item.component */ 145);

Object.defineProperty(exports, 'BuyItem', {
  enumerable: true,
  get: function get() {
    return _buyItem.BuyItem;
  }
});

/***/ }),
/* 147 */
/* no static exports found */
/* all exports used */
/*!**************************************************************************************!*\
  !*** ./scripts/player/v2/shared/components/buy-share-actions/buy-share.component.js ***!
  \**************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BuyShareActions = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _translationsKeys;

var _mithril = __webpack_require__(/*! mithril */ 0);

var m = _interopRequireDefault(_mithril).default;

var _constants = __webpack_require__(/*! ../../../../../common/constants */ 5);

var constants = _interopRequireDefault(_constants).default;

var _buyAlbum = __webpack_require__(/*! ../buy-album */ 29);

var BuyAlbum = _buyAlbum.BuyAlbum;

var _l10n = __webpack_require__(/*! ../../l10n */ 1);

var l10n = _l10n.l10n;

var _translationKeys = __webpack_require__(/*! ../../translation-keys */ 10);

var registerTranslationKeys = _translationKeys.registerTranslationKeys;

__webpack_require__(/*! ./buy-share-actions.less */ 161);

var _buyShare = __webpack_require__(/*! ./buy-share.controller */ 57);

var BuyShareController = _buyShare.BuyShareController;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var translationsKeys = (_translationsKeys = {}, _defineProperty(_translationsKeys, constants.ALBUM_TYPES.ALBUM, {
  buyButton: 'player_buy_album',
  downloadButton: 'player_download_album',
  getButton: 'player_get_album',
  shareButton: 'player_share_album'
}), _defineProperty(_translationsKeys, constants.ALBUM_TYPES.SINGLE, {
  buyButton: 'player_buy_single',
  downloadButton: 'player_download_single',
  getButton: 'player_get_single',
  shareButton: 'player_share_single'
}), _defineProperty(_translationsKeys, constants.ALBUM_TYPES.PLAYLIST, {
  buyButton: 'player_buy_album',
  downloadButton: 'player_download_album',
  shareButton: 'player_share_playlist'
}), _translationsKeys);

registerTranslationKeys(translationsKeys);

var BuyShareActions = {
  controller: BuyShareController,

  view: function view(ctrl, attrs) {
    var album = ctrl.album;
    var isDisabled = attrs.isDisabled,
        canShare = attrs.canShare,
        onShare = attrs.onShare,
        ShareAlbum = attrs.ShareAlbum,
        _attrs$shareAlbumAttr = attrs.shareAlbumAttrs,
        shareAlbumAttrs = _attrs$shareAlbumAttr === undefined ? {} : _attrs$shareAlbumAttr,
        _attrs$buyAlbumClass = attrs.buyAlbumClass,
        buyAlbumClass = _attrs$buyAlbumClass === undefined ? '' : _attrs$buyAlbumClass,
        albumTranslationKeys = attrs.albumTranslationKeys,
        _attrs$buyTextKey = attrs.buyTextKey,
        buyTextKey = _attrs$buyTextKey === undefined ? albumTranslationKeys.buyButton : _attrs$buyTextKey;
    var albumPriceFormatted = album.albumPriceFormatted,
        currency = album.currency,
        currencySymbol = album.currencySymbol;

    var className = ['buy-share', isDisabled ? 'buy-share_disabled' : ''].join(' ');

    var shareButton = m.component(ShareAlbum, _extends({}, shareAlbumAttrs, {
      accName: l10n(albumTranslationKeys.shareButton) + ' ' + album.name,
      shareItem: album,
      isDisabled: isDisabled,
      onShare: onShare
    }), [l10n(albumTranslationKeys.shareButton)]);

    return {
      tag: 'div',
      children: [{
        tag: 'div',
        children: [m.component(BuyAlbum, {
          album: album,
          className: buyAlbumClass,
          buy: attrs.buyAlbum,
          buyTextKey: buyTextKey,
          downloadTextKey: albumTranslationKeys.downloadButton,
          getTextKey: albumTranslationKeys.getButton,
          hasExternalLinks: album.externalLinks && album.externalLinks.length,
          isDisabled: isDisabled,
          price: albumPriceFormatted,
          currency: currency,
          currencySymbol: currencySymbol,
          isFree: ctrl.isFree(),
          isDownloadable: ctrl.canBuy()
        }, [])],
        attrs: { className: 'buy-wrapper' }
      }, {
        tag: 'div',
        children: [canShare ? shareButton : null],
        attrs: { className: 'share-wrapper' }
      }],
      attrs: { className: className }
    };
  }
};

exports.BuyShareActions = BuyShareActions;

/***/ }),
/* 148 */
/* no static exports found */
/* all exports used */
/*!******************************************************************************!*\
  !*** ./scripts/player/v2/shared/components/buy-track/buy-track.component.js ***!
  \******************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BuyTrack = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _mithril = __webpack_require__(/*! mithril */ 0);

var m = _interopRequireDefault(_mithril).default;

var _l10n = __webpack_require__(/*! ../../l10n */ 1);

var l10n = _l10n.l10n;

var _buyItem = __webpack_require__(/*! ../buy-item */ 146);

var BuyItem = _buyItem.BuyItem;

var _price = __webpack_require__(/*! ../price */ 43);

var formatPrice = _price.formatPrice;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BuyTrackController = function () {
  function BuyTrackController(_ref) {
    var track = _ref.track,
        isFree = _ref.isFree,
        freeText = _ref.freeText;

    _classCallCheck(this, BuyTrackController);

    this.track = track;
    this.isFreeProp = isFree;
    this.freeText = freeText;
  }

  _createClass(BuyTrackController, [{
    key: 'isFree',
    value: function isFree() {
      var track = this.track,
          isFreeProp = this.isFreeProp;

      return isFreeProp || track && track.purchaseAvail && !track.trackPrice;
    }
  }]);

  return BuyTrackController;
}();

var BuyTrack = {
  controller: BuyTrackController,
  view: function view(ctrl, attrs, children) {
    if (attrs.freeText && !attrs.freeAccText) {
      throw new Error('Free text must have ally text');
    }

    if (attrs.buyText && !attrs.buyAccText) {
      throw new Error('Buy text must have ally text');
    }
    var isFree = attrs.isFree,
        track = attrs.track,
        _buy = attrs.buy,
        _attrs$freeText = attrs.freeText,
        freeText = _attrs$freeText === undefined ? l10n('player_download_track') : _attrs$freeText,
        _attrs$freeAccText = attrs.freeAccText,
        freeAccText = _attrs$freeAccText === undefined ? l10n('player_download_track') : _attrs$freeAccText,
        className = attrs.className,
        isDisabled = attrs.isDisabled,
        hasExternalLinks = attrs.hasExternalLinks,
        _attrs$buyText = attrs.buyText,
        buyText = _attrs$buyText === undefined ? function (price) {
      return price;
    } : _attrs$buyText,
        _attrs$buyAccText = attrs.buyAccText,
        buyAccText = _attrs$buyAccText === undefined ? function (price) {
      return l10n('player_acc_buy_track', [price]);
    } : _attrs$buyAccText;

    ctrl.track = track;
    // TODO: why do we have it as prop and calc in controller?
    ctrl.isFreeProp = isFree;
    ctrl.freeText = freeText;
    // I love mithril
    var shouldRenderChildren = Boolean(children && children.length && children[0].split());

    var price = formatPrice(track.trackPriceFormatted, track.currency, track.currencySymbol);

    var content = void 0;
    var accName = void 0;
    if (shouldRenderChildren) {
      content = '\xA0';
    } else if (hasExternalLinks) {
      content = l10n('player_get_track');
      accName = l10n('player_get_track');
    } else if (ctrl.isFree()) {
      content = freeText;
      accName = freeAccText;
    } else {
      content = buyText(price);
      accName = buyAccText(price);
    }

    return m.component(BuyItem, { className: className, isDisabled: isDisabled, accName: accName, buy: function buy() {
        return _buy(track.id);
      } }, [{
      tag: 'span',
      children: [content],
      attrs: { classname: track.currency.toUpperCase() }
    }]);
  }
};

exports.BuyTrack = BuyTrack;

/***/ }),
/* 149 */
/* no static exports found */
/* all exports used */
/*!************************************************************************************!*\
  !*** ./scripts/player/v2/shared/components/progress-bar/progress-bar.component.js ***!
  \************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProgressBar = undefined;

var _mithril = __webpack_require__(/*! mithril */ 0);

var m = _interopRequireDefault(_mithril).default;

var _utils = __webpack_require__(/*! ../../../../../utils/utils */ 2);

var utils = _utils.utils;

var _l10n = __webpack_require__(/*! ../../l10n */ 1);

var l10n = _l10n.l10n;

__webpack_require__(/*! ./progress-bar.less */ 162);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProgressBar = {
  view: function view(ctrl, attrs, children) {
    var played = attrs.played,
        duration = attrs.duration,
        shouldAriaHide = attrs.shouldAriaHide;

    var playedText = utils.durationToString(played);
    var durationText = utils.durationToString(duration);
    var accDuration = function accDuration(duration) {
      return utils.durationToAccString(duration);
    };

    return {
      tag: 'div',
      children: [{
        tag: 'div',
        children: [{
          tag: 'span',
          children: [playedText],
          attrs: { 'aria-hidden': 'true' }
        }, {
          tag: 'span',
          children: [l10n('player_acc_track_played', [accDuration(played)])],
          attrs: { className: 'sr-only' }
        }],
        attrs: { className: 'progress-bar__played' }
      }, {
        tag: 'div',
        children: [children],
        attrs: { className: 'progress-bar__slider' }
      }, {
        tag: 'div',
        children: ['\xA0/\xA0'],
        attrs: { className: 'progress-bar__duration-slash', 'aria-hidden': 'true' }
      }, {
        tag: 'div',
        children: [{
          tag: 'span',
          children: [durationText],
          attrs: { 'aria-hidden': 'true' }
        }, {
          tag: 'span',
          children: [l10n('player_acc_track_duration', [accDuration(duration)])],
          attrs: { className: 'sr-only' }
        }],
        attrs: { className: 'progress-bar__duration' }
      }],
      attrs: { className: 'progress-bar', 'aria-hidden': shouldAriaHide }
    };
  }
};

exports.ProgressBar = ProgressBar;

/***/ }),
/* 150 */
/* no static exports found */
/* all exports used */
/*!******************************************************************!*\
  !*** ./scripts/player/v2/shared/components/scroll-area/index.js ***!
  \******************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _scrollArea = __webpack_require__(/*! ./scroll-area.component */ 151);

Object.defineProperty(exports, 'ScrollArea', {
  enumerable: true,
  get: function get() {
    return _scrollArea.ScrollArea;
  }
});

/***/ }),
/* 151 */
/* no static exports found */
/* all exports used */
/*!**********************************************************************************!*\
  !*** ./scripts/player/v2/shared/components/scroll-area/scroll-area.component.js ***!
  \**********************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ScrollArea = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _mithril = __webpack_require__(/*! mithril */ 0);

var m = _interopRequireDefault(_mithril).default;

var _utils = __webpack_require__(/*! ../../../../../utils/utils */ 2);

var utils = _utils.utils;

__webpack_require__(/*! ./scroll-area.less */ 163);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ScrollAreaController = function () {
  function ScrollAreaController() {
    _classCallCheck(this, ScrollAreaController);
  }

  _createClass(ScrollAreaController, [{
    key: 'contructor',
    value: function contructor() {
      this.isScrolled = false;
    }
  }]);

  return ScrollAreaController;
}();

var ScrollArea = {
  controller: ScrollAreaController,
  view: function view(ctrl, attrs, children) {
    var idAttr = attrs.id,
        className = attrs.className,
        initialScrollTo = attrs.initialScrollTo,
        tabindex = attrs.tabindex;

    var initScroll = function initScroll(el, isInitialized) {
      requestAnimationFrame(function () {
        var height = utils.isFunction(attrs.height) ? attrs.height(el) : attrs.height;
        var shouldScroll = !ctrl.isScrolled && utils.isFunction(initialScrollTo);

        if (height) {
          el.style.height = height + 'px';
        }

        if (shouldScroll) {
          initialScrollTo(el);
          ctrl.isScrolled = true;
        }

        if (isInitialized) {
          return;
        }

        el.children[0].classList.add('scroll-area__content');
      });
    };

    var scrollAreaClassName = ['scroll-area', className || ''].join(' ');

    return {
      tag: 'div',
      children: [children],
      attrs: { className: scrollAreaClassName, id: idAttr, tabindex: tabindex, config: initScroll }
    };
  }
};

exports.ScrollArea = ScrollArea;

/***/ }),
/* 152 */
/* no static exports found */
/* all exports used */
/*!********************************************************************!*\
  !*** ./scripts/player/v2/shared/components/slider/slider.model.js ***!
  \********************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SliderModel = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _mithril = __webpack_require__(/*! mithril */ 0);

var m = _interopRequireDefault(_mithril).default;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SliderModel = exports.SliderModel = function () {
  function SliderModel() {
    _classCallCheck(this, SliderModel);

    this.isDragging = m.prop(false);
    this.draggingProgress = m.prop(null);
  }

  _createClass(SliderModel, [{
    key: 'startDragging',
    value: function startDragging(progress) {
      this.isDragging(true);
      this.draggingProgress(progress);
    }
  }, {
    key: 'drag',
    value: function drag(progress) {
      this.draggingProgress(progress);
    }
  }, {
    key: 'stopDragging',
    value: function stopDragging() {
      this.isDragging(false);
      this.draggingProgress(null);
    }
  }]);

  return SliderModel;
}();

/***/ }),
/* 153 */
/* no static exports found */
/* all exports used */
/*!************************************************************************************!*\
  !*** ./scripts/player/v2/shared/components/track-button-like/track-button-like.js ***!
  \************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TrackButtonLike = undefined;

var _mithril = __webpack_require__(/*! mithril */ 0);

var m = _interopRequireDefault(_mithril).default;

__webpack_require__(/*! ./track-button-like.less */ 165);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Screen readers skip all other buttons inside button, so making this group clickable and accessible
var TrackButtonLike = exports.TrackButtonLike = {
  view: function view(ctrl, attrs, children) {
    var onActivation = attrs.onActivation,
        ariaLabel = attrs.ariaLabel;

    var handleKeyUp = function handleKeyUp( /** KeyboardEvent */event) {
      // Handle actions only on subscribed element
      if (event.currentTarget !== event.target) {
        return;
      }

      if (event.code === 'Space' || event.keyCode === 32) {
        event.preventDefault();
        onActivation();
      }
    };

    var handleKeyDown = function handleKeyDown( /** KeyboardEvent */event) {
      if (event.currentTarget !== event.target) {
        return;
      }
      // The action button is activated by space on the keyup event, but the
      // default action for space is already triggered on keydown. It needs to be
      // prevented to stop scrolling the page before activating the button.
      if (event.code === 'Space' || event.keyCode === 32) {
        event.preventDefault();
      }
      // If enter is pressed, activate the button
      else if (event.code === 'Enter' || event.keyCode === 13) {
          event.preventDefault();
          onActivation();
        }
    };

    return {
      tag: 'div',
      children: [children],
      attrs: {
        className: 'track-button',
        tabindex: '0',
        onclick: function onclick() {
          return onActivation();
        },
        'aria-label': ariaLabel,
        onkeyup: handleKeyUp,
        onkeydown: handleKeyDown
      }
    };
  }
};

/***/ }),
/* 154 */
/* no static exports found */
/* all exports used */
/*!****************************************************************!*\
  !*** ./scripts/player/v2/shared/models/MediaSessionSupport.js ***!
  \****************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MediaSessionSupport = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _media = __webpack_require__(/*! @wix/music-shared/dist/src/utils/media/media */ 170);

var getResizedImageUrl = _media.getResizedImageUrl;

var _errors = __webpack_require__(/*! ../errors */ 12);

var BI_ERRORS = _errors.BI_ERRORS;
var errorReporter = _errors.errorReporter;

var _playerApi = __webpack_require__(/*! ./player-api */ 45);

var PlayerApi = _playerApi.PlayerApi;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MediaSessionSupport = exports.MediaSessionSupport = function () {
  function MediaSessionSupport(playerApi) {
    _classCallCheck(this, MediaSessionSupport);

    /** @type PlayerApi*/
    this.playerApi = playerApi;
    this.mediaSession = window && window.navigator.mediaSession;
    this.MediaMetadata = window && window.MediaMetadata;
  }

  _createClass(MediaSessionSupport, [{
    key: 'init',
    value: function init(_ref) {
      var _this = this;

      var settings = _ref.settings;

      this.settings = settings;

      if (!(this.mediaSession && this.MediaMetadata !== undefined)) {
        return;
      }
      this.updateMetaData();
      this.mediaSession.setActionHandler('play', function () {
        _this.playerApi.play();
      });
      this.mediaSession.setActionHandler('pause', function () {
        _this.playerApi.pause();
      });

      if (this.playerApi.album.tracks.length > 1) {
        this.mediaSession.setActionHandler('nexttrack', function () {
          _this.playerApi.next();
        });
        this.mediaSession.setActionHandler('previoustrack', function () {
          _this.playerApi.previous();
        });
      }

      try {
        this.mediaSession.setActionHandler('seekto', function (event) {
          var time = event.seekTime;
          _this.playerApi.updateCurrentTime(time);
        });
      } catch (error) {
        console.log('Warning! The "seekto" media session action is not supported.');
      }

      this.playerApi.on('playing', function () {
        _this.mediaSession.playbackState = 'playing';
      });

      this.playerApi.on('pause', function () {
        _this.mediaSession.playbackState = 'paused';
      });

      this.playerApi.playback.on('play', function () {
        _this.updateMetaData();
      });

      this.playerApi.on('timeupdate', function (currentTime, a, b, c, duration) {
        _this.updateMetaData();
        _this.updatePositionState({ currentTime: currentTime, duration: duration });
      });
    }
  }, {
    key: 'updateMetaData',
    value: function updateMetaData() {
      try {
        var currentTrack = this.playerApi.currentTrack;
        var item = currentTrack || this.playerApi.album;

        if (this.updatedFor === item) {
          return;
        }
        this.updatedFor = item;
        var coverDetails = this.playerApi.playback.getCoverDetails();

        var shouldShowArtwork = coverDetails.coverUrl && this.settings.albumCoverShow;

        this.mediaSession.metadata = new this.MediaMetadata({
          title: item.name,
          album: this.playerApi.album.name,
          artist: item.artistName,
          artwork: shouldShowArtwork ? this._getArtwork(coverDetails) : undefined
        });
      } catch (reason) {
        console.error(reason);
        errorReporter.report(BI_ERRORS.widget.mediaSession, { reason: reason });
      }
    }
  }, {
    key: '_getArtwork',
    value: function _getArtwork(_ref2) {
      var coverUrl = _ref2.coverUrl,
          imageWidth = _ref2.imageWidth,
          imageHeight = _ref2.imageHeight;

      var sizes = [128, 256, 384, 512, 1024, 1536, 2048, 3072, 4096];
      var ext = coverUrl.split('.').pop();
      var isJpeg = ext === 'jpg' || ext === 'jpeg';
      var type = isJpeg ? 'image/jpeg' : 'image/png';
      var coverUrlNormalized = isJpeg ? coverUrl : coverUrl.replace('.' + ext, '.png');

      return sizes.filter(function (size) {
        return size <= imageHeight && size <= imageWidth;
      }).map(function (size) {
        return {
          src: getResizedImageUrl(coverUrlNormalized, size),
          sizes: size + 'x' + size,
          type: type
        };
      });
    }
  }, {
    key: 'updatePositionState',
    value: function updatePositionState(_ref3) {
      var currentTime = _ref3.currentTime,
          duration = _ref3.duration;

      if ('setPositionState' in navigator.mediaSession) {
        try {
          if (Number.isNaN(duration)) {
            return;
          }
          navigator.mediaSession.setPositionState({
            duration: duration,
            playbackRate: 1,
            position: currentTime
          });
        } catch (reason) {
          console.error(reason);
          errorReporter.report(BI_ERRORS.widget.mediaSession, { reason: reason });
        }
      }
    }
  }]);

  return MediaSessionSupport;
}();

/***/ }),
/* 155 */
/* no static exports found */
/* all exports used */
/*!***********************************************************!*\
  !*** ./scripts/player/v2/shared/models/playback-model.js ***!
  \***********************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Playback = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _events = __webpack_require__(/*! events */ 8);

var EventEmitter = _interopRequireDefault(_events).default;

var _mithril = __webpack_require__(/*! mithril */ 0);

var m = _interopRequireDefault(_mithril).default;

var _assert = __webpack_require__(/*! ../../../../utils/assert */ 35);

var assert = _assert.assert;

var _utils = __webpack_require__(/*! ../../../../utils/utils */ 2);

var utils = _utils.utils;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Preview = function () {
  function Preview() {
    _classCallCheck(this, Preview);

    this.isPreview = false;
  }

  _createClass(Preview, null, [{
    key: 'create',
    value: function create() {
      if (!Preview.instance) {
        Preview.instance = new Preview();
      }
      return Preview.instance;
    }
  }]);

  return Preview;
}();

var isPlayingKey = Symbol('isPlaying');
var currentTrackKey = Symbol('currentTrack');
var currentOriginKey = Symbol('currentOrigin');

var Playback = exports.Playback = function (_EventEmitter) {
  _inherits(Playback, _EventEmitter);

  function Playback(album, playerApi) {
    _classCallCheck(this, Playback);

    var _this = _possibleConstructorReturn(this, (Playback.__proto__ || Object.getPrototypeOf(Playback)).call(this));

    _this.album = album;
    _this.playerApi = playerApi;
    _this.volume = m.prop(1);
    _this.isPlaying = false;
    _this.currentTrack = null;
    _this.currentOrigin = 'widget';
    _this.hasAutoplay = false;
    _this.currentProgress = m.prop(0);
    _this.loadedProgress = m.prop(0);
    _this.preview = Preview.create();
    _this.hasPlayed = false;
    if (_this.preview.isPreview) {
      _this.currentTrack = _this.getFirstTrack();
    }
    return _this;
  }

  _createClass(Playback, [{
    key: 'getCurrentAudioUrl',
    value: function getCurrentAudioUrl() {
      var currentTrack = this.currentTrack || this.getFirstTrack();
      return currentTrack ? currentTrack.url : null;
    }
  }, {
    key: 'getFirstTrack',
    value: function getFirstTrack() {
      var tracks = this.tracks;

      return tracks.length ? tracks[0] : null;
    }
  }, {
    key: 'getCurrentTitle',
    value: function getCurrentTitle() {
      var track = this.currentTrack || this.getFirstTrack();
      if (!track) {
        return '';
      }
      return track.artistName + ' - ' + track.name;
    }
  }, {
    key: 'setCurrent',
    value: function setCurrent(track) {
      this.currentProgress(0);
      this.currentTrack = track;
      this.emit('setUrl', { src: this.getCurrentAudioUrl() });
    }
  }, {
    key: 'autoplay',
    value: function autoplay(track) {
      if (track) {
        this.currentTrack = track;
      }
      this.hasAutoplay = true;
      this.play();
    }
  }, {
    key: 'play',
    value: function play() {
      var tracks = this.tracks;

      if (!tracks.length) {
        return;
      }
      if (!this.currentTrack) {
        this.setCurrent(tracks[0]);
      }
      this._emitPlayCurrent();
    }
  }, {
    key: 'pause',
    value: function pause() {
      var currentTrack = this.currentTrack;

      this.emit('pause', { track: currentTrack });
    }
  }, {
    key: 'togglePlay',
    value: function togglePlay() {
      return this.isPlaying ? this.pause() : this.play();
    }
  }, {
    key: 'mute',
    value: function mute() {
      this.previosVoule = this.volume();
      this.volume(0);
      this.muted = true;
    }
  }, {
    key: 'unmute',
    value: function unmute() {
      this.volume(this.previosVoule);
      this.muted = false;
    }
  }, {
    key: 'toggleMute',
    value: function toggleMute() {
      this.muted ? this.unmute() : this.mute();
    }
  }, {
    key: 'playTrack',
    value: function playTrack(track) {
      if (this.currentTrack !== track) {
        this.setCurrent(track);
      }
      this.play();
    }
  }, {
    key: 'playNext',
    value: function playNext() {
      this._navigateFromCurrentTrack(1);
    }
  }, {
    key: 'playPrev',
    value: function playPrev() {
      this._navigateFromCurrentTrack(-1);
    }
  }, {
    key: 'emitPlayError',
    value: function emitPlayError() {
      var playerApi = this.playerApi;

      playerApi.emit('player.error');
    }
  }, {
    key: 'currentDuration',
    value: function currentDuration() {
      var currentTrack = this.currentTrack || this.getFirstTrack();
      if (!currentTrack) {
        return null;
      }
      var durationString = currentTrack.isPreview ? currentTrack.previewDuration : currentTrack.duration;
      return utils.stringToDuration(durationString);
    }
  }, {
    key: 'updateProgress',
    value: function updateProgress(progress) {
      if (!this.currentTrack) {
        this.play();
      }
      this.currentProgress(Math.max(0, Math.min(progress, this.currentDuration())));
    }
  }, {
    key: 'setPreview',
    value: function setPreview(isPreview) {
      var firstTrack = this.getFirstTrack();
      this.preview.isPreview = isPreview;
      this.currentTrack = isPreview ? firstTrack : null;
    }
  }, {
    key: 'currentTrackIndex',
    value: function currentTrackIndex() {
      var tracks = this.tracks;

      if (!tracks || !tracks.length) {
        return null;
      }
      var track = this.currentTrack || this.getFirstTrack();
      return tracks.indexOf(track);
    }
  }, {
    key: '_navigateFromCurrentTrack',
    value: function _navigateFromCurrentTrack(jumpSize) {
      var currentTrack = this.currentTrack || this.getFirstTrack();
      var tracks = this.tracks;

      if (!currentTrack) {
        return;
      }
      var currentTrackIndex = tracks.indexOf(currentTrack);
      assert(currentTrackIndex !== -1, 'current track is not in track list');

      var prevTrackIndex = utils.mod(currentTrackIndex + jumpSize, tracks.length);
      this.setCurrent(tracks[prevTrackIndex]);
      if (this.isPlaying) {
        this._emitPlayCurrent();
      }
    }
  }, {
    key: '_emitPlayCurrent',
    value: function _emitPlayCurrent() {
      this.emit('play', { track: this.currentTrack });
    }
  }, {
    key: 'getCoverDetails',
    value: function getCoverDetails() {
      var currentTrack = this.currentTrack;
      var item = currentTrack && currentTrack.cover ? currentTrack : this.album;
      return {
        coverUrl: item.cover,
        imageWidth: item.imageWidth,
        imageHeight: item.imageHeight
      };
    }
  }, {
    key: 'isPlaying',
    get: function get() {
      return this[isPlayingKey];
    },
    set: function set(value) {
      var playerApi = this.playerApi,
          currentTrack = this.currentTrack;

      value = Boolean(value);
      var shouldUpdate = this[isPlayingKey] !== value;
      this[isPlayingKey] = value;
      if (value) {
        this.hasPlayed = true;
      }
      if (!shouldUpdate) {
        return;
      }

      if (!currentTrack) {
        return;
      }
      playerApi.emit(value ? 'playing' : 'pause', currentTrack.id);
    }
  }, {
    key: 'currentTrack',
    get: function get() {
      return this[currentTrackKey];
    },
    set: function set(track) {
      var shouldUpdate = this[currentTrackKey] !== track;
      this[currentTrackKey] = track;
      if (shouldUpdate) {
        this.emit('trackChange', { track: track });
      }
    }
  }, {
    key: 'currentOrigin',
    get: function get() {
      return this[currentOriginKey];
    },
    set: function set(value) {
      this[currentOriginKey] = value;
    }
  }, {
    key: 'tracks',
    get: function get() {
      return this.album.tracks;
    }
  }]);

  return Playback;
}(EventEmitter);

/***/ }),
/* 156 */
/* no static exports found */
/* all exports used */
/*!*********************************!*\
  !*** ./scripts/utils/colors.js ***!
  \*********************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.colorToRGBA = colorToRGBA;
exports.makeRGBA = makeRGBA;
exports.isLight = isLight;
exports.lighten = lighten;
exports.darken = darken;

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* eslint-disable */
var percentToNumber = function percentToNumber(percent) {
  return parseInt(percent, 10) / 100;
};
var makeNumber = function makeNumber(value) {
  return typeof value === 'string' && value[value.length - 1] === '%' ? percentToNumber(value) : Number(value);
};
var normalizeHue = function normalizeHue(h) {
  return h > 1 ? h / 360 : h;
};

function colorToRGBA(color) {
  var rgba = void 0;

  if (color.indexOf('hsl') === 0) {
    var _color$match = color.match(/^hsla?\((.+?),(.+?),(.+?)(?:,(.+?))?\)$/i),
        _color$match2 = _slicedToArray(_color$match, 5),
        h = _color$match2[1],
        s = _color$match2[2],
        l = _color$match2[3],
        _color$match2$ = _color$match2[4],
        a = _color$match2$ === undefined ? 1 : _color$match2$;

    var rgb = hslToRgb(normalizeHue(h), makeNumber(s), makeNumber(l));
    return [].concat(_toConsumableArray(rgb), [a]);
  }

  if (color.charAt(0) === '#') {
    color = color.slice(1);
  }

  if (color.length === 6) {
    rgba = color.match(/../g).map(function (pair) {
      return parseInt(pair, 16);
    });
    rgba.push(1);
    return rgba;
  }

  if (color.length === 3) {
    rgba = color.match(/./g).map(function (pair) {
      return parseInt(pair + pair, 16);
    });
    rgba.push(1);
    return rgba;
  }

  rgba = color.replace(/^rgba?\(/, '').replace(/\)$/, '').split(',').map(function (value) {
    return Number(value);
  });

  if (rgba.length === 3) {
    rgba.push(1);
  }

  return rgba;
}

function makeRGBA(color, opacity) {
  var colorRGBA = colorToRGBA(color);
  colorRGBA[3] = typeof opacity === 'function' ? opacity(colorRGBA[3]) : opacity;
  return 'rgba(' + colorRGBA.join(',') + ')';
}

/**
 * Converts an HSL color value to RGB. Conversion formula
 * adapted from http://en.wikipedia.org/wiki/HSL_color_space.
 * Assumes h, s, and l are contained in the set [0, 1] and
 * returns r, g, and b in the set [0, 255].
 *
 * @param   {number}  h       The hue
 * @param   {number}  s       The saturation
 * @param   {number}  l       The lightness
 * @return  {Array}           The RGB representation
 */
function hslToRgb(h, s, l) {
  var r = void 0,
      g = void 0,
      b = void 0;

  if (s == 0) {
    r = g = b = l; // achromatic
  } else {
    var hue2rgb = function hue2rgb(p, q, t) {
      if (t < 0) {
        t += 1;
      }
      if (t > 1) {
        t -= 1;
      }
      if (t < 1 / 6) {
        return p + (q - p) * 6 * t;
      }
      if (t < 1 / 2) {
        return q;
      }
      if (t < 2 / 3) {
        return p + (q - p) * (2 / 3 - t) * 6;
      }
      return p;
    };

    var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
    var p = 2 * l - q;
    r = hue2rgb(p, q, h + 1 / 3);
    g = hue2rgb(p, q, h);
    b = hue2rgb(p, q, h - 1 / 3);
  }

  return [Math.round(r * 255), Math.round(g * 255), Math.round(b * 255)];
}

/**
 * Converts an RGB color value to HSL. Conversion formula
 * adapted from http://en.wikipedia.org/wiki/HSL_color_space.
 * Assumes r, g, and b are contained in the set [0, 255] and
 * returns h, s, and l in the set [0, 1].
 *
 * @param   {number}  r       The red color value
 * @param   {number}  g       The green color value
 * @param   {number}  b       The blue color value
 * @return  {Array}           The HSL representation
 */
function rgbToHsl(r, g, b) {
  r /= 255;
  g /= 255;
  b /= 255;
  var max = Math.max(r, g, b),
      min = Math.min(r, g, b);
  var h = void 0,
      s = void 0,
      l = (max + min) / 2;

  if (max == min) {
    h = s = 0; // achromatic
  } else {
    var d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    switch (max) {
      case r:
        h = (g - b) / d + (g < b ? 6 : 0);
        break;
      case g:
        h = (b - r) / d + 2;
        break;
      case b:
        h = (r - g) / d + 4;
        break;
    }
    h /= 6;
  }

  return [h, s, l];
}

function isLight(color) {
  var _colorToRGBA = colorToRGBA(color),
      _colorToRGBA2 = _slicedToArray(_colorToRGBA, 3),
      r = _colorToRGBA2[0],
      g = _colorToRGBA2[1],
      b = _colorToRGBA2[2];

  var _rgbToHsl = rgbToHsl(r, g, b),
      _rgbToHsl2 = _slicedToArray(_rgbToHsl, 3),
      lightness = _rgbToHsl2[2];

  return lightness > 0.25;
}

function lightenDarken(color, percent) {
  var _colorToRGBA3 = colorToRGBA(color),
      _colorToRGBA4 = _slicedToArray(_colorToRGBA3, 3),
      r = _colorToRGBA4[0],
      g = _colorToRGBA4[1],
      b = _colorToRGBA4[2];

  var _rgbToHsl3 = rgbToHsl(r, g, b),
      _rgbToHsl4 = _slicedToArray(_rgbToHsl3, 3),
      h = _rgbToHsl4[0],
      s = _rgbToHsl4[1],
      l = _rgbToHsl4[2];

  return 'rgb(' + hslToRgb(h, s, (1 - l) * percent / 100).join(',') + ')';
}

function lighten(color, percent) {
  return lightenDarken(color, percent);
}

function darken(color, percent) {
  return lightenDarken(color, -percent);
}

/***/ }),
/* 157 */
/* no static exports found */
/* all exports used */
/*!*********************************!*\
  !*** ./scripts/utils/cookie.js ***!
  \*********************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = __webpack_require__(/*! ./utils */ 2);

var utils = _utils.utils;


var cookie = {
  get: function get(name) {
    return utils.getUrlParam(name, document.cookie, ';');
  }
};

exports.default = cookie;

/***/ }),
/* 158 */
/* no static exports found */
/* all exports used */
/*!*********************************!*\
  !*** ./scripts/utils/events.js ***!
  \*********************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var events = {
  on: function on(_events, handler) {
    var handlers = this.handlers = this.handlers || {};

    _events.trim().split(/\s+/).forEach(function (event) {
      if (!handlers[event]) {
        handlers[event] = [];
      }

      handlers[event].push(handler);
    });
  },
  off: function off(event, handler) {
    var handlers = this.handlers = this.handlers || {};

    if (!handlers[event]) {
      return;
    }

    if (!handler) {
      delete handlers[event];
      return;
    }

    handlers[event].forEach(function (_handler, i) {
      if (handler === _handler) {
        handlers[event].splice(i, 1);
      }
    });
  },
  removeAllListeners: function removeAllListeners(eventName) {
    var handlers = this.handlers = this.handlers || {};
    if (eventName) {
      delete handlers[eventName];
      return;
    }
    this.handlers = {};
  },
  once: function once(_events, handler) {
    handler.once = true;
    this.on(_events, handler);
  },
  emit: function emit(event) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var handlers = this.handlers = this.handlers || {};

    if (!handlers[event]) {
      return;
    }

    var node = this;

    handlers[event].forEach(function (handler, i) {
      handler.apply(node, args);

      if (handler.once) {
        handlers[event].splice(i, 1);
      }
    });
  },
  moveEvents: function moveEvents(_events, destination) {
    var origin = this;
    var handlers = origin.handlers || {};

    _events.trim().split(/\s+/).forEach(function (event) {
      if (!handlers[event]) {
        return;
      }

      handlers[event].forEach(function (handler) {
        destination.on(event, handler);
      });
      origin.off(event);
    });
  }
};

var Events = exports.Events = function Events() {
  _classCallCheck(this, Events);
};

Events.prototype = _extends({}, events, Events.prototype);

exports.default = events;

/***/ }),
/* 159 */
/* no static exports found */
/* all exports used */
/*!**************************************************************************!*\
  !*** ./scripts/player/v2/shared/components/album-cover/album-cover.less ***!
  \**************************************************************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 160 */
/* no static exports found */
/* all exports used */
/*!********************************************************************!*\
  !*** ./scripts/player/v2/shared/components/buy-item/buy-item.less ***!
  \********************************************************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 161 */
/* no static exports found */
/* all exports used */
/*!**************************************************************************************!*\
  !*** ./scripts/player/v2/shared/components/buy-share-actions/buy-share-actions.less ***!
  \**************************************************************************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 162 */
/* no static exports found */
/* all exports used */
/*!****************************************************************************!*\
  !*** ./scripts/player/v2/shared/components/progress-bar/progress-bar.less ***!
  \****************************************************************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 163 */
/* no static exports found */
/* all exports used */
/*!**************************************************************************!*\
  !*** ./scripts/player/v2/shared/components/scroll-area/scroll-area.less ***!
  \**************************************************************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 164 */
/* no static exports found */
/* all exports used */
/*!****************************************************************!*\
  !*** ./scripts/player/v2/shared/components/slider/slider.less ***!
  \****************************************************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 165 */
/* no static exports found */
/* all exports used */
/*!**************************************************************************************!*\
  !*** ./scripts/player/v2/shared/components/track-button-like/track-button-like.less ***!
  \**************************************************************************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 166 */
/* no static exports found */
/* all exports used */
/*!************************************************************************!*\
  !*** ./scripts/player/v2/shared/components/track-list/track-list.less ***!
  \************************************************************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 167 */
/* no static exports found */
/* all exports used */
/*!**************************************************!*\
  !*** ./scripts/player/v2/shared/styles/app.less ***!
  \**************************************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 168 */
/* no static exports found */
/* all exports used */
/*!***********************************!*\
  !*** ./l10n ^\.\/texts_.*\.json$ ***!
  \***********************************/
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./texts_ar.json": 100,
	"./texts_bg.json": 101,
	"./texts_ca.json": 102,
	"./texts_cs.json": 103,
	"./texts_da.json": 104,
	"./texts_de.json": 105,
	"./texts_el.json": 106,
	"./texts_en.json": 38,
	"./texts_es.json": 107,
	"./texts_fi.json": 108,
	"./texts_fr.json": 109,
	"./texts_he.json": 110,
	"./texts_hi.json": 111,
	"./texts_hu.json": 112,
	"./texts_id.json": 113,
	"./texts_it.json": 114,
	"./texts_ja.json": 115,
	"./texts_ko.json": 116,
	"./texts_lt.json": 117,
	"./texts_ms.json": 118,
	"./texts_nl.json": 119,
	"./texts_no.json": 120,
	"./texts_pl.json": 121,
	"./texts_pt.json": 122,
	"./texts_ro.json": 123,
	"./texts_ru.json": 124,
	"./texts_sk.json": 125,
	"./texts_sl.json": 126,
	"./texts_sv.json": 127,
	"./texts_th.json": 128,
	"./texts_tl.json": 129,
	"./texts_tr.json": 130,
	"./texts_uk.json": 131,
	"./texts_vi.json": 132,
	"./texts_zh.json": 133
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 168;

/***/ }),
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */
/* no static exports found */
/* all exports used */
/*!*********************************************!*\
  !*** ./scripts/common/parse-settings/v3.js ***!
  \*********************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.parseSettingsV3 = parseSettingsV3;

var _deepFreeze = __webpack_require__(/*! deep-freeze */ 54);

var deepFreeze = _interopRequireDefault(_deepFreeze).default;

var _utils = __webpack_require__(/*! ../../utils/utils */ 2);

var utils = _utils.utils;

var _defaultSettings = __webpack_require__(/*! ../default-settings */ 53);

var defaultSettingsV3 = _defaultSettings.defaultSettingsV3;

var _v = __webpack_require__(/*! ./v2 */ 33);

var parseSettingsV2 = _v.parseSettingsV2;

var _v2SettingsConstants = __webpack_require__(/*! ./v2-settings-constants */ 4);

var LAYOUT_TYPES = _v2SettingsConstants.LAYOUT_TYPES;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function parseSettingsV3(widgetSettings) {
  var allTextColor = widgetSettings.colors.allTextColor || widgetSettings.colors.trackColor || defaultSettingsV3.colors.allTextColor;
  var layout = widgetSettings.numbers.layout;
  var isListLayout = layout === LAYOUT_TYPES.LIST;
  var albumArtistFont = isListLayout ? widgetSettings.fonts.listAlbumArtistFont : widgetSettings.fonts.albumArtistFont;
  var trackTitleFont = isListLayout ? widgetSettings.fonts.listTrackTitleFont : widgetSettings.fonts.trackTitleFont;

  widgetSettings.colors = _extends({}, widgetSettings.colors, {
    trackColor: allTextColor,
    trackTitleColor: allTextColor,
    albumArtistColor: allTextColor,
    buyShareLinksColor: allTextColor
  });

  widgetSettings.fonts = _extends({}, widgetSettings.fonts, {
    albumArtistFont: albumArtistFont,
    trackTitleFont: trackTitleFont
  });

  var settingsV3 = parseSettingsV2(widgetSettings);
  var buttonStyle = widgetSettings.numbers.buttonStyle !== undefined ? widgetSettings.numbers.buttonStyle : defaultSettingsV3.numbers.buttonStyle;

  settingsV3 = utils.merge({}, settingsV3, { buttonStyle: buttonStyle });

  return deepFreeze(settingsV3);
}

/***/ }),
/* 175 */
/* no static exports found */
/* all exports used */
/*!**********************************************************!*\
  !*** ./scripts/player/v2/desktop/styles/desktop-v2.less ***!
  \**********************************************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 176 */,
/* 177 */,
/* 178 */
/* no static exports found */
/* all exports used */
/*!**********************************************************************************************************!*\
  !*** ./scripts/player/v2/shared/components/share-icons/share-icon-button/share-icon-button.component.js ***!
  \**********************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ShareIconButton = undefined;

var _mithril = __webpack_require__(/*! mithril */ 0);

var m = _interopRequireDefault(_mithril).default;

var _classnames = __webpack_require__(/*! classnames */ 3);

var classNames = _interopRequireDefault(_classnames).default;

var _shareIconButton = __webpack_require__(/*! ./share-icon-button.controller */ 179);

var ShareIconButtonController = _shareIconButton.ShareIconButtonController;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ShareIconButton = exports.ShareIconButton = {
  controller: ShareIconButtonController,

  view: function view(ctrl, attrs, children) {
    function config(element, isInitialized, context) {
      if (isInitialized) {
        return;
      }

      function onStart() {
        element.classList.add('active');
        try {
          window.navigator.vibrate(200);
        } catch (o_O) {
          // do nothing
        }
      }

      function onEnd() {
        element.classList.remove('active');
      }

      function onKeyPress() {
        ctrl.enableFocus();
      }

      function isMouseEvent(event) {
        return event.detail === 1;
      }

      function onClick(event) {
        if (isMouseEvent(event)) {
          /*
          Because of requirements:
            1. ally: keeping focus on last focused element after modal window closes,
            2. We need to show focus state only when user interacts with keyboard.
          We need to disable focus outline if user interacts with button by mouse.
          And return default behaviour when user navigates with keyboard
          */
          ctrl.disableFocus();
        }
      }

      element.addEventListener('touchstart', onStart);
      element.addEventListener('touchend', onEnd);
      element.addEventListener('click', onClick);
      document.addEventListener('keydown', onKeyPress);

      context.onunload = function () {
        element.removeEventListener('touchstart', onStart);
        element.removeEventListener('touchend', onEnd);
        element.removeEventListener('click', onClick);
        document.removeEventListener('keydown', onKeyPress);
      };
    }

    var buttonClassName = classNames(attrs.className, {
      'focus-disabled': ctrl.isFocusDisabled
    });

    return {
      tag: 'button',
      children: [children],
      attrs: { type: 'button', className: buttonClassName, 'aria-label': attrs.title, onclick: attrs.onclick, config: config }
    };
  }
};

/***/ }),
/* 179 */
/* no static exports found */
/* all exports used */
/*!***********************************************************************************************************!*\
  !*** ./scripts/player/v2/shared/components/share-icons/share-icon-button/share-icon-button.controller.js ***!
  \***********************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ShareIconButtonController = exports.ShareIconButtonController = function () {
  function ShareIconButtonController() {
    _classCallCheck(this, ShareIconButtonController);

    this.isFocusDisabled = false;
  }

  _createClass(ShareIconButtonController, [{
    key: "disableFocus",
    value: function disableFocus() {
      this.isFocusDisabled = true;
    }
  }, {
    key: "enableFocus",
    value: function enableFocus() {
      this.isFocusDisabled = false;
    }
  }]);

  return ShareIconButtonController;
}();

/***/ }),
/* 180 */
/* no static exports found */
/* all exports used */
/*!**********************************************************************************!*\
  !*** ./scripts/player/v2/shared/components/share-icons/share-icons.component.js ***!
  \**********************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ShareIcons = undefined;

var _mithril = __webpack_require__(/*! mithril */ 0);

var m = _interopRequireDefault(_mithril).default;

var _l10n = __webpack_require__(/*! ../../l10n */ 1);

var l10n = _l10n.l10n;

var _blogger = __webpack_require__(/*! ./icons/blogger.svg */ 183);

var bloggerIconDefault = _interopRequireDefault(_blogger).default;

var _facebook = __webpack_require__(/*! ./icons/facebook.svg */ 184);

var facebookIconDefault = _interopRequireDefault(_facebook).default;

var _tumblr = __webpack_require__(/*! ./icons/tumblr.svg */ 185);

var tumblerIconDefault = _interopRequireDefault(_tumblr).default;

var _twitter = __webpack_require__(/*! ./icons/twitter.svg */ 186);

var twitterIconDefault = _interopRequireDefault(_twitter).default;

var _shareIconButton = __webpack_require__(/*! ./share-icon-button/share-icon-button.component */ 178);

var ShareIconButton = _shareIconButton.ShareIconButton;

__webpack_require__(/*! ./share-icons.less */ 181);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ShareIcons = {
  view: function view(ctrl, attrs) {
    var share = function share(network) {
      return function (event) {
        event.stopPropagation();
        if (attrs.onShare) {
          attrs.onShare(network);
        }
      };
    };

    var _attrs$facebookIcon = attrs.facebookIcon,
        facebookIcon = _attrs$facebookIcon === undefined ? facebookIconDefault : _attrs$facebookIcon,
        _attrs$twitterIcon = attrs.twitterIcon,
        twitterIcon = _attrs$twitterIcon === undefined ? twitterIconDefault : _attrs$twitterIcon,
        _attrs$tumblerIcon = attrs.tumblerIcon,
        tumblerIcon = _attrs$tumblerIcon === undefined ? tumblerIconDefault : _attrs$tumblerIcon,
        _attrs$bloggerIcon = attrs.bloggerIcon,
        bloggerIcon = _attrs$bloggerIcon === undefined ? bloggerIconDefault : _attrs$bloggerIcon,
        _attrs$shouldFocusFir = attrs.shouldFocusFirst,
        shouldFocusFirst = _attrs$shouldFocusFir === undefined ? false : _attrs$shouldFocusFir,
        _attrs$onFocusFirst = attrs.onFocusFirst,
        onFocusFirst = _attrs$onFocusFirst === undefined ? function () {} : _attrs$onFocusFirst,
        className = attrs.className;

    var shareIconsClassName = 'share-icons ' + (className || '');

    var config = function config(element) {
      if (shouldFocusFirst) {
        element.querySelector('button').focus();
        onFocusFirst();
      }
    };
    return {
      tag: 'span',
      children: [m.component(ShareIconButton, {
        className: 'share-button share-facebook',
        title: l10n('player_acc_share_on_facebook'),
        onclick: share('facebook')
      }, [{
        tag: 'span',
        children: [m.trust(facebookIcon)],
        attrs: { className: 'share-button_icon', 'aria-hidden': 'true' }
      }]), m.component(ShareIconButton, {
        className: 'share-button share-twitter',
        title: l10n('player_acc_share_on_twitter'),
        onclick: share('twitter')
      }, [{
        tag: 'span',
        children: [m.trust(twitterIcon)],
        attrs: { className: 'share-button_icon', 'aria-hidden': 'true' }
      }]), m.component(ShareIconButton, {
        className: 'share-button share-tumblr',
        title: l10n('player_acc_share_on_tumblr'),
        onclick: share('tumblr')
      }, [{
        tag: 'span',
        children: [m.trust(tumblerIcon)],
        attrs: { className: 'share-button_icon', 'aria-hidden': 'true' }
      }]), m.component(ShareIconButton, {
        className: 'share-button share-blogger',
        title: l10n('player_acc_share_on_blogger'),
        onclick: share('blogger')
      }, [{
        tag: 'span',
        children: [m.trust(bloggerIcon)],
        attrs: { className: 'share-button_icon', 'aria-hidden': 'true' }
      }])],
      attrs: { className: shareIconsClassName, config: config }
    };
  }
};

exports.ShareIcons = ShareIcons;

/***/ }),
/* 181 */
/* no static exports found */
/* all exports used */
/*!**************************************************************************!*\
  !*** ./scripts/player/v2/shared/components/share-icons/share-icons.less ***!
  \**************************************************************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 182 */
/* no static exports found */
/* all exports used */
/*!*****************************************************!*\
  !*** ./scripts/player/v2/modals/shared/icons/x.svg ***!
  \*****************************************************/
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" x=\"0px\" y=\"0px\" viewBox=\"0 0 20 20\" xml:space=\"preserve\"><path d=\"M10.7,10l7.1-7.1c0.2-0.2,0.2-0.5,0-0.7l0,0c-0.2-0.2-0.5-0.2-0.7,0L10,9.3L2.9,2.2C2.7,2,2.4,2,2.2,2.2l0,0 C2,2.4,2,2.7,2.2,2.9L9.3,10l-7.1,7.1c-0.2,0.2-0.2,0.5,0,0.7l0,0c0.2,0.2,0.5,0.2,0.7,0l7.1-7.1l7.1,7.1c0.2,0.2,0.5,0.2,0.7,0 l0,0c0.2-0.2,0.2-0.5,0-0.7L10.7,10z\"></path></svg>"

/***/ }),
/* 183 */
/* no static exports found */
/* all exports used */
/*!***************************************************************************!*\
  !*** ./scripts/player/v2/shared/components/share-icons/icons/blogger.svg ***!
  \***************************************************************************/
/***/ (function(module, exports) {

module.exports = "<svg width=\"49px\" height=\"49px\" viewBox=\"0 0 49 49\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\"><g id=\"Page-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"blogger-icon\" fill-rule=\"nonzero\" fill=\"#000000\"><path d=\"M48.279,20.151 L47.873,19.311 L47.193,18.78 C46.306,18.085 41.818,18.825 40.609,17.727 C39.752,16.938 39.619,15.516 39.359,13.596 C38.879,9.862 38.572,9.67 37.99,8.41 C35.877,3.922 30.142,0.547 26.203,0.078 L15.531,0.078 C7.136,0.078 0.274,6.955 0.274,15.349 L0.274,33.162 C0.274,41.541 7.136,48.404 15.531,48.404 L33.065,48.404 C41.46,48.404 48.28,41.541 48.327,33.162 L48.421,20.824 L48.279,20.151 Z M15.726,12.559 L24.187,12.559 C25.8,12.559 27.109,13.87 27.109,15.469 C27.109,17.065 25.8,18.391 24.187,18.391 L15.726,18.391 C14.111,18.391 12.803,17.065 12.803,15.469 C12.803,13.87 14.111,12.559 15.726,12.559 Z M32.918,35.845 L15.726,35.845 C14.111,35.845 12.803,34.517 12.803,32.939 C12.803,31.337 14.111,30.033 15.726,30.033 L32.918,30.033 C34.523,30.033 35.824,31.338 35.824,32.939 C35.824,34.517 34.523,35.845 32.918,35.845 Z\" id=\"Shape\"></path></g></g></svg>"

/***/ }),
/* 184 */
/* no static exports found */
/* all exports used */
/*!****************************************************************************!*\
  !*** ./scripts/player/v2/shared/components/share-icons/icons/facebook.svg ***!
  \****************************************************************************/
/***/ (function(module, exports) {

module.exports = "<svg width=\"22px\" height=\"48px\" viewBox=\"0 0 22 48\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\"><g id=\"Page-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"facebook-icon-svg\" transform=\"translate(-1.000000, 0.000000)\" fill-rule=\"nonzero\" fill=\"#000000\"><path d=\"M23,15.5426206 L15.5075731,15.5426206 L15.5075731,10.5607949 C15.5075731,8.68987787 16.7306664,8.25369489 17.592124,8.25369489 C18.4516215,8.25369489 22.8794547,8.25369489 22.8794547,8.25369489 L22.8794547,0.0288139102 L15.597737,0 C7.51434426,0 5.67480399,6.13438212 5.67480399,10.060029 L5.67480399,15.5426206 L1,15.5426206 L1,24.0178845 L5.67480399,24.0178845 C5.67480399,34.8946388 5.67480399,48 5.67480399,48 L15.5075731,48 C15.5075731,48 15.5075731,34.765473 15.5075731,24.0178845 L22.1424626,24.0178845 L23,15.5426206 Z\" id=\"Shape\"></path></g></g></svg>"

/***/ }),
/* 185 */
/* no static exports found */
/* all exports used */
/*!**************************************************************************!*\
  !*** ./scripts/player/v2/shared/components/share-icons/icons/tumblr.svg ***!
  \**************************************************************************/
/***/ (function(module, exports) {

module.exports = "<svg width=\"32px\" height=\"50px\" viewBox=\"0 0 32 50\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\"><g id=\"Page-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><path d=\"M18.2135144,0.188 L18.2135144,11.569 L29.5925144,11.569 L29.5925144,20.357 L18.2135144,20.357 L18.2135144,32.976 C18.2135144,35.831 18.1785144,37.478 18.4795144,38.287 C18.7805144,39.092 19.5345144,39.928 20.3545144,40.41 C21.4465144,41.064 22.6865144,41.39 24.0885144,41.39 C26.5805144,41.39 29.0595144,40.581 31.5245144,38.962 L31.5245144,46.722 C29.4245144,47.712 27.5185144,48.41 25.8135144,48.806 C24.1065144,49.202 22.2645144,49.406 20.2825144,49.406 C18.0325144,49.406 16.7045144,49.121 14.9775144,48.556 C13.2475144,47.984 11.7725144,47.171 10.5535144,46.126 C9.32851444,45.073 8.48551444,43.954 8.01351444,42.771 C7.54051444,41.585 7.30451444,39.867 7.30451444,37.617 L7.30451444,20.357 L0.618514436,20.357 L0.618514436,13.386 C2.55151444,12.759 4.79251444,11.859 6.16851444,10.687 C7.55051444,9.511 8.65651444,8.105 9.48851444,6.46 C10.3265144,4.819 10.9005144,2.726 11.2155144,0.189 L18.2135144,0.189 L18.2135144,0.188 Z\" id=\"Shape\" fill=\"#000000\" fill-rule=\"nonzero\"></path></g></svg>"

/***/ }),
/* 186 */
/* no static exports found */
/* all exports used */
/*!***************************************************************************!*\
  !*** ./scripts/player/v2/shared/components/share-icons/icons/twitter.svg ***!
  \***************************************************************************/
/***/ (function(module, exports) {

module.exports = "<svg width=\"61px\" height=\"49px\" viewBox=\"0 0 61 49\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\"><g id=\"Page-1\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><path d=\"M60.2934856,5.79985363 C58.0763768,6.78473213 55.6919599,7.44931399 53.1885792,7.74745789 C55.743364,6.21757332 57.7040641,3.79362419 58.627992,0.903611027 C56.237578,2.32175284 53.5913672,3.35142635 50.7729526,3.90659087 C48.517046,1.50246905 45.3018406,0 41.7443082,0 C34.9129452,0 29.3743959,5.53867174 29.3743959,12.3700347 C29.3743959,13.3393696 29.4836908,14.2830024 29.6946925,15.1883269 C19.4139905,14.6731842 10.298571,9.74891409 4.19763611,2.26435157 C3.13320362,4.09066658 2.52308565,6.21524789 2.52308565,8.48314879 C2.52308565,12.7745362 4.7067817,16.5604498 8.02589689,18.7793944 C5.99873863,18.7142825 4.09054419,18.158506 2.42321478,17.2315184 C2.42211326,17.2829225 2.42211326,17.3349386 2.42211326,17.3881786 C2.42211326,23.3804305 6.68608517,28.3799709 12.3454342,29.5172259 C11.3073157,29.7993366 10.2143662,29.9511011 9.0860457,29.9511011 C8.2881803,29.9511011 7.51369153,29.873995 6.75829572,29.7288395 C8.33309771,34.6429512 12.9012107,38.2196989 18.313208,38.3194474 C14.0797114,41.6374611 8.74653372,43.6149287 2.95035181,43.6149287 C1.9523775,43.6149287 0.968110961,43.5556915 0,43.4422353 C5.47527332,46.9525249 11.9766708,49 18.9621238,49 C41.7155464,49 54.1566902,30.1507205 54.1566902,13.8042097 C54.1566902,13.2687501 54.1459198,12.7339025 54.1220536,12.2038281 C56.5381697,10.4600044 58.6363146,8.28120403 60.2934856,5.79985363 Z\" id=\"Shape\" fill=\"#000000\" fill-rule=\"nonzero\"></path></g></svg>"

/***/ }),
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */
/* no static exports found */
/* all exports used */
/*!***************************************************!*\
  !*** ./styles/v3/desktop-wiring-v3.settings.less ***!
  \***************************************************/
/***/ (function(module, exports) {

module.exports =  function buildCss(settings) {
  var css = ".--appName--.desktop.v3 .app .track {\n  height: auto;\n}\n.--appName--.desktop.v3 .app.app_layout_vertical.app_preview .control-bar__controls,\n.--appName--.desktop.v3 .app.app_layout_horizontal.app_preview .control-bar__controls {\n  border-color: --activeTrackColor--;\n}\n.--appName--.desktop.v3 .app.app_layout_vertical.app_preview .control-bar__controls svg path,\n.--appName--.desktop.v3 .app.app_layout_horizontal.app_preview .control-bar__controls svg path {\n  fill: --activeTrackColor--;\n}\n.--appName--.desktop.v3 .app.app_layout_vertical.app_preview .buy-wrapper .buy,\n.--appName--.desktop.v3 .app.app_layout_horizontal.app_preview .buy-wrapper .buy {\n  color: --activeTrackColor--;\n}\n.--appName--.desktop.v3 .app.app_layout_vertical .track {\n  padding: calc(16px + --trackListMargins--px) 0;\n}\n.--appName--.desktop.v3 .app.app_layout_horizontal .track {\n  padding-top: calc(15px + --trackListMargins--px);\n  padding-bottom: calc(15px + --trackListMargins--px);\n}\n";
  return css.replace(/--(\w[\w\d]*)--/g, function (match, group) {
    return settings.hasOwnProperty(group) ? settings[group] : match;
  });
};

/***/ }),
/* 191 */
/* no static exports found */
/* all exports used */
/*!************************************************************************************!*\
  !*** ./scripts/player/v2/desktop/components/moving-text/moving-text.controller.js ***!
  \************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MovingTextController = exports.MovingTextController = function () {
  function MovingTextController() {
    _classCallCheck(this, MovingTextController);

    this.movingClassName = 'moving-text-wrapper__active';
    this.transitionDurationCoefficient = 100;
  }

  _createClass(MovingTextController, [{
    key: 'setWrapper',
    value: function setWrapper(textWrapperElem) {
      this.textWrapperElem = textWrapperElem;
    }
  }, {
    key: 'setContentWrapper',
    value: function setContentWrapper(contentWrapper) {
      this.contentWrapperElem = contentWrapper;
    }
  }, {
    key: 'startMovingEffect',
    value: function startMovingEffect() {
      var movingClassName = this.movingClassName;


      var oneTextSpanFullSize = this.textWrapperElem.scrollWidth;
      var wrapperWidth = this.textWrapperElem.clientWidth;
      var isOverflown = oneTextSpanFullSize > wrapperWidth;

      if (!isOverflown) {
        return;
      }

      this.isMoving = true;
      this.textWrapperElem.classList.add(movingClassName);
      this.addTextDublicate(this.textWrapperElem);
      this.addStylesForMoving(this.textWrapperElem, oneTextSpanFullSize);
    }
  }, {
    key: 'stopMovingEffect',
    value: function stopMovingEffect() {
      if (!this.isMoving) {
        return;
      }

      this.removeStylesForMoving(this.textWrapperElem);
      this.removeTextDublicate(this.textWrapperElem);
      this.textWrapperElem.classList.remove(this.movingClassName);
      this.isMoving = false;
    }
  }, {
    key: 'addTextDublicate',
    value: function addTextDublicate(textWrapperElem) {
      this.clonedContentElement = this.contentWrapperElem.cloneNode(true);
      textWrapperElem.appendChild(this.clonedContentElement);
    }
  }, {
    key: 'removeTextDublicate',
    value: function removeTextDublicate(textWrapperElem) {
      textWrapperElem.removeChild(this.clonedContentElement);
      this.clonedContentElement = null;
    }
  }, {
    key: 'addStylesForMoving',
    value: function addStylesForMoving(textWrapperElem, oneTextSpanFullSize) {
      var transitionDurationCoefficient = this.transitionDurationCoefficient;


      textWrapperElem.style.width = 2 * oneTextSpanFullSize + 'px';
      textWrapperElem.style.transitionDuration = oneTextSpanFullSize / transitionDurationCoefficient + 's';
      textWrapperElem.style.left = -oneTextSpanFullSize + 'px';
    }
  }, {
    key: 'removeStylesForMoving',
    value: function removeStylesForMoving(textWrapperElem) {
      textWrapperElem.style.width = 'auto';
      textWrapperElem.style.left = 0;
      textWrapperElem.style.transitionDuration = '';
    }
  }]);

  return MovingTextController;
}();

/***/ }),
/* 192 */
/* no static exports found */
/* all exports used */
/*!*************************************************************************!*\
  !*** ./scripts/player/v2/desktop/components/moving-text/moving-text.js ***!
  \*************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MovingText = undefined;

var _mithril = __webpack_require__(/*! mithril */ 0);

var m = _interopRequireDefault(_mithril).default;

var _movingText = __webpack_require__(/*! ./moving-text.controller */ 191);

var MovingTextController = _movingText.MovingTextController;

__webpack_require__(/*! ./moving-text.less */ 246);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MovingText = {
  controller: MovingTextController,
  view: function view( /** MovingTextController */ctrl, attrs, children) {
    var triggerClassname = 'moving-text-trigger-area';

    return {
      tag: 'div',
      children: [{
        tag: 'div',
        attrs: {
          className: triggerClassname,
          onmouseover: function onmouseover() {
            return ctrl.startMovingEffect();
          },
          onmouseout: function onmouseout() {
            return ctrl.stopMovingEffect();
          }
        }
      }, {
        tag: 'span',
        children: [children],
        attrs: { className: 'moving-text', config: function config(element) {
            return ctrl.setContentWrapper(element);
          } }
      }],
      attrs: { className: 'moving-text-wrapper', config: function config(element) {
          return ctrl.setWrapper(element);
        } }
    };
  }
};

exports.MovingText = MovingText;

/***/ }),
/* 193 */
/* no static exports found */
/* all exports used */
/*!***********************************************************************************!*\
  !*** ./scripts/player/v2/desktop/components/share-album/share-album.component.js ***!
  \***********************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ShareAlbum = undefined;

var _mithril = __webpack_require__(/*! mithril */ 0);

var m = _interopRequireDefault(_mithril).default;

var _l10n = __webpack_require__(/*! ../../../shared/l10n */ 1);

var l10n = _l10n.l10n;

var _shareButton = __webpack_require__(/*! ../share-button */ 52);

var ShareButton = _shareButton.ShareButton;

__webpack_require__(/*! ./share-album.less */ 247);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ShareAlbum = {
  view: function view(ctrl, attrs, children) {
    var isDisabled = attrs.isDisabled,
        onShare = attrs.onShare,
        ShareIcons = attrs.ShareIcons,
        accName = attrs.accName;


    return {
      tag: 'div',
      children: [m.component(ShareButton, { isDisabled: isDisabled, onShare: onShare, ShareIcons: ShareIcons, accName: accName }, [children && children.length ? children : l10n('player_share_album')])],
      attrs: { className: 'share-album' }
    };
  }
};

exports.ShareAlbum = ShareAlbum;

/***/ }),
/* 194 */
/* no static exports found */
/* all exports used */
/*!*************************************************************************************!*\
  !*** ./scripts/player/v2/desktop/components/share-button/share-button.component.js ***!
  \*************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ShareButton = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _classnames = __webpack_require__(/*! classnames */ 3);

var classNames = _interopRequireDefault(_classnames).default;

var _mithril = __webpack_require__(/*! mithril */ 0);

var m = _interopRequireDefault(_mithril).default;

var _shareIcons = __webpack_require__(/*! ../../../shared/components/share-icons */ 36);

var ShareIconsDefault = _shareIcons.ShareIcons;

var _l10n = __webpack_require__(/*! ../../../shared/l10n */ 1);

var l10n = _l10n.l10n;

__webpack_require__(/*! ./share-button.less */ 248);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ShareButtonController = function () {
  function ShareButtonController() {
    _classCallCheck(this, ShareButtonController);

    this.shouldFocusFirst = false;
  }

  _createClass(ShareButtonController, [{
    key: 'handleFocusedFirst',
    value: function handleFocusedFirst() {
      this.shouldFocusFirst = false;
    }
  }, {
    key: 'openShare',
    value: function openShare(shouldFocus) {
      if (shouldFocus !== undefined) {
        this.shouldFocusFirst = shouldFocus;
      }
      this.isSharing = true;
    }
  }, {
    key: 'closeShare',
    value: function closeShare() {
      this.isSharing = false;
    }
  }]);

  return ShareButtonController;
}();

var ShareButton = {
  controller: ShareButtonController,
  view: function view( /** ShareButtonController */ctrl, attrs, children) {
    var _attrs$isDisabled = attrs.isDisabled,
        isDisabled = _attrs$isDisabled === undefined ? false : _attrs$isDisabled,
        onShare = attrs.onShare,
        _attrs$ShareIcons = attrs.ShareIcons,
        ShareIcons = _attrs$ShareIcons === undefined ? ShareIconsDefault : _attrs$ShareIcons,
        accName = attrs.accName;


    var onShareButtonClick = function onShareButtonClick( /**KeyboardEvent*/event) {
      event.stopPropagation();
      ctrl.openShare(true);
    };
    var config = function config( /** HTMLDivElement */element, isConfigured, context) {
      if (isConfigured) {
        return;
      }

      function handleFocusOut() {
        // wait for focus to be changed and settle for ally lib
        setTimeout(function () {
          var contains = element.contains(document.activeElement);
          if (!contains) {
            ctrl.closeShare();
            m.redraw();
          }
        }, 0);
      }

      element.addEventListener('focusout', handleFocusOut);
      context.onunload = function () {
        element.removeEventListener('focusout', handleFocusOut);
      };
    };
    return {
      tag: 'div',
      children: [{
        tag: 'button',
        children: [children],
        attrs: {
          className: 'share-container__handler',
          disabled: isDisabled,
          onclick: onShareButtonClick,
          onmouseenter: function onmouseenter() {
            return ctrl.openShare();
          },
          'aria-label': accName || l10n('player_share_song')
        }
      }, m.component(ShareIcons, {
        onShare: onShare,
        shouldFocusFirst: ctrl.shouldFocusFirst && ctrl.isSharing,
        onFocusFirst: function onFocusFirst() {
          return ctrl.handleFocusedFirst();
        }
      }, [])],
      attrs: {
        id: 'shareOpener',
        className: classNames('share-container', {
          'share-container_disabled': isDisabled,
          'share-container_opened': ctrl.isSharing
        }),
        config: config,
        onmouseleave: function onmouseleave() {
          return ctrl.closeShare();
        }
      }
    };
  }
};

exports.ShareButton = ShareButton;

/***/ }),
/* 195 */
/* no static exports found */
/* all exports used */
/*!************************************************************************!*\
  !*** ./scripts/player/v2/desktop/components/track-list/track/index.js ***!
  \************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _track = __webpack_require__(/*! ./track.component */ 197);

Object.defineProperty(exports, 'Track', {
  enumerable: true,
  get: function get() {
    return _track.Track;
  }
});

/***/ }),
/* 196 */
/* no static exports found */
/* all exports used */
/*!**********************************************************************************************!*\
  !*** ./scripts/player/v2/desktop/components/track-list/track/track-buy/track-buy-wrapper.js ***!
  \**********************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TrackBuyWrapper = undefined;

var _mithril = __webpack_require__(/*! mithril */ 0);

var m = _interopRequireDefault(_mithril).default;

var _buyTrack = __webpack_require__(/*! ../../../../../shared/components/buy-track */ 17);

var BuyTrack = _buyTrack.BuyTrack;

var _l10n = __webpack_require__(/*! ../../../../../shared/l10n */ 1);

var l10n = _l10n.l10n;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TrackBuyWrapper = {
  view: function view(ctrl, attrs) {
    var isPurchaseAvailable = attrs.isPurchaseAvailable,
        hasTracksForPurchase = attrs.hasTracksForPurchase,
        _attrs$buyClassName = attrs.buyClassName,
        buyClassName = _attrs$buyClassName === undefined ? '' : _attrs$buyClassName,
        buy = attrs.buy,
        isFree = attrs.isFree,
        isBuyDisabled = attrs.isBuyDisabled,
        track = attrs.track;
    var externalLinks = track.externalLinks;

    var hasExternalLinks = externalLinks && externalLinks.length;
    var shouldShowBuyTrack = isPurchaseAvailable || hasExternalLinks;
    var shouldShowAdjuster = hasTracksForPurchase || hasExternalLinks;

    return {
      tag: 'div',
      children: [shouldShowBuyTrack ? m.component(BuyTrack, {
        className: 'track-price ' + buyClassName,
        track: track,
        buy: buy,
        freeText: l10n('player_download'),
        freeAccText: l10n('player_download_track'),
        isFree: isFree,
        hasExternalLinks: hasExternalLinks,
        isDisabled: isBuyDisabled
      }, []) : null, shouldShowAdjuster ? {
        tag: 'span',
        children: [m.component(BuyTrack, { className: 'track-price track-price__height-adjuster ' + buyClassName, track: track, isFree: true }, ['\xA0'])],
        attrs: { 'aria-hidden': 'true' }
      } : null],
      attrs: { className: 'track-buy' }
    };
  }
};

exports.TrackBuyWrapper = TrackBuyWrapper;

/***/ }),
/* 197 */
/* no static exports found */
/* all exports used */
/*!**********************************************************************************!*\
  !*** ./scripts/player/v2/desktop/components/track-list/track/track.component.js ***!
  \**********************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Track = undefined;

var _classnames = __webpack_require__(/*! classnames */ 3);

var classNames = _interopRequireDefault(_classnames).default;

var _mithril = __webpack_require__(/*! mithril */ 0);

var m = _interopRequireDefault(_mithril).default;

var _trackButtonLike = __webpack_require__(/*! ../../../../shared/components/track-button-like */ 49);

var TrackButtonLike = _trackButtonLike.TrackButtonLike;

var _pause = __webpack_require__(/*! ../../../../shared/icons/pause.svg */ 302);

var pauseIcon = _interopRequireDefault(_pause).default;

var _play = __webpack_require__(/*! ../../../../shared/icons/play.svg */ 305);

var playIcon = _interopRequireDefault(_play).default;

var _shareTrack = __webpack_require__(/*! ./share-track */ 85);

var ShareTrack = _shareTrack.ShareTrack;

var _trackBuy = __webpack_require__(/*! ./track-buy */ 86);

var TrackBuyWrapper = _trackBuy.TrackBuyWrapper;

var _trackName = __webpack_require__(/*! ./track-name */ 56);

var TrackName = _trackName.TrackName;

var _track = __webpack_require__(/*! ./track.controller */ 46);

var TrackController = _track.TrackController;

__webpack_require__(/*! ./track.less */ 95);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Track = {
  controller: TrackController,
  view: function view(ctrl, attrs) {
    var number = attrs.number,
        track = attrs.track,
        isPlaying = attrs.isPlaying,
        isCurrent = attrs.isCurrent,
        onPause = attrs.onPause,
        onPlay = attrs.onPlay,
        canShare = attrs.canShare,
        showArtist = attrs.showArtist;

    ctrl.updateAttrs(attrs);

    var className = classNames('track', {
      'track_is-playing': isPlaying,
      'track_is-current': isCurrent,
      'track_show-actions': canShare || track.purchaseAvail
    });

    var shareData = {
      canShare: canShare,
      isShareDisabled: attrs.isShareDisabled,
      onShare: attrs.onShare,
      ShareIcons: attrs.ShareIcons
    };

    var buyData = {
      isPurchaseAvailable: ctrl.isPurchaseAvailable(),
      hasTracksForPurchase: attrs.hasTracksForPurchase,
      buy: attrs.buy,
      isBuyDisabled: attrs.isBuyDisabled,
      isFree: ctrl.isFree(),
      buyClassName: attrs.buyClassName
    };

    return {
      tag: 'li',
      children: [m.component(TrackButtonLike, { onActivation: function onActivation() {
          return ctrl.togglePlaying();
        }, ariaLabel: ctrl.getAriaLabel() }, [{
        tag: 'div',
        children: [{
          tag: 'div',
          children: [{
            tag: 'div',
            children: [number],
            attrs: { className: 'track-index-number' }
          }, {
            tag: 'div',
            children: [{
              tag: 'div',
              children: [{
                tag: 'span',
                children: [m.trust(playIcon)],
                attrs: { className: 'play' }
              }, {
                tag: 'span',
                children: [m.trust(pauseIcon)],
                attrs: { className: 'pause' }
              }],
              attrs: { className: 'track-index-control', 'aria-hidden': 'true' }
            }],
            attrs: { className: 'track-control-wrapper' }
          }],
          attrs: { className: 'track-index' }
        }, m.component(TrackName, { track: track, showArtist: showArtist }, []), {
          tag: 'div',
          children: [track.duration],
          attrs: { className: 'track-duration' }
        }, shareData.canShare ? m.component(ShareTrack, {
          isDisabled: shareData.isShareDisabled,
          shareItem: track,
          onShare: shareData.onShare,
          ShareIcons: shareData.ShareIcons
        }, []) : null, m.component(TrackBuyWrapper, {
          track: track,
          isPurchaseAvailable: buyData.isPurchaseAvailable,
          hasTracksForPurchase: buyData.hasTracksForPurchase,
          buy: buyData.buy,
          isBuyDisabled: buyData.isBuyDisabled,
          isFree: buyData.isFree,
          buyClassName: buyData.buyClassName
        }, [])],
        attrs: { className: className }
      }])],
      attrs: { className: 'track__list-item' }
    };
  }
};

exports.Track = Track;

/***/ }),
/* 198 */
/* no static exports found */
/* all exports used */
/*!***************************************************************!*\
  !*** ./scripts/player/v2/desktop/horizontal/app.component.js ***!
  \***************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HorizontalAppComponent = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _mithril = __webpack_require__(/*! mithril */ 0);

var m = _interopRequireDefault(_mithril).default;

var _v2SettingsConstants = __webpack_require__(/*! ../../../../common/parse-settings/v2-settings-constants */ 4);

var SETTINGS_CONSTANTS = _interopRequireWildcard(_v2SettingsConstants);

var _albumCover = __webpack_require__(/*! ../../shared/components/album-cover */ 48);

var AlbumCover = _albumCover.AlbumCover;

var _audioPlayer = __webpack_require__(/*! ../../shared/components/audio-player */ 24);

var AudioPlayer = _audioPlayer.AudioPlayer;

var _trackList = __webpack_require__(/*! ../components/track-list */ 84);

var TrackList = _trackList.TrackListDesktop;

var _app = __webpack_require__(/*! ./app.controller */ 199);

var HorizontalAppController = _app.HorizontalAppController;

var _albumTitles = __webpack_require__(/*! ./components/album-titles/album-titles */ 200);

var AlbumTitles = _albumTitles.AlbumTitles;

var _buyShareActions = __webpack_require__(/*! ./components/buy-share-actions */ 202);

var BuyShare = _buyShareActions.HorizontalBuyShare;

var _controlBar = __webpack_require__(/*! ./components/control-bar */ 206);

var ControlBar = _controlBar.ControlBar;
var PlayPauseMaxi = _controlBar.PlayPauseMaxi;

var _shareOverlay = __webpack_require__(/*! ./components/share-overlay */ 207);

var ShareOverlay = _shareOverlay.ShareOverlay;

var _sizeAdjuster = __webpack_require__(/*! ./size-adjuster */ 210);

var sizeAdjuster = _sizeAdjuster.sizeAdjuster;

__webpack_require__(/*! ./styles/app.less */ 258);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HorizontalAppComponent = {
  controller: HorizontalAppController,

  view: function view(ctrl, attrs) {
    var playerApiEmit = ctrl.playerApiEmit,
        albumTranslationKeys = ctrl.albumTranslationKeys;
    var album = attrs.album,
        settings = attrs.settings,
        playback = attrs.playback,
        playerApi = attrs.playerApi,
        config = attrs.config;
    var tracks = album.tracks;
    var buttonStyle = settings.buttonStyle,
        trackListShow = settings.trackListShow,
        canShareTrack = settings.canShareTrack,
        canShareAlbum = settings.canShareAlbum,
        horizontalControlBarType = settings.horizontalControlBarType,
        showingCover = settings.horizontalAlbumCoverShow,
        imageResizeMode = settings.imageResizeMode;

    var isMaxi = horizontalControlBarType === SETTINGS_CONSTANTS.HORIZONTAL_CONTROL_BAR_TYPE.MAXI;
    var controlBarType = isMaxi ? 'maxi' : 'mini';
    var showShareButton = !trackListShow && (canShareTrack || canShareAlbum);

    var className = ['app', 'app_layout_horizontal', 'app_control-bar_' + controlBarType, 'app_button-style_' + SETTINGS_CONSTANTS.BUTTON_STYLE_CLASSES[buttonStyle], !trackListShow ? 'app_no-tracklist' : 'app_show-tracklist', !showingCover ? 'app_hide-cover' : '', !ctrl.hasTracks() ? 'app_no-tracks' : '', ctrl.shareModalOpened ? 'app_overlay-opened' : 'app_overlay-hidden', playback.preview.isPreview ? 'app_preview' : ''].join(' ');
    var shouldDisableShareBuy = ctrl.shouldDisableShareBuy();
    var duration = playback.currentDuration();
    var played = playback.currentProgress();
    var loaded = playback.loadedProgress();
    var currentTrack = playback.currentTrack || playback.getFirstTrack();

    if (!showingCover) {
      playerApi.emit('album-cover-loaded');
    }

    var albumTitlesConfig = function albumTitlesConfig(element) {
      var triggerElement = element.getElementsByClassName('share-container')[0];
      var shrinkingElements = Array.from(element.querySelectorAll('.artist-name, .track-name'));
      if (triggerElement && shrinkingElements.length) {
        sizeAdjuster(triggerElement, shrinkingElements);
      }
    };

    var albumHasExternalLinks = album.externalLinks && album.externalLinks.length;

    return {
      tag: 'div',
      children: [showShareButton ? m.component(ShareOverlay, {
        isOpened: ctrl.shareModalOpened,
        onClose: function onClose() {
          return ctrl.closeShareMenu();
        },
        canShareTrack: canShareTrack,
        canShareAlbum: canShareAlbum,
        albumTranslationKeys: albumTranslationKeys,
        onAlbumShare: function onAlbumShare(network) {
          return ctrl.shareAlbum(network);
        },
        onTrackShare: function onTrackShare(network) {
          return ctrl.shareCurrentTrack(network);
        }
      }, []) : null, {
        tag: 'div',
        children: [m.component(AudioPlayer, {
          playback: playback,
          statisticEvents: playerApi.statisticEvents,
          onTimeUpdate: playerApiEmit('timeupdate'),
          onLoadedProgress: playerApiEmit('progress'),
          onEnded: playerApiEmit('pause')
        }, []), {
          tag: 'div',
          children: [showingCover ? m.component(AlbumCover, _extends({
            imageResizeMode: imageResizeMode,
            shouldSetProportion: false,
            onCoverReady: function onCoverReady() {
              return playerApi.emit('album-cover-loaded');
            }
          }, ctrl.getCurrentCoverInfo()), []) : null, {
            tag: 'div',
            children: [{
              tag: 'div',
              children: [isMaxi ? m.component(PlayPauseMaxi, {
                isPlaying: playback.isPlaying,
                isDisabled: !ctrl.hasTracks(),
                onPlay: function onPlay() {
                  return playback.play();
                },
                onPause: function onPause() {
                  return playback.pause();
                }
              }, []) : null, m.component(AlbumTitles, {
                album: album,
                playback: playback,
                settings: settings,
                albumTranslationKeys: albumTranslationKeys
              }, []), m.component(BuyShare, {
                albumTranslationKeys: albumTranslationKeys,
                canBuyAlbum: ctrl.hasTracks() && (album.purchaseAvail || albumHasExternalLinks),
                canBuyTrack: currentTrack && currentTrack.purchaseAvail,
                showBuyTrack: !trackListShow,
                album: album,
                buyAlbum: function buyAlbum() {
                  return ctrl.buyAlbum();
                },
                buyTrack: function buyTrack(track) {
                  return ctrl.buyTrack(track);
                },
                track: currentTrack,
                onShare: function onShare(network) {
                  return ctrl.shareAlbum(network);
                },
                isDisabled: ctrl.shouldDisableShareBuy(),
                canShareAlbum: canShareAlbum && trackListShow
              }, [])],
              attrs: { className: 'album-titles-actions', config: albumTitlesConfig }
            }, m.component(ControlBar, {
              controlBarType: horizontalControlBarType,
              duration: duration,
              played: played,
              loaded: loaded,
              showShareButton: showShareButton,
              track: currentTrack,
              onUpdateProgress: function onUpdateProgress(value) {
                return playback.updateProgress(value);
              },
              isDisabled: !ctrl.hasTracks(),
              showTrackInfo: ctrl.hasCurrentLyrics(),
              onShare: function onShare() {
                return ctrl.openShareMenu();
              },
              isPlaying: playback.isPlaying,
              onPlay: function onPlay() {
                return playback.play();
              },
              onPause: function onPause() {
                return playback.pause();
              },
              onPrev: function onPrev() {
                return playback.playPrev();
              },
              onNext: function onNext() {
                return playback.playNext();
              },
              album: album,
              settings: settings,
              playback: playback,
              playerApi: playerApi,
              showDetailedTrackInfo: settings.showDetailedTrackInfo,
              openTrackPage: function openTrackPage(trackId) {
                return ctrl.openTrackPage(trackId);
              }
            }, [])],
            attrs: { className: 'controls' }
          }],
          attrs: { id: 'top-part', className: 'top-part' }
        }, trackListShow ? m.component(TrackList, {
          tracks: tracks,
          albumName: album.name,
          buy: function buy(trackId) {
            return ctrl.buyTrack(trackId);
          },
          onShare: function onShare(network, track) {
            return ctrl.shareTrack(network, track);
          },
          isBuyDisabled: shouldDisableShareBuy,
          isShareDisabled: shouldDisableShareBuy,
          buyClassName: 'wiring-button',
          settings: settings,
          playback: playback
        }, []) : null],
        attrs: { className: 'app-content' }
      }],
      attrs: { className: className, config: config }
    };
  }
};

exports.HorizontalAppComponent = HorizontalAppComponent;

/***/ }),
/* 199 */
/* no static exports found */
/* all exports used */
/*!****************************************************************!*\
  !*** ./scripts/player/v2/desktop/horizontal/app.controller.js ***!
  \****************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HorizontalAppController = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _app = __webpack_require__(/*! ../../shared/app/app.controller */ 22);

var AppController = _app.AppController;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HorizontalAppController = function (_AppController) {
  _inherits(HorizontalAppController, _AppController);

  function HorizontalAppController() {
    _classCallCheck(this, HorizontalAppController);

    var _this = _possibleConstructorReturn(this, (HorizontalAppController.__proto__ || Object.getPrototypeOf(HorizontalAppController)).apply(this, arguments));

    _this.shareModalOpened = false;
    return _this;
  }

  _createClass(HorizontalAppController, [{
    key: 'openShareMenu',
    value: function openShareMenu() {
      this.shareModalOpened = true;
    }
  }, {
    key: 'closeShareMenu',
    value: function closeShareMenu() {
      this.shareModalOpened = false;
    }
  }]);

  return HorizontalAppController;
}(AppController);

exports.HorizontalAppController = HorizontalAppController;

/***/ }),
/* 200 */
/* no static exports found */
/* all exports used */
/*!**************************************************************************************!*\
  !*** ./scripts/player/v2/desktop/horizontal/components/album-titles/album-titles.js ***!
  \**************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AlbumTitles = undefined;

var _mithril = __webpack_require__(/*! mithril */ 0);

var m = _interopRequireDefault(_mithril).default;

var _albumTitles = __webpack_require__(/*! ../../../../shared/components/album-titles/album-titles.controller */ 23);

var AlbumTitlesController = _albumTitles.AlbumTitlesController;

var _trackName = __webpack_require__(/*! ../../../../shared/components/track-name/track-name */ 92);

var TrackName = _trackName.TrackName;

__webpack_require__(/*! ./album-titles.less */ 250);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AlbumTitles = {
  controller: AlbumTitlesController,
  view: function view(ctrl) {
    var artistName = ctrl.getArtistName();
    var albumName = ctrl.album.name;
    var trackName = ctrl.getTrackName();
    var shouldShowAddFirst = ctrl.shouldShowAddFirst;
    return {
      tag: 'div',
      children: [{
        tag: 'p',
        children: [artistName],
        attrs: { className: 'artist-name' }
      }, {
        tag: 'div',
        children: [m.component(TrackName, {
          trackName: trackName,
          shouldShowAddFirst: shouldShowAddFirst,
          albumTranslationKeys: ctrl.albumTranslationKeys
        }, [])],
        attrs: { className: 'track-name' }
      }, {
        tag: 'p',
        children: [albumName],
        attrs: { className: 'album-name' }
      }],
      attrs: { className: 'album-titles' }
    };
  }
};

exports.AlbumTitles = AlbumTitles;

/***/ }),
/* 201 */
/* no static exports found */
/* all exports used */
/*!**********************************************************************************************************!*\
  !*** ./scripts/player/v2/desktop/horizontal/components/buy-share-actions/buy-share-actions.component.js ***!
  \**********************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HorizontalBuyShare = undefined;

var _translationsKeys;

var _mithril = __webpack_require__(/*! mithril */ 0);

var m = _interopRequireDefault(_mithril).default;

var _classnames = __webpack_require__(/*! classnames */ 3);

var classNames = _interopRequireDefault(_classnames).default;

var _constants = __webpack_require__(/*! ../../../../../../common/constants */ 5);

var constants = _interopRequireDefault(_constants).default;

var _buyAlbum = __webpack_require__(/*! ../../../../shared/components/buy-album */ 29);

var BuyAlbum = _buyAlbum.BuyAlbum;

var _buyShare = __webpack_require__(/*! ../../../../shared/components/buy-share-actions/buy-share.controller */ 57);

var BuyShareController = _buyShare.BuyShareController;

var _buyTrack = __webpack_require__(/*! ../../../../shared/components/buy-track */ 17);

var BuyTrack = _buyTrack.BuyTrack;

var _l10n = __webpack_require__(/*! ../../../../shared/l10n */ 1);

var l10n = _l10n.l10n;

var _translationKeys = __webpack_require__(/*! ../../../../shared/translation-keys */ 10);

var registerTranslationKeys = _translationKeys.registerTranslationKeys;

__webpack_require__(/*! ./buy-share-actions.less */ 251);

var _shareComponent = __webpack_require__(/*! ./share-component */ 203);

var ShareButtonComponent = _shareComponent.ShareButtonComponent;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var translationsKeys = (_translationsKeys = {}, _defineProperty(_translationsKeys, constants.ALBUM_TYPES.ALBUM, {
  albumType: 'player_album',
  getButton: 'player_get_album'
}), _defineProperty(_translationsKeys, constants.ALBUM_TYPES.SINGLE, {
  albumType: 'player_single',
  getButton: 'player_get_single'
}), _defineProperty(_translationsKeys, constants.ALBUM_TYPES.PLAYLIST, {
  albumType: 'player_album'
}), _translationsKeys);

registerTranslationKeys(translationsKeys);

var HorizontalBuyShare = exports.HorizontalBuyShare = {
  controller: BuyShareController,

  view: function view(ctrl, attrs) {
    var canBuyAlbum = attrs.canBuyAlbum,
        canBuyTrack = attrs.canBuyTrack,
        album = attrs.album,
        track = attrs.track,
        canShareAlbum = attrs.canShareAlbum,
        showBuyTrack = attrs.showBuyTrack,
        onShare = attrs.onShare,
        isDisabled = attrs.isDisabled,
        albumTranslationKeys = attrs.albumTranslationKeys,
        _attrs$buyAlbumClass = attrs.buyAlbumClass,
        buyAlbumClass = _attrs$buyAlbumClass === undefined ? '' : _attrs$buyAlbumClass;
    var albumPriceFormatted = album.albumPriceFormatted,
        albumCurrency = album.currency,
        albumCurrencySymbol = album.currencySymbol;


    var showBuyButton = canBuyTrack && showBuyTrack;
    var firstFreeTrack = ctrl.getFirstFreeTrack();
    var mostExpensiveTrack = ctrl.getTheMostExpensiveTrack();
    var shouldShowBuyBlock = canBuyAlbum || showBuyButton;
    var buyAlbumClassame = classNames('buy-share__buy-album', 'wiring-button', buyAlbumClass);

    var hasExternalLinks = album.externalLinks && album.externalLinks.length;

    var buyBlock = {
      tag: 'div',
      children: [canBuyAlbum ? m.component(BuyAlbum, {
        album: album,
        className: buyAlbumClassame,
        buy: attrs.buyAlbum,
        buyTextKey: albumTranslationKeys.albumType,
        downloadTextKey: albumTranslationKeys.downloadButton,
        getTextKey: albumTranslationKeys.getButton,
        hasExternalLinks: hasExternalLinks,
        price: albumPriceFormatted,
        currency: albumCurrency,
        currencySymbol: albumCurrencySymbol,
        isDisabled: isDisabled,
        isFree: ctrl.isFree(),
        isDownloadable: ctrl.canBuy()
      }, []) : null, showBuyButton ? m.component(BuyTrack, {
        className: 'wiring-button',
        isDisabled: isDisabled,
        track: track,
        buy: function buy() {
          return attrs.buyTrack(track.id);
        },
        buyText: function buyText(price) {
          return l10n('player_track') + ' ' + price;
        },
        buyAccText: function buyAccText(price) {
          return l10n('player_acc_buy_track', [price]);
        }
      }, []) : null, showBuyButton && firstFreeTrack ? m.component(BuyTrack, { className: 'buy-share__sizing-button wiring-button', track: firstFreeTrack }, []) : null, showBuyButton && mostExpensiveTrack ? m.component(BuyTrack, {
        className: 'buy-share__sizing-button wiring-button',
        track: mostExpensiveTrack,
        buyText: function buyText(price) {
          return l10n('player_track') + ' ' + price;
        },
        buyAccText: function buyAccText(price) {
          return l10n('player_acc_buy_track', [price]);
        }
      }, []) : null],
      attrs: { className: 'buy-share__buy' }
    };

    return {
      tag: 'div',
      children: [canShareAlbum ? m.component(ShareButtonComponent, {
        onShare: onShare,
        accName: l10n(albumTranslationKeys.shareButton) + ' ' + album.name,
        isDisabled: isDisabled
      }, []) : null, shouldShowBuyBlock ? buyBlock : null],
      attrs: { className: 'buy-share' }
    };
  }
};

/***/ }),
/* 202 */
/* no static exports found */
/* all exports used */
/*!************************************************************************************!*\
  !*** ./scripts/player/v2/desktop/horizontal/components/buy-share-actions/index.js ***!
  \************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _buyShareActions = __webpack_require__(/*! ./buy-share-actions.component */ 201);

Object.defineProperty(exports, 'HorizontalBuyShare', {
  enumerable: true,
  get: function get() {
    return _buyShareActions.HorizontalBuyShare;
  }
});

/***/ }),
/* 203 */
/* no static exports found */
/* all exports used */
/*!**********************************************************************************************!*\
  !*** ./scripts/player/v2/desktop/horizontal/components/buy-share-actions/share-component.js ***!
  \**********************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ShareButtonComponent = undefined;

var _mithril = __webpack_require__(/*! mithril */ 0);

var m = _interopRequireDefault(_mithril).default;

var _share = __webpack_require__(/*! ../../../../shared/icons/share.svg */ 13);

var shareIcon = _interopRequireDefault(_share).default;

var _shareAlbum = __webpack_require__(/*! ../../../components/share-album */ 83);

var ShareAlbum = _shareAlbum.ShareAlbum;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ShareButtonComponent = exports.ShareButtonComponent = {
  view: function view(ctrl, attrs) {
    var onShare = attrs.onShare,
        isDisabled = attrs.isDisabled,
        accName = attrs.accName;


    return {
      tag: 'div',
      children: [{
        tag: 'div',
        children: [m.component(ShareAlbum, { isDisabled: isDisabled, onShare: onShare, accName: accName }, [{
          tag: 'span',
          children: [m.trust(shareIcon)],
          attrs: { 'aria-hidden': 'true' }
        }]), {
          tag: 'button',
          children: ['2'],
          attrs: { className: 'buy-share__centering-button wiring-button' }
        }],
        attrs: { className: 'buy-share__centering-wrapper' }
      }],
      attrs: { className: 'buy-share__share' }
    };
  }
};

/***/ }),
/* 204 */
/* no static exports found */
/* all exports used */
/*!*****************************************************************************************!*\
  !*** ./scripts/player/v2/desktop/horizontal/components/control-bar/control-bar-mini.js ***!
  \*****************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ControlBarMini = undefined;

var _classnames = __webpack_require__(/*! classnames */ 3);

var classNames = _interopRequireDefault(_classnames).default;

var _mithril = __webpack_require__(/*! mithril */ 0);

var m = _interopRequireDefault(_mithril).default;

var _utils = __webpack_require__(/*! ../../../../../../utils/utils */ 2);

var utils = _utils.utils;

var _playPauseButton = __webpack_require__(/*! ../../../../shared/components/play-pause-button/play-pause-button.component */ 26);

var PlayPauseButton = _playPauseButton.PlayPauseButton;

var _slider = __webpack_require__(/*! ../../../../shared/components/slider */ 16);

var Slider = _slider.DesktopSlider;

var _volume = __webpack_require__(/*! ../../../../shared/components/volume */ 27);

var Volume = _volume.Volume;

var _share = __webpack_require__(/*! ../../../../shared/icons/share.svg */ 13);

var shareIcon = _interopRequireDefault(_share).default;

var _trackInfo = __webpack_require__(/*! ../../../../shared/icons/track-info.svg */ 28);

var trackInfoIcon = _interopRequireDefault(_trackInfo).default;

var _l10n = __webpack_require__(/*! ../../../../shared/l10n */ 1);

var l10n = _l10n.l10n;

var _next = __webpack_require__(/*! ./icons/mini/next.svg */ 284);

var nextIcon = _interopRequireDefault(_next).default;

var _pause = __webpack_require__(/*! ./icons/mini/pause.svg */ 285);

var pauseIcon = _interopRequireDefault(_pause).default;

var _play = __webpack_require__(/*! ./icons/mini/play.svg */ 286);

var playIcon = _interopRequireDefault(_play).default;

var _prev = __webpack_require__(/*! ./icons/mini/prev.svg */ 287);

var prevIcon = _interopRequireDefault(_prev).default;

__webpack_require__(/*! ./styles/control-bar-mini.less */ 253);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ControlBarMini = exports.ControlBarMini = {
  view: function view(ctrl, attrs) {
    var onPlay = attrs.onPlay,
        onPause = attrs.onPause,
        onPrev = attrs.onPrev,
        onNext = attrs.onNext,
        isDisabled = attrs.isDisabled,
        duration = attrs.duration,
        played = attrs.played,
        isPlaying = attrs.isPlaying,
        loaded = attrs.loaded,
        onUpdateProgress = attrs.onUpdateProgress,
        openTrackPage = attrs.openTrackPage,
        showDetailedTrackInfo = attrs.showDetailedTrackInfo,
        showShareButton = attrs.showShareButton;
    var playback = attrs.playback;

    var className = classNames('control-bar', 'control-bar_type_mini', {
      'control-bar_is-playing': isPlaying,
      'control-bar_is-disabled': isDisabled
    });

    var togglePlay = function togglePlay() {
      if (isPlaying) {
        onPause();
      } else {
        onPlay();
      }
    };

    var playedText = utils.durationToAccString(played);
    var durationText = utils.durationToAccString(duration);

    return {
      tag: 'div',
      children: [{
        tag: 'div',
        children: [{
          tag: 'div',
          children: [m.component(PlayPauseButton, {
            isDisabled: isDisabled,
            isPlaying: isPlaying,
            onAction: togglePlay,
            playIcon: m.trust(playIcon),
            pauseIcon: m.trust(pauseIcon)
          }, []), {
            tag: 'button',
            children: [{
              tag: 'span',
              children: [m.trust(prevIcon)],
              attrs: { 'aria-hidden': 'true' }
            }],
            attrs: { className: 'prev', 'aria-label': l10n('player_acc_prev'), disabled: isDisabled, onclick: onPrev }
          }, {
            tag: 'button',
            children: [{
              tag: 'span',
              children: [m.trust(nextIcon)],
              attrs: { 'aria-hidden': 'true' }
            }],
            attrs: { className: 'next', 'aria-label': l10n('player_acc_next'), disabled: isDisabled, onclick: onNext }
          }, {
            tag: 'span',
            children: [{
              tag: 'span',
              children: [utils.durationToString(played)],
              attrs: { 'aria-hidden': 'true' }
            }, {
              tag: 'span',
              children: [utils.durationToAccString(played)],
              attrs: { className: 'sr-only' }
            }],
            attrs: { className: 'progress-bar__played' }
          }, {
            tag: 'span',
            children: ['\xA0/\xA0'],
            attrs: { className: 'control-bar__progress-duration-slash progress-bar__duration-slash', 'aria-hidden': 'true' }
          }, {
            tag: 'span',
            children: [{
              tag: 'span',
              children: [utils.durationToString(duration)],
              attrs: { 'aria-hidden': 'true' }
            }, {
              tag: 'span',
              children: [utils.durationToAccString(duration)],
              attrs: { className: 'sr-only' }
            }],
            attrs: { className: 'progress-bar__duration' }
          }],
          attrs: { className: 'control-bar__controls' }
        }, {
          tag: 'div',
          children: [m.component(Volume, { playback: playback, isDisabled: isDisabled }, []), showDetailedTrackInfo ? {
            tag: 'button',
            children: [{
              tag: 'span',
              children: [m.trust(trackInfoIcon)],
              attrs: { 'aria-hidden': 'true' }
            }],
            attrs: {
              className: 'track-info',
              'aria-label': l10n('player_acc_track_info'),
              onclick: openTrackPage,
              disabled: isDisabled
            }
          } : null, showShareButton ? {
            tag: 'button',
            children: [{
              tag: 'span',
              children: [m.trust(shareIcon)],
              attrs: { 'aria-hidden': 'true' }
            }],
            attrs: { className: 'share', disabled: isDisabled, onclick: attrs.onShare, 'aria-label': l10n('player_acc_share') }
          } : null],
          attrs: { className: 'control-bar__controls' }
        }],
        attrs: { className: 'control-bar__controls-wrapper' }
      }, m.component(Slider, {
        progress: played || 0,
        isDisabled: isDisabled,
        maxValue: duration,
        valueText: l10n('player_acc_progress_value', [playedText, durationText]),
        loaded: loaded,
        onUpdate: onUpdateProgress
      }, [])],
      attrs: { className: className }
    };
  }
};

/***/ }),
/* 205 */
/* no static exports found */
/* all exports used */
/*!**********************************************************************************************!*\
  !*** ./scripts/player/v2/desktop/horizontal/components/control-bar/control-bar.component.js ***!
  \**********************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ControlBar = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _mithril = __webpack_require__(/*! mithril */ 0);

var m = _interopRequireDefault(_mithril).default;

var _v2SettingsConstants = __webpack_require__(/*! ../../../../../../common/parse-settings/v2-settings-constants */ 4);

var HORIZONTAL_CONTROL_BAR_TYPE = _v2SettingsConstants.HORIZONTAL_CONTROL_BAR_TYPE;

var _controlBarMaxi = __webpack_require__(/*! ./control-bar-maxi */ 87);

var ControlBarMaxi = _controlBarMaxi.ControlBarMaxi;

var _controlBarMini = __webpack_require__(/*! ./control-bar-mini */ 204);

var ControlBarMini = _controlBarMini.ControlBarMini;

__webpack_require__(/*! ./styles/control-bar.less */ 254);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ControlBarController = function ControlBarController(_ref) {
  var openTrackPage = _ref.openTrackPage;

  _classCallCheck(this, ControlBarController);

  this.openTrackPage = openTrackPage;
};

var ControlBar = exports.ControlBar = {
  controller: ControlBarController,
  view: function view(ctrl, attrs) {
    var _controlBars;

    var track = attrs.track;

    var controlBars = (_controlBars = {}, _defineProperty(_controlBars, HORIZONTAL_CONTROL_BAR_TYPE.MAXI, ControlBarMaxi), _defineProperty(_controlBars, HORIZONTAL_CONTROL_BAR_TYPE.MINI, ControlBarMini), _controlBars);
    var ControlBarComponent = controlBars[attrs.controlBarType];
    return m.component(ControlBarComponent, _extends({}, attrs, { openTrackPage: function openTrackPage() {
        return track && ctrl.openTrackPage(track.id);
      } }), []);
  }
};

/***/ }),
/* 206 */
/* no static exports found */
/* all exports used */
/*!******************************************************************************!*\
  !*** ./scripts/player/v2/desktop/horizontal/components/control-bar/index.js ***!
  \******************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _controlBar = __webpack_require__(/*! ./control-bar.component */ 205);

Object.defineProperty(exports, 'ControlBar', {
  enumerable: true,
  get: function get() {
    return _controlBar.ControlBar;
  }
});

var _controlBarMaxi = __webpack_require__(/*! ./control-bar-maxi */ 87);

Object.defineProperty(exports, 'PlayPauseMaxi', {
  enumerable: true,
  get: function get() {
    return _controlBarMaxi.PlayPauseMaxi;
  }
});

/***/ }),
/* 207 */
/* no static exports found */
/* all exports used */
/*!********************************************************************************!*\
  !*** ./scripts/player/v2/desktop/horizontal/components/share-overlay/index.js ***!
  \********************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _shareOverlay = __webpack_require__(/*! ./share-overlay */ 209);

Object.defineProperty(exports, 'ShareOverlay', {
  enumerable: true,
  get: function get() {
    return _shareOverlay.ShareOverlay;
  }
});

/***/ }),
/* 208 */
/* no static exports found */
/* all exports used */
/*!********************************************************************************************************************!*\
  !*** ./scripts/player/v2/desktop/horizontal/components/share-overlay/share-overlay-header/share-overlay-header.js ***!
  \********************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ShareOverlayHeader = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _mithril = __webpack_require__(/*! mithril */ 0);

var m = _interopRequireDefault(_mithril).default;

var _l10n = __webpack_require__(/*! ../../../../../shared/l10n */ 1);

var l10n = _l10n.l10n;

__webpack_require__(/*! ./share-overlay-header.less */ 256);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SliderPosition = function SliderPosition() {
  _classCallCheck(this, SliderPosition);

  this.left = 0;
  this.width = 0;
};

var ShareOverlayHeaderController = function () {
  function ShareOverlayHeaderController(attrs) {
    _classCallCheck(this, ShareOverlayHeaderController);

    this.sliderPosition = new SliderPosition();
    this.selectedPosition = new SliderPosition();
    this.onSelectionChange = attrs.onSelectionChange;
  }

  _createClass(ShareOverlayHeaderController, [{
    key: 'setSelected',
    value: function setSelected(selected, element) {
      var _calculatePosition2 = this._calculatePosition(element),
          left = _calculatePosition2.left,
          width = _calculatePosition2.width;

      var sliderPosition = this.sliderPosition,
          selectedPosition = this.selectedPosition;

      sliderPosition.left = selectedPosition.left = left;
      sliderPosition.width = selectedPosition.width = width;
      this.selected = selected;
      this.onSelectionChange(selected);
    }
  }, {
    key: 'slideTo',
    value: function slideTo(element) {
      var _calculatePosition3 = this._calculatePosition(element),
          left = _calculatePosition3.left,
          width = _calculatePosition3.width;

      this.sliderPosition.left = left;
      this.sliderPosition.width = width;
    }
  }, {
    key: 'restorePosition',
    value: function restorePosition() {
      var sliderPosition = this.sliderPosition,
          selectedPosition = this.selectedPosition;

      sliderPosition.left = selectedPosition.left;
      sliderPosition.width = selectedPosition.width;
    }
  }, {
    key: '_calculatePosition',
    value: function _calculatePosition(element) {
      var left = element.offsetLeft;
      var width = element.offsetWidth;

      return {
        left: left,
        width: width
      };
    }
  }]);

  return ShareOverlayHeaderController;
}();

var ShareOverlayHeader = {
  controller: ShareOverlayHeaderController,
  view: function view(ctrl, attrs) {
    var selected = attrs.selected,
        canShareTrack = attrs.canShareTrack,
        canShareAlbum = attrs.canShareAlbum,
        albumTranslationKeys = attrs.albumTranslationKeys;

    var sliderStyle = {
      left: ctrl.sliderPosition.left + 'px',
      width: ctrl.sliderPosition.width + 'px'
    };

    function config(element, isInitialized) {
      if (isInitialized && ctrl.selected === selected) {
        return;
      }

      var selectedElement = element.getElementsByClassName('share-overlay-header__share-' + selected)[0];
      ctrl.setSelected(selected, selectedElement);

      // Based on font style width can have fractions. So right bar will have small gap on the left
      Array.from(element.getElementsByClassName('share-overlay-header__share-title')).forEach(function (element) {
        element.style.width = element.offsetWidth + 1 + 'px';
      });

      setTimeout(function () {
        m.redraw();
      }, 0);
    }

    var handleLinkClick = function handleLinkClick(selected) {
      return function (event) {
        event.preventDefault();
        ctrl.setSelected(selected, event.target);
      };
    };

    return {
      tag: 'div',
      children: [canShareTrack ? {
        tag: 'a',
        children: [l10n('player_share_song')],
        attrs: {
          className: 'share-overlay-header__share-title share-overlay-header__share-track',
          href: '#',
          onmouseenter: function onmouseenter(event) {
            return ctrl.slideTo(event.target);
          },
          onmouseleave: function onmouseleave() {
            return ctrl.restorePosition();
          },
          onclick: handleLinkClick('track')
        }
      } : null, canShareAlbum ? {
        tag: 'a',
        children: [l10n(albumTranslationKeys.shareButton)],
        attrs: {
          className: 'share-overlay-header__share-title share-overlay-header__share-album',
          href: '#',
          onmouseenter: function onmouseenter(event) {
            return ctrl.slideTo(event.target);
          },
          onmouseleave: function onmouseleave() {
            return ctrl.restorePosition();
          },
          onclick: handleLinkClick('album')
        }
      } : null, {
        tag: 'div',
        attrs: { className: 'share-overlay-header__slider', style: sliderStyle }
      }],
      attrs: { className: 'share-overlay-header', config: config }
    };
  }
};

exports.ShareOverlayHeader = ShareOverlayHeader;

/***/ }),
/* 209 */
/* no static exports found */
/* all exports used */
/*!****************************************************************************************!*\
  !*** ./scripts/player/v2/desktop/horizontal/components/share-overlay/share-overlay.js ***!
  \****************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ShareOverlay = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _maintainDisabled = __webpack_require__(/*! @wix/music-shared/dist/src/accessibility/maintain-disabled */ 187);

var maintainDisabled = _maintainDisabled.maintainDisabled;

var _maintainHidden = __webpack_require__(/*! @wix/music-shared/dist/src/accessibility/maintain-hidden */ 188);

var maintainHidden = _maintainHidden.maintainHidden;

var _maintainTabFocus = __webpack_require__(/*! @wix/music-shared/dist/src/accessibility/maintain-tab-focus */ 307);

var maintainTabFocus = _maintainTabFocus.maintainTabFocus;

var _whenKey = __webpack_require__(/*! @wix/music-shared/dist/src/accessibility/when-key */ 189);

var whenKey = _whenKey.whenKey;

var _classnames = __webpack_require__(/*! classnames */ 3);

var classNames = _interopRequireDefault(_classnames).default;

var _mithril = __webpack_require__(/*! mithril */ 0);

var m = _interopRequireDefault(_mithril).default;

var _x = __webpack_require__(/*! ../../../../modals/shared/icons/x.svg */ 182);

var xSvg = _interopRequireDefault(_x).default;

var _index = __webpack_require__(/*! ../../../../shared/components/share-icons/index */ 36);

var ShareIcons = _index.ShareIcons;

var _l10n = __webpack_require__(/*! ../../../../shared/l10n */ 1);

var l10n = _l10n.l10n;

var _shareOverlayHeader = __webpack_require__(/*! ./share-overlay-header/share-overlay-header */ 208);

var ShareOverlayHeader = _shareOverlayHeader.ShareOverlayHeader;

__webpack_require__(/*! ./share-overlay.less */ 257);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ShareOverlayController = function () {
  function ShareOverlayController(attrs) {
    _classCallCheck(this, ShareOverlayController);

    this.onAlbumShare = attrs.onAlbumShare;
    this.onTrackShare = attrs.onTrackShare;
    this.selected = attrs.canShareTrack ? 'track' : 'album';

    this.disabledHandle = null;
    this.tabHandle = null;
    this.escapeHandle = null;
    this.hiddenHandle = null;
    this.focusedElementBeforeDialogOpened = null;
  }

  _createClass(ShareOverlayController, [{
    key: 'setSelected',
    value: function setSelected(selection) {
      this.selected = selection;
    }
  }, {
    key: 'share',
    value: function share(network) {
      var shareCb = this.selected === 'track' ? this.onTrackShare : this.onAlbumShare;
      shareCb(network);
    }
  }]);

  return ShareOverlayController;
}();

var ShareOverlay = {
  controller: ShareOverlayController,
  view: function view(ctrl, attrs) {
    var canShareAlbum = attrs.canShareAlbum,
        canShareTrack = attrs.canShareTrack,
        albumTranslationKeys = attrs.albumTranslationKeys,
        isOpened = attrs.isOpened,
        onClose = attrs.onClose;

    var className = classNames('share-overlay', 'share-overlay_' + ctrl.selected, {
      'share-overlay_opened': isOpened,
      'share-overlay__single-share': !canShareAlbum || !canShareTrack
    });

    var config = function config(element, isInitialized, context) {
      var handleOpen = function handleOpen() {
        ctrl.opened = true;
        ctrl.focusedElementBeforeDialogOpened = document.activeElement;
        ctrl.disabledHandle = maintainDisabled({
          filter: element
        });
        ctrl.tabHandle = maintainTabFocus({
          context: element
        });
        ctrl.escapeHandle = whenKey({
          context: element,
          escape: function escape() {
            onClose();
            m.redraw();
          }
        });
        ctrl.hiddenHandle = maintainHidden({
          filter: element
        });
        element.focus();
      };
      var handleClose = function handleClose() {
        if (!ctrl.opened) {
          return;
        }
        ctrl.opened = false;
        ctrl.disabledHandle.disengage();
        ctrl.tabHandle.disengage();
        ctrl.escapeHandle.disengage();
        ctrl.hiddenHandle.disengage();
        ctrl.focusedElementBeforeDialogOpened.focus();
      };
      if (!ctrl.wasOpened && isOpened) {
        handleOpen();
      } else if (ctrl.wasOpened && !isOpened) {
        handleClose();
      }

      ctrl.wasOpened = isOpened;

      if (isInitialized) {
        return;
      }

      context.onunload = handleClose;
    };

    return {
      tag: 'div',
      children: [{
        tag: 'button',
        children: [{
          tag: 'span',
          children: [m.trust(xSvg)],
          attrs: { 'aria-hidden': 'true' }
        }],
        attrs: { className: 'share-overlay__close', type: 'button', 'aria-label': l10n('player_acc_close'), onclick: onClose }
      }, m.component(ShareOverlayHeader, {
        selected: ctrl.selected,
        onSelectionChange: function onSelectionChange(selection) {
          return ctrl.setSelected(selection);
        },
        canShareTrack: canShareTrack,
        canShareAlbum: canShareAlbum,
        albumTranslationKeys: albumTranslationKeys
      }, []), m.component(ShareIcons, { onShare: function onShare(network) {
          return ctrl.share(network);
        } }, [])],
      attrs: { className: className, role: 'dialog', tabindex: '-1', 'aria-label': l10n('player_acc_share_dialog'), config: config }
    };
  }
};
exports.ShareOverlay = ShareOverlay;

/***/ }),
/* 210 */
/* no static exports found */
/* all exports used */
/*!***************************************************************!*\
  !*** ./scripts/player/v2/desktop/horizontal/size-adjuster.js ***!
  \***************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sizeAdjuster = sizeAdjuster;
var SIZE_ADJUSTER_LEAVING_CLASS = 'size-adjuster_leaving';

var previousMaxWidth = typeof WeakMap !== 'undefined' ? new WeakMap() : new Map();
function sizeAdjuster(triggerElement, shrinkingElements) {
  var clientRect = triggerElement.getBoundingClientRect();

  shrinkingElements.forEach(function (element) {
    var shrinkingClientRec = element.getBoundingClientRect();
    var distance = clientRect.left - shrinkingClientRec.right;
    var topOverflow = shrinkingClientRec.bottom > clientRect.top;
    var bottomOverflow = shrinkingClientRec.top < clientRect.bottom;

    if (distance < 0 && topOverflow && bottomOverflow) {
      previousMaxWidth.set(element, element.style.maxWidth);
      element.style.maxWidth = shrinkingClientRec.width + distance + 'px';
    } else if (previousMaxWidth.has(element)) {
      element.classList.add(SIZE_ADJUSTER_LEAVING_CLASS);
      element.style.maxWidth = previousMaxWidth.get(element);
      previousMaxWidth.delete(element);
      // if element doesn't have transition event will not be fired
      element.addEventListener('transitionend', function removeClass() {
        console.log('remove');
        element.classList.remove(SIZE_ADJUSTER_LEAVING_CLASS);
        element.removeEventListener('transitionend', removeClass);
      });
    }
  });
}

/***/ }),
/* 211 */
/* no static exports found */
/* all exports used */
/*!*********************************************************!*\
  !*** ./scripts/player/v2/desktop/list/app.component.js ***!
  \*********************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ListAppComponent = undefined;

var _mithril = __webpack_require__(/*! mithril */ 0);

var m = _interopRequireDefault(_mithril).default;

var _v2SettingsConstants = __webpack_require__(/*! ../../../../common/parse-settings/v2-settings-constants */ 4);

var BUTTON_STYLE_CLASSES = _v2SettingsConstants.BUTTON_STYLE_CLASSES;
var LIST_LAYOUT_TRACK_STYLE = _v2SettingsConstants.LIST_LAYOUT_TRACK_STYLE;

var _app = __webpack_require__(/*! ../../shared/app/app.controller */ 22);

var AppController = _app.AppController;

var _audioPlayer = __webpack_require__(/*! ../../shared/components/audio-player */ 24);

var AudioPlayer = _audioPlayer.AudioPlayer;

var _albumInfo = __webpack_require__(/*! ./components/album-info */ 213);

var AlbumInfo = _albumInfo.AlbumInfo;

var _trackList = __webpack_require__(/*! ./components/track-list */ 220);

var TrackList = _trackList.TrackListDesktop;

__webpack_require__(/*! ./styles/app-basic.less */ 268);

__webpack_require__(/*! ./styles/app-cover.less */ 269);

__webpack_require__(/*! ./styles/app-minimal.less */ 270);

__webpack_require__(/*! ./styles/app.less */ 271);

var _playPauseLiveAria = __webpack_require__(/*! ../../shared/components/play-pause-button/play-pause-live-aria.component */ 244);

var PlayPauseLiveAria = _playPauseLiveAria.PlayPauseLiveAria;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ListAppComponent = {
  controller: AppController,

  view: function view(ctrl, attrs) {
    var _trackStyles;

    var playerApiEmit = ctrl.playerApiEmit,
        albumTranslationKeys = ctrl.albumTranslationKeys;
    var album = attrs.album,
        settings = attrs.settings,
        playback = attrs.playback,
        playerApi = attrs.playerApi,
        config = attrs.config;
    var tracks = album.tracks;
    var buttonStyle = settings.buttonStyle,
        _settings$listLayoutT = settings.listLayoutTrackStyle,
        listLayoutTrackStyle = _settings$listLayoutT === undefined ? LIST_LAYOUT_TRACK_STYLE.BASIC : _settings$listLayoutT,
        canShareAlbum = settings.canShareAlbum,
        _settings$showTrackDu = settings.showTrackDuration,
        showTrackDuration = _settings$showTrackDu === undefined ? true : _settings$showTrackDu,
        _settings$showAlbumIn = settings.showAlbumInfo,
        showAlbumInfo = _settings$showAlbumIn === undefined ? true : _settings$showAlbumIn;

    var shouldShowAlbumInfo = !ctrl.hasTracks() || showAlbumInfo;
    var showNoTracks = !ctrl.hasTracks();
    var trackStyles = (_trackStyles = {}, _defineProperty(_trackStyles, LIST_LAYOUT_TRACK_STYLE.BASIC, 'basic'), _defineProperty(_trackStyles, LIST_LAYOUT_TRACK_STYLE.MINIMAL, 'minimal'), _defineProperty(_trackStyles, LIST_LAYOUT_TRACK_STYLE.COVER, 'cover'), _trackStyles);
    var showTrackCover = listLayoutTrackStyle === LIST_LAYOUT_TRACK_STYLE.COVER;
    var className = ['app', 'app_' + trackStyles[listLayoutTrackStyle], 'app_layout_list', 'app_button-style_' + BUTTON_STYLE_CLASSES[buttonStyle], 'app_show-tracklist', shouldShowAlbumInfo ? '' : 'app_hide_album_info', ctrl.shareModalOpened ? 'app_overlay-opened' : 'app_overlay-hidden', playback.preview.isPreview ? 'app_preview' : ''].join(' ');
    var shouldDisableShareBuy = ctrl.shouldDisableShareBuy();
    var showBuyShareActions = album.purchaseAvail || canShareAlbum;
    var shouldShowAddFirst = ctrl.isEditor();

    return {
      tag: 'div',
      children: [shouldShowAlbumInfo ? {
        tag: 'div',
        children: [m.component(AlbumInfo, {
          showBuyShareActions: showBuyShareActions,
          showNoTracks: showNoTracks,
          album: album,
          playback: playback,
          shouldShowAddFirst: shouldShowAddFirst,
          albumTranslationKeys: albumTranslationKeys,
          buyAlbum: function buyAlbum() {
            return ctrl.buyAlbum();
          },
          isDisabled: shouldDisableShareBuy,
          canShare: settings.canShareAlbum,
          onShare: function onShare(network) {
            return ctrl.shareAlbum(network);
          }
        }, [])]
      } : null, {
        tag: 'div',
        children: [m.component(AudioPlayer, {
          playback: playback,
          statisticEvents: playerApi.statisticEvents,
          onTimeUpdate: playerApiEmit('timeupdate'),
          onLoadedProgress: playerApiEmit('progress'),
          onEnded: playerApiEmit('pause')
        }, []), m.component(PlayPauseLiveAria, { isPlaying: playback.isPlaying }, []), m.component(TrackList, {
          tracks: tracks,
          albumName: album.name,
          buy: function buy(trackId) {
            return ctrl.buyTrack(trackId);
          },
          onShare: function onShare(network, track) {
            return ctrl.shareTrack(network, track);
          },
          isBuyDisabled: shouldDisableShareBuy,
          isShareDisabled: shouldDisableShareBuy,
          buyClassName: 'wiring-button',
          settings: settings,
          playback: playback,
          openTrackPage: function openTrackPage(trackId) {
            return ctrl.openTrackPage(trackId);
          },
          trackCoverDefault: album.cover,
          showTrackCover: showTrackCover,
          showTrackDuration: showTrackDuration,
          trackStyle: listLayoutTrackStyle
        }, [])],
        attrs: { className: 'app-content' }
      }],
      attrs: { className: className, config: config }
    };
  }
};

exports.ListAppComponent = ListAppComponent;

/***/ }),
/* 212 */
/* no static exports found */
/* all exports used */
/*!****************************************************************************!*\
  !*** ./scripts/player/v2/desktop/list/components/album-info/album-info.js ***!
  \****************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AlbumInfo = undefined;

var _mithril = __webpack_require__(/*! mithril */ 0);

var m = _interopRequireDefault(_mithril).default;

var _noTracks = __webpack_require__(/*! ../../../../shared/components/no-tracks */ 91);

var NoTracks = _noTracks.NoTracks;

var _albumTitles = __webpack_require__(/*! ../album-titles/album-titles */ 214);

var AlbumTitles = _albumTitles.AlbumTitles;

var _buyShareActions = __webpack_require__(/*! ../buy-share-actions */ 217);

var BuyShareActions = _buyShareActions.BuyShareActions;

var _shareAlbum = __webpack_require__(/*! ../share-album */ 218);

var ShareAlbum = _shareAlbum.ShareAlbum;

__webpack_require__(/*! ./album-info.less */ 259);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AlbumInfo = {
  view: function view(ctrl, attrs) {
    var album = attrs.album,
        albumTranslationKeys = attrs.albumTranslationKeys,
        playback = attrs.playback,
        showBuyShareActions = attrs.showBuyShareActions,
        shouldShowAddFirst = attrs.shouldShowAddFirst,
        buyAlbum = attrs.buyAlbum,
        isDisabled = attrs.isDisabled,
        canShare = attrs.canShare,
        onShare = attrs.onShare,
        showNoTracks = attrs.showNoTracks;


    return {
      tag: 'div',
      children: [{
        tag: 'div',
        children: [m.component(AlbumTitles, { album: album, playback: playback, albumTranslationKeys: albumTranslationKeys }, []), showBuyShareActions ? m.component(BuyShareActions, {
          buyAlbumClass: 'buy-share__buy-album wiring-button',
          album: album,
          albumTranslationKeys: albumTranslationKeys,
          buyAlbum: buyAlbum,
          isDisabled: isDisabled,
          canShare: canShare,
          ShareAlbum: ShareAlbum,
          onShare: onShare
        }, []) : null],
        attrs: { className: 'album-titles-actions' }
      }, showNoTracks ? m.component(NoTracks, { albumTranslationKeys: albumTranslationKeys, shouldShowAddFirst: shouldShowAddFirst }, []) : {
        tag: 'div',
        attrs: { className: 'album-info-separator' }
      }],
      attrs: { className: 'album-info', id: 'top-part' }
    };
  }
};

exports.AlbumInfo = AlbumInfo;

/***/ }),
/* 213 */
/* no static exports found */
/* all exports used */
/*!***********************************************************************!*\
  !*** ./scripts/player/v2/desktop/list/components/album-info/index.js ***!
  \***********************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _albumInfo = __webpack_require__(/*! ./album-info */ 212);

Object.defineProperty(exports, 'AlbumInfo', {
  enumerable: true,
  get: function get() {
    return _albumInfo.AlbumInfo;
  }
});

/***/ }),
/* 214 */
/* no static exports found */
/* all exports used */
/*!********************************************************************************!*\
  !*** ./scripts/player/v2/desktop/list/components/album-titles/album-titles.js ***!
  \********************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AlbumTitles = undefined;

var _mithril = __webpack_require__(/*! mithril */ 0);

var m = _interopRequireDefault(_mithril).default;

var _albumTitles = __webpack_require__(/*! ../../../../shared/components/album-titles/album-titles.controller */ 23);

var AlbumTitlesController = _albumTitles.AlbumTitlesController;

var _movingText = __webpack_require__(/*! ../../../components/moving-text */ 82);

var MovingText = _movingText.MovingText;

__webpack_require__(/*! ./album-titles.less */ 260);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AlbumTitles = {
  controller: AlbumTitlesController,
  view: function view(ctrl) {
    return {
      tag: 'div',
      children: [{
        tag: 'p',
        children: [m.component(MovingText, {}, [ctrl.album.name])],
        attrs: { className: 'album-name' }
      }, {
        tag: 'p',
        children: [m.component(MovingText, {}, [ctrl.album.artistName])],
        attrs: { className: 'artist-name' }
      }],
      attrs: { className: 'album-titles' }
    };
  }
};

exports.AlbumTitles = AlbumTitles;

/***/ }),
/* 215 */
/* no static exports found */
/* all exports used */
/*!********************************************************************************************!*\
  !*** ./scripts/player/v2/desktop/list/components/buy-share-actions/buy-share.component.js ***!
  \********************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BuyShareActions = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _translationsKeys;

var _mithril = __webpack_require__(/*! mithril */ 0);

var m = _interopRequireDefault(_mithril).default;

var _constants = __webpack_require__(/*! ../../../../../../common/constants */ 5);

var constants = _interopRequireDefault(_constants).default;

var _buyAlbum = __webpack_require__(/*! ../../../../shared/components/buy-album */ 29);

var BuyAlbum = _buyAlbum.BuyAlbum;

var _l10n = __webpack_require__(/*! ../../../../shared/l10n */ 1);

var l10n = _l10n.l10n;

var _translationKeys = __webpack_require__(/*! ../../../../shared/translation-keys */ 10);

var registerTranslationKeys = _translationKeys.registerTranslationKeys;

__webpack_require__(/*! ./buy-share-actions.less */ 261);

var _buyShare = __webpack_require__(/*! ./buy-share.controller */ 216);

var BuyShareController = _buyShare.BuyShareController;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var translationsKeys = (_translationsKeys = {}, _defineProperty(_translationsKeys, constants.ALBUM_TYPES.ALBUM, {
  buyButton: 'player_buy_album',
  downloadButton: 'player_download_album',
  getButton: 'player_get_album',
  shareButton: 'player_share_album'
}), _defineProperty(_translationsKeys, constants.ALBUM_TYPES.SINGLE, {
  buyButton: 'player_buy_single',
  downloadButton: 'player_download_single',
  getButton: 'player_get_single',
  shareButton: 'player_share_single'
}), _defineProperty(_translationsKeys, constants.ALBUM_TYPES.PLAYLIST, {
  buyButton: 'player_buy_album',
  downloadButton: 'player_download_album',
  shareButton: 'player_share_playlist'
}), _translationsKeys);

registerTranslationKeys(translationsKeys);

var BuyShareActions = {
  controller: BuyShareController,

  view: function view(ctrl, attrs) {
    var album = ctrl.album;
    var isDisabled = attrs.isDisabled,
        canShare = attrs.canShare,
        onShare = attrs.onShare,
        ShareAlbum = attrs.ShareAlbum,
        _attrs$shareAlbumAttr = attrs.shareAlbumAttrs,
        shareAlbumAttrs = _attrs$shareAlbumAttr === undefined ? {} : _attrs$shareAlbumAttr,
        _attrs$buyAlbumClass = attrs.buyAlbumClass,
        buyAlbumClass = _attrs$buyAlbumClass === undefined ? '' : _attrs$buyAlbumClass,
        albumTranslationKeys = attrs.albumTranslationKeys,
        _attrs$buyTextKey = attrs.buyTextKey,
        buyTextKey = _attrs$buyTextKey === undefined ? albumTranslationKeys.buyButton : _attrs$buyTextKey;
    var albumPriceFormatted = album.albumPriceFormatted,
        currency = album.currency,
        currencySymbol = album.currencySymbol;

    var className = ['buy-share', isDisabled ? 'buy-share_disabled' : ''].join(' ');

    var shareButton = m.component(ShareAlbum, _extends({}, shareAlbumAttrs, {
      accName: l10n(albumTranslationKeys.shareButton) + ' ' + album.name,
      shareItem: album,
      isDisabled: isDisabled,
      onShare: onShare
    }), [l10n(albumTranslationKeys.shareButton)]);

    return {
      tag: 'div',
      children: [{
        tag: 'div',
        children: [canShare ? shareButton : null],
        attrs: { className: 'share-wrapper' }
      }, {
        tag: 'div',
        children: [m.component(BuyAlbum, {
          album: album,
          className: buyAlbumClass,
          buy: attrs.buyAlbum,
          buyTextKey: buyTextKey,
          downloadTextKey: albumTranslationKeys.downloadButton,
          getTextKey: albumTranslationKeys.getButton,
          hasExternalLinks: album.externalLinks && album.externalLinks.length,
          isDisabled: isDisabled,
          price: albumPriceFormatted,
          currency: currency,
          currencySymbol: currencySymbol,
          isFree: ctrl.isFree(),
          isDownloadable: ctrl.canBuy()
        }, [])],
        attrs: { className: 'buy-wrapper' }
      }],
      attrs: { className: className }
    };
  }
};

exports.BuyShareActions = BuyShareActions;

/***/ }),
/* 216 */
/* no static exports found */
/* all exports used */
/*!*********************************************************************************************!*\
  !*** ./scripts/player/v2/desktop/list/components/buy-share-actions/buy-share.controller.js ***!
  \*********************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BuyShareController = exports.BuyShareController = function () {
  function BuyShareController(_ref) {
    var album = _ref.album;

    _classCallCheck(this, BuyShareController);

    this.album = album;
  }

  _createClass(BuyShareController, [{
    key: "canBuy",
    value: function canBuy() {
      return this.album.purchaseAvail;
    }
  }, {
    key: "isFree",
    value: function isFree() {
      return this.canBuy() && this.album.albumPrice === 0;
    }
  }, {
    key: "getFirstFreeTrack",
    value: function getFirstFreeTrack() {
      return this.album.tracks.find(function (track) {
        return track.purchaseAvail && track.trackPrice === 0;
      });
    }
  }, {
    key: "getTheMostExpensiveTrack",
    value: function getTheMostExpensiveTrack() {
      var purchasable = this.album.tracks.filter(function (track) {
        return track.purchaseAvail && track.trackPrice > 0;
      });
      if (!purchasable.length) {
        return;
      }
      return purchasable.sort(function (trackA, trackB) {
        return trackB.trackPrice - trackA.trackPrice;
      })[0];
    }
  }]);

  return BuyShareController;
}();

/***/ }),
/* 217 */
/* no static exports found */
/* all exports used */
/*!******************************************************************************!*\
  !*** ./scripts/player/v2/desktop/list/components/buy-share-actions/index.js ***!
  \******************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _buyShare = __webpack_require__(/*! ./buy-share.component */ 215);

Object.defineProperty(exports, 'BuyShareActions', {
  enumerable: true,
  get: function get() {
    return _buyShare.BuyShareActions;
  }
});

/***/ }),
/* 218 */
/* no static exports found */
/* all exports used */
/*!************************************************************************!*\
  !*** ./scripts/player/v2/desktop/list/components/share-album/index.js ***!
  \************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _shareAlbum = __webpack_require__(/*! ./share-album */ 219);

Object.defineProperty(exports, 'ShareAlbum', {
  enumerable: true,
  get: function get() {
    return _shareAlbum.ShareAlbum;
  }
});

/***/ }),
/* 219 */
/* no static exports found */
/* all exports used */
/*!******************************************************************************!*\
  !*** ./scripts/player/v2/desktop/list/components/share-album/share-album.js ***!
  \******************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ShareAlbum = undefined;

var _mithril = __webpack_require__(/*! mithril */ 0);

var m = _interopRequireDefault(_mithril).default;

var _share = __webpack_require__(/*! ../../../../shared/icons/share.svg */ 13);

var shareIcon = _interopRequireDefault(_share).default;

var _shareButton = __webpack_require__(/*! ../../../components/share-button */ 52);

var ShareButton = _shareButton.ShareButton;

__webpack_require__(/*! ./share-album.less */ 262);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ShareAlbum = exports.ShareAlbum = {
  view: function view(ctrl, attrs) {
    var onShare = attrs.onShare,
        isDisabled = attrs.isDisabled,
        accName = attrs.accName;


    return {
      tag: 'div',
      children: [{
        tag: 'div',
        children: [{
          tag: 'div',
          children: [m.component(ShareButton, { isDisabled: isDisabled, onShare: onShare }, [{
            tag: 'span',
            children: [m.trust(shareIcon)],
            attrs: { 'aria-hidden': 'true' }
          }])],
          attrs: { className: 'share-album', 'aria-label': accName }
        }],
        attrs: { className: 'buy-share__centering-wrapper' }
      }],
      attrs: { className: 'buy-share__share' }
    };
  }
};

/***/ }),
/* 220 */
/* no static exports found */
/* all exports used */
/*!***********************************************************************!*\
  !*** ./scripts/player/v2/desktop/list/components/track-list/index.js ***!
  \***********************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TrackListDesktop = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _mithril = __webpack_require__(/*! mithril */ 0);

var m = _interopRequireDefault(_mithril).default;

var _trackList = __webpack_require__(/*! ../../../../shared/components/track-list/track-list.component */ 51);

var TrackList = _trackList.TrackList;

var _scrollToTrack = __webpack_require__(/*! ../../../../shared/components/track-list/scroll-to-track */ 50);

var scrollToTrack = _scrollToTrack.scrollToTrack;

__webpack_require__(/*! ../../../components/track-list/track-list.less */ 94);

var _track = __webpack_require__(/*! ./track */ 221);

var Track = _track.Track;

__webpack_require__(/*! ./track-list.less */ 263);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TrackListDesktop = {
  view: function view(ctrl, attrs) {
    var playback = attrs.playback,
        openTrackPage = attrs.openTrackPage,
        tracks = attrs.tracks;

    var handleOpenTrackPage = function handleOpenTrackPage(trackId) {
      var track = tracks.find(function (track) {
        return track.id === trackId;
      });
      if (playback.currentTrack !== track) {
        playback.pause();
        // we need this setTimeout, because otherwise
        // pause event is not sent from 'audio' element for some reason
        // therefore playback.isPlaying stays true and pause icon is still shown
        setTimeout(function () {
          playback.setCurrent(track);
        }, 0);
      }
      openTrackPage(trackId);
    };
    return m.component(TrackList, _extends({}, attrs, { openTrackPage: handleOpenTrackPage, Track: Track, scrollToTrack: scrollToTrack }), []);
  }
};

exports.TrackListDesktop = TrackListDesktop;

/***/ }),
/* 221 */
/* no static exports found */
/* all exports used */
/*!*****************************************************************************!*\
  !*** ./scripts/player/v2/desktop/list/components/track-list/track/index.js ***!
  \*****************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _track = __webpack_require__(/*! ./track */ 232);

Object.defineProperty(exports, 'Track', {
  enumerable: true,
  get: function get() {
    return _track.Track;
  }
});

/***/ }),
/* 222 */
/* no static exports found */
/* all exports used */
/*!*****************************************************************************************!*\
  !*** ./scripts/player/v2/desktop/list/components/track-list/track/track-index/index.js ***!
  \*****************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _trackIndex = __webpack_require__(/*! ./track-index */ 224);

Object.defineProperty(exports, 'TrackIndex', {
  enumerable: true,
  get: function get() {
    return _trackIndex.TrackIndex;
  }
});

/***/ }),
/* 223 */
/* no static exports found */
/* all exports used */
/*!**********************************************************************************************************!*\
  !*** ./scripts/player/v2/desktop/list/components/track-list/track/track-index/track-index.controller.js ***!
  \**********************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TrackIndexController = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = __webpack_require__(/*! ../../../../../../../../utils/utils */ 2);

var utils = _utils.utils;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TrackIndexController = exports.TrackIndexController = function () {
  function TrackIndexController() {
    _classCallCheck(this, TrackIndexController);
  }

  _createClass(TrackIndexController, [{
    key: 'getTrackCoverStyle',
    value: function getTrackCoverStyle(originalUrl, mode, width, height) {
      var scaledImageUrl = utils.buildScaledImageUrl(originalUrl, mode, width, height);
      var background = 'url("' + scaledImageUrl + '") center center / ' + width + 'px ' + height + 'px no-repeat';

      return { background: background };
    }
  }]);

  return TrackIndexController;
}();

/***/ }),
/* 224 */
/* no static exports found */
/* all exports used */
/*!***********************************************************************************************!*\
  !*** ./scripts/player/v2/desktop/list/components/track-list/track/track-index/track-index.js ***!
  \***********************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TrackIndex = undefined;

var _classnames = __webpack_require__(/*! classnames */ 3);

var classNames = _interopRequireDefault(_classnames).default;

var _mithril = __webpack_require__(/*! mithril */ 0);

var m = _interopRequireDefault(_mithril).default;

var _pauseRounded = __webpack_require__(/*! ../../../../../../shared/icons/pause-rounded.svg */ 301);

var pauseIcon = _interopRequireDefault(_pauseRounded).default;

var _playRounded = __webpack_require__(/*! ../../../../../../shared/icons/play-rounded.svg */ 304);

var playIcon = _interopRequireDefault(_playRounded).default;

var _l10n = __webpack_require__(/*! ../../../../../../shared/l10n */ 1);

var l10n = _l10n.l10n;

var _trackIndex = __webpack_require__(/*! ./track-index.controller */ 223);

var TrackIndexController = _trackIndex.TrackIndexController;

__webpack_require__(/*! ./track-index.less */ 264);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TrackIndex = {
  controller: TrackIndexController,
  view: function view(ctrl, attrs) {
    var number = attrs.number,
        coverUrl = attrs.coverUrl,
        showTrackCover = attrs.showTrackCover;

    var coverSize = 78;
    var coverStyle = '';

    if (showTrackCover && coverUrl) {
      coverStyle = ctrl.getTrackCoverStyle(coverUrl, 'fill', coverSize, coverSize);
    }
    var coverClassName = classNames('track-index-cover', {
      'track-index-cover_dummy': !coverUrl && showTrackCover
    });

    return {
      tag: 'div',
      children: [{
        tag: 'div',
        children: [number],
        attrs: { className: 'track-index-number' }
      }, {
        tag: 'div',
        children: [{
          tag: 'div',
          children: [{
            tag: 'div',
            children: [{
              tag: 'div',
              children: [m.trust(playIcon)],
              attrs: { className: 'play', 'aria-hidden': 'true' }
            }, {
              tag: 'div',
              children: [m.trust(pauseIcon)],
              attrs: { className: 'pause', 'aria-hidden': 'true' }
            }],
            attrs: { className: 'track-index-control' }
          }],
          attrs: { className: 'track-control-wrapper' }
        }],
        attrs: {
          className: coverClassName,
          style: coverStyle,
          role: coverStyle ? 'img' : '',
          'aria-label': coverStyle ? l10n('player_acc_track_cover') : ''
        }
      }],
      attrs: { className: 'track-index' }
    };
  }
};

exports.TrackIndex = TrackIndex;

/***/ }),
/* 225 */
/* no static exports found */
/* all exports used */
/*!****************************************************************************************!*\
  !*** ./scripts/player/v2/desktop/list/components/track-list/track/track-name/index.js ***!
  \****************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _trackName = __webpack_require__(/*! ./track-name */ 226);

Object.defineProperty(exports, 'TrackName', {
  enumerable: true,
  get: function get() {
    return _trackName.TrackName;
  }
});

/***/ }),
/* 226 */
/* no static exports found */
/* all exports used */
/*!*********************************************************************************************!*\
  !*** ./scripts/player/v2/desktop/list/components/track-list/track/track-name/track-name.js ***!
  \*********************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TrackName = undefined;

var _mithril = __webpack_require__(/*! mithril */ 0);

var m = _interopRequireDefault(_mithril).default;

var _v2SettingsConstants = __webpack_require__(/*! ../../../../../../../../common/parse-settings/v2-settings-constants */ 4);

var LIST_LAYOUT_TRACK_STYLE = _v2SettingsConstants.LIST_LAYOUT_TRACK_STYLE;

var _artistName = __webpack_require__(/*! ../../../../../../shared/artist-name */ 20);

var getFullArtistName = _artistName.getFullArtistName;

var _movingText = __webpack_require__(/*! ../../../../../components/moving-text */ 82);

var MovingText = _movingText.MovingText;

__webpack_require__(/*! ./track-name.less */ 265);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TrackName = {
  view: function view(ctrl, attrs) {
    var track = attrs.track,
        showArtist = attrs.showArtist,
        trackStyle = attrs.trackStyle;

    var isMinimalStyle = trackStyle === LIST_LAYOUT_TRACK_STYLE.MINIMAL;
    var trackName = track.name;
    var artistName = getFullArtistName(track);
    var trackArtistSeparator = ' / ';
    var trackNameElement = {
      tag: 'span',
      children: [trackName]
    };
    var trackArtistElement = {
      tag: 'span',
      children: [artistName]
    };

    if (isMinimalStyle) {
      var minimalTrackNameElement = showArtist ? {
        tag: 'span',
        children: [trackName, trackArtistSeparator, {
          tag: 'span',
          children: [artistName],
          attrs: { className: 'track-artist-name' }
        }]
      } : trackNameElement;

      return {
        tag: 'div',
        children: [m.component(MovingText, {}, [minimalTrackNameElement])],
        attrs: { className: 'track-name-wrapper' }
      };
    } else if (showArtist) {
      return {
        tag: 'div',
        children: [{
          tag: 'div',
          children: [m.component(MovingText, {}, [trackNameElement])],
          attrs: { className: 'track-name' }
        }, {
          tag: 'div',
          children: [m.component(MovingText, {}, [trackArtistElement])],
          attrs: { className: 'track-artist-name' }
        }],
        attrs: { className: 'track-name-wrapper' }
      };
    }

    return {
      tag: 'div',
      children: [{
        tag: 'div',
        children: [m.component(MovingText, {}, [trackNameElement])],
        attrs: { className: 'track-name' }
      }],
      attrs: { className: 'track-name-wrapper' }
    };
  }
};

exports.TrackName = TrackName;

/***/ }),
/* 227 */
/* no static exports found */
/* all exports used */
/*!***********************************************************************************************!*\
  !*** ./scripts/player/v2/desktop/list/components/track-list/track/track-page-button/index.js ***!
  \***********************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _trackPageButton = __webpack_require__(/*! ./track-page-button */ 228);

Object.defineProperty(exports, 'TrackPageButton', {
  enumerable: true,
  get: function get() {
    return _trackPageButton.TrackPageButton;
  }
});

/***/ }),
/* 228 */
/* no static exports found */
/* all exports used */
/*!***********************************************************************************************************!*\
  !*** ./scripts/player/v2/desktop/list/components/track-list/track/track-page-button/track-page-button.js ***!
  \***********************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TrackPageButton = undefined;

var _mithril = __webpack_require__(/*! mithril */ 0);

var m = _interopRequireDefault(_mithril).default;

var _trackInfo = __webpack_require__(/*! ../../../../../../shared/icons/track-info.svg */ 28);

var trackInfoIcon = _interopRequireDefault(_trackInfo).default;

var _l10n = __webpack_require__(/*! ../../../../../../shared/l10n */ 1);

var l10n = _l10n.l10n;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TrackPageButton = exports.TrackPageButton = {
  view: function view(ctrl, attrs) {
    var openTrackPage = attrs.openTrackPage;


    return {
      tag: 'button',
      children: [{
        tag: 'span',
        children: [m.trust(trackInfoIcon)],
        attrs: { 'aria-hidden': 'true' }
      }],
      attrs: { className: 'track-info', 'aria-label': l10n('player_acc_track_info'), onclick: openTrackPage }
    };
  }
};

/***/ }),
/* 229 */
/* no static exports found */
/* all exports used */
/*!************************************************************************************************!*\
  !*** ./scripts/player/v2/desktop/list/components/track-list/track/track-progress-bar/index.js ***!
  \************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _trackProgressBar = __webpack_require__(/*! ./track-progress-bar */ 231);

Object.defineProperty(exports, 'TrackProgressBar', {
  enumerable: true,
  get: function get() {
    return _trackProgressBar.TrackProgressBar;
  }
});

/***/ }),
/* 230 */
/* no static exports found */
/* all exports used */
/*!*************************************************************************************************!*\
  !*** ./scripts/player/v2/desktop/list/components/track-list/track/track-progress-bar/slider.js ***!
  \*************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Slider = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _classnames = __webpack_require__(/*! classnames */ 3);

var classNames = _interopRequireDefault(_classnames).default;

var _mithril = __webpack_require__(/*! mithril */ 0);

var m = _interopRequireDefault(_mithril).default;

var _handleKeyboardSlider = __webpack_require__(/*! ../../../../../../../../utils/handle-keyboard-slider/handle-keyboard-slider */ 30);

var handleKeyboardSlider = _handleKeyboardSlider.handleKeyboardSlider;

var _utils = __webpack_require__(/*! ../../../../../../../../utils/utils */ 2);

var utils = _utils.utils;

var _slider = __webpack_require__(/*! ../../../../../../shared/components/slider/slider.controller */ 58);

var SliderController = _slider.SliderController;

var _l10n = __webpack_require__(/*! ../../../../../../shared/l10n */ 1);

var l10n = _l10n.l10n;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Slider = {
  controller: SliderController,

  view: function view(ctrl, attrs) {
    var _attrs$isActive = attrs.isActive,
        isActive = _attrs$isActive === undefined ? true : _attrs$isActive,
        progress = attrs.progress,
        _attrs$minValue = attrs.minValue,
        minValue = _attrs$minValue === undefined ? 0 : _attrs$minValue,
        _attrs$maxValue = attrs.maxValue,
        maxValue = _attrs$maxValue === undefined ? 1 : _attrs$maxValue,
        _attrs$step = attrs.step,
        step = _attrs$step === undefined ? 5 : _attrs$step,
        valueText = attrs.valueText,
        played = attrs.played,
        isPreview = attrs.isPreview;

    ctrl.progress = progress;
    ctrl.minValue = minValue;
    ctrl.maxValue = maxValue;
    var loaded = Math.max(attrs.loaded, ctrl.visibleProgress);
    var progressStyle = isPreview ? {} : {
      width: ctrl.visibleProgress * 100 + '%'
    };
    var notLoadedStyle = isPreview ? {} : {
      width: 100 - loaded * 100 + '%'
    };

    if (!valueText) {
      // eslint-disable-next-line no-console
      console.warn('valueText is missing in track progress slider in list. We should pass valueText to slider for accessibility!');
    }

    var config = function config(el, isInitialized, context) {
      ctrl.config(el, isInitialized, context);
    };
    var startDragAttr = ctrl.startDragAttr;

    var className = classNames('slider', { 'slider_is-active': isActive });

    var handleKeydown = handleKeyboardSlider({
      decrease: function decrease() {
        ctrl.onUpdate(progress - step);
      },
      increase: function increase() {
        ctrl.onUpdate(progress + step);
      }
    });

    return {
      tag: 'div',
      children: [{
        tag: 'div',
        attrs: { className: 'track-slider-progress', style: progressStyle }
      }, {
        tag: 'div',
        children: [utils.durationToString(played)],
        attrs: { className: 'track-slider-info' }
      }, {
        tag: 'div',
        attrs: { className: 'track-slider-loaded' }
      }, {
        tag: 'div',
        attrs: { className: 'track-slider-as-divider', style: notLoadedStyle }
      }],
      attrs: _extends({
        className: className,
        role: 'slider',
        'aria-label': l10n('player_acc_progressbar'),
        'aria-valuemin': minValue,
        'aria-valuemax': maxValue,
        'aria-valuenow': progress.toFixed(1),
        'aria-valuetext': valueText,
        tabindex: '0',
        onkeydown: handleKeydown
      }, startDragAttr, {
        config: config
      })
    };
  }
};

exports.Slider = Slider;

/***/ }),
/* 231 */
/* no static exports found */
/* all exports used */
/*!*************************************************************************************************************!*\
  !*** ./scripts/player/v2/desktop/list/components/track-list/track/track-progress-bar/track-progress-bar.js ***!
  \*************************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TrackProgressBar = undefined;

var _mithril = __webpack_require__(/*! mithril */ 0);

var m = _interopRequireDefault(_mithril).default;

var _utils = __webpack_require__(/*! ../../../../../../../../utils/utils */ 2);

var utils = _utils.utils;

var _l10n = __webpack_require__(/*! ../../../../../../shared/l10n */ 1);

var l10n = _l10n.l10n;

var _slider = __webpack_require__(/*! ./slider */ 230);

var Slider = _slider.Slider;

__webpack_require__(/*! ./track-progress-bar.less */ 266);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TrackProgressBar = {
  view: function view(ctrl, attrs) {
    var duration = attrs.duration,
        played = attrs.played,
        loaded = attrs.loaded,
        onSeek = attrs.onSeek,
        isActive = attrs.isActive,
        isPreview = attrs.isPreview;

    var progress = played || 0;
    var addDragHandlers = function addDragHandlers(_ref) {
      var dragHandler = _ref.dragHandler,
          dragEndHandler = _ref.dragEndHandler;

      document.addEventListener('mousemove', dragHandler);
      document.addEventListener('mouseup', dragEndHandler);
      document.addEventListener('mouseleave', dragEndHandler);
    };
    var removeDragHandlers = function removeDragHandlers(_ref2) {
      var dragHandler = _ref2.dragHandler,
          dragEndHandler = _ref2.dragEndHandler;

      document.removeEventListener('mousemove', dragHandler);
      document.removeEventListener('mouseup', dragEndHandler);
      document.removeEventListener('mouseleave', dragEndHandler);
    };

    var playedText = utils.durationToAccString(played);
    var durationText = utils.durationToAccString(duration);

    return {
      tag: 'div',
      children: [m.component(Slider, {
        addDragHandlers: addDragHandlers,
        removeDragHandler: removeDragHandlers,
        startDragEvent: 'mousedown',
        progress: progress,
        maxValue: duration,
        valueText: l10n('player_acc_progress_value', [playedText, durationText]),
        played: played,
        loaded: loaded,
        onUpdate: onSeek,
        isActive: isActive,
        isPreview: isPreview
      }, [])],
      attrs: { className: 'progress-bar' }
    };
  }
};

exports.TrackProgressBar = TrackProgressBar;

/***/ }),
/* 232 */
/* no static exports found */
/* all exports used */
/*!*****************************************************************************!*\
  !*** ./scripts/player/v2/desktop/list/components/track-list/track/track.js ***!
  \*****************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Track = undefined;

var _mithril = __webpack_require__(/*! mithril */ 0);

var m = _interopRequireDefault(_mithril).default;

var _trackButtonLike = __webpack_require__(/*! ../../../../../shared/components/track-button-like */ 49);

var TrackButtonLike = _trackButtonLike.TrackButtonLike;

var _shareTrack = __webpack_require__(/*! ../../../../components/track-list/track/share-track */ 85);

var ShareTrack = _shareTrack.ShareTrack;

var _trackBuy = __webpack_require__(/*! ../../../../components/track-list/track/track-buy */ 86);

var TrackBuyWrapper = _trackBuy.TrackBuyWrapper;

var _track = __webpack_require__(/*! ../../../../components/track-list/track/track.controller */ 46);

var TrackController = _track.TrackController;

__webpack_require__(/*! ../../../../components/track-list/track/track.less */ 95);

var _trackIndex = __webpack_require__(/*! ./track-index */ 222);

var TrackIndex = _trackIndex.TrackIndex;

var _trackName = __webpack_require__(/*! ./track-name */ 225);

var TrackName = _trackName.TrackName;

var _trackPageButton = __webpack_require__(/*! ./track-page-button */ 227);

var TrackPageButton = _trackPageButton.TrackPageButton;

var _trackProgressBar = __webpack_require__(/*! ./track-progress-bar */ 229);

var TrackProgressBar = _trackProgressBar.TrackProgressBar;

__webpack_require__(/*! ./track.less */ 267);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Track = {
  controller: TrackController,
  view: function view(ctrl, attrs) {
    var number = attrs.number,
        track = attrs.track,
        isPlaying = attrs.isPlaying,
        isCurrent = attrs.isCurrent,
        canShare = attrs.canShare,
        showArtist = attrs.showArtist,
        duration = attrs.duration,
        played = attrs.played,
        loaded = attrs.loaded,
        onSeek = attrs.onSeek,
        trackCoverDefault = attrs.trackCoverDefault,
        showTrackCover = attrs.showTrackCover,
        showTrackDuration = attrs.showTrackDuration,
        trackStyle = attrs.trackStyle,
        isPreview = attrs.isPreview;


    ctrl.updateAttrs(attrs);

    var className = ['track', isPlaying ? 'track_is-playing' : '', isCurrent ? 'track_is-current' : '', canShare || track.purchaseAvail ? 'track_show-actions' : ''].join(' ');

    var openTrackPage = function openTrackPage(event) {
      track && attrs.openTrackPage(track.id);
      event.stopPropagation();
    };

    var coverUrl = track.cover || trackCoverDefault;

    var shareData = ctrl.getShareData();
    var buyData = {
      isPurchaseAvailable: ctrl.isPurchaseAvailable(),
      hasTracksForPurchase: attrs.hasTracksForPurchase,
      buy: attrs.buy,
      isBuyDisabled: attrs.isBuyDisabled,
      isFree: ctrl.isFree(),
      buyClassName: 'wiring-button'
    };

    return {
      tag: 'li',
      children: [m.component(TrackButtonLike, { onActivation: function onActivation() {
          return ctrl.togglePlaying();
        }, ariaLabel: ctrl.getAriaLabel() }, [{
        tag: 'div',
        children: [m.component(TrackIndex, {
          track: track,
          number: number,
          coverUrl: coverUrl,
          showTrackCover: showTrackCover,
          isPlaying: isPlaying,
          isCurrent: isCurrent
        }, []), m.component(TrackName, { track: track, showArtist: showArtist, trackStyle: trackStyle }, []), showTrackDuration ? {
          tag: 'div',
          children: [track.duration],
          attrs: { className: 'track-duration' }
        } : null, shareData.canShare ? m.component(ShareTrack, {
          isDisabled: shareData.isShareDisabled,
          shareItem: track,
          onShare: shareData.onShare,
          ShareIcons: shareData.ShareIcons
        }, []) : null, m.component(TrackPageButton, { openTrackPage: openTrackPage }, []), m.component(TrackBuyWrapper, {
          track: track,
          isPurchaseAvailable: buyData.isPurchaseAvailable,
          hasTracksForPurchase: buyData.hasTracksForPurchase,
          buyClassName: buyData.buyClassName,
          buy: buyData.buy,
          isBuyDisabled: buyData.isBuyDisabled,
          isFree: buyData.isFree
        }, [])],
        attrs: { className: className }
      }]), m.component(TrackProgressBar, {
        duration: duration,
        played: played,
        loaded: loaded,
        onSeek: onSeek,
        isActive: isCurrent,
        isPreview: isPreview
      }, [])],
      attrs: { className: 'track-wrapper track__list-item' }
    };
  }
};

exports.Track = Track;

/***/ }),
/* 233 */
/* no static exports found */
/* all exports used */
/*!*************************************************************!*\
  !*** ./scripts/player/v2/desktop/vertical/app.component.js ***!
  \*************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VerticalAppComponent = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _mithril = __webpack_require__(/*! mithril */ 0);

var m = _interopRequireDefault(_mithril).default;

var _v2SettingsConstants = __webpack_require__(/*! ../../../../common/parse-settings/v2-settings-constants */ 4);

var SETTINGS_CONSTANTS = _interopRequireWildcard(_v2SettingsConstants);

var _index = __webpack_require__(/*! ../../shared/app-keyboard-handler/index */ 47);

var handleAppKeydown = _index.handleAppKeydown;

var _app = __webpack_require__(/*! ../../shared/app/app.controller */ 22);

var AppController = _app.AppController;

var _albumCover = __webpack_require__(/*! ../../shared/components/album-cover */ 48);

var AlbumCover = _albumCover.AlbumCover;

var _audioPlayer = __webpack_require__(/*! ../../shared/components/audio-player */ 24);

var AudioPlayer = _audioPlayer.AudioPlayer;

var _buyShareActions = __webpack_require__(/*! ../../shared/components/buy-share-actions */ 81);

var BuyShareActions = _buyShareActions.BuyShareActions;

var _shareAlbum = __webpack_require__(/*! ../components/share-album */ 83);

var ShareAlbum = _shareAlbum.ShareAlbum;

var _trackList = __webpack_require__(/*! ../components/track-list */ 84);

var TrackList = _trackList.TrackListDesktop;

var _albumTitles = __webpack_require__(/*! ./components/album-titles */ 237);

var AlbumTitles = _albumTitles.AlbumTitles;

var _controlBar = __webpack_require__(/*! ./components/control-bar */ 240);

var ControlBar = _controlBar.ControlBar;

var _shareIcons = __webpack_require__(/*! ./components/share-icons */ 241);

var ShareIcons = _shareIcons.ShareIcons;

__webpack_require__(/*! ./styles/app.less */ 276);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var controlBarTypeFromSettings = function controlBarTypeFromSettings(settings) {
  return settings.controlBarType === SETTINGS_CONSTANTS.CONTROL_BAR_TYPE.CENTER ? 'center' : 'left';
};

var AlbumTitlesContainer = {
  controller: AppController,
  view: function view(ctrl, attrs) {
    var albumTranslationKeys = ctrl.albumTranslationKeys;
    var album = attrs.album,
        settings = attrs.settings,
        playback = attrs.playback;

    var controlBarType = controlBarTypeFromSettings(settings);
    var shouldDisableBuyShare = ctrl.shouldDisableShareBuy();
    return m.component(AlbumTitles, {
      album: album,
      playback: playback,
      settings: settings,
      buy: function buy(track) {
        return ctrl.buyTrack(track);
      },
      shouldShowBuyCurrentTrack: !settings.trackListShow && ctrl.isVisibleTrackPurchasable(),
      shouldShowFakeBuyTrack: !settings.trackListShow && ctrl.isAnyTrackPurchasable(),
      theme: controlBarType,
      isBuyDisabled: shouldDisableBuyShare,
      albumTranslationKeys: albumTranslationKeys
    }, []);
  }
};

var VerticalAppComponent = {
  controller: AppController,
  view: function view(ctrl, attrs) {
    var playerApiEmit = ctrl.playerApiEmit,
        albumTranslationKeys = ctrl.albumTranslationKeys;
    var album = attrs.album,
        settings = attrs.settings,
        playback = attrs.playback,
        playerApi = attrs.playerApi,
        config = attrs.config;
    var tracks = album.tracks;

    var controlBarType = controlBarTypeFromSettings(settings);
    var isInfoAbove = settings.infoPlacement === SETTINGS_CONSTANTS.INFO_PLACEMENT.ABOVE;
    var showingCover = settings.albumCoverShow;
    var trackListShow = settings.trackListShow;
    var shouldDisableBuyShare = ctrl.shouldDisableShareBuy();
    var showBuyShareActions = album.purchaseAvail || settings.canShareAlbum;
    var imageResizeMode = settings.imageResizeMode,
        buttonStyle = settings.buttonStyle;


    if (!showingCover) {
      playerApi.emit('album-cover-loaded');
    }
    var className = ['app', 'app_layout_vertical', 'app_control-bar_' + controlBarType, 'app_button-style_' + SETTINGS_CONSTANTS.BUTTON_STYLE_CLASSES[buttonStyle], !showBuyShareActions ? 'app_no-buy-share' : '', isInfoAbove ? 'app_info_above' : 'app_info_below', !showingCover ? 'app_hide-cover' : '', !ctrl.hasTracks() ? 'app_no-tracks' : '', !trackListShow ? 'app_no-tracklist' : 'app_show-tracklist', playback.preview.isPreview ? 'app_preview' : ''].join(' ');

    return {
      tag: 'div',
      children: [{
        tag: 'div',
        children: [m.component(AudioPlayer, {
          playback: playback,
          statisticEvents: playerApi.statisticEvents,
          onTimeUpdate: playerApiEmit('timeupdate'),
          onLoadedProgress: playerApiEmit('progress'),
          onEnded: playerApiEmit('pause')
        }, []), showBuyShareActions ? m.component(BuyShareActions, {
          album: album,
          albumTranslationKeys: albumTranslationKeys,
          buyAlbum: function buyAlbum() {
            return ctrl.buyAlbum();
          },
          isDisabled: shouldDisableBuyShare,
          canShare: settings.canShareAlbum,
          ShareAlbum: ShareAlbum,
          shareAlbumAttrs: { ShareIcons: ShareIcons },
          onShare: function onShare(network) {
            return ctrl.shareAlbum(network);
          }
        }, []) : null, showingCover ? m.component(AlbumCover, _extends({
          imageResizeMode: imageResizeMode,
          onCoverReady: function onCoverReady() {
            return playerApi.emit('album-cover-loaded');
          }
        }, ctrl.getCurrentCoverInfo()), [isInfoAbove ? m.component(AlbumTitlesContainer, attrs, []) : null]) : null, !isInfoAbove ? m.component(AlbumTitlesContainer, attrs, []) : null, m.component(ControlBar, {
          theme: controlBarType,
          playback: playback,
          isDisabled: !ctrl.hasTracks(),
          showDetailedTrackInfo: settings.showDetailedTrackInfo,
          openTrackPage: function openTrackPage(trackId) {
            return ctrl.openTrackPage(trackId);
          },
          track: playback.currentTrack || playback.getFirstTrack()
        }, [])],
        attrs: { id: 'top-part', className: 'top-part' }
      }, trackListShow ? m.component(TrackList, {
        tracks: tracks,
        albumName: album.name,
        ShareIcons: ShareIcons,
        isBuyDisabled: shouldDisableBuyShare,
        isShareDisabled: shouldDisableBuyShare,
        buy: function buy(track) {
          return ctrl.buyTrack(track);
        },
        buyClassName: 'wiring-button',
        onShare: function onShare(network, track) {
          return ctrl.shareTrack(network, track);
        },
        settings: settings,
        playback: playback
      }, []) : null],
      attrs: { className: className, config: config }
    };
  }
};

exports.VerticalAppComponent = VerticalAppComponent;

/***/ }),
/* 234 */
/* no static exports found */
/* all exports used */
/*!*****************************************************************************************************!*\
  !*** ./scripts/player/v2/desktop/vertical/components/album-titles/album-titles-center.component.js ***!
  \*****************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AlbumTitlesCenter = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _mithril = __webpack_require__(/*! mithril */ 0);

var m = _interopRequireDefault(_mithril).default;

__webpack_require__(/*! ./album-titles-center.less */ 272);

var _albumTitlesView = __webpack_require__(/*! ./album-titles-view.component */ 88);

var AlbumTitlesView = _albumTitlesView.AlbumTitlesView;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AlbumTitlesCenter = {
  view: function view(ctrl, attrs) {
    var fakeTrack = {
      price: 200,
      currency: 'USD',
      currencySymbol: '$',
      purchaseAvail: true
    };

    return {
      tag: 'div',
      children: [{
        tag: 'div',
        children: [m.component(AlbumTitlesView, _extends({}, attrs, { track: fakeTrack, theme: 'center' }), [])],
        attrs: { className: 'album-titles-center__height-layer', 'aria-hidden': 'true' }
      }, {
        tag: 'div',
        children: [m.component(AlbumTitlesView, _extends({}, attrs, { theme: 'center' }), [])],
        attrs: { className: 'album-titles-center__real-layer' }
      }],
      attrs: { className: 'album-titles-center' }
    };
  }
};

exports.AlbumTitlesCenter = AlbumTitlesCenter;

/***/ }),
/* 235 */
/* no static exports found */
/* all exports used */
/*!***************************************************************************************************!*\
  !*** ./scripts/player/v2/desktop/vertical/components/album-titles/album-titles-left.component.js ***!
  \***************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AlbumTitlesLeft = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _mithril = __webpack_require__(/*! mithril */ 0);

var m = _interopRequireDefault(_mithril).default;

var _albumTitlesView = __webpack_require__(/*! ./album-titles-view.component */ 88);

var AlbumTitlesView = _albumTitlesView.AlbumTitlesView;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AlbumTitlesLeft = {
  view: function view(ctrl, attrs) {
    return {
      tag: 'div',
      children: [m.component(AlbumTitlesView, _extends({}, attrs, { theme: 'left' }), [])],
      attrs: { className: 'album-titles-left' }
    };
  }
};

exports.AlbumTitlesLeft = AlbumTitlesLeft;

/***/ }),
/* 236 */
/* no static exports found */
/* all exports used */
/*!**********************************************************************************************!*\
  !*** ./scripts/player/v2/desktop/vertical/components/album-titles/album-titles.component.js ***!
  \**********************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AlbumTitles = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _mithril = __webpack_require__(/*! mithril */ 0);

var m = _interopRequireDefault(_mithril).default;

var _albumTitles = __webpack_require__(/*! ../../../../shared/components/album-titles/album-titles.controller */ 23);

var AlbumTitlesController = _albumTitles.AlbumTitlesController;

var _albumTitlesCenterComponent = __webpack_require__(/*! ./album-titles-center.component.js */ 234);

var AlbumTitlesCenter = _albumTitlesCenterComponent.AlbumTitlesCenter;

var _albumTitlesLeftComponent = __webpack_require__(/*! ./album-titles-left.component.js */ 235);

var AlbumTitlesLeft = _albumTitlesLeftComponent.AlbumTitlesLeft;

__webpack_require__(/*! ./album-titles.less */ 273);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AlbumTitlesContainer = {
  controller: AlbumTitlesController,
  view: function view(ctrl, attrs) {
    var albumName = ctrl.album.name;
    var theme = attrs.theme;

    var track = ctrl.getTrack();
    var artistName = ctrl.getArtistName();
    var trackName = ctrl.getTrackName();
    var shouldShowAddFirst = ctrl.shouldShowAddFirst;
    var albumViewAttrs = _extends({}, attrs, {
      albumName: albumName,
      trackName: trackName,
      artistName: artistName,
      theme: theme,
      track: track,
      shouldShowAddFirst: shouldShowAddFirst
    });

    var albumTitlesComponents = {
      center: function center() {
        return m.component(AlbumTitlesCenter, albumViewAttrs, []);
      },
      left: function left() {
        return m.component(AlbumTitlesLeft, albumViewAttrs, []);
      }
    };

    return albumTitlesComponents[theme]();
  }
};

exports.AlbumTitles = AlbumTitlesContainer;

/***/ }),
/* 237 */
/* no static exports found */
/* all exports used */
/*!*****************************************************************************!*\
  !*** ./scripts/player/v2/desktop/vertical/components/album-titles/index.js ***!
  \*****************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _albumTitlesComponent = __webpack_require__(/*! ./album-titles.component.js */ 236);

Object.defineProperty(exports, 'AlbumTitles', {
  enumerable: true,
  get: function get() {
    return _albumTitlesComponent.AlbumTitles;
  }
});

/***/ }),
/* 238 */
/* no static exports found */
/* all exports used */
/*!*****************************************************************************************!*\
  !*** ./scripts/player/v2/desktop/vertical/components/control-bar/control-bar-center.js ***!
  \*****************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ControlBarCenter = undefined;

var _classnames = __webpack_require__(/*! classnames */ 3);

var classNames = _interopRequireDefault(_classnames).default;

var _mithril = __webpack_require__(/*! mithril */ 0);

var m = _interopRequireDefault(_mithril).default;

var _utils = __webpack_require__(/*! ../../../../../../utils/utils */ 2);

var utils = _utils.utils;

var _playPauseButton = __webpack_require__(/*! ../../../../shared/components/play-pause-button/play-pause-button.component */ 26);

var PlayPauseButton = _playPauseButton.PlayPauseButton;

var _progressBar = __webpack_require__(/*! ../../../../shared/components/progress-bar */ 25);

var ProgressBar = _progressBar.ProgressBar;

var _slider = __webpack_require__(/*! ../../../../shared/components/slider */ 16);

var Slider = _slider.DesktopSlider;

var _volume = __webpack_require__(/*! ../../../../shared/components/volume */ 27);

var Volume = _volume.Volume;

var _l10n = __webpack_require__(/*! ../../../../shared/l10n */ 1);

var l10n = _l10n.l10n;

var _next = __webpack_require__(/*! ./center-icons/next.svg */ 288);

var nextIcon = _interopRequireDefault(_next).default;

var _pause = __webpack_require__(/*! ./center-icons/pause.svg */ 289);

var pauseIcon = _interopRequireDefault(_pause).default;

var _play = __webpack_require__(/*! ./center-icons/play.svg */ 290);

var playIcon = _interopRequireDefault(_play).default;

var _prev = __webpack_require__(/*! ./center-icons/prev.svg */ 291);

var prevIcon = _interopRequireDefault(_prev).default;

var _controlBarController = __webpack_require__(/*! ./control-bar-controller */ 89);

var ControlBarController = _controlBarController.ControlBarController;

var _trackInfoButton = __webpack_require__(/*! ./track-info-button.component */ 90);

var TrackInfoButton = _trackInfoButton.TrackInfoButton;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ControlBarCenter = {
  controller: ControlBarController,

  view: function view(ctrl, attrs) {
    var playback = ctrl.playback;
    var track = attrs.track,
        showDetailedTrackInfo = attrs.showDetailedTrackInfo,
        openTrackPage = attrs.openTrackPage,
        isDisabled = attrs.isDisabled;

    var played = ctrl.getProgress();
    var duration = ctrl.getDuration();
    var loaded = ctrl.getLoaded();
    var isPlaying = playback.isPlaying;
    var className = classNames('control-bar', 'control-bar_type_center', { 'control-bar_is-playing': isPlaying });
    var playedText = utils.durationToAccString(played);
    var durationText = utils.durationToAccString(duration);

    return {
      tag: 'div',
      children: [m.component(ProgressBar, { duration: duration, played: played, shouldAriaHide: !playback.hasPlayed }, [m.component(Slider, {
        progress: played || 0,
        maxValue: duration,
        valueText: l10n('player_acc_progress_value', [playedText, durationText]),
        loaded: loaded,
        isDisabled: isDisabled,
        onUpdate: function onUpdate(value) {
          return ctrl.updateProgress(value);
        }
      }, [])]), {
        tag: 'div',
        children: [m.component(Volume, { playback: playback, isDisabled: isDisabled }, []), {
          tag: 'button',
          children: [{
            tag: 'span',
            children: [m.trust(prevIcon)],
            attrs: { 'aria-hidden': 'true' }
          }],
          attrs: {
            className: 'prev',
            type: 'button',
            'aria-label': l10n('player_acc_prev'),
            disabled: isDisabled,
            onclick: function onclick() {
              return ctrl.playPrev();
            }
          }
        }, m.component(PlayPauseButton, {
          isDisabled: isDisabled,
          isPlaying: isPlaying,
          onAction: function onAction() {
            return isPlaying ? ctrl.pause() : ctrl.play();
          },
          playIcon: m.trust(playIcon),
          pauseIcon: m.trust(pauseIcon)
        }, []), {
          tag: 'button',
          children: [{
            tag: 'span',
            children: [m.trust(nextIcon)],
            attrs: { 'aria-hidden': 'true' }
          }],
          attrs: {
            className: 'next',
            type: 'button',
            disabled: isDisabled,
            'aria-label': l10n('player_acc_next'),
            onclick: function onclick() {
              return ctrl.playNext();
            }
          }
        }, showDetailedTrackInfo ? m.component(TrackInfoButton, { isDisabled: isDisabled, onclick: function onclick() {
            return openTrackPage(track.id);
          } }, []) : null],
        attrs: { className: 'control-bar__controls' }
      }],
      attrs: { className: className }
    };
  }
};

exports.ControlBarCenter = ControlBarCenter;

/***/ }),
/* 239 */
/* no static exports found */
/* all exports used */
/*!***************************************************************************************!*\
  !*** ./scripts/player/v2/desktop/vertical/components/control-bar/control-bar-left.js ***!
  \***************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ControlBarLeft = undefined;

var _classnames = __webpack_require__(/*! classnames */ 3);

var classNames = _interopRequireDefault(_classnames).default;

var _mithril = __webpack_require__(/*! mithril */ 0);

var m = _interopRequireDefault(_mithril).default;

var _utils = __webpack_require__(/*! ../../../../../../utils/utils */ 2);

var utils = _utils.utils;

var _playPauseButton = __webpack_require__(/*! ../../../../shared/components/play-pause-button/play-pause-button.component */ 26);

var PlayPauseButton = _playPauseButton.PlayPauseButton;

var _progressBar = __webpack_require__(/*! ../../../../shared/components/progress-bar */ 25);

var ProgressBar = _progressBar.ProgressBar;

var _slider = __webpack_require__(/*! ../../../../shared/components/slider */ 16);

var Slider = _slider.DesktopSlider;

var _volume = __webpack_require__(/*! ../../../../shared/components/volume */ 27);

var Volume = _volume.Volume;

var _nextLeft = __webpack_require__(/*! ../../../../shared/icons/next-left.svg */ 299);

var nextIcon = _interopRequireDefault(_nextLeft).default;

var _pauseLeft = __webpack_require__(/*! ../../../../shared/icons/pause-left.svg */ 300);

var pauseIcon = _interopRequireDefault(_pauseLeft).default;

var _playLeft = __webpack_require__(/*! ../../../../shared/icons/play-left.svg */ 303);

var playIcon = _interopRequireDefault(_playLeft).default;

var _prevLeft = __webpack_require__(/*! ../../../../shared/icons/prev-left.svg */ 306);

var prevIcon = _interopRequireDefault(_prevLeft).default;

var _l10n = __webpack_require__(/*! ../../../../shared/l10n */ 1);

var l10n = _l10n.l10n;

var _controlBarController = __webpack_require__(/*! ./control-bar-controller */ 89);

var ControlBarController = _controlBarController.ControlBarController;

var _trackInfoButton = __webpack_require__(/*! ./track-info-button.component */ 90);

var TrackInfoButton = _trackInfoButton.TrackInfoButton;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ControlBarLeft = {
  controller: ControlBarController,

  view: function view(ctrl, attrs) {
    var playback = ctrl.playback;
    var track = attrs.track,
        showDetailedTrackInfo = attrs.showDetailedTrackInfo,
        openTrackPage = attrs.openTrackPage,
        isDisabled = attrs.isDisabled;

    var isPlaying = playback.isPlaying;
    var className = classNames('control-bar', 'control-bar_type_left', { 'control-bar_is-playing': isPlaying });
    var played = ctrl.getProgress();
    var duration = ctrl.getDuration();
    var loaded = ctrl.getLoaded();
    var playedText = utils.durationToAccString(played);
    var durationText = utils.durationToAccString(duration);
    var controlButtonTranslationKey = isPlaying ? 'player_acc_pause' : 'player_acc_play';

    return {
      tag: 'div',
      children: [m.component(PlayPauseButton, {
        isDisabled: isDisabled,
        isPlaying: isPlaying,
        onAction: function onAction() {
          return isPlaying ? ctrl.pause() : ctrl.play();
        },
        playIcon: m.trust(playIcon),
        pauseIcon: m.trust(pauseIcon)
      }, []), {
        tag: 'button',
        children: [{
          tag: 'span',
          children: [m.trust(prevIcon)],
          attrs: { 'aria-hidden': 'true' }
        }],
        attrs: {
          className: 'prev',
          type: 'button',
          disabled: isDisabled,
          'aria-label': l10n('player_acc_prev'),
          onclick: function onclick() {
            return ctrl.playPrev();
          }
        }
      }, {
        tag: 'button',
        children: [{
          tag: 'span',
          children: [m.trust(nextIcon)],
          attrs: { 'aria-hidden': 'true' }
        }],
        attrs: {
          className: 'next',
          type: 'button',
          disabled: isDisabled,
          'aria-label': l10n('player_acc_next'),
          onclick: function onclick() {
            return ctrl.playNext();
          }
        }
      }, m.component(ProgressBar, { duration: duration, played: played, loaded: loaded, shouldAriaHide: !playback.hasPlayed }, [m.component(Slider, {
        progress: played || 0,
        maxValue: duration,
        valueText: l10n('player_acc_progress_value', [playedText, durationText]),
        loaded: loaded,
        isDisabled: isDisabled,
        onUpdate: function onUpdate(value) {
          return ctrl.updateProgress(value);
        }
      }, [])]), m.component(Volume, { playback: playback, isDisabled: isDisabled }, []), showDetailedTrackInfo ? m.component(TrackInfoButton, { isDisabled: isDisabled, onclick: function onclick() {
          return openTrackPage(track.id);
        } }, []) : null],
      attrs: { className: className }
    };
  }
};

exports.ControlBarLeft = ControlBarLeft;

/***/ }),
/* 240 */
/* no static exports found */
/* all exports used */
/*!****************************************************************************!*\
  !*** ./scripts/player/v2/desktop/vertical/components/control-bar/index.js ***!
  \****************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ControlBar = undefined;

var _mithril = __webpack_require__(/*! mithril */ 0);

var m = _interopRequireDefault(_mithril).default;

var _controlBarCenter = __webpack_require__(/*! ./control-bar-center */ 238);

var ControlBarCenter = _controlBarCenter.ControlBarCenter;

var _controlBarLeft = __webpack_require__(/*! ./control-bar-left */ 239);

var ControlBarLeft = _controlBarLeft.ControlBarLeft;

__webpack_require__(/*! ./control-bar.less */ 274);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ControlBar = {
  view: function view(ctrl, attrs) {
    var theme = attrs.theme;

    return theme === 'center' ? m.component(ControlBarCenter, attrs, []) : m.component(ControlBarLeft, attrs, []);
  }
};

exports.ControlBar = ControlBar;

/***/ }),
/* 241 */
/* no static exports found */
/* all exports used */
/*!****************************************************************************!*\
  !*** ./scripts/player/v2/desktop/vertical/components/share-icons/index.js ***!
  \****************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _shareIcons = __webpack_require__(/*! ./share-icons */ 242);

Object.defineProperty(exports, 'ShareIcons', {
  enumerable: true,
  get: function get() {
    return _shareIcons.ShareIcons;
  }
});

/***/ }),
/* 242 */
/* no static exports found */
/* all exports used */
/*!**********************************************************************************!*\
  !*** ./scripts/player/v2/desktop/vertical/components/share-icons/share-icons.js ***!
  \**********************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ShareIcons = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _mithril = __webpack_require__(/*! mithril */ 0);

var m = _interopRequireDefault(_mithril).default;

var _shareIcons = __webpack_require__(/*! ../../../../shared/components/share-icons */ 36);

var ShareIconsDefault = _shareIcons.ShareIcons;

var _Blogger = __webpack_require__(/*! ./icons/Blogger.svg */ 292);

var bloggerIcon = _interopRequireDefault(_Blogger).default;

var _Facebook = __webpack_require__(/*! ./icons/Facebook.svg */ 293);

var facebookIcon = _interopRequireDefault(_Facebook).default;

var _Tumbler = __webpack_require__(/*! ./icons/Tumbler.svg */ 294);

var tumblerIcon = _interopRequireDefault(_Tumbler).default;

var _Twitter = __webpack_require__(/*! ./icons/Twitter.svg */ 295);

var twitterIcon = _interopRequireDefault(_Twitter).default;

__webpack_require__(/*! ./share-icons.less */ 275);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ShareIcons = {
  view: function view(ctrl, attrs) {
    return m.component(ShareIconsDefault, _extends({}, attrs, {
      className: 'share-icons_vertical',
      facebookIcon: facebookIcon,
      twitterIcon: twitterIcon,
      tumblerIcon: tumblerIcon,
      bloggerIcon: bloggerIcon
    }), []);
  }
};

exports.ShareIcons = ShareIcons;

/***/ }),
/* 243 */
/* no static exports found */
/* all exports used */
/*!********************************************************************!*\
  !*** ./scripts/player/v2/shared/components/no-tracks/no-tracks.js ***!
  \********************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NoTracks = undefined;

var _translationsKeys;

var _mithril = __webpack_require__(/*! mithril */ 0);

var m = _interopRequireDefault(_mithril).default;

var _constants = __webpack_require__(/*! ../../../../../common/constants */ 5);

var constants = _interopRequireDefault(_constants).default;

var _translationKeys = __webpack_require__(/*! ../../translation-keys */ 10);

var registerTranslationKeys = _translationKeys.registerTranslationKeys;

var _l10n = __webpack_require__(/*! ../../l10n */ 1);

var l10n = _l10n.l10n;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var translationsKeys = (_translationsKeys = {}, _defineProperty(_translationsKeys, constants.ALBUM_TYPES.ALBUM, {
  noTracksPublish: 'player_no_tracks_publish'
}), _defineProperty(_translationsKeys, constants.ALBUM_TYPES.SINGLE, {
  noTracksPublish: 'player_no_tracks_publish_single'
}), _defineProperty(_translationsKeys, constants.ALBUM_TYPES.PLAYLIST, {
  noTracksPublish: 'player_no_tracks_publish_playlist'
}), _translationsKeys);

registerTranslationKeys(translationsKeys);

var NoTracks = {
  view: function view(ctrl, attrs) {
    var albumTranslationKeys = attrs.albumTranslationKeys,
        shouldShowAddFirst = attrs.shouldShowAddFirst;


    return {
      tag: 'div',
      children: [shouldShowAddFirst ? l10n('player_no_tracks') : l10n(albumTranslationKeys.noTracksPublish)],
      attrs: { className: 'no-tracks' }
    };
  }
};

exports.NoTracks = NoTracks;

/***/ }),
/* 244 */
/* no static exports found */
/* all exports used */
/*!*************************************************************************************************!*\
  !*** ./scripts/player/v2/shared/components/play-pause-button/play-pause-live-aria.component.js ***!
  \*************************************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PlayPauseLiveAria = undefined;

var _mithril = __webpack_require__(/*! mithril */ 0);

var m = _interopRequireDefault(_mithril).default;

var _l10n = __webpack_require__(/*! ../../l10n */ 1);

var l10n = _l10n.l10n;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PlayPauseLiveAria = exports.PlayPauseLiveAria = {
  view: function view(ctrl, attrs) {
    var isPlaying = attrs.isPlaying;


    return {
      tag: 'span',
      children: [l10n(isPlaying ? 'player_acc_play_live' : 'player_acc_pause_live')],
      attrs: { className: 'sr-only', 'aria-live': 'polite' }
    };
  }
};

/***/ }),
/* 245 */
/* no static exports found */
/* all exports used */
/*!**************************************************************!*\
  !*** ./scripts/player/v2/shared/components/volume/volume.js ***!
  \**************************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Volume = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _classnames = __webpack_require__(/*! classnames */ 3);

var classNames = _interopRequireDefault(_classnames).default;

var _mithril = __webpack_require__(/*! mithril */ 0);

var m = _interopRequireDefault(_mithril).default;

var _l10n = __webpack_require__(/*! ../../l10n */ 1);

var l10n = _l10n.l10n;

var _volumeHalf = __webpack_require__(/*! ./icons/volume-half.svg */ 298);

var volumeHalfIcon = _interopRequireDefault(_volumeHalf).default;

var _VolumeOFF = __webpack_require__(/*! ./icons/Volume-OFF.svg */ 296);

var volumeOffIcon = _interopRequireDefault(_VolumeOFF).default;

var _VolumeON = __webpack_require__(/*! ./icons/Volume-ON.svg */ 297);

var volumeOnIcon = _interopRequireDefault(_VolumeON).default;

var _volumeSlider = __webpack_require__(/*! ./volume-slider */ 93);

var VolumeSlider = _volumeSlider.VolumeSlider;

__webpack_require__(/*! ./volume.less */ 279);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var VolumeBarModel = function VolumeBarModel() {
  _classCallCheck(this, VolumeBarModel);

  this.showingSlider = m.prop(false);
  this.isDragging = m.prop(false);
  this.inMouseInsideSlider = m.prop(false);
  this.lastVolume = m.prop();
};

var VolumeController = function () {
  function VolumeController(_ref) {
    var playback = _ref.playback;

    _classCallCheck(this, VolumeController);

    this.playback = playback;
    this.volumeBar = new VolumeBarModel();
    this.volumeBar.lastVolume(this.playback.volume());
  }

  _createClass(VolumeController, [{
    key: 'toggleVolumeBar',
    value: function toggleVolumeBar() {
      var volumeBar = this.volumeBar;

      volumeBar.showingSlider(!volumeBar.showingSlider());
    }
  }, {
    key: 'updateVolume',
    value: function updateVolume(volume) {
      this.playback.volume(volume);
    }
  }, {
    key: 'startDragging',
    value: function startDragging() {
      this.volumeBar.isDragging(true);
    }
  }, {
    key: 'stopDragging',
    value: function stopDragging() {
      var volumeBar = this.volumeBar;

      volumeBar.isDragging(false);
      if (!volumeBar.inMouseInsideSlider()) {
        volumeBar.showingSlider(false);
      }
    }
  }, {
    key: 'sliderLeft',
    value: function sliderLeft() {
      var volumeBar = this.volumeBar;

      volumeBar.inMouseInsideSlider(false);
      if (!volumeBar.isDragging()) {
        volumeBar.showingSlider(false);
      }
    }
  }, {
    key: 'sliderEntered',
    value: function sliderEntered() {
      var volumeBar = this.volumeBar;

      volumeBar.showingSlider(true);
      volumeBar.inMouseInsideSlider(true);
    }
  }, {
    key: 'toggleMute',
    value: function toggleMute() {
      var playback = this.playback,
          volumeBar = this.volumeBar;

      var currentVolume = playback.volume();
      if (currentVolume === 0) {
        playback.volume(volumeBar.lastVolume());
      } else {
        volumeBar.lastVolume(playback.volume());
        playback.volume(0);
      }
    }
  }, {
    key: 'isLoud',
    value: function isLoud() {
      var playback = this.playback;

      var volume = playback.volume();
      return volume > 0.5;
    }
  }, {
    key: 'isQuite',
    value: function isQuite() {
      return !this.isLoud() && !this.isMuted();
    }
  }, {
    key: 'isMuted',
    value: function isMuted() {
      var playback = this.playback;

      var volume = playback.volume();
      return volume === 0;
    }
  }]);

  return VolumeController;
}();

var Volume = {
  controller: VolumeController,

  view: function view(ctrl, attrs) {
    var _ctrl$isLoud$ctrl$isQ;

    var playback = ctrl.playback;
    var isDisabled = attrs.isDisabled;

    var className = classNames('volume', {
      volume_loud: ctrl.isLoud(),
      volume_quite: ctrl.isQuite(),
      volume_muted: ctrl.isMuted(),
      'volume_showing-slider': ctrl.volumeBar.showingSlider()
    });
    var volumeIcon = (_ctrl$isLoud$ctrl$isQ = {}, _defineProperty(_ctrl$isLoud$ctrl$isQ, ctrl.isLoud(), volumeOnIcon), _defineProperty(_ctrl$isLoud$ctrl$isQ, ctrl.isQuite(), volumeHalfIcon), _defineProperty(_ctrl$isLoud$ctrl$isQ, ctrl.isMuted(), volumeOffIcon), _ctrl$isLoud$ctrl$isQ).true;

    var config = function config(element, isInitialized, context) {
      if (isInitialized) {
        return;
      }
      var close = function close() {
        return ctrl.sliderLeft();
      };

      document.addEventListener('mouseleave', close);
      window.addEventListener('blur', close);

      context.onunload = function () {
        document.removeEventListener('mouseleave', close);
        window.removeEventListener('blur', close);
      };
    };
    var volumeButtonTranslationKey = ctrl.isMuted() ? 'player_acc_unmute' : 'player_acc_mute';

    return {
      tag: 'div',
      children: [{
        tag: 'div',
        children: [{
          tag: 'button',
          children: [{
            tag: 'span',
            children: [m.trust(volumeIcon)],
            attrs: { 'aria-hidden': 'true' }
          }],
          attrs: {
            className: 'volume-button',
            type: 'button',
            disabled: isDisabled,
            'aria-label': l10n(volumeButtonTranslationKey),
            onclick: function onclick() {
              return !isDisabled && ctrl.toggleMute();
            },
            onmouseenter: function onmouseenter() {
              return !isDisabled && ctrl.sliderEntered();
            }
          }
        }, {
          tag: 'div',
          children: [m.component(VolumeSlider, {
            volume: playback.volume(),
            onUpdateVolume: function onUpdateVolume(volume) {
              return ctrl.updateVolume(volume);
            },
            ondragstart: function ondragstart() {
              return ctrl.startDragging();
            },
            ondragend: function ondragend() {
              return ctrl.stopDragging(false);
            }
          }, [])],
          attrs: { className: 'volume__volume-slider', onmouseleave: function onmouseleave() {
              return ctrl.sliderLeft();
            } }
        }],
        attrs: { className: className, config: config }
      }],
      attrs: { className: 'volume-focus-within' }
    };
  }
};

exports.Volume = Volume;

/***/ }),
/* 246 */
/* no static exports found */
/* all exports used */
/*!***************************************************************************!*\
  !*** ./scripts/player/v2/desktop/components/moving-text/moving-text.less ***!
  \***************************************************************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 247 */
/* no static exports found */
/* all exports used */
/*!***************************************************************************!*\
  !*** ./scripts/player/v2/desktop/components/share-album/share-album.less ***!
  \***************************************************************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 248 */
/* no static exports found */
/* all exports used */
/*!*****************************************************************************!*\
  !*** ./scripts/player/v2/desktop/components/share-button/share-button.less ***!
  \*****************************************************************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 249 */
/* no static exports found */
/* all exports used */
/*!********************************************************************************!*\
  !*** ./scripts/player/v2/desktop/components/track-list/track/share-track.less ***!
  \********************************************************************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 250 */
/* no static exports found */
/* all exports used */
/*!****************************************************************************************!*\
  !*** ./scripts/player/v2/desktop/horizontal/components/album-titles/album-titles.less ***!
  \****************************************************************************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 251 */
/* no static exports found */
/* all exports used */
/*!**************************************************************************************************!*\
  !*** ./scripts/player/v2/desktop/horizontal/components/buy-share-actions/buy-share-actions.less ***!
  \**************************************************************************************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 252 */
/* no static exports found */
/* all exports used */
/*!**************************************************************************************************!*\
  !*** ./scripts/player/v2/desktop/horizontal/components/control-bar/styles/control-bar-maxi.less ***!
  \**************************************************************************************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 253 */
/* no static exports found */
/* all exports used */
/*!**************************************************************************************************!*\
  !*** ./scripts/player/v2/desktop/horizontal/components/control-bar/styles/control-bar-mini.less ***!
  \**************************************************************************************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 254 */
/* no static exports found */
/* all exports used */
/*!*********************************************************************************************!*\
  !*** ./scripts/player/v2/desktop/horizontal/components/control-bar/styles/control-bar.less ***!
  \*********************************************************************************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 255 */
/* no static exports found */
/* all exports used */
/*!*************************************************************************************************!*\
  !*** ./scripts/player/v2/desktop/horizontal/components/control-bar/styles/play-pause-maxi.less ***!
  \*************************************************************************************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 256 */
/* no static exports found */
/* all exports used */
/*!**********************************************************************************************************************!*\
  !*** ./scripts/player/v2/desktop/horizontal/components/share-overlay/share-overlay-header/share-overlay-header.less ***!
  \**********************************************************************************************************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 257 */
/* no static exports found */
/* all exports used */
/*!******************************************************************************************!*\
  !*** ./scripts/player/v2/desktop/horizontal/components/share-overlay/share-overlay.less ***!
  \******************************************************************************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 258 */
/* no static exports found */
/* all exports used */
/*!**************************************************************!*\
  !*** ./scripts/player/v2/desktop/horizontal/styles/app.less ***!
  \**************************************************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 259 */
/* no static exports found */
/* all exports used */
/*!******************************************************************************!*\
  !*** ./scripts/player/v2/desktop/list/components/album-info/album-info.less ***!
  \******************************************************************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 260 */
/* no static exports found */
/* all exports used */
/*!**********************************************************************************!*\
  !*** ./scripts/player/v2/desktop/list/components/album-titles/album-titles.less ***!
  \**********************************************************************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 261 */
/* no static exports found */
/* all exports used */
/*!********************************************************************************************!*\
  !*** ./scripts/player/v2/desktop/list/components/buy-share-actions/buy-share-actions.less ***!
  \********************************************************************************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 262 */
/* no static exports found */
/* all exports used */
/*!********************************************************************************!*\
  !*** ./scripts/player/v2/desktop/list/components/share-album/share-album.less ***!
  \********************************************************************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 263 */
/* no static exports found */
/* all exports used */
/*!******************************************************************************!*\
  !*** ./scripts/player/v2/desktop/list/components/track-list/track-list.less ***!
  \******************************************************************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 264 */
/* no static exports found */
/* all exports used */
/*!*************************************************************************************************!*\
  !*** ./scripts/player/v2/desktop/list/components/track-list/track/track-index/track-index.less ***!
  \*************************************************************************************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 265 */
/* no static exports found */
/* all exports used */
/*!***********************************************************************************************!*\
  !*** ./scripts/player/v2/desktop/list/components/track-list/track/track-name/track-name.less ***!
  \***********************************************************************************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 266 */
/* no static exports found */
/* all exports used */
/*!***************************************************************************************************************!*\
  !*** ./scripts/player/v2/desktop/list/components/track-list/track/track-progress-bar/track-progress-bar.less ***!
  \***************************************************************************************************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 267 */
/* no static exports found */
/* all exports used */
/*!*******************************************************************************!*\
  !*** ./scripts/player/v2/desktop/list/components/track-list/track/track.less ***!
  \*******************************************************************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 268 */
/* no static exports found */
/* all exports used */
/*!**************************************************************!*\
  !*** ./scripts/player/v2/desktop/list/styles/app-basic.less ***!
  \**************************************************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 269 */
/* no static exports found */
/* all exports used */
/*!**************************************************************!*\
  !*** ./scripts/player/v2/desktop/list/styles/app-cover.less ***!
  \**************************************************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 270 */
/* no static exports found */
/* all exports used */
/*!****************************************************************!*\
  !*** ./scripts/player/v2/desktop/list/styles/app-minimal.less ***!
  \****************************************************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 271 */
/* no static exports found */
/* all exports used */
/*!********************************************************!*\
  !*** ./scripts/player/v2/desktop/list/styles/app.less ***!
  \********************************************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 272 */
/* no static exports found */
/* all exports used */
/*!*********************************************************************************************!*\
  !*** ./scripts/player/v2/desktop/vertical/components/album-titles/album-titles-center.less ***!
  \*********************************************************************************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 273 */
/* no static exports found */
/* all exports used */
/*!**************************************************************************************!*\
  !*** ./scripts/player/v2/desktop/vertical/components/album-titles/album-titles.less ***!
  \**************************************************************************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 274 */
/* no static exports found */
/* all exports used */
/*!************************************************************************************!*\
  !*** ./scripts/player/v2/desktop/vertical/components/control-bar/control-bar.less ***!
  \************************************************************************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 275 */
/* no static exports found */
/* all exports used */
/*!************************************************************************************!*\
  !*** ./scripts/player/v2/desktop/vertical/components/share-icons/share-icons.less ***!
  \************************************************************************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 276 */
/* no static exports found */
/* all exports used */
/*!************************************************************!*\
  !*** ./scripts/player/v2/desktop/vertical/styles/app.less ***!
  \************************************************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 277 */
/* no static exports found */
/* all exports used */
/*!************************************************************************!*\
  !*** ./scripts/player/v2/shared/components/track-name/track-name.less ***!
  \************************************************************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 278 */
/* no static exports found */
/* all exports used */
/*!***********************************************************************!*\
  !*** ./scripts/player/v2/shared/components/volume/volume-slider.less ***!
  \***********************************************************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 279 */
/* no static exports found */
/* all exports used */
/*!****************************************************************!*\
  !*** ./scripts/player/v2/shared/components/volume/volume.less ***!
  \****************************************************************/
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 280 */
/* no static exports found */
/* all exports used */
/*!*****************************************************************************************!*\
  !*** ./scripts/player/v2/desktop/horizontal/components/control-bar/icons/maxi/next.svg ***!
  \*****************************************************************************************/
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"22\" height=\"13\" viewBox=\"0 0 22 13\"><defs><style> .cls-1 { fill-rule: evenodd; } </style></defs><path class=\"cls-1\" d=\"M0.728,0.171A0.485,0.485,0,0,0,0,.6V12.4a0.485,0.485,0,0,0,.728.426l9.113-5.9a0.5,0.5,0,0,0,0-.852Zm10.083,0A0.485,0.485,0,0,0,10.083.6V12.4a0.485,0.485,0,0,0,.728.426l9.113-5.9a0.5,0.5,0,0,0,0-.852ZM21.083,0.1a0.915,0.915,0,0,0-.917.913v10.96a0.917,0.917,0,0,0,1.833,0V1.018A0.915,0.915,0,0,0,21.083.1Z\"></path></svg>"

/***/ }),
/* 281 */
/* no static exports found */
/* all exports used */
/*!******************************************************************************************!*\
  !*** ./scripts/player/v2/desktop/horizontal/components/control-bar/icons/maxi/pause.svg ***!
  \******************************************************************************************/
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"80\" height=\"80\" viewBox=\"0 0 80 80\"><defs><style> .cls-1 { fill-rule: evenodd; } </style></defs><path class=\"cls-1\" d=\"M34.125,25h-5.25A0.891,0.891,0,0,0,28,26V54a0.891,0.891,0,0,0,.875,1h5.25A0.891,0.891,0,0,0,35,54V26A0.891,0.891,0,0,0,34.125,25Zm17,0h-5.25A0.891,0.891,0,0,0,45,26V54a0.891,0.891,0,0,0,.875,1h5.25A0.891,0.891,0,0,0,52,54V26A0.891,0.891,0,0,0,51.125,25ZM40,1A39,39,0,1,1,1,40,39.044,39.044,0,0,1,40,1m0-1A40,40,0,1,0,80,40,40,40,0,0,0,40,0h0Z\"></path></svg>"

/***/ }),
/* 282 */
/* no static exports found */
/* all exports used */
/*!*****************************************************************************************!*\
  !*** ./scripts/player/v2/desktop/horizontal/components/control-bar/icons/maxi/play.svg ***!
  \*****************************************************************************************/
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"80\" height=\"80\" viewBox=\"0 0 80 80\"><defs><style> .cls-1 { fill-rule: evenodd; } </style></defs><path class=\"cls-1\" d=\"M40,1A39,39,0,1,1,1,40,39.044,39.044,0,0,1,40,1m0-1A40,40,0,1,0,80,40,40,40,0,0,0,40,0h0ZM30,40V26.734a1.849,1.849,0,0,1,2.83-1.462L43.8,31.794l11.342,6.743a1.676,1.676,0,0,1,0,2.924L43.8,48.206,32.83,54.729A1.849,1.849,0,0,1,30,53.266V40Z\"></path></svg>"

/***/ }),
/* 283 */
/* no static exports found */
/* all exports used */
/*!*****************************************************************************************!*\
  !*** ./scripts/player/v2/desktop/horizontal/components/control-bar/icons/maxi/prev.svg ***!
  \*****************************************************************************************/
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"22\" height=\"13\" viewBox=\"0 0 22 13\"><defs><style> .cls-1 { fill-rule: evenodd; } </style></defs><g transform=\"rotate(180 11 6.5)\"><path class=\"cls-1\" d=\"M0.728,0.171A0.485,0.485,0,0,0,0,.6V12.4a0.485,0.485,0,0,0,.728.426l9.113-5.9a0.5,0.5,0,0,0,0-.852Zm10.083,0A0.485,0.485,0,0,0,10.083.6V12.4a0.485,0.485,0,0,0,.728.426l9.113-5.9a0.5,0.5,0,0,0,0-.852ZM21.083,0.1a0.915,0.915,0,0,0-.917.913v10.96a0.917,0.917,0,0,0,1.833,0V1.018A0.915,0.915,0,0,0,21.083.1Z\"></path></g></svg>"

/***/ }),
/* 284 */
/* no static exports found */
/* all exports used */
/*!*****************************************************************************************!*\
  !*** ./scripts/player/v2/desktop/horizontal/components/control-bar/icons/mini/next.svg ***!
  \*****************************************************************************************/
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"10\" height=\"10\" viewBox=\"0 0 10 10\"><defs><style> .cls-1 { fill-rule: evenodd; } </style></defs><path class=\"cls-1\" d=\"M0.577,0.129A0.385,0.385,0,0,0,0,.457V9.541a0.385,0.385,0,0,0,.577.328l7.23-4.542a0.376,0.376,0,0,0,0-.656ZM9,0.078a1.006,1.006,0,0,0-1,.984V8.936A0.933,0.933,0,0,0,9,9.92a0.986,0.986,0,0,0,1-.984V1.062A1.006,1.006,0,0,0,9,.078Z\"></path></svg>"

/***/ }),
/* 285 */
/* no static exports found */
/* all exports used */
/*!******************************************************************************************!*\
  !*** ./scripts/player/v2/desktop/horizontal/components/control-bar/icons/mini/pause.svg ***!
  \******************************************************************************************/
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"18\" height=\"22\" viewBox=\"0 0 18 22\"><defs><style> .cls-1 { fill-rule: evenodd; } </style></defs><path class=\"cls-1\" d=\"M14,22h3a1,1,0,0,0,1-1V1a1,1,0,0,0-1-1H14a1,1,0,0,0-1,1V21A1,1,0,0,0,14,22ZM1,22h3a1,1,0,0,0,1-1V1a1,1,0,0,0-1-1H1A1,1,0,0,0,0,1V21A1,1,0,0,0,1,22Z\"></path></svg>"

/***/ }),
/* 286 */
/* no static exports found */
/* all exports used */
/*!*****************************************************************************************!*\
  !*** ./scripts/player/v2/desktop/horizontal/components/control-bar/icons/mini/play.svg ***!
  \*****************************************************************************************/
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"18\" height=\"23\" viewBox=\"0 0 18 23\"><defs><style> .cls-1 { fill-rule: evenodd; } </style></defs><path class=\"cls-1\" d=\"M-0.01,11.5V1.647A1.263,1.263,0,0,1,1.93.56L9.451,5.407l7.775,5.011a1.3,1.3,0,0,1,0,2.173L9.451,17.6,1.93,22.449A1.263,1.263,0,0,1-.01,21.363V11.5Z\"></path></svg>"

/***/ }),
/* 287 */
/* no static exports found */
/* all exports used */
/*!*****************************************************************************************!*\
  !*** ./scripts/player/v2/desktop/horizontal/components/control-bar/icons/mini/prev.svg ***!
  \*****************************************************************************************/
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"10\" height=\"10\" viewBox=\"0 0 10 10\"><defs><style> .cls-1 { fill-rule: evenodd; } </style></defs><g transform=\"rotate(180 5 5)\"><path class=\"cls-1\" d=\"M0.577,0.129A0.385,0.385,0,0,0,0,.457V9.541a0.385,0.385,0,0,0,.577.328l7.23-4.542a0.376,0.376,0,0,0,0-.656ZM9,0.078a1.006,1.006,0,0,0-1,.984V8.936A0.933,0.933,0,0,0,9,9.92a0.986,0.986,0,0,0,1-.984V1.062A1.006,1.006,0,0,0,9,.078Z\"></path></g></svg>"

/***/ }),
/* 288 */
/* no static exports found */
/* all exports used */
/*!*****************************************************************************************!*\
  !*** ./scripts/player/v2/desktop/vertical/components/control-bar/center-icons/next.svg ***!
  \*****************************************************************************************/
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"26\" height=\"26\" viewBox=\"0 0 26 26\"><defs><style> .cls-1 { fill-rule: evenodd; } </style></defs><path class=\"cls-1\" d=\"M16,12.375L13,10.5,9,8V18l4-2.5,3-1.875V18h1V8H16v4.373ZM13,0A13,13,0,1,0,26,13,13,13,0,0,0,13,0Zm0,25A12,12,0,1,1,25,13,12.014,12.014,0,0,1,13,25Z\"></path></svg>"

/***/ }),
/* 289 */
/* no static exports found */
/* all exports used */
/*!******************************************************************************************!*\
  !*** ./scripts/player/v2/desktop/vertical/components/control-bar/center-icons/pause.svg ***!
  \******************************************************************************************/
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" x=\"0px\" y=\"0px\" width=\"42\" height=\"42\" viewBox=\"0 0 42 42\" style=\"enable-background:new 0 0 42 42;\" xml:space=\"preserve\"><path d=\"M21,0C9.4,0,0,9.4,0,21s9.4,21,21,21s21-9.4,21-21S32.6,0,21,0z M21,41C10,41,1,32,1,21S10,1,21,1s20,9,20,20 C41,32,32,41,21,41z M14,30h4V12h-4C14,12,14,30,14,30z M24,30h4V12h-4V30z\"></path></svg>"

/***/ }),
/* 290 */
/* no static exports found */
/* all exports used */
/*!*****************************************************************************************!*\
  !*** ./scripts/player/v2/desktop/vertical/components/control-bar/center-icons/play.svg ***!
  \*****************************************************************************************/
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"42\" height=\"42\" viewBox=\"0 0 42 42\"><defs><style> .cls-1 { fill-rule: evenodd; } </style></defs><path class=\"cls-1\" d=\"M16,12V30l7-4.5L30,21l-7-4.5ZM21,0A21,21,0,1,0,42,21,21,21,0,0,0,21,0Zm0,41A20,20,0,1,1,41,21,20.023,20.023,0,0,1,21,41Z\"></path></svg>"

/***/ }),
/* 291 */
/* no static exports found */
/* all exports used */
/*!*****************************************************************************************!*\
  !*** ./scripts/player/v2/desktop/vertical/components/control-bar/center-icons/prev.svg ***!
  \*****************************************************************************************/
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"26\" height=\"26\" viewBox=\"0 0 26 26\"><defs><style> .cls-1 { fill-rule: evenodd; } </style></defs><path class=\"cls-1\" d=\"M10,13.625L13,15.5,17,18V8l-4,2.5-3,1.875V8H9V18h1V13.625ZM13,26A13,13,0,1,0,0,13,13,13,0,0,0,13,26ZM13,1A12,12,0,1,1,1,13,12.014,12.014,0,0,1,13,1Z\"></path></svg>"

/***/ }),
/* 292 */
/* no static exports found */
/* all exports used */
/*!*************************************************************************************!*\
  !*** ./scripts/player/v2/desktop/vertical/components/share-icons/icons/Blogger.svg ***!
  \*************************************************************************************/
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"22\" height=\"22\" viewBox=\"0 0 22 22\"><defs><style> .cls-1 { fill: #282828; fill-rule: evenodd; } </style></defs><path class=\"cls-1\" d=\"M12.981,11.938H8.893a0.875,0.875,0,0,0,0,1.75h4.088a0.859,0.859,0,0,0,.912-0.875A0.881,0.881,0,0,0,12.981,11.938ZM11,0A11,11,0,1,0,22,11,11,11,0,0,0,11,0Zm5,12.374v0.439a3.142,3.142,0,0,1-.88,2.312A3.242,3.242,0,0,1,12.793,16H9.082a3.062,3.062,0,0,1-2.327-.812A3.257,3.257,0,0,1,6,12.75V8.688a2.912,2.912,0,0,1,.819-1.875A2.814,2.814,0,0,1,9.019,6h2.472a2.623,2.623,0,0,1,2.622,2.625,9.668,9.668,0,0,1-.063,1.25C15.781,9.921,16,11.718,16,12.374ZM9.145,9.751H11.3a0.805,0.805,0,0,0,.8-0.813A0.91,0.91,0,0,0,11.22,8H9.145A0.876,0.876,0,0,0,9.145,9.751Z\"></path></svg>"

/***/ }),
/* 293 */
/* no static exports found */
/* all exports used */
/*!**************************************************************************************!*\
  !*** ./scripts/player/v2/desktop/vertical/components/share-icons/icons/Facebook.svg ***!
  \**************************************************************************************/
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"22\" height=\"22\" viewBox=\"0 0 22 22\"><defs><style> .cls-1 { fill: #282828; fill-rule: evenodd; } </style></defs><path class=\"cls-1\" d=\"M11,0A11,11,0,1,0,22,11,11,11,0,0,0,11,0Zm2.992,6.408a0.3,0.3,0,0,1-.28.272H12.593a0.731,0.731,0,0,0-.909.886V8.8h1.953a0.261,0.261,0,0,1,.21.069,0.247,0.247,0,0,1,.07.2v2.112a0.3,0.3,0,0,1-.28.272H11.68V16.83a0.3,0.3,0,0,1-.28.272H9.237a0.3,0.3,0,0,1-.28-0.272V11.449H7.28A0.3,0.3,0,0,1,7,11.177V9.065A0.3,0.3,0,0,1,7.279,8.8H8.957V7.292a2.921,2.921,0,0,1,3.076-3.2h1.678a0.248,0.248,0,0,1,.05,0,0.253,0.253,0,0,1,.232.273V6.408Z\"></path></svg>"

/***/ }),
/* 294 */
/* no static exports found */
/* all exports used */
/*!*************************************************************************************!*\
  !*** ./scripts/player/v2/desktop/vertical/components/share-icons/icons/Tumbler.svg ***!
  \*************************************************************************************/
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"22\" height=\"22\" viewBox=\"0 0 22 22\"><defs><style> .cls-1 { fill: #282828; fill-rule: evenodd; } </style></defs><path class=\"cls-1\" d=\"M11,0A11,11,0,1,0,22,11,11,11,0,0,0,11,0Zm4,16.274a4.6,4.6,0,0,1-1.442.581A8.809,8.809,0,0,1,12.117,17a3.873,3.873,0,0,1-1.369-.22,3,3,0,0,1-1.153-.654,3.416,3.416,0,0,1-.649-0.871,3.438,3.438,0,0,1-.216-1.38V9.3H7V7.486A4.5,4.5,0,0,0,8.441,6.76a3.211,3.211,0,0,0,.868-1.09A5.12,5.12,0,0,0,9.741,4h1.8V7.123H14.5V9.447H11.545v3.341c0,1.537.114,1.678,0.572,1.961a1.663,1.663,0,0,0,1.009.145A4.091,4.091,0,0,0,15,14.24v2.034Z\"></path></svg>"

/***/ }),
/* 295 */
/* no static exports found */
/* all exports used */
/*!*************************************************************************************!*\
  !*** ./scripts/player/v2/desktop/vertical/components/share-icons/icons/Twitter.svg ***!
  \*************************************************************************************/
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"22\" height=\"22\" viewBox=\"0 0 22 22\"><defs><style> .cls-1 { fill: #282828; fill-rule: evenodd; } </style></defs><path class=\"cls-1\" d=\"M11,0A11,11,0,1,0,22,11,11,11,0,0,0,11,0Zm5.669,8.49q0.008,0.163.008,0.327,0,0.059,0,.118A7.33,7.33,0,0,1,9.088,16,7.863,7.863,0,0,1,5,14.866a5.7,5.7,0,0,0,.636.034,5.546,5.546,0,0,0,3.313-1.08,2.656,2.656,0,0,1-2.491-1.755,2.817,2.817,0,0,0,1.2-.043,2.566,2.566,0,0,1-2.14-2.475V9.515a2.771,2.771,0,0,0,1.208.316,2.491,2.491,0,0,1-1.187-2.1A2.411,2.411,0,0,1,5.9,6.462,7.721,7.721,0,0,0,11.4,9.1a2.4,2.4,0,0,1-.067-0.576A2.6,2.6,0,0,1,14,6a2.736,2.736,0,0,1,1.947.8,5.527,5.527,0,0,0,1.694-.613,2.562,2.562,0,0,1-1.173,1.4A5.567,5.567,0,0,0,18,7.184,5.265,5.265,0,0,1,16.669,8.49Z\"></path></svg>"

/***/ }),
/* 296 */
/* no static exports found */
/* all exports used */
/*!*************************************************************************!*\
  !*** ./scripts/player/v2/shared/components/volume/icons/Volume-OFF.svg ***!
  \*************************************************************************/
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"17\" height=\"14\" viewBox=\"0 0 17 11\"><defs><style> .cls-1 { fill-rule: evenodd; } </style></defs><path class=\"cls-1\" d=\"M7.289,0.179c-0.5.347-3.49,2.552-3.681,2.685a0.6,0.6,0,0,1-.517.121l-2.087,0a1,1,0,0,0-1,1l0,3a1,1,0,0,0,1,1l2.069,0a0.752,0.752,0,0,1,.607.143c0.2,0.144,3.161,2.375,3.6,2.7s0.7,0.133.7-.343L7.992,0.524C7.993,0.026,7.826-.191,7.289.179ZM14.2,5.46l2.642-2.643a0.5,0.5,0,1,0-.709-0.709L13.488,4.751,10.846,2.108a0.5,0.5,0,0,0-.709.709L12.779,5.46,10.137,8.1a0.5,0.5,0,1,0,.709.709l2.642-2.643,2.642,2.643A0.5,0.5,0,1,0,16.838,8.1Z\"></path></svg>"

/***/ }),
/* 297 */
/* no static exports found */
/* all exports used */
/*!************************************************************************!*\
  !*** ./scripts/player/v2/shared/components/volume/icons/Volume-ON.svg ***!
  \************************************************************************/
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"17\" height=\"14\" viewBox=\"0 0 17 13\"><defs><style> .cls-1 { fill-rule: evenodd; } </style></defs><path class=\"cls-1\" d=\"M7.3,1.171c-0.5.347-3.492,2.556-3.683,2.69a0.6,0.6,0,0,1-.517.121l-2.088,0a1,1,0,0,0-1,1l0,3a1,1,0,0,0,1,1l2.071,0a0.752,0.752,0,0,1,.607.143c0.2,0.145,3.163,2.379,3.6,2.709s0.7,0.133.7-.343L8,1.516C8,1.018,7.833.8,7.3,1.171ZM14.063,13a0.5,0.5,0,0,1-.356-0.849A8.077,8.077,0,0,0,13.663.834a0.5,0.5,0,1,1,.707-0.7,9.075,9.075,0,0,1,.049,12.722A0.494,0.494,0,0,1,14.063,13Zm-3-2.017a0.5,0.5,0,0,1-.386-0.815,5.8,5.8,0,0,0-.022-7.351,0.5,0.5,0,1,1,.767-0.638,6.793,6.793,0,0,1,.026,8.621A0.5,0.5,0,0,1,11.063,10.986Z\"></path></svg>"

/***/ }),
/* 298 */
/* no static exports found */
/* all exports used */
/*!**************************************************************************!*\
  !*** ./scripts/player/v2/shared/components/volume/icons/volume-half.svg ***!
  \**************************************************************************/
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"13\" height=\"14\" viewBox=\"0 0 13 11\"><defs><style> .cls-1 { fill-rule: evenodd; } </style></defs><path class=\"cls-1\" d=\"M7.3,0.171c-0.5.347-3.492,2.556-3.683,2.69a0.6,0.6,0,0,1-.517.121l-2.088,0a1,1,0,0,0-1,1l0,3a1,1,0,0,0,1,1l2.071,0a0.752,0.752,0,0,1,.607.143c0.2,0.145,3.163,2.379,3.6,2.709s0.7,0.133.7-.343L8,0.516C8,0.018,7.833-.2,7.3.171Zm3.767,9.815a0.5,0.5,0,0,1-.386-0.815,5.8,5.8,0,0,0-.022-7.351,0.5,0.5,0,1,1,.767-0.638A6.793,6.793,0,0,1,11.449,9.8,0.5,0.5,0,0,1,11.063,9.986Z\"></path></svg>"

/***/ }),
/* 299 */
/* no static exports found */
/* all exports used */
/*!******************************************************!*\
  !*** ./scripts/player/v2/shared/icons/next-left.svg ***!
  \******************************************************/
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"9\" height=\"10\" viewBox=\"0 0 9 10\"><defs><style> .cls-1 { fill: #282828; fill-rule: evenodd; } </style></defs><path class=\"cls-1\" d=\"M7,0V4.374L4,2.5,0,0V10L4,7.5,7,5.624V10H9V0H7Z\"></path></svg>"

/***/ }),
/* 300 */
/* no static exports found */
/* all exports used */
/*!*******************************************************!*\
  !*** ./scripts/player/v2/shared/icons/pause-left.svg ***!
  \*******************************************************/
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"17\" height=\"21\" viewBox=\"0 0 17 21\"><defs><style> .cls-1 { fill: #282828; fill-rule: evenodd; } </style></defs><path class=\"cls-1\" d=\"M0,21H5V0H0V21Zm12,0h5V0H12V21Z\"></path></svg>"

/***/ }),
/* 301 */
/* no static exports found */
/* all exports used */
/*!**********************************************************!*\
  !*** ./scripts/player/v2/shared/icons/pause-rounded.svg ***!
  \**********************************************************/
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"12\" height=\"16\" viewBox=\"0 0 12 16\"><defs><style> .cls-1 { fill-rule: evenodd; } </style></defs><path class=\"cls-1\" d=\"M2,0A1.9,1.9,0,0,0,0,1.778V14.222A1.9,1.9,0,0,0,2,16a1.9,1.9,0,0,0,2-1.778V1.778A1.9,1.9,0,0,0,2,0Zm8,0A1.9,1.9,0,0,0,8,1.778V14.222A1.9,1.9,0,0,0,10,16a1.9,1.9,0,0,0,2-1.778V1.778A1.9,1.9,0,0,0,10,0Z\"></path></svg>"

/***/ }),
/* 302 */
/* no static exports found */
/* all exports used */
/*!**************************************************!*\
  !*** ./scripts/player/v2/shared/icons/pause.svg ***!
  \**************************************************/
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"15\" height=\"19\" viewBox=\"0 0 15 19\"><path d=\"M264,700h4v19h-4V700Zm11,0h4v19h-4V700Z\" transform=\"translate(-264 -700)\"></path></svg>"

/***/ }),
/* 303 */
/* no static exports found */
/* all exports used */
/*!******************************************************!*\
  !*** ./scripts/player/v2/shared/icons/play-left.svg ***!
  \******************************************************/
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"18\" height=\"24\" viewBox=\"0 0 18 24\"><defs><style> .cls-1 { fill: #282828; fill-rule: evenodd; } </style></defs><path class=\"cls-1\" d=\"M18,12L9,18,0,24V0L9,6Z\"></path></svg>"

/***/ }),
/* 304 */
/* no static exports found */
/* all exports used */
/*!*********************************************************!*\
  !*** ./scripts/player/v2/shared/icons/play-rounded.svg ***!
  \*********************************************************/
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"12\" height=\"16\" viewBox=\"0 0 12 16\"><defs><style> .cls-1 { fill-rule: evenodd; } </style></defs><path class=\"cls-1\" d=\"M-0.009,7.994V1.106A0.843,0.843,0,0,1,1.285.347L6.3,3.734l5.186,3.5a0.931,0.931,0,0,1,0,1.518L6.3,12.255,1.285,15.642a0.843,0.843,0,0,1-1.294-.759V7.994Z\"></path></svg>"

/***/ }),
/* 305 */
/* no static exports found */
/* all exports used */
/*!*************************************************!*\
  !*** ./scripts/player/v2/shared/icons/play.svg ***!
  \*************************************************/
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"15\" height=\"20.357\" viewBox=\"0 0 14 19\"><defs><style> .cls-1 { fill-rule: evenodd; } </style></defs><path class=\"cls-1\" d=\"M1575,629.5l-14,9.5V620Z\" transform=\"translate(-1561 -620)\"></path></svg>"

/***/ }),
/* 306 */
/* no static exports found */
/* all exports used */
/*!******************************************************!*\
  !*** ./scripts/player/v2/shared/icons/prev-left.svg ***!
  \******************************************************/
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"9\" height=\"10\" viewBox=\"0 0 9 10\"><defs><style> .cls-1 { fill: #282828; fill-rule: evenodd; } </style></defs><path class=\"cls-1\" d=\"M7,0V4.374L4,2.5,0,0V10L4,7.5,7,5.624V10H9V0H7Z\" transform=\"rotate(180, 4.5, 5)\"></path></svg>"

/***/ }),
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */
/* no static exports found */
/* all exports used */
/*!********************************************!*\
  !*** ./scripts/player/v3/desktop/index.js ***!
  \********************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DesktopApp = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _desktopWiringV2Settings = __webpack_require__(/*! ../../../../styles/v2/desktop-wiring-v2.settings.less */ 66);

var v2DynamicCss = _interopRequireDefault(_desktopWiringV2Settings).default;

var _desktopWiringV3Settings = __webpack_require__(/*! ../../../../styles/v3/desktop-wiring-v3.settings.less */ 190);

var v3DynamicCss = _interopRequireDefault(_desktopWiringV3Settings).default;

var _app = __webpack_require__(/*! ../../v2/desktop/app.component */ 69);

var DesktopAppComponent = _app.DesktopAppComponent;

__webpack_require__(/*! ../../v2/desktop/styles/desktop-v2.less */ 175);

var _app2 = __webpack_require__(/*! ../../v2/shared/app */ 37);

var App = _app2.App;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DesktopApp = exports.DesktopApp = function (_App) {
  _inherits(DesktopApp, _App);

  function DesktopApp() {
    _classCallCheck(this, DesktopApp);

    var _this = _possibleConstructorReturn(this, (DesktopApp.__proto__ || Object.getPrototypeOf(DesktopApp)).call(this, 'v3'));

    _this.component = DesktopAppComponent;
    _this.className = 'desktop';
    _this.dynamicCss = [v2DynamicCss, v3DynamicCss];
    _this.openSharedTrackPage = true;
    return _this;
  }

  _createClass(DesktopApp, [{
    key: 'addStyles',
    value: function addStyles(generators, additionalClassNames, settings) {
      this.domElement.classList.add('v3');
      return _get(DesktopApp.prototype.__proto__ || Object.getPrototypeOf(DesktopApp.prototype), 'addStyles', this).call(this, generators, additionalClassNames, settings);
    }
  }]);

  return DesktopApp;
}(App);

/***/ })
];;
//# sourceMappingURL=wix-music-widget-3.js.map